var instituteMetaData = {
  "data-attribute": "menu-institute",
  "name": "institute"
}

var instituteTagsDataIimjobs = [
  {
    text: "Indian Institute of Management, Ahmedabad (IIMA)",
    val: 1,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management, Bangalore (IIMB)",
    val: 2,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management, Kolkata (IIMC)",
    val: 3,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management, Indore (IIMI)",
    val: 4,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management, Kozhikode (IIMK)",
    val: 5,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management, Lucknow (IIML)",
    val: 6,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian School of Business, Hyderabad (ISB)",
    val: 7,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Delhi (IITD)",
    val: 8,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Mumbai (IITB)",
    val: 9,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Chennai (IITM)",
    val: 10,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Roorkee (IITR)",
    val: 11,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Kanpur (IITK)",
    val: 12,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Kharagpur (IITKGP)",
    val: 13,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Xavier Labour Relations Institute (XLRI)",
    val: 14,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Management Development Institute (MDI)",
    val: 15,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Narsee Monjee Institute of Management Studies (NMIMS)",
    val: 16,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Faculty of Management Studies (FMS) - Delhi University",
    val: 17,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management, Mumbai (IIM Mumbai formerly known as NITIE)",
    val: 18,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "SP Jain Institute of Management - Research (SPJIMR)",
    val: 19,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Symbiosis Institute of Business Management (SIBM)",
    val: 20,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "TA Pai Management Institute (TAPMI)",
    val: 21,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Tata Institute of Social Sciences (TISS)",
    val: 22,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian Institute of Foreign Trade (IIFT)",
    val: 23,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Mudra Institute of Communications, Ahmedabad (MICA)",
    val: 24,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Institute of Rural Management Anand (IRMA)",
    val: 25,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "University Business School, Chandigarh (UBS)",
    val: 26,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Symbiosis Centre for Management and Human Resource Development (SCMHRD)",
    val: 27,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Institute of Management Technology (IMT), Ghaziabad",
    val: 28,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "International Management Institute (IMI), New Delhi",
    val: 29,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Fore School of Management Delhi",
    val: 30,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "KJ Somaiya Institute of Management Studies and Research, Mumbai",
    val: 31,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "ICFAI Business School (IBS), Hyderabad",
    val: 32,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "ICFAI, Gurgaon",
    val: 33,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Institute of Management Technology (IMT), Nagpur",
    val: 34,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "SIIB Pune",
    val: 35,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "ISB&M Pune",
    val: 36,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Loyola Institute of Business Administration (LIBA), Chennai",
    val: 37,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "BIM Trichy",
    val: 38,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Lal Bahadur Shastri Institute of Management (LBSIM), New Delhi",
    val: 39,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Institute of Management, Nirma University, Ahmedabad",
    val: 40,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "SIMS",
    val: 41,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Welingkar Institute of Management Development & Research, Mumbai",
    val: 42,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian Institute of Social Welfare and Business Management (IISWBM), Kolkata",
    val: 43,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Other",
    val: 44,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Shillong (IIMS)",
    val: 45,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Rohtak (IIMRohtak)",
    val: 46,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Ranchi (IIMR)",
    val: 47,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Raipur (IIMRaipur)",
    val: 48,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Tiruchirappalli (IIMT)",
    val: 49,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Udaipur (IIMU)",
    val: 50,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Kashipur (IIMKashipur)",
    val: 51,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Jamnalal Bajaj Institute of Management Studies (JBIMS)",
    val: 52,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Birla Institute of Technology and Science (BITS), Pilani",
    val: 53,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Guwahati (IITG)",
    val: 54,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Institute of Chartered Accountants of India (ICAI)",
    val: 55,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Xavier Institute Of Management - Bhubaneswar (XIMB)",
    val: 56,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian Institute of Science (IISc)",
    val: 57,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Delhi School of Economics (DSE)",
    val: 59,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Great Lakes Institute of Management",
    val: 60,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Institute for Financial Management and Research (IFMR)",
    val: 61,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Xavier Institute of Management and Entrepreneurship (XIME)",
    val: 62,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Columbia Business School",
    val: 63,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Harvard Business School",
    val: 64,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Johnson Graduate School of Management, Cornell University",
    val: 65,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "The Wharton School of the University of Pennsylvania",
    val: 66,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Tuck School of Business at Dartmouth",
    val: 67,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Yale School of Management",
    val: 68,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "INSEAD (France or Singapore Campus)",
    val: 69,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Kellogg School of Management - Northwestern University",
    val: 70,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "London Business School, UK",
    val: 71,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "MIT Sloan School of Management",
    val: 72,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "NYU Stern School of Business",
    val: 73,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Stanford Graduate School of Business",
    val: 74,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "ESCP Europe Business School",
    val: 75,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "University of Oxford - Said, UK",
    val: 76,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "University of Cambridge - Judge, UK",
    val: 77,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "IE Business School, Spain",
    val: 78,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "HEC Paris, France",
    val: 79,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Esade Business School, Spain",
    val: 80,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Iese Business School, Spain",
    val: 81,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "IMD, Switzerland",
    val: 82,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "University of St Gallen, Switzerland",
    val: 83,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Rotterdam School of Management, Erasmus University, Netherlands",
    val: 84,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "SDA Bocconi, Italy",
    val: 85,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Institute of Cost and Management Accountants of India (ICMAI)",
    val: 86,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "London School of Economics (LSE)",
    val: 87,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Asian Institute of Management (AIM), Philippines",
    val: 88,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Varanasi (IIT BHU)",
    val: 89,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Haas School of Business, University of California Berkeley",
    val: 90,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National University Of Singapore(NUS) Business School",
    val: 91,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Institute of Management Technology (IMT) Dubai",
    val: 92,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Bhubaneswar (IITBBS)",
    val: 93,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Gandhinagar (IITGN)",
    val: 94,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Hyderabad (IITH)",
    val: 95,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Indore (IITI)",
    val: 96,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Jodhpur (IITJ)",
    val: 97,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Mandi (IITMandi)",
    val: 98,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Patna (IITP)",
    val: 99,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Indian Institute of Technology, Ropar (IITRPR)",
    val: 100,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Institute of Company Secretaries of India (ICSI)",
    val: 101,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "B. S. Abdur Rahman University",
    val: 102,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Anna University",
    val: 103,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Visvesvaraya Technological University",
    val: 104,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Birsa Institute of Technology Sindri",
    val: 105,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Osmania University",
    val: 106,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "College of Engineering, Guindy",
    val: 107,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "University of Mumbai",
    val: 108,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Uttarakhand Technical University",
    val: 109,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Delhi Technological University",
    val: 110,
    isTop: "topinst",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Dhirubhai Ambani Institute of Information and Communication Technology",
    val: 111,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Malaviya National Institute of Technology, Jaipur",
    val: 112,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Government College of Engineering, Amravati",
    val: 113,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Harcourt Butler Technological Institute Kanpur (HBTI)",
    val: 114,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Walchand Institute of Technology",
    val: 115,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Guru Gobind Singh Indraprastha University",
    val: 116,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian Institute of Information Technology, Allahabad (IITA)",
    val: 117,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Indian School of Mines, Dhanbad (ISM)",
    val: 118,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Institute of Technology, Nirma University",
    val: 119,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "International Institute of Information Technology, Hyderabad",
    val: 120,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "University of Pune",
    val: 121,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Manipal Institute of Technology Manipal University",
    val: 122,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "M.S.Ramaiah Institute of Technology",
    val: 123,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Mepco Schlenk Engineering College",
    val: 124,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Model Engineering College",
    val: 125,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Motilal Nehru National Institute of Technology, Allahabad (NIT)",
    val: 126,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Engineering Visvesvaraya Technological University",
    val: 127,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology Srinagar (NIT)",
    val: 128,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology, Calicut (NIT)",
    val: 129,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology, Durgapur (NIT)",
    val: 130,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology, Hamirpur (NIT)",
    val: 131,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology Karnataka (NIT)",
    val: 132,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology, Rourkela (NIT)",
    val: 133,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology, Silchar (NIT)",
    val: 134,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology, Tiruchirappalli (NIT)",
    val: 135,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology, Warangal (NIT)",
    val: 136,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Netaji Subhas Institute of Technology (NSIT)",
    val: 137,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "P.S.G. College of Technology",
    val: 138,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "P.E.S. College of Engineering",
    val: 139,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "P.E.S. Institute of Technology",
    val: 140,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "PEC University of Technology",
    val: 141,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "R.V. College of Engineering",
    val: 142,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Rajagiri School of Engineering & Technology",
    val: 143,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Sardar Vallabhbhai National Institute of Technology, Surat",
    val: 144,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Shri Mata Vaishno Devi University",
    val: 145,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Sir M. Visvesvaraya Institute of Technology",
    val: 146,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "SSN College of Engineering",
    val: 147,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "SRM University",
    val: 148,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Thadomal Shahani Engineering College",
    val: 149,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Thapar University",
    val: 150,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Veermata Jijabai Technological Institute",
    val: 151,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Vellore Institute of Technology",
    val: 152,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Visvesvaraya National Institute of Technology",
    val: 153,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "West Bengal University of Technology",
    val: 154,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Birla Institute of Management Technology (BIMTECH), Greater Noida",
    val: 155,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Lal Bahadur Shastri Institute of Management (LBSIM), New Delhi",
    val: 156,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Department of Financial Studies, University of Delhi",
    val: 157,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Goa Institute of Management (GIM)",
    val: 158,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Construction Management and Research",
    val: 159,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Birla Institute of Technology, Mesra",
    val: 160,
    isTop: "",
    created: "2015-03-02 01:44:16",
    cluster: "management",
  },
  {
    text: "Dr. B. R. Ambedkar National Institute of Technology (NIT) Jalandhar",
    val: 161,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "MYRA School of Business",
    val: 162,
    isTop: "",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "Maulana Azad National Institute of Technology (MANIT) Bhopal",
    val: 163,
    isTop: "topinst",
    created: "2015-03-02 01:44:17",
    cluster: "management",
  },
  {
    text: "National Institute of Technology, Kurukshetra (NIT KKR)",
    val: 164,
    isTop: "topinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Faculty of Management Studies, Banaras Hindu University (FMS, BHU)",
    val: 165,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "National Institute of Technology (NIT), Patna",
    val: 166,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management, Visakhapatnam",
    val: 167,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Forest Management, Bhopal",
    val: 168,
    isTop: "topinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Nagpur (IIM Nagpur)",
    val: 169,
    isTop: "topinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Visakhapatnam (IIMV)",
    val: 170,
    isTop: "topinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "IFIM Business School, Bangalore",
    val: 171,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "VES Institute of Management Studies and Research",
    val: 172,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Sirmaur (IIM Sirmaur)",
    val: 173,
    isTop: "topinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indraprastha Institute of Information Technology",
    val: 174,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Amritsar (IIM Amritsar)",
    val: 175,
    isTop: "topinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "National Law University, Bangalore",
    val: 176,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "National Law Institute University, Bhopal",
    val: 177,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "ILS Law College, Pune",
    val: 178,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Gujarat National Law University",
    val: 179,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Symbiosis Law School, Pune",
    val: 180,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "National Law University, Delhi",
    val: 181,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Bharathi Vidyapeeth",
    val: 182,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "NALSAR University of Law, Hyderabad",
    val: 183,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Faculty of Law, Delhi University",
    val: 184,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Hidayatullah National Law University, Raipur",
    val: 185,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Faculty of Law, Varanasi",
    val: 186,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Amity Law School, Delhi",
    val: 187,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "MS Ramaiah College of Law",
    val: 188,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Government Law College, Mumbai",
    val: 189,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Jindal Global Law School",
    val: 190,
    isTop: "lawinst",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Xavier Institute of Social Service, Ranchi (XISS)",
    val: 191,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "SIMSREE",
    val: 192,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Jammu (IIM Jammu)",
    val: 194,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Christ University",
    val: 195,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Bodh Gaya (IIM Bodh Gaya)",
    val: 196,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Delhi University",
    val: 197,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Hindu College",
    val: 198,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "COEP (College of Engineering, Pune)",
    val: 199,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "National Institute of Design, Bengaluru",
    val: 200,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "National Institute of Design, Ahmedabad",
    val: 201,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Symbiosis Institute of Design, Pune",
    val: 202,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "MIT Institute of Design, Pune",
    val: 203,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Domus Academy",
    val: 204,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Srishti Institute of Art, Design and Technology",
    val: 205,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "Indian Institute of Management Sambalpur (IIM Sambalpur)",
    val: 206,
    isTop: "",
    created: "2022-01-27 22:13:12",
    cluster: "management",
  },
  {
    text: "University of Madras",
    val: 207,
    isTop: "",
    created: "2022-07-13 18:11:04",
    cluster: "management",
  },
  {
    text: "Symbiosis Centre for Media and Communication",
    val: 208,
    isTop: "",
    created: "2022-11-02 11:42:55",
    cluster: "management",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), New Delhi",
    val: 210,
    isTop: "",
    created: "2025-10-01 16:39:43",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Bathinda",
    val: 211,
    isTop: "",
    created: "2025-10-01 16:39:43",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Bhopal",
    val: 212,
    isTop: "",
    created: "2025-10-01 16:39:43",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Bhubaneswar",
    val: 213,
    isTop: "",
    created: "2025-10-01 16:39:43",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Bibinagar",
    val: 214,
    isTop: "",
    created: "2025-10-01 16:39:43",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Bilaspur",
    val: 215,
    isTop: "",
    created: "2025-10-01 16:39:43",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Darbhanga",
    val: 216,
    isTop: "",
    created: "2025-10-01 16:39:43",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Deoghar",
    val: 217,
    isTop: "",
    created: "2025-10-01 16:39:43",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Gorakhpur",
    val: 218,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Guwahati",
    val: 219,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Jammu",
    val: 220,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Jodhpur",
    val: 221,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Kalyani",
    val: 222,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Madurai",
    val: 223,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Mangalagiri",
    val: 224,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Nagpur",
    val: 225,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Raebareli",
    val: 226,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Raipur",
    val: 227,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Rajkot",
    val: 228,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Rishikesh",
    val: 229,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Patna",
    val: 230,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Rewari",
    val: 231,
    isTop: "",
    created: "2025-10-01 16:39:44",
    cluster: "healthcare",
  },
  {
    text: "All India Institute of Medical Sciences (AIIMS), Awantipora",
    val: 232,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Postgraduate Institute of Medical Education and Research, Chandigarh",
    val: 233,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Christian Medical College, Vellore",
    val: 234,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Jawaharlal Institute of Postgraduate Medical Education and Research, Pondicherry",
    val: 235,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Sanjay Gandhi Postgraduate Institute of Medical Sciences, Lucknow",
    val: 236,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Institute of Medical Sciences Banaras Hindu University, Varanasi",
    val: 237,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Armed Forces Medical College, Pune",
    val: 238,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Bangalore Medical College and Research Institute",
    val: 239,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Kasturba Medical College, Manipal",
    val: 240,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "King Edward Medical College (KEC), Mumbai",
    val: 241,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Lady Hardinge Medical College, DU",
    val: 242,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Madras Medical College",
    val: 243,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Maulana Azad Medical College, DU",
    val: 244,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Calcutta Medical College (CMC)",
    val: 245,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Dr. MGR Medical University (MGRMU), Chennai",
    val: 246,
    isTop: "",
    created: "2025-10-01 16:39:45",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College and Hospital (GMCH), Chandigarh",
    val: 247,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Guwahati Medical College and Hospital (GMCH)",
    val: 248,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Amrita Institute of Medical Sciences & Research Centre, Kochi",
    val: 249,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "B J Medical College, Pune",
    val: 250,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Christian Medical College & Hospital, Ludhiana",
    val: 251,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Grant Medical College, Mumbai",
    val: 252,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Institute of Medical Sciences, Varanasi",
    val: 253,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "King George's Medical University",
    val: 254,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "M S Ramaiah Medical College, Bangalore",
    val: 255,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Medical College & Hospital, Kolkata",
    val: 256,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Nil Ratan Sircar Medical College & Hospital, Kolkata",
    val: 257,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Osmania Medical College, Hyderabad",
    val: 258,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "King Edward Memorial Hospital and Seth Gordhandas Sunderdas Medical College, Mumbai",
    val: 259,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "St. John's Medical College, Bangalore",
    val: 260,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Stanley Medical College, Chennai",
    val: 261,
    isTop: "",
    created: "2025-10-01 16:39:46",
    cluster: "healthcare",
  },
  {
    text: "Institute of Post Graduate Medical Education & Research, Kolkata",
    val: 262,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "University College of Medical Sciences, DU",
    val: 263,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "A J Institute of Medical Sciences, Mangalore",
    val: 264,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "AB Shetty Memorial Institute of Dental Sciences, Mangalore",
    val: 265,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "Acharya Shri Chander College of Medical Sciences and Hospital, Jammu",
    val: 266,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "Acharya Vinoba Bhave Rural Hospital, Sawangi",
    val: 267,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "ACPM Medical College, Dhule",
    val: 268,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "Adesh Institute of Medical Science, Ludhiana",
    val: 269,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "Adichunchanagiri Institute of Medical Sciences, Mandya",
    val: 270,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "AECS Maruti College of Dental Sciences and Research Centre, Bangalore",
    val: 271,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "All Saints Institute of Medical Sciences and Research, Ludhiana",
    val: 272,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "Alluri Sitaram Raju Academy of Medical Sciences, West Godavari",
    val: 273,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "Amala Institute of Medical Sciences, Thrissur",
    val: 274,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "AMEs Dental College and Hospital, Raichur",
    val: 275,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "AN Magadh Medical College, Gaya",
    val: 276,
    isTop: "",
    created: "2025-10-01 16:39:47",
    cluster: "healthcare",
  },
  {
    text: "Andhra Medical College, Visakhapatnam",
    val: 277,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Anjuman-I-Islaams Tibbia College and Hospital, Mumbai",
    val: 278,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Annai Therasa Institute of Para Medical Sciences, Salem",
    val: 279,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Annasaheb Chudaman Patil Memorial Medical College, Dhule",
    val: 280,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Apeejay Institute of Hospitality, Navi Mumbai",
    val: 281,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Army College of Dental Sciences, Secunderabad",
    val: 282,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Army Hospital Research and Referral, Delhi",
    val: 283,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Army Medical Corps, Pune",
    val: 284,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Arvind Eye Hospital, Madurai",
    val: 285,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Assam Medical College, Dibrugarh",
    val: 286,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Ayurved Medical College, Gaya",
    val: 287,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Azamgarh Medical College, Azamgarh",
    val: 288,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "B R S Institute of Medical Sciences, Panchkula",
    val: 289,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Baba Jaswant Singh Dental College, Ludhiana",
    val: 290,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Babu Jagajivanram Dental College, Bangalore",
    val: 291,
    isTop: "",
    created: "2025-10-01 16:39:48",
    cluster: "healthcare",
  },
  {
    text: "Balaji Dental College and Hospital, Chennai",
    val: 292,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Bangalore Institute of Dental Sciences and Hospital, Bangalore",
    val: 293,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Bapuji Dental College and Hospital, Davanagere",
    val: 294,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Belgaum Institute of Medical Sciences, Belgaum",
    val: 295,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Bharati Vidyapeeths Dental College & Hospital, Pune",
    val: 296,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Bharati Vidyapeeths Medical College, Pune",
    val: 297,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Bhartiya Homeo Medical College and Hospital, Bharatpur",
    val: 298,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Bhaskar Medical College, Hyderabad",
    val: 299,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Bhavnagar Medical College, Bhavnagar",
    val: 300,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "BJ Medical College, Ahmedabad",
    val: 301,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "BJS Dental College of Research Institute, Ludhiana",
    val: 302,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "BLDEA Sri BM Patil Medical College, Bijapur",
    val: 303,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "Bombay Hospital Institute of Medical Science, Mumbai",
    val: 304,
    isTop: "",
    created: "2025-10-01 16:39:49",
    cluster: "healthcare",
  },
  {
    text: "BRD Medical College, Gorakhpur",
    val: 305,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Brij Kishore Homeopathic Medical College, Faizabad",
    val: 306,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Buddha Institute of Medical Sciences and Hospital, Patna",
    val: 307,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Budha Institute of Dental Sciences, Kankarbag",
    val: 308,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Burdwan Medical College, Bardhaman",
    val: 309,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "BVV Sangha's S Nijalingappa Medical College, Bagalkot",
    val: 310,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Calcutta National Medical College, Kolkata",
    val: 311,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Calicut Medical College, Calicut",
    val: 312,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Calicut Medical College, Kozhikode",
    val: 313,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "CDFD Goa Medical College, Goa",
    val: 314,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Ch Multan Singh Rural Dental College, Firozabad",
    val: 315,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Chandigarh College of Hospitality, Landran",
    val: 316,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Chengalpattu Medical College, Changalpattu",
    val: 317,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Chennai Medical College, Chennai",
    val: 318,
    isTop: "",
    created: "2025-10-01 16:39:50",
    cluster: "healthcare",
  },
  {
    text: "Chettinad Hospital and Research Institute, Kelambakkam",
    val: 319,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "Choudary Multan Singh Rural Dental College, Firozabad",
    val: 320,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "Christian Dental College, Ludhiana",
    val: 321,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "Christian Medical College, Gaya",
    val: 322,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "Christian Medical College, Nizamabad",
    val: 323,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "Co-operative Medical College, Kochi",
    val: 324,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "Coimbatore Medical College, Coimbatore",
    val: 325,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "College of Allied Health Sciences (COAHS), Manipal",
    val: 326,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "College of Dental Sciences, Davanagere",
    val: 327,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "College of Dental Surgery, Mangalore",
    val: 328,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "College of Dental Surgery, Manipal",
    val: 329,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "College of Hospitality and Tourism Studies, Lucknow",
    val: 330,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "College of Hospitality and Tourism, Faridabad",
    val: 331,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "Command Hospital, Bangalore",
    val: 332,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "Corporation Medical College, Surat",
    val: 333,
    isTop: "",
    created: "2025-10-01 16:39:51",
    cluster: "healthcare",
  },
  {
    text: "CREMA-Clinical Research, Mumbai",
    val: 334,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "CSMSS's Dental College & Hospital, Aurangabad",
    val: 335,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "D A V Centanary Dental College, Una",
    val: 336,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "D Y Patil Pratishthan's Medical College, Pimpri",
    val: 337,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Darbhanga Dental College, Darbhanga",
    val: 338,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Darbhanga Medical College, Darbhanga",
    val: 339,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Dasmesh Institute of Research and Dental Sciences, Faridkot",
    val: 340,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "DAV Dental College and Hospital, Solan",
    val: 341,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Dayanand Medical College & Hospital, Ludhiana",
    val: 342,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Dayananda Sagar College of Dental Sciences, Bangalore",
    val: 343,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Deccan College of Medical Sciences, Hyderabad",
    val: 344,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Dental College and Hospital, Amravati",
    val: 345,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Dental College and Hospital, Aurangabad",
    val: 346,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Dental College and Hospital, Hyderabad",
    val: 347,
    isTop: "",
    created: "2025-10-01 16:39:52",
    cluster: "healthcare",
  },
  {
    text: "Dental College and Hospital, Nashik",
    val: 348,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College and Hospital, Pune",
    val: 349,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College and Research Centre, Belgaum",
    val: 350,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Aligarh",
    val: 351,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Amravati",
    val: 352,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Bangalore",
    val: 353,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Kottayam",
    val: 354,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Kozhikode",
    val: 355,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Nagpur",
    val: 356,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Raichur",
    val: 357,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Rohtak",
    val: 358,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dental College, Thiruvananthapuram",
    val: 359,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dicky Memorial Charitable Hospital and College, Bhopal",
    val: 360,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dr B C Roy Memorial Hospital for Children, Kolkata",
    val: 361,
    isTop: "",
    created: "2025-10-01 16:39:53",
    cluster: "healthcare",
  },
  {
    text: "Dr B R Ambedkar Medical College, Bangalore",
    val: 362,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr BR Ambedkar Centre for Bio-Medical Research, Delhi",
    val: 363,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr BR Ambedkar Dental College, Bangalore",
    val: 364,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr BR Ambedkar Institute of Dental Sciences & Hospital, Patna",
    val: 365,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr D Y Patil Medical College, Kolhapur",
    val: 366,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr DY Patil Medical College for Women, Pune",
    val: 367,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr P D Medical College, Amravati",
    val: 368,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr Punjabrao Alias Bhausaheb Deshmukh Memorial Medical College, Amravati",
    val: 369,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr R Ahmed Dental College and Hospital, Kolkata",
    val: 370,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr Rajendra Prasad Government Medical College, Dharamshala",
    val: 371,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr Rajendra Prasad Government Medical College, Kangra",
    val: 372,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr Sampurnananda Medical College, Jodhpur",
    val: 373,
    isTop: "",
    created: "2025-10-01 16:39:54",
    cluster: "healthcare",
  },
  {
    text: "Dr Shyamala Reddy Dental College, Bangalore",
    val: 374,
    isTop: "",
    created: "2025-10-01 16:39:55",
    cluster: "healthcare",
  },
  {
    text: "Dr Somervel Memorial CSI Hospital & Medical College, Thiruvananthapuram",
    val: 375,
    isTop: "",
    created: "2025-10-01 16:39:55",
    cluster: "healthcare",
  },
  {
    text: "Dr Vaishampayan Memorial Medical College, Solapur",
    val: 376,
    isTop: "",
    created: "2025-10-01 16:39:55",
    cluster: "healthcare",
  },
  {
    text: "DY Patil Society Medical College, Kolhapur",
    val: 377,
    isTop: "",
    created: "2025-10-01 16:39:55",
    cluster: "healthcare",
  },
  {
    text: "ENT Hospital & Postgraduate Institute, Sangli",
    val: 378,
    isTop: "",
    created: "2025-10-01 16:39:55",
    cluster: "healthcare",
  },
  {
    text: "Era Medical College, Lucknow",
    val: 379,
    isTop: "",
    created: "2025-10-01 16:39:55",
    cluster: "healthcare",
  },
  {
    text: "Eras Lucknow Medical College and Hospital, Lucknow",
    val: 380,
    isTop: "",
    created: "2025-10-01 16:39:55",
    cluster: "healthcare",
  },
  {
    text: "Faculty of Medical Sciences, New Delhi",
    val: 381,
    isTop: "",
    created: "2025-10-01 16:39:55",
    cluster: "healthcare",
  },
  {
    text: "Farooqia Dental College, Mysore",
    val: 382,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "Father Mullers Institue of Medical Education and Research, Mangalore",
    val: 383,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "Father Mullers Medical College, Mangalore",
    val: 384,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "Fr Mullers Institute of Medical Education, Mangalore",
    val: 385,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "Gajra Raja Medical College, Gwalior",
    val: 386,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "Gandhi Medical College, Bhopal",
    val: 387,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "Gandhi Medical College, Hyderabad",
    val: 388,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "GB Pant Medical College, Delhi",
    val: 389,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "GITAM Dental College and Hospital, Visakhapatnam",
    val: 390,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "GND Dental College and Research Institute, Sunam",
    val: 391,
    isTop: "",
    created: "2025-10-01 16:39:56",
    cluster: "healthcare",
  },
  {
    text: "Goa Dental College and Hospital, Bamboli",
    val: 392,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Goa Medical College and Hospital, Bamboli",
    val: 393,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Goa Medical College, Panaji",
    val: 394,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government College of Indian Medicine and Hospital, Mysore",
    val: 395,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College and Hospital, Ahmedabad",
    val: 396,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College and Hospital, Chennai",
    val: 397,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College and Hospital, Jamnagar",
    val: 398,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College and Hospital, Mumbai",
    val: 399,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College and Hospital, Nagpur",
    val: 400,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College and Hospital, Patiala",
    val: 401,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College and Hospital, Srinagar",
    val: 402,
    isTop: "",
    created: "2025-10-01 16:39:57",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Bangalore",
    val: 403,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Homeopathic Medical College, Thiruvananthapuram",
    val: 404,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Amritsar",
    val: 405,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Aurangabad",
    val: 406,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Bellary",
    val: 407,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Dhule",
    val: 408,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Jabalpur",
    val: 409,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Jammu",
    val: 410,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Kottayam",
    val: 411,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Mangalore",
    val: 412,
    isTop: "",
    created: "2025-10-01 16:39:58",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Miraj",
    val: 413,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Mysore",
    val: 414,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Nagpur",
    val: 415,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Nanded",
    val: 416,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Patiala",
    val: 417,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Rajkot",
    val: 418,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Rohtak",
    val: 419,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Sangli",
    val: 420,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Srinagar",
    val: 421,
    isTop: "",
    created: "2025-10-01 16:39:59",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Surat",
    val: 422,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Vazirabad",
    val: 423,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Government Mohan Kumaramangalam Medical College, Salem",
    val: 424,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Government Sidha Medical College, Tirunelveli",
    val: 425,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Government Vellore Medical College, Vellore",
    val: 426,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Grants Medical College, Mumbai",
    val: 427,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "GSL Medical College, Rajahmundry",
    val: 428,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "GSVM Medical College, Kanpur",
    val: 429,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "GTB Hospital, Delhi",
    val: 430,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Guntur Medical College, Guntur",
    val: 431,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Guru Gobind Singh Medical College, Faridkot",
    val: 432,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Gurunanak Institute of Dental Science and Research, Kolkata",
    val: 433,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "Guwahati Medical College and Hospital, Guwahati",
    val: 434,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "H K D E T Dental College, Humanabad",
    val: 435,
    isTop: "",
    created: "2025-10-01 16:40:00",
    cluster: "healthcare",
  },
  {
    text: "H K E Society's M R Medical College, Gulbarga",
    val: 436,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Hi-Tech Medical College & Hospital, Bhuvaneshwar",
    val: 437,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Himachal Pradesh Dental College, Sundernagar",
    val: 438,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Himalaya Institute of Medical Sciences, Dehradun",
    val: 439,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Holy Family Hospital and college, Delhi",
    val: 440,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Holy Family Hospital, Thodupuzha",
    val: 441,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Homeopathic Medical College, Bijnor",
    val: 442,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "HP Government Dental College and Hospital, Shimla",
    val: 443,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "IIMT College of Medical Sciences, Meerut",
    val: 444,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Indian Centre for Hospital Administration (ICHA), Kochi",
    val: 445,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Indian Institute of Medical Transcription, Delhi",
    val: 446,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Indira Gandhi Medical College, Shimla",
    val: 447,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Indira Gandhi University of Medical Sciences, Patna",
    val: 448,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Indo American Academy of Medical Transcription, Delhi",
    val: 449,
    isTop: "",
    created: "2025-10-01 16:40:01",
    cluster: "healthcare",
  },
  {
    text: "Institute of Advanced Medical Studies, Delhi",
    val: 450,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Institute of Biomedical Science, Jhansi",
    val: 451,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Institute of Clinical Research India, Ahmedabad",
    val: 452,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Institute of Clinical Research India, Delhi",
    val: 453,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Institute of Clinical Research, Bangalore",
    val: 454,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Institute of Dental Sciences, Bangalore",
    val: 455,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Institute of Medical Post-Graduate Studies and Research, Ahmedabad",
    val: 456,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Institute of Medical Sciences, Rohtak",
    val: 457,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "IRT Perundurai Medical College and Research Centre, Erode",
    val: 458,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "J K K Munirajah Medical Research Foundation, Salem",
    val: 459,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "J Somaya Medical College, Mumbai",
    val: 460,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Jagadguru Sri Shivarathreeshwara Dental College and Hospital, Mysore",
    val: 461,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Jaipur Dental College, Jaipur",
    val: 462,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Jamnalal Goenka Dental College aDental College and Hospital, Akola",
    val: 463,
    isTop: "",
    created: "2025-10-01 16:40:02",
    cluster: "healthcare",
  },
  {
    text: "Jawahar Medical Foundations Annasahed Chudaman Patil Memorial Medical College, Dhule",
    val: 464,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "Jawaharlal Institute of Post Graduate Medical Education And Research, Pondicherry",
    val: 465,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "Jawaharlal Nehru Medical College, Ajmer",
    val: 466,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "Jawaharlal Nehru Medical College, Belgaum",
    val: 467,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "Jawaharlal Nehru Medical College, Bhagalpur",
    val: 468,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "Jawaharlal Nehru Medical College, Wardha",
    val: 469,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "JD Medical College, Allapuzha",
    val: 470,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "Jhelum Valley College of Medical Sciences, Srinagar",
    val: 471,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "JJM Medical College, Davanagere",
    val: 472,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "JKK Munirajah Medical Research Foundation, Namakkal",
    val: 473,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "JKK Natarajah Dental College, Salem",
    val: 474,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "JKK Natarajah Medical Research Foundation, Kumarapalayam",
    val: 475,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "JSS Dental College and Hospital, Mysore",
    val: 476,
    isTop: "",
    created: "2025-10-01 16:40:03",
    cluster: "healthcare",
  },
  {
    text: "JSS Medical College, Bangalore",
    val: 477,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "JSS Medical College, Mysore",
    val: 478,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "Jubilee Mission Medical College & Research Institute, Thrissur",
    val: 479,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "Jwawahar Lal Nehru Medical college, Aligarh",
    val: 480,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "Jyoti Rao Phulle Memorial Subharti College of Para Medical & Applied Science, Meerut",
    val: 481,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "K A P Viswanathan Government Medical College, Tiruchirapalli",
    val: 482,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "K E S C H Keluskar Hom Medical College & Hospital, Rajgarh",
    val: 483,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "K J Somaiya Medical College, Mumbai",
    val: 484,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "K L E Society's Jawaharlal Nehru Medical College, Belgaum",
    val: 485,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "K L E Societys Dental College and Hospital, Bangalore",
    val: 486,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "K L E Societys Dental College, Belgaum",
    val: 487,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "K S Hegde Medical Academy, Mangalore",
    val: 488,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "K V G Medical College, Sullia",
    val: 489,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "Kakatiya Medical College, Warangal",
    val: 490,
    isTop: "",
    created: "2025-10-01 16:40:04",
    cluster: "healthcare",
  },
  {
    text: "Kamineni Institute of Medical Sciences, Nalgonda",
    val: 491,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Kamineni Medical College, Warangal",
    val: 492,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Karnataka Institute of Medical Sciences, Hubli",
    val: 493,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Karnataka Medical College, Hubli",
    val: 494,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Katuri Medical College, Mumbai",
    val: 495,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Kempegowda Institute of Medical Science, Bangalore",
    val: 496,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "KGF College of Dental Sciences and Hospital, Kolar Gold fields",
    val: 497,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Khaja Banda Nawaz Institute of Medical Sciences, Gulbarga",
    val: 498,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Khalsa Dental College and Hospital (For Women), Mansa",
    val: 499,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Kilpauk Medical College, Chennai",
    val: 500,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "King Edward Memorial Hospital and Seth Gordhandas Sunderdas Medical College (GSMC), Mumbai",
    val: 501,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "King Edward Memorial Medical College, Mumbai",
    val: 502,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "KNH Medical College, Bhagalpur",
    val: 503,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Konaseema Institute of Medical Sciences & Research Foundation, East Godavari",
    val: 504,
    isTop: "",
    created: "2025-10-01 16:40:05",
    cluster: "healthcare",
  },
  {
    text: "Kothari Medical Centre & Research Institute, Kolkata",
    val: 505,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Kothiwal Dental College, Moradabad",
    val: 506,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Kovai Medical Centre & Hospital, Coimbatore",
    val: 507,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Krishna Institute of Medical Sciences, Satara",
    val: 508,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Krishnadevaraya College of Dental Sciences, Bangalore",
    val: 509,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Kurnool Medical College, Kurnool",
    val: 510,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "KVG Dental College and Hospital, Dakshina Kannada",
    val: 511,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "L T M Medical College, Mumbai",
    val: 512,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Lady Harding Medical College, Delhi",
    val: 513,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Lal Bahadur Homeopathic Medical College, Allahabad",
    val: 514,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Lal Bahadur Homeopathic Medical College, Lucknow",
    val: 515,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "LLRM Medical College, Meerut",
    val: 516,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Lok Manya Tilak Municipal Medical College, Mumbai",
    val: 517,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "M S Ramaiah Dental College, Bangalore",
    val: 518,
    isTop: "",
    created: "2025-10-01 16:40:06",
    cluster: "healthcare",
  },
  {
    text: "Shri MP Shah Medical College, Jamnagar",
    val: 519,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Madras Medical College and Research Institute, Chennai",
    val: 520,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Madurai Medical College, Madurai",
    val: 521,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Maeer Punes MIMS and Research Hospital and College, Pune",
    val: 522,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Mahadevappa Rampure Medical College, Gulbarga",
    val: 523,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Maharaja Agrasen Institute of Medical Research and Education, Hissar",
    val: 524,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Maharajah's Institute of Medical Sciences, Vizianagaram",
    val: 525,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Maharani Laxmi Bai Medical College, Jhansi",
    val: 526,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Maharashtra Institute of Medical Science and Research, Pune",
    val: 527,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Maharishi Dayanand Medical College, Rohtak",
    val: 528,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Maharishi Markandeshwar College of Dental Science & Research, Ambala",
    val: 529,
    isTop: "",
    created: "2025-10-01 16:40:07",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Dental College, Pondicherry",
    val: 530,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Institute of Medical Sciences, Agra",
    val: 531,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Institute of Medical Sciences, Wardha",
    val: 532,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Medical College and Hospital, Jaipur",
    val: 533,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Medical College, Navi Mumbai",
    val: 534,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Memorial Medical College, Indore",
    val: 535,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Missions Medical College & Hospital, New Aurangabad",
    val: 536,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Missions Medical College, Navi Mumbai",
    val: 537,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi University School of Medical Education, Angamally",
    val: 538,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Vidyamandir's Dental College & Hospital, Nashik",
    val: 539,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Malankara Orthodox & Syrian Church Medical College, Kochi",
    val: 540,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mamta Medical College, Khammam",
    val: 541,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Mandya Institute of Medical Sciences, Mandya",
    val: 542,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Manipal College of Dental Sciences (MCODS), Manipal",
    val: 543,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "MAPLES-International Institute of Aviation Hospitality and Travel & Tourism, Delhi",
    val: 544,
    isTop: "",
    created: "2025-10-01 16:40:08",
    cluster: "healthcare",
  },
  {
    text: "Maratha Mandal's Dental College and Research Centre, Belgaum",
    val: 545,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Maratha Mandals Dental College and Hospital, Belgaum",
    val: 546,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Maruti College of Dental Sciences and Research Centre, Bangalore",
    val: 547,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Mathrushree Ramabai Ambedkar Dental College and Hospital, Bangalore",
    val: 548,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "MBBS College Uttar Pradesh Technical University, Agra",
    val: 549,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Agra",
    val: 550,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Jaipur",
    val: 551,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Kota",
    val: 552,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Kozhikode",
    val: 553,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Mulagunnthukavu",
    val: 554,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Nagpur",
    val: 555,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Pune",
    val: 556,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Rajkot",
    val: 557,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Thiruvananthapuram",
    val: 558,
    isTop: "",
    created: "2025-10-01 16:40:09",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Thrissur",
    val: 559,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "Medical College, Vadodara",
    val: 560,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "Medical Library Association of India, Delhi",
    val: 561,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "Medical university Pravara Institute of Medical Sciences, Loni",
    val: 562,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "Meenakshi Ammal Dental College and Hospital, Chennai",
    val: 563,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "Meenakshi Medical College and Research Institute, Kanchipuram",
    val: 564,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "Meenakshi Mission Hospital and Research Centre, Madurai",
    val: 565,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "MET Institute of Medical Sciences, Mumbai",
    val: 566,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "MGM Medical College, Aurangabad",
    val: 567,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "MGM Medical College, Jamshedpur",
    val: 568,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "MGM Medical College, Mumbai",
    val: 569,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "MIMSR Medical College, Latur",
    val: 570,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "Mithila Minority Dental College and Hospital, Darbhanga",
    val: 571,
    isTop: "",
    created: "2025-10-01 16:40:10",
    cluster: "healthcare",
  },
  {
    text: "MKCG Medical College, Berhampur",
    val: 572,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "MLB Medical college, Jhansi",
    val: 573,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "MM College of Dental Sciences & Research, Ambala",
    val: 574,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "MN Dav Dental College, Solan",
    val: 575,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "MNDAV Dental College, Tatul",
    val: 576,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "MNR Medical College, Sangareddy",
    val: 577,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "Mohameddia Tibbia College and Assayer Hospital, Nashik",
    val: 578,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "Motilal Nehru Medical College, Allahabad",
    val: 579,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "MR Medical College, Gulbarga",
    val: 580,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "Municipal Eye Hospital, Mumbai",
    val: 581,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "Municipal Institute of Medical Education and Research, Surat",
    val: 582,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "MVJ Medical College and Research Hospital, Bangalore",
    val: 583,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "Mysore Medical College, Mysore",
    val: 584,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "Nair Hospital Dental College, Mumbai",
    val: 585,
    isTop: "",
    created: "2025-10-01 16:40:11",
    cluster: "healthcare",
  },
  {
    text: "Nalanda Medical College, Patna",
    val: 586,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "Narayana Medical College, Nellore",
    val: 587,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "Nashik District Maratha Vidya Prasarak Samajs Medical College, Agra",
    val: 588,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "National Medical College, Kolkata",
    val: 589,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "Navodaya Medical College, Raichur",
    val: 590,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "NDMVP Medical College, Nashik",
    val: 591,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "NDMVP Samajs Medical College, Shivajinagar",
    val: 592,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "NE Regional Medical College, Imphal",
    val: 593,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "Nehru Smaraka Vidya Kendra Sri Venkateswara Dental College, Bangalore",
    val: 594,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "Netaji Subhash Chandra Bose Medical College, Jabalpur",
    val: 595,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "Nitishwar Institute of Medical Sciences, Muzaffarpur",
    val: 596,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "Nittte Institute of Medical Laboratory Sciences, Mangalore",
    val: 597,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "Nizam's Institute of Medical Sciences, Hyderabad",
    val: 598,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "NKP Salve Institute of Medical Sciences and Research Centre, Nagpur",
    val: 599,
    isTop: "",
    created: "2025-10-01 16:40:12",
    cluster: "healthcare",
  },
  {
    text: "North Bengal Dental College, Darjeeling",
    val: 600,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "North Bengal Medical College, Siliguri",
    val: 601,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "NR Sircar Medical College, Kolkata",
    val: 602,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "NRI Medical College, Guntur",
    val: 603,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "NRS Medical College, Kolkata",
    val: 604,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "NSVK Sri Venkateshwara Dental College and Hospital, Bangalore",
    val: 605,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "NTR University of Health Sciences Dental College, Vijayawada",
    val: 606,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "Orissa Homeopathic Medical College & Hospital, Sambalpur",
    val: 607,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "Orthopaedic Hospital Medicine and Post Graduate Training Centre of Swasthiyog Prabhodini, Miraj",
    val: 608,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "P E S Institute of Medical Sciences and Research, Chittoor",
    val: 609,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "Pacific Dental College and Research Center, Udaipur",
    val: 610,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "Padmashree College of Hospital Administration, Bangalore",
    val: 611,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "Patliputra Medical College, Dhanbad",
    val: 612,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "Patna Dental College and Hospital, Patna",
    val: 613,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "Patna Medical College, Patna",
    val: 614,
    isTop: "",
    created: "2025-10-01 16:40:13",
    cluster: "healthcare",
  },
  {
    text: "People's College of Dental Sciences and Research Centre, Bhopal",
    val: 615,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "People's College of Medical Sciences & Research Centre, Bhopal",
    val: 616,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "Perundurai Medical College & Research Centre, Perundurai",
    val: 617,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "PM Nadagowda Memorial Dental College and Hospital, Bagalkot",
    val: 618,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "PM Nadagunda Memorial Dental College and Hospital, Bikaner",
    val: 619,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "Pondicherry Dental College, Pondicherry",
    val: 620,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "Pramukh Swami Medical College, Karamsad",
    val: 621,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "Prathima Institute of Medical Sciences, Karimnagar",
    val: 622,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "Pravara Institute of Medical Sciences, Ahmednagar",
    val: 623,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "Pravara Rural Dental College, Ahmednagar",
    val: 624,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "PSG Institute and Medical College, Coimbatore",
    val: 625,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "PSG Institute of Medical Sciences and Research, Coimbatore",
    val: 626,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "PSI Medical College, Krishna",
    val: 627,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "Pt B D Sharma Postgraduate Institute of Medical Sciences, Rohtak",
    val: 628,
    isTop: "",
    created: "2025-10-01 16:40:14",
    cluster: "healthcare",
  },
  {
    text: "Pt BD Sharma Post-Graduate Institute o Medical Sciences Guru Jambeswar University, Hissar",
    val: 629,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Pt Bhagwat Dayal Sharma PG Institute of Medical Sciences, Bahadurgarh",
    val: 630,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Pt Jawaharlal Nehru Memorial Medical College, Raipur",
    val: 631,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "PT School and Central Government Medical College, Nagpur",
    val: 632,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Pt. Deendayal Upadhyay Memorial Health Sciences and Ayush University of Chhattisgarh",
    val: 633,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Punjab Government Dental College and Hospital, Amritsar",
    val: 634,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "PV Narasimha Rao Medical College, Dehradun",
    val: 635,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "R A Poddar Medical College (Ayur), Mumbai",
    val: 636,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "R D Gardi Medical College, Surasa",
    val: 637,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Ragas Dental College & Hospital, Chennai",
    val: 638,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Raja Rajeshwari Dental College and Hospital, Bangalore",
    val: 639,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Raja Rajeshwari Medical College and Hospital, Bangalore",
    val: 640,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Rajah Muthiah Medical College, Annamalainagar",
    val: 641,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Rajarajeswari Medical College & Hospital, Bangalore",
    val: 642,
    isTop: "",
    created: "2025-10-01 16:40:15",
    cluster: "healthcare",
  },
  {
    text: "Rajas Dental College, Chennai",
    val: 643,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rajeev Gandhi Homeopathic Medical College, Bhopal",
    val: 644,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rajeev Gandhi Medical College, Thane",
    val: 645,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rajendra Medical College, Ranchi",
    val: 646,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rajiv Gandhi Dental College, Bangalore",
    val: 647,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rajiv Gandhi Institute of Medical Sciences, Kadapa",
    val: 648,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rajiv Gandhi Medical College & C S M Hosp, Thane",
    val: 649,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rama Dental College Hospital and Research Centre, Kanpur",
    val: 650,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rama Krishna Ayurved Medical College, Bangalore",
    val: 651,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rama Medical College Hospital and Research Centre, Kanpur",
    val: 652,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Ramrao Adik Education Societys Dental College, Navi Mumbai",
    val: 653,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Rangaraja Medical College, Kakinada",
    val: 654,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Regional Dental College, Guwahati",
    val: 655,
    isTop: "",
    created: "2025-10-01 16:40:16",
    cluster: "healthcare",
  },
  {
    text: "Regional Institute of Medical Sciences, Imphal",
    val: 656,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "Regional Medical Research Centre, Port Blair",
    val: 657,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "RG Kar Medical College, Kolkata",
    val: 658,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "RNT Medical College, Udaipur",
    val: 659,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "Rural Medical College, Loni",
    val: 660,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "RV Dental College, Bangalore",
    val: 661,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "S N Medical College, Agra",
    val: 662,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "S Nijalingappa Institute of Dental Sciences and Research, Gulbarga",
    val: 663,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "S Nijalingappa Medical College & HSK Hospital, Bagalkot",
    val: 664,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "S R T R Medical College, Beed",
    val: 665,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "S S Institute of Medical Sciences& Research Centre, Davanagere",
    val: 666,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "S V S Medical College, Mahaboobnagar",
    val: 667,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "Samaritan Hospital, Aluva",
    val: 668,
    isTop: "",
    created: "2025-10-01 16:40:17",
    cluster: "healthcare",
  },
  {
    text: "Sanjeevan Medical Foundations ENT Postgraduate Training Institute, Miraj",
    val: 669,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Sankara Nethralaya Medical Research Foundation, Chennai",
    val: 670,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Santhiram Medical College, Kurnool",
    val: 671,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Santosh Medical and Dental College, Ghaziabad",
    val: 672,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Saraswati Dental College, Lucknow",
    val: 673,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Sardar Bhagwan Singh Post Graduate Institute of Biomedical Sciences and Research, Dehradun",
    val: 674,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Sardar Patel institute of Dental and Medical Sciences, Dhar",
    val: 675,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Sardar Patel Institute of Dental Science, Lucknow",
    val: 676,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Sardar Patel Medical College, Bikaner",
    val: 677,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Sarjug Dental College, Aheri",
    val: 678,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "Saveetha Dental College and Hospital, Chennai",
    val: 679,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "SB Patil Institute for Dental Sciences and Research, Bidar",
    val: 680,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "SCB Medical College, Cuttack",
    val: 681,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "SDM College of Dental Sciences and Hospital, Dharwad",
    val: 682,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "SDM Medical College, Dharwad",
    val: 683,
    isTop: "",
    created: "2025-10-01 16:40:18",
    cluster: "healthcare",
  },
  {
    text: "SDME Societys College of Dental Science and Hospital, Dharwad",
    val: 684,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "SGS Medical College & KEM Hospital, Mumbai",
    val: 685,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "SGT Dental College, Rohtak",
    val: 686,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Sham-e-Ghausia Minority Ayurved Medical College, Ghazipur",
    val: 687,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Shankrechariyar Dental College, Salem",
    val: 688,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Sharad Pawar Dental College, Wardha",
    val: 689,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Sharavathi Dental College and Hospital, Shimoga",
    val: 690,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Sharma Hospital, Junagarh",
    val: 691,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Sher-I-Kashmir Institute of Medical Sciences, Srinagar",
    val: 692,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Shiksahana Prasanna Samithis Dhanvanthri Ayruvedic Medical College, Dharwad",
    val: 693,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Shiva Dental College and Hospital, Chandigarh",
    val: 694,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Shri Aurobindo Institute of Medical Sciences, Indore",
    val: 695,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Shri B M Patil Medical College, Vijayapur",
    val: 696,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Shri Baba Mast Nath Dental College and Hospital, Rohtak",
    val: 697,
    isTop: "",
    created: "2025-10-01 16:40:19",
    cluster: "healthcare",
  },
  {
    text: "Shri Bhausaheb Hire Government Medical College, Dhule",
    val: 698,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Shri BM Patil Medical College, Bijapur",
    val: 699,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Shri Durgaji Homeopathic Medical College, Azamgarh",
    val: 700,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Shri Ram Murti Smarak Institute of Medical Sciences, Bareilly",
    val: 701,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Shri Vasantrao Naik Government Medical College, Yavatmal",
    val: 702,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Shyam Shah Medical College, Rewa",
    val: 703,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Sikkim Manipal University of Health Medical and Technological Sciences, Gangtok",
    val: 704,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Silchar Medical College, Silchar",
    val: 705,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "SJM Dental College and Hospital, Chitradurga",
    val: 706,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "SMS Dental College, Jaipur",
    val: 707,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "SMS Medical College, Jaipur",
    val: 708,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Smt NHL Municipal Medical College, Ahmedabad",
    val: 709,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "Smt RM Memorial Dental College, Wardha",
    val: 710,
    isTop: "",
    created: "2025-10-01 16:40:20",
    cluster: "healthcare",
  },
  {
    text: "SMVMCH Sri Manakula Vinaynagar Medical College, Pondicherry",
    val: 711,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Speed Medical Institute, Chennai",
    val: 712,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sree Gokulam Medical College & Research Foundation, Thiruvananthapuram",
    val: 713,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sree Sevalal College of Dental Sciences and Hospital, Bangalore",
    val: 714,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sree Uthradom Thiurnal Academy of Medical Sciences, Thiruvananthapuram",
    val: 715,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri AB Shetty Memorial Institute of Dental Sciences, Dakshina Kannada",
    val: 716,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Devaraj Urs Medical College, Kolar",
    val: 717,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Guru Ram Das Institute of Dental Sciences and Research, Amritsar",
    val: 718,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Guru Ram Das Institute of Medical Education and Research, Amritsar",
    val: 719,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Hasanamba Dental College, Hassan",
    val: 720,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Jagadguru Jayadeva Murugarajendra Dental College and Hospital, Chitradurga",
    val: 721,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Krishna Medical College, Muzaffarpur",
    val: 722,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Nijalingappa Institute of Dental Sciences, Hassan",
    val: 723,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Rajiv Gandhi College of Dental Science & Hospital, Bangalore",
    val: 724,
    isTop: "",
    created: "2025-10-01 16:40:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Ram Chandra Bhanja Medical College, Cuttack",
    val: 725,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Ramachandra College of Allied Health Science Institution, Chennai",
    val: 726,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Ramachandra Dental College, Chennai",
    val: 727,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Ramakrishna Dental College and Hospital, Coimbatore",
    val: 728,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Sairam Ayurved Medical College & Research Centre, Tiruchirapalli",
    val: 729,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Venkateshwara Institute of Medical Sciences, Tirupati",
    val: 730,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Venkateswara Medical College, Tirupati",
    val: 731,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "SRM Dental College and Hospital, Chennai",
    val: 732,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "SSR Medical College, Delhi",
    val: 733,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "State Takmil-Ut-Tib College and Hospital, Lucknow",
    val: 734,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Subharti Dental College, Meerut",
    val: 735,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Subharti Medical College, Meerut",
    val: 736,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Surya Mukhi Dinesh Ayurved Medical College, Ranchi",
    val: 737,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Susrutha Institute of Medical Science, Hyderabad",
    val: 738,
    isTop: "",
    created: "2025-10-01 16:40:22",
    cluster: "healthcare",
  },
  {
    text: "Swami Ramanand Teerth Rural Medical College, Ambajogai",
    val: 739,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "T Choihram Hospital & Research Centre, Indore",
    val: 740,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "T D Homeopathic Medical College, Jaunpur",
    val: 741,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "T D Medical College, Thiruvananthapuram",
    val: 742,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "T N Medical College & B Y L Nair Ch Hospital, Mumbai",
    val: 743,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "Taj Tibbia College and Rasheedia Hospital, Nagpur",
    val: 744,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "Tamil Nadu Government Dental College and Hospital, Chennai",
    val: 745,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "Tamil Nadu Hospital, Chennai",
    val: 746,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "TD Medical College, Allepey",
    val: 747,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "Thai Moogabigai Dental College and Hospital, Chennai",
    val: 748,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "Thane Municipal Corporations Rajiv Gandhi Medical College, Thane",
    val: 749,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "Thanjavur Medical College, Thanjavur",
    val: 750,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "The Calcutta Medical Research Institute, Kolkata",
    val: 751,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "The Oxford Dental College, Bangalore",
    val: 752,
    isTop: "",
    created: "2025-10-01 16:40:23",
    cluster: "healthcare",
  },
  {
    text: "The Tamilnadu Dr M G R Medical University, Chennai",
    val: 753,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "The TD Medical College, Alappuzha",
    val: 754,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Thoothukudi Medical College, Thoothukudi",
    val: 755,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Tibbia College and Hospital, Mumbai",
    val: 756,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Tirunelveli Medical College, Tirunelveli",
    val: 757,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "TN Medical College, Mumbai",
    val: 758,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Topiwala National Medical College, Mumbai",
    val: 759,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Trinity Mission and Medical Foundation, Madurai",
    val: 760,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "U P Dental College & Research Centre, Lucknow",
    val: 761,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "UHS Dental College, Vijayawada",
    val: 762,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Universal Empire Institute of Medical Sciences, Kochi",
    val: 763,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "University College of Medical Sciences, Delhi",
    val: 764,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Vardhman Mahavir Medical College and Safdarjung Hospital, New Delhi",
    val: 765,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Vardhman Medical College, Karimnagar",
    val: 766,
    isTop: "",
    created: "2025-10-01 16:40:24",
    cluster: "healthcare",
  },
  {
    text: "Vasant Dada Patil Dental College and Hospital, Sangli",
    val: 767,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Venkataeswara Homeopathic medical college, Chennai",
    val: 768,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vidarbha Youth Welfare Societys Dental College and Hospital, Amravati",
    val: 769,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vijaynagar Institute of Medical Sciences, Bellary",
    val: 770,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vinayak Mission Dental College, Sitapur",
    val: 771,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vinayaka Mission Sankarachariyar Dental College, Salem",
    val: 772,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vinayaka Missions Kirupananda Variyar Medical College, Salem",
    val: 773,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vivekananda Institute of Medical Sciences, Kolkata",
    val: 774,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vivekanandha Institute of Medical Science and Research, Salem",
    val: 775,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vokkaligara Sangha Dental College, Bangalore",
    val: 776,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "VSPMs Dental College and Research Centre, Nagpur",
    val: 777,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "VSS Medical College, Sambalpur",
    val: 778,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Vydehi Institute of Medical Sciences & Research Centre, Bangalore",
    val: 779,
    isTop: "",
    created: "2025-10-01 16:40:25",
    cluster: "healthcare",
  },
  {
    text: "Wockgardt Hospital & Heart Institute, Bangalore",
    val: 780,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Yenepoya Dental College, Mangalore",
    val: 781,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Yenepoya Medical College, Mangalore",
    val: 782,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Yuvraj PS Memorial Homeo Medical College and Hospital, Alwar",
    val: 783,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Clinical Research Institute",
    val: 784,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Prasad Institute of Medical Science",
    val: 785,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Institute of Clinical Research India, Mumbai",
    val: 786,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "King Georges Medical College, Lucknow",
    val: 787,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Shridevi Institute Of Medical Sciences & Research Hospital, Tumkur",
    val: 788,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Inderprastha Dental College & Hospital, Ghaziabad",
    val: 789,
    isTop: "",
    created: "2025-10-01 16:40:26",
    cluster: "healthcare",
  },
  {
    text: "Asian Institute of Hospitality and Tourism (AIHT), Noida",
    val: 790,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Adesh Medical College and Hospital (AMCH), Kurukshetra",
    val: 791,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Adhiparasakthi Dental College And Hospital, Kanchipuram",
    val: 792,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Akash Institute of Medical Sciences and Research Centre (AIMSRC), Bengaluru",
    val: 793,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Agartala Government Medical College (AGMC), Agartala",
    val: 794,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Al Azhar Medical College and Super Speciality Hospital, Idukki",
    val: 795,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Ananta Institute of Medical Sciences and Research Centre, Rajsamand",
    val: 796,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Anil Neerukonda Institute of Dental Sciences, Visakhapatnam",
    val: 797,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Annoor Dental College and Hospital, Muvattupuzha",
    val: 798,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Apollo Institute of Medical Sciences and Research (AIMSR), Hyderabad",
    val: 799,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Asan Memorial Dental College and Hospital (AMDECH), Chengalpattu",
    val: 800,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Arunai Medical College and Hospital, Tiruvannamalai",
    val: 801,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Azeezia College of Dental Sciences and Research, Kollam",
    val: 802,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Azeezia Institute of Medical Sciences and Research, Kollam",
    val: 803,
    isTop: "",
    created: "2025-10-01 16:40:27",
    cluster: "healthcare",
  },
  {
    text: "Autonomous State Medical College, Etah",
    val: 804,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Autonomous State Medical College, Hardoi",
    val: 805,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Awadh Dental College And Hospital, Jamshedpur",
    val: 806,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Bangalore Baptist Hospital (BBH), Bengaluru",
    val: 807,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Bangalore Baptist Hospital, Bengaluru",
    val: 808,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "BGS Global Institute of Medical Sciences, Bengaluru",
    val: 809,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Basaveshwara Medical College and Hospital, Chitradurga",
    val: 810,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Bhagwan Mahaveer Cancer Hospital and Research Centre (BMCHRC), Jaipur",
    val: 811,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Believers Church Medical College, Pathanamthitta",
    val: 812,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Bhima Bhoi Medical College and Hospital, Balangir",
    val: 813,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Bhojia Dental College, Baddi",
    val: 814,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Bhopal Memorial Hospital and Research Centre, Bhopal",
    val: 815,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Bidar Institute of Medical Sciences, Bidar",
    val: 816,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "BSD College of Allied Health Sciences, Coimbatore",
    val: 817,
    isTop: "",
    created: "2025-10-01 16:40:28",
    cluster: "healthcare",
  },
  {
    text: "Bundelkhand Medical College, Sagar",
    val: 818,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Burdwan Institute of Medical and Life Sciences, Bardhaman",
    val: 819,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Century International Institute of Dental Sciences and Research Centre, Kasargode",
    val: 820,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Career Institute of Medical Sciences and Hospital, Lucknow",
    val: 821,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Career Post Graduate Institute of Dental Sciences and Hospitals, Lucknow",
    val: 822,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Chamarajanagar Institute of Medical Sciences, Chamarajanagar",
    val: 823,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Chandra Dental College and Hospital, Lucknow",
    val: 824,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Chettinad Dental College And Research Institute, Kanchipuram",
    val: 825,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Chhattisgarh Ayurved Medical College, Alwar",
    val: 826,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Chhattisgarh Institute of Medical Science (CIMS), Bilaspur",
    val: 827,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Chikkaballapura Institute of Medical Sciences, Chikkaballapura",
    val: 828,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Chikkamagaluru Institute of Medical Sciences, Chikmagalur",
    val: 829,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "Chitradurga Medical College and Research Institute, Chitradurga",
    val: 830,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "CKS Teja Institute of Dental Sciences and Research, Tirupati",
    val: 831,
    isTop: "",
    created: "2025-10-01 16:40:29",
    cluster: "healthcare",
  },
  {
    text: "CMR Institute of Medical Sciences, Medchal",
    val: 832,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "College of Dental Science and Research Centre, Ahmedabad",
    val: 833,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "College of Hospitality Administration (CHA), Jaipur",
    val: 834,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "College of Hospitality Administration, Jaipur",
    val: 835,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "College of Medicine and JNM Hospital, Kalyani",
    val: 836,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "College of Medicine and Sagore Dutta Hospital, Sagar",
    val: 837,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Coorg Institute of Dental Sciences, Virajpet",
    val: 838,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Darshan Dental College and Hospital, Udaipur",
    val: 839,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Daswani Dental College and Research Centre, Kota",
    val: 840,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Deben Mahata Government Medical College and Hospital, Purulia",
    val: 841,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Dhanalakshmi Srinivasan Medical College and Hospital, Perambalur",
    val: 842,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Doon Institute of Medical Sciences, Dehradun",
    val: 843,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Diphu Medical College and Hospital, Karbi Anglong",
    val: 844,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Dr Abdul Ali Tibbiya College and Hospital, Lucknow",
    val: 845,
    isTop: "",
    created: "2025-10-01 16:40:30",
    cluster: "healthcare",
  },
  {
    text: "Dr Hedgewar Smruti Rugna Seva Mandal's Dental College, Hingoli",
    val: 846,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Dr Kiran C Patel Medical College and Research Institute, Bharuch",
    val: 847,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Dr Rajendra Gode Medical College, Amravati",
    val: 848,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Dr Ram Manohar Lohia Institute of Medical Sciences, Lucknow",
    val: 849,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Dr Sudha and Nageswara Rao Inst of Dental Sciences, Krishna",
    val: 850,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Dr Vasantrao Pawar Medical College Hospital and Research Centre, Nashik",
    val: 851,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Educare Institute of Dental Sciences, Malappuram",
    val: 852,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Fathima Institute of Medical Sciences, Kadapa",
    val: 853,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "ESIC Dental College, Kalburagi",
    val: 854,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "ESIC Medical College and Hospital, Alwar",
    val: 855,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "ESIC Medical College and Hospital, Faridabad",
    val: 856,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "ESIC Medical College and Hospital, Sedam",
    val: 857,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Fakhruddin Ali Ahmed Medical College, Barpeta",
    val: 858,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "G Kuppuswamy Naidu Memorial Hospital, Coimbatore",
    val: 859,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Gadag Institute of Medical Sciences, Gadag",
    val: 860,
    isTop: "",
    created: "2025-10-01 16:40:31",
    cluster: "healthcare",
  },
  {
    text: "Father Colombo Institute of Medical Sciences, Warangal",
    val: 861,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "GCS Hospital, Medical College and Research Centre, Ahmedabad",
    val: 862,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "Gem Hospital And Research Centre, Chennai",
    val: 863,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "Gem Hospital and Research Centre, Coimbatore",
    val: 864,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "Gesto Culinary and Hospitality Academy, Hyderabad",
    val: 865,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "Gian Sagar Medical College and Hospital, Banur",
    val: 866,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "GITAM Institute of Medical Sciences and Research, Visakhapatnam",
    val: 867,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "Global College of Allied Health Sciences, Kanniyakumari",
    val: 868,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "Goenka Research Institute of Dental Science, Gandhinagar",
    val: 869,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "GMERS Medical College, Junagadh",
    val: 870,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "GMERS Medical College, Patan",
    val: 871,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "GMERS Medical College, Rajpipla",
    val: 872,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "Gouri Devi Institute of Medical Sciences and Hospital (GIMSH), Durgapur",
    val: 873,
    isTop: "",
    created: "2025-10-01 16:40:32",
    cluster: "healthcare",
  },
  {
    text: "GNIOT Institute of Medical Sciences and Research, Greater Noida",
    val: 874,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Goa College of Hospitality and Culinary Education, North Goa",
    val: 875,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Dholpur",
    val: 876,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Raipur",
    val: 877,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Rajanna Sircilla",
    val: 878,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Government Institute of Medical Sciences (GIMS), Greater Noida",
    val: 879,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Government Theni Medical College, Theni",
    val: 880,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Government Tibbi College and Hospital, Patna",
    val: 881,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Government Tiruvannamalai Medical College and Hospital, Tiruvannamalai",
    val: 882,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "GR Medical College Hospital and Research Centre, Dakshina Kannada",
    val: 883,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Grace College of Allied Health Sciences, Kanniyakumari",
    val: 884,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Gujarat Adani Institute of Medical Science, Bhuj",
    val: 885,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Great Eastern Medical School and Hospital, Kolkata",
    val: 886,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Great Eastern Medical School and Hospital, Srikakulam",
    val: 887,
    isTop: "",
    created: "2025-10-01 16:40:33",
    cluster: "healthcare",
  },
  {
    text: "Guru Teg Bahadur Para Medical, Shahjahanpur",
    val: 888,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Gurukrupa College of Medical Science, Umarkote",
    val: 889,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Haldia Institute of Dental Sciences and Research, Medinipur",
    val: 890,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Hillwood Medical School, Bulandshahr",
    val: 891,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Himachal Institute of Dental Sciences, Paonta Sahib",
    val: 892,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Hassan Institute of Medical Sciences, Hassan",
    val: 893,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Haveri Institute of Medical Sciences, Haveri",
    val: 894,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Hazaribag College of Dental Sciences and Hospital, Hazaribag",
    val: 895,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Hind Institute of Medical Sciences, Sitapur",
    val: 896,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Hi-Tech Dental College and Hospital, Bhubaneswar",
    val: 897,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "ICARE Institute of Medical Sciences and Research, Haldia",
    val: 898,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Homi Bhabha Cancer Hospital (HBCH), Sangrur",
    val: 899,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Homi Bhabha Cancer Hospital, Varanasi",
    val: 900,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "IMB School of Hospitality, Khordha",
    val: 901,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Indira Medical College and Hospitals, Thiruvallur",
    val: 902,
    isTop: "",
    created: "2025-10-01 16:40:34",
    cluster: "healthcare",
  },
  {
    text: "Indian Institute of Ayurved Research and Hospital, Rajkot",
    val: 903,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Institute of Medical Sciences and SUM Hospital (IMS), Bhubaneswar",
    val: 904,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Institute of Mental Health and Hospital, Agra",
    val: 905,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Jagadguru Gangadhar Mahaswamigalu Moorsavirmath Medical College, Hubli",
    val: 906,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "IQ City Medical College, Bardhaman",
    val: 907,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Jannayak Karpuri Thakur Medical College and Hospital, Madhepura",
    val: 908,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Jaipur National University Institute for Medical Sciences and Research Centre, Jaipur",
    val: 909,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Jawaharlal Nehru Institute of Medical Sciences, Imphal",
    val: 910,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Jan Nayak Choudhary Devi Lal Dental College, Sirsa",
    val: 911,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Jhargram Government Medical College and Hospital (JGMCH), Jhargram",
    val: 912,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "JMF's ACPM Dental College, Dhule",
    val: 913,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Kalka Dental College, Karondna",
    val: 914,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Karpaga Vinayaga Institute of Dental Sciences, Kanchipuram",
    val: 915,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Karpaga Vinayaga Institute of Medical Sciences and Research Centre, Kanchipuram",
    val: 916,
    isTop: "",
    created: "2025-10-01 16:40:35",
    cluster: "healthcare",
  },
  {
    text: "Kanachur Institute of Medical Sciences, Mangaluru",
    val: 917,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Karwar Institute of Medical Sciences, Karwar",
    val: 918,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "KD Medical College Hospital and Research Centre, Mathura",
    val: 919,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "KDMGs Ayurved Medical College, Chalisgaon",
    val: 920,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "KIMS Dental College, Amalapuram",
    val: 921,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Kingston Imperial Institute of Medical Sciences, Dehradun",
    val: 922,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "KMCT College of Allied Health Science, Kozhikode",
    val: 923,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Koppal Institute of Medical Sciences, Koppal",
    val: 924,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Kusum Devi Sunderlal Dugar Jain Dental College and Hospital, Kolkata",
    val: 925,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Lenora Institute of Dental Sciences, Rajahmundry",
    val: 926,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Little Flower Institute of Medical Science and Research, Ernakulam",
    val: 927,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Luxmi Bai Institute of Dental Sciences and Hospital, Patiala",
    val: 928,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Lourde Institute of Allied Health Sciences, Kannur",
    val: 929,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Maa Vindhyavasini Autonomous State Medical College, Mirzapur",
    val: 930,
    isTop: "",
    created: "2025-10-01 16:40:36",
    cluster: "healthcare",
  },
  {
    text: "Madha Medical College and Hospital, Kanchipuram",
    val: 931,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Maharaja Ganga Singh Dental College, Ganganagar",
    val: 932,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Maharaja Suhel Dev Autonomous State Medical College and Maharishi Balark Hospital Kdc, Bahraich",
    val: 933,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Maharana Pratap Dental College and Hospital, Kanpur",
    val: 934,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Maharshi Devraha Baba Autonomous State Medical College (MDBMC), Deoria",
    val: 935,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Maharshi Vishwamitra Autonomous State Medical College, Ghazipur",
    val: 936,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Maharashtra Institute of Dental Sciences and Research Dental College, Latur",
    val: 937,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Maharashtra Institute of Medical Sciences and Research (MIMSR), Latur",
    val: 938,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Mahaveer Institute of Medical Sciences and Research, Bhopal",
    val: 939,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Malabar Dental College and Research Centre, Malappuram",
    val: 940,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Malabar Medical College and Research Centre, Kozhikode",
    val: 941,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Malla Reddy Institute of Dental sciences (MRIDS), Hyderabad",
    val: 942,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Malla Reddy Institute of Medical Sciences, Hyderabad",
    val: 943,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Manonidhi Institute of Allied Health Sciences, Chamarajanagar",
    val: 944,
    isTop: "",
    created: "2025-10-01 16:40:37",
    cluster: "healthcare",
  },
  {
    text: "Mar Baselios Dental College, Kothamangalam",
    val: 945,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Matoshri Asarabai Darade Homeopathic and Medical College, Nashik",
    val: 946,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Maulana Azad Institute of Dental Sciences, New Delhi",
    val: 947,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Melaka Manipal Medical College, Udupi",
    val: 948,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Melmaruvathur Adhiparasakthi Institute of Medical Sciences and Research, Kanchipuram",
    val: 949,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Mims College of Allied Health Sciences, Kozhikode",
    val: 950,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Modern Dental College, Indore",
    val: 951,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "MOSC Institute of Allied Health Sciences, Ernakulam",
    val: 952,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "MR Ambedkar Dental College and Hospital Institute, Bengaluru",
    val: 953,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Muzaffarnagar Medical College, Muzaffarnagar",
    val: 954,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Nagaon Medical College and Hospital, Nagaon",
    val: 955,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Narayana Dental College and Hospital, Nellore",
    val: 956,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Narsinhbhai Patel Dental College and Hospital, Visnagar",
    val: 957,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Nanded Rural Dental College and Research Centre, Nanded",
    val: 958,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "Nandha Medical College and Hospital, Erode",
    val: 959,
    isTop: "",
    created: "2025-10-01 16:40:38",
    cluster: "healthcare",
  },
  {
    text: "National Dental College, Dera Bassi",
    val: 960,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Nimra Institute of Medical Sciences, Krishna",
    val: 961,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "NRI Institute of Medical Sciences, Visakhapatnam",
    val: 962,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "North Delhi Municipal Corporation Medical College, New Delhi",
    val: 963,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "North Eastern Indira Gandhi Regional Institute of Health and Medical Sciences (NEIGRIHMS), Shillong",
    val: 964,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "OPR Memorial College of Para Medical Sciences, Cuddalore",
    val: 965,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Pandit Deendayal Upadhyaya Medical College, Churu",
    val: 966,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Pandit Raghunath Murmu Medical College and Hospital ,Mayurbhanj",
    val: 967,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Pandit Raghunath Murmu Medical College and Hospital, Baripada",
    val: 968,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Panineeya Mahavidyalaya Institute of Dental Sciences and Research Centre, Hyderabad",
    val: 969,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "PGP Institute of Allied Health Sciences, Namakkal",
    val: 970,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "PK DAS Institute of Medical Sciences, Palakkad",
    val: 971,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Post Graduate Institute of Behavioural and Medical Sciences (PGIBAMS), Raipur",
    val: 972,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Postgraduate Institute of Dental Sciences, Rohtak",
    val: 973,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Prestige Medical Health Sciences, Bengaluru",
    val: 974,
    isTop: "",
    created: "2025-10-01 16:40:39",
    cluster: "healthcare",
  },
  {
    text: "Prakruthi College of Allied Health Sciences, Kolar",
    val: 975,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Priyadarshini Dental College and Hospital, Thiruvallur",
    val: 976,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Prof Brijmohan Mishra Institute of Medical and Technical Sciences, Burhanpur",
    val: 977,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Punjab Ayurved Medical College and Hospital, Ganganagar",
    val: 978,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Purvanchal Institute of Dental Sciences, Gorakhpur",
    val: 979,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Pushpagiri College of Dental Sciences, Thiruvalla",
    val: 980,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Pushpagiri Institute of Medical Sciences and Research Centre, Thiruvalla",
    val: 981,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Raichur Institute of Medical Sciences, Raichur",
    val: 982,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "R R Dental College and Hospital, Udaipur",
    val: 983,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Raiganj Government Medical College and Hospital, Uttar Dinajpur",
    val: 984,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Raipur Institute of Medical Sciences, Raipur",
    val: 985,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Rajashree Chhatrapati Shahu Maharaj Government Medical College, Kolhapur",
    val: 986,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Rampurhat Government Medical College, Rampurhat",
    val: 987,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Rajiv Institute of Medical Sciences, Adilabad",
    val: 988,
    isTop: "",
    created: "2025-10-01 16:40:40",
    cluster: "healthcare",
  },
  {
    text: "Rajiv Lochan Ayurved Medical College and Hospital, Durg",
    val: 989,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Rajmata Vijayaraje Scindia Medical College, Bhilwara",
    val: 990,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Rayat Bahra Dental College, Kharar",
    val: 991,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Rao Hospital, Coimbatore",
    val: 992,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Reynolds Memorial Hospital (RMH), Washim",
    val: 993,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Rural Institute of Ayurved Research Centre and Hospital, Satara",
    val: 994,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "RVM Institute of Medical Sciences and Research Centre, Siddipet",
    val: 995,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Sanjay Gandhi Accidental Hospital and Research Centre, Bengaluru",
    val: 996,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Sapthagiri Institute of Medical Sciences and Research Centre (SIMSRC), Bengaluru",
    val: 997,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Saraswati Ayurved Hospital and Medical College (SAHMC), Mohali",
    val: 998,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Sarat Chandra Chattopadhyay Government Medical College and Hospital, Howrah",
    val: 999,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Santiniketan Medical College, Bolpur",
    val: 1000,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Seema Dental College and Hospital, Rishikesh",
    val: 1001,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Shaheed Kartar Singh Sarabha Dental College and Hospital, Ludhiana",
    val: 1002,
    isTop: "",
    created: "2025-10-01 16:40:41",
    cluster: "healthcare",
  },
  {
    text: "Shimoga Institute of Medical Sciences, Shivamogga",
    val: 1003,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Shree HN Shukla Homeopathic Medical College and Hospital, Rajkot",
    val: 1004,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Shri Jagannath Medical College and Hospital, Puri",
    val: 1005,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Shri Lal Bahadur Shastri Government Medical College and Hospital, Mandi",
    val: 1006,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Shri Ramkrishna Institute of Medical Sciences and Sanaka Hospitals, Bardhaman",
    val: 1007,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Shristi Institute of Medical Science and Research Centre, Korba",
    val: 1008,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Sibar Institute of Dental Sciences, Guntur",
    val: 1009,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "SMBT Ayurved College and Hospital, Igatpuri",
    val: 1010,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "SMBT Institute of Dental Sciences and Research, Nashik",
    val: 1011,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "SNS College of Allied Health Sciences, Coimbatore",
    val: 1012,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Soban Singh Jeena Government Institute of Medical Sciences and Research, Almora",
    val: 1013,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Smt Shalinitai Meghe Ayurved Medical College and Hospital, Bhandara",
    val: 1014,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Smt Tarawati Institute of Bio Medical and Applied Sciences, Haridwar",
    val: 1015,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Sree Anjaneya Institute of Dental Sciences, Kozhikode",
    val: 1016,
    isTop: "",
    created: "2025-10-01 16:40:42",
    cluster: "healthcare",
  },
  {
    text: "Sree Abirami Hospital, Coimbatore",
    val: 1017,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Sree Mookambika Institute of Dental Sciences (SMIDS), Kanniyakumari",
    val: 1018,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Sree Mookambika Institute of Medical Sciences, Kanyakumari",
    val: 1019,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Sree Narayana Institute of Medical Sciences, Ernakulam",
    val: 1020,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Sree Sai Dental College and Research Institute, Srikakulam",
    val: 1021,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Sri Sathya Sai Institute of Higher Medical Sciences, Bengaluru",
    val: 1022,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Sri Venkateswara Dental College and Hospital, Chennai",
    val: 1023,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Srinivas Institute of Dental Sciences, Mangaluru",
    val: 1024,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Srinivas Institute of Medical Sciences and Research Centre, Mangaluru",
    val: 1025,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "St Joseph Dental College, West Godavari",
    val: 1026,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Subbaiah Institute of Dental Sciences, Shimoga",
    val: 1027,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Sudha Rustagi College of Dental Sciences and Research, Faridabad",
    val: 1028,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Surendera Dental College And Research Institute, Ganganagar",
    val: 1029,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Swaminarayan Institute of Medical Sciences and Research, Gandhinagar",
    val: 1030,
    isTop: "",
    created: "2025-10-01 16:40:43",
    cluster: "healthcare",
  },
  {
    text: "Swargiya Dadasaheb Kalmegh Smruti Dental College and Hospital, Hingna",
    val: 1031,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Tamralipto Government Medical College and Hospital, Medinipur",
    val: 1032,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Tatyasaheb Kore Dental College and Research Centre, Hatkanangle",
    val: 1033,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Tahira Institute of Medical Sciences, Gorakhpur",
    val: 1034,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Tomo Riba Institute of Health and Medical Sciences, Papum Pare",
    val: 1035,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Tripura Medical College and Dr BRAM Teaching Hospital, West Tripura",
    val: 1036,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Triveni Institute of Dental Sciences Hospital and Research Centre, Bilaspur",
    val: 1037,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "TS Misra Medical College and Hospital, Lucknow",
    val: 1038,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Vananchal Dental College and Hospital, Garhwa",
    val: 1039,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Uttaranchal Dental and Medical Research Institute (UDMRI), Dehradun",
    val: 1040,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Vedanta Institute of Medical Sciences, Palghar",
    val: 1041,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "World College of Medical Sciences Research and Hospital (WCMSRH), Jhajjar",
    val: 1042,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Yadgiri Institute of Medical Sciences, Yadgir",
    val: 1043,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Zydus Medical College and Hospital, Dohad",
    val: 1044,
    isTop: "",
    created: "2025-10-01 16:40:44",
    cluster: "healthcare",
  },
  {
    text: "Aakash Institute of Medical Sciences, Nalagarh",
    val: 1045,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Aarupadai Veedu Medical College and Hospital, Puducherry",
    val: 1046,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Aditya Dental College, Bid",
    val: 1047,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Al-Azhar Dental College, Thodupuzha",
    val: 1048,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Andaman and Nicobar Inslands Institute of Medical Sciences, South Andaman",
    val: 1049,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Army College of Medical Science, New Delhi",
    val: 1050,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Annapoorana Medical College and Hospital, Salem",
    val: 1051,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Atal Bihari Vajpayee Government Medical College, Vidisha",
    val: 1052,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Bankura Sammilani Medical College, Bankura",
    val: 1053,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Barasat Government Medical College and Hospital, Barasat",
    val: 1054,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Beehive Ayurved Medical College and Hospital, Dehradun",
    val: 1055,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Best Dental Science College, Madurai",
    val: 1056,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Banas Medical College and Research Institute, Banas Kantha",
    val: 1057,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Bhabha College of Dental Science, Bhopal",
    val: 1058,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "Bharti Ayurved Medical College and Hospital, Durg",
    val: 1059,
    isTop: "",
    created: "2025-10-01 16:40:45",
    cluster: "healthcare",
  },
  {
    text: "C U Shah Medical College and Hospital, Surendranagar",
    val: 1060,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Care Dental College, Guntur",
    val: 1061,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "C D Pachhigar College of Homeopathic Medicine and Hospital, Surat",
    val: 1062,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Chalmeda Ananda Rao Institute of Medical Sciences, Karimnagar",
    val: 1063,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Chhattisgarh Dental College and Research Institute, Rajnandgaon",
    val: 1064,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Chirayu Medical College and Hospital, Bhopal",
    val: 1065,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Combined PG Institute of Medical Sciences and Research, Dehradun",
    val: 1066,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "CSI College of Dental Sciences and Research, Madurai",
    val: 1067,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "D A Pandu Memorial R V Dental College, Pandu",
    val: 1068,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "DJ College of Dental Sciences and Research, Ghaziabad",
    val: 1069,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Dhanvantri Institute of Medical Science, Jaipur",
    val: 1070,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "DmbH Institute of Medical Science, Hooghly",
    val: 1071,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Diamond Harbour Government Medical College and Hospital, 24 Paraganas South",
    val: 1072,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Dr MK Shah Medical College and Research Center, Ahmedabad",
    val: 1073,
    isTop: "",
    created: "2025-10-01 16:40:46",
    cluster: "healthcare",
  },
  {
    text: "Dr B R Ambedkar State Institute of Medical Sciences, Mohali",
    val: 1074,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Dr Baba Saheb Ambedkar Medical College and Hospital, New Delhi",
    val: 1075,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Dr Radhakrishnan Government Medical College, Hamirpur",
    val: 1076,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Dr S N Medical College and Hospital, Jodhpur",
    val: 1077,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Dr GD Pol Foundation YMT Dental College and Hospital, Raigad",
    val: 1078,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Dr VRK Women's Medical College, Rangareddy",
    val: 1079,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Dr Yashwant Singh Parmar Government Medical College, Nahan",
    val: 1080,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Fakir Mohan Medical College, Baleshwar",
    val: 1081,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "ESI PGIMSR, Medical College and Hospital and ODC, Kolkata",
    val: 1082,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "ESIC Dental College and Hospital, New Delhi",
    val: 1083,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "ESIC Medical College and PGIMSR and Model Hospital, Bengaluru",
    val: 1084,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "G S Medical College and Hospital, Hapur",
    val: 1085,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Gandhinagar Homeopathic Medical College, Gandhinagar",
    val: 1086,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Glanis Institute of Allied Health Sciences, Madurai",
    val: 1087,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Genesis Institute of Dental Sciences and Research, Moga",
    val: 1088,
    isTop: "",
    created: "2025-10-01 16:40:47",
    cluster: "healthcare",
  },
  {
    text: "Government Arignar Anna Memorial Cancer Hospital, Kancheepuram",
    val: 1089,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College and Hospital, Cuddalore",
    val: 1090,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College and Hospital, Sundargarh",
    val: 1091,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Alleppey",
    val: 1092,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Dhaulpur",
    val: 1093,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Ballari",
    val: 1094,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Jagtial",
    val: 1095,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Dibrugarh",
    val: 1096,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Kallakkurichi",
    val: 1097,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Hyderabad",
    val: 1098,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Warangal",
    val: 1099,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Pudukkottai",
    val: 1100,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Vijayawada",
    val: 1101,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Dharmapuri Medical College, Dharmapuri",
    val: 1102,
    isTop: "",
    created: "2025-10-01 16:40:48",
    cluster: "healthcare",
  },
  {
    text: "Government Doon Medical College, Dehradun",
    val: 1103,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Gujarat Medical and Education Research Society Medical College, Rajpipla",
    val: 1104,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Guru Nanak Dev Dental College and Research Institute, Bathinda",
    val: 1105,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Hinduhridaysamrat Balasaheb Thackeray Medical College and Dr RN Cooper Municipal General Hospital, Mumbai",
    val: 1106,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Hyderabad Karnataka Education Societies Dental College, Kalburagi",
    val: 1107,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Indira Gandhi Medical College and Research Institute, Puducherry",
    val: 1108,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Institute of Biomedical Sciences, Bardhaman",
    val: 1109,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Indian School of Hospitality, Gurugram",
    val: 1110,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Jalpaiguri Government Medical College and Hospital, Jalpaiguri",
    val: 1111,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "ITS Dental College Hospital and Research Centre, Greater Noida",
    val: 1112,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Jagannath Gupta Institute of Medical Sciences and Hospital, 24 Paraganas South",
    val: 1113,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Kala Ashram Ayurved Medical College and Hospital, New Delhi",
    val: 1114,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Kalpana Chawla Government Medical College, Karnal",
    val: 1115,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Kamineni Academy of Medical Sciences and Research Centre, Rangareddy",
    val: 1116,
    isTop: "",
    created: "2025-10-01 16:40:49",
    cluster: "healthcare",
  },
  {
    text: "Kamineni Institute of Dental Sciences, Nalgonda",
    val: 1117,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "Kannur Dental College, Kannur",
    val: 1118,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "KD Medical College Hospital and Research Center, Mathura",
    val: 1119,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "KMCT Dental College, Malappuram",
    val: 1120,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "Kodagu Institute of Medical Sciences, Madikeri",
    val: 1121,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "KSR Institute of Dental Science and Research, Tiruchengode",
    val: 1122,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "Madha Dental College and Hospita, Chennai",
    val: 1123,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "M A Rangoonwala College of Dental Sciences and Research Centre, Pune",
    val: 1124,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "M B Gohil Institute of Medical Science and Research Center, Navsari",
    val: 1125,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "Mahamaya Rajkiya Allopathic Medical College, Ambedkar Nagar",
    val: 1126,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "Malla Reddy Dental College For Women, Malkajgiri",
    val: 1127,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "Malla Reddy Medical College For Women, Rangareddy",
    val: 1128,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "Manipal Tata Medical College, Jamshedpur",
    val: 1129,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "MES Dental College, Perinthalmanna",
    val: 1130,
    isTop: "",
    created: "2025-10-01 16:40:50",
    cluster: "healthcare",
  },
  {
    text: "MGM School of Biomedical Sciences, Navi Mumbai",
    val: 1131,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Mayo College of Peramedical Science Maya Hospital Campus, Bhopal",
    val: 1132,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Meghana Institute of Dental Sciences, Nizamabad",
    val: 1133,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Mount Zion Medical College, Pathanamthitta",
    val: 1134,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Murshidabad Medical College and Hospital, Murshidabad",
    val: 1135,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Naraina Medical College and Research Centre, Kanpur Nagar",
    val: 1136,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Narendra Modi Medical College, Ahmedabad",
    val: 1137,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "New Horizon Dental College and Research Institute, Bilaspur",
    val: 1138,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Nimra Institute of Dental Sciences, Vijayawada",
    val: 1139,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "PMS College of Dental Science and Research, Thiruvananthapuram",
    val: 1140,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Post Graduate Institute of Behavioural and Medical Sciences Santvana Manopchar Avam Anusandhan Sansthan, Raipur",
    val: 1141,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Priyadarshini Dental College and Hospital, Chennai",
    val: 1142,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "Prathima Relief Institute of Medical Sciences, Hanamkonda",
    val: 1143,
    isTop: "",
    created: "2025-10-01 16:40:51",
    cluster: "healthcare",
  },
  {
    text: "PSM College of Dental Science and Research, Thrissur",
    val: 1144,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Preethi Hospital, Madurai",
    val: 1145,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Punjab Institute of Medical Sciences, Jalandhar",
    val: 1146,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Radharaman Ayurved Medical College Research Hospital, Bhopal",
    val: 1147,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Rajshree Medical Research Institute, Bareilly",
    val: 1148,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Rashtrasant Janardhan Swami Ayurved Medical College and Research Centre, Ahmednagar",
    val: 1149,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Rosy Royal Homeopathic Medical College and Hospital, Bengaluru",
    val: 1150,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Royal Dental College, Palakkad",
    val: 1151,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "RP Inderaprastha Institute of Medical Sciences, Karnal",
    val: 1152,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Rishiraj College of Dental Sciences and Research Centre, Bhopal",
    val: 1153,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Rukmani Ben Deepchandgardi Medical College, Ben",
    val: 1154,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Rungta College of Dental Sciences and Research, Bhilai",
    val: 1155,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "RVS Dental College and Hospital, Coimbatore",
    val: 1156,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Shadhan Institute of Medical Sciences Teaching Hospital and Research Center, Hyderabad",
    val: 1157,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Sheik Ul Hind Maulana Mehmood Hasan Medical College, Saharanpur",
    val: 1158,
    isTop: "",
    created: "2025-10-01 16:40:52",
    cluster: "healthcare",
  },
  {
    text: "Shri Atal Bihari Vajpayee Government Medical College, Faridabad",
    val: 1159,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Shri B M Patil Medical College Hospital and Research Centre, Vijayapura",
    val: 1160,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Shri Sathya Sai Medical College and Research Institute, Chengalpattu",
    val: 1161,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Sikkim Manipal Institute of Medical Sciences (SMIMS), East District",
    val: 1162,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Shri Yashwantrao Chavan Memorial Medical and Rural Development Foundations Dental College and Hospital, Ahmednagar",
    val: 1163,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Shridev Suman Subharti Medical College, Dehradun",
    val: 1164,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Sri Ramachandra Medical College and Research Institute, Thiruvallur",
    val: 1165,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Sri Shiridi Sai Baba Ayurved College and Hospital, Jaipur",
    val: 1166,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Sri Muthukumaran Medical College Hospital and Research Institute, Chennai",
    val: 1167,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Sri Sukhmani Dental College and Hospital, S.A.S. Nagar",
    val: 1168,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Sri Ramachandra College of Allied Health Sciences, Thiruvallur",
    val: 1169,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Sri Vikasa Institute of Medical Sciences College, Kadapa",
    val: 1170,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "St Gregorios Dental College, Kothamangalam",
    val: 1171,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "Ssts Ayurved Medical College, Sangamner",
    val: 1172,
    isTop: "",
    created: "2025-10-01 16:40:53",
    cluster: "healthcare",
  },
  {
    text: "St Peters Medical College Hospital and Research Institute, Krishnagiri",
    val: 1173,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Surajmal Medical College of Ayurved and Hospital, Udham Singh Nagar",
    val: 1174,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Swamy Vivekanandha Medical College Hospital and Research Institute, Namakkal",
    val: 1175,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Swami Devi Dayal Hospital and Dental College, Panchkula",
    val: 1176,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Swami Vivekanand Para Medical College, Jamui",
    val: 1177,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Tezpur Medical College and Hospital, Sonitpur",
    val: 1178,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Travancore Dental College, Kollam",
    val: 1179,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Trichy Srm Medical College Hospital and Reserch Centre, Tiruchirapalli",
    val: 1180,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Trr Institute of Medical Sciences, Sangareddy",
    val: 1181,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Vadamalayan Institute of Medical and Allied Health Sciences, Madurai",
    val: 1182,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Velammal Medical College Hospital and Research Institute, Madurai",
    val: 1183,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Vishnu Dental College, West Godavari",
    val: 1184,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Yamuna Institute of Dental Sciences and Research, Yamunanagar",
    val: 1185,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Yenepoya Homeopathic Medical College and Hospital, Kannad",
    val: 1186,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Vyas Dental College and Hospital, Jodhpur",
    val: 1187,
    isTop: "",
    created: "2025-10-01 16:40:54",
    cluster: "healthcare",
  },
  {
    text: "Acharya Institute of Allied Health Sciences, Bengaluru",
    val: 1188,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "ACSR Government Medical College, Nellore",
    val: 1189,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Ayush College of Education, Marwahi",
    val: 1190,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Baby Memorial College of Allied Medical Sciences, Kozhikode",
    val: 1191,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "G Pulla Reddy Dental College and Hospital, Kurnool",
    val: 1192,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Employees State Insurance Corporation Medical College, Patna",
    val: 1193,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "GMERS Medical College, Navsari",
    val: 1194,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College and Hospital, Aurangabad",
    val: 1195,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Satara",
    val: 1196,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "KM Shah Dental College and Hospital, Vadodara",
    val: 1197,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Lakhimpur Medical College, Lakhimpur",
    val: 1198,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "MGM Dental College and Hospital, Navi Mumbai",
    val: 1199,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Netaji Subhas Medical College and Hospital, Patna",
    val: 1200,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Pandit Jawahar Lal Nehru Government Medical College, Chamba",
    val: 1201,
    isTop: "",
    created: "2025-10-01 16:40:55",
    cluster: "healthcare",
  },
  {
    text: "Parul Institute of Medical Sciences and Research, Vadodara",
    val: 1202,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "PG Institute of Medical Sciences, Medinipur",
    val: 1203,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "PR Pote Patil College of Medical Sciences Ayurved, Amravati",
    val: 1204,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "SCB Dental College and Hospital, Cuttack",
    val: 1205,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "Saraswati Institute of Medical Sciences, Hapur",
    val: 1206,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "Shri Shankaracharya Institute of Medical Sciences, Durg",
    val: 1207,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "Smt B K Shah Medical Institute and Research Centre, Vadodara",
    val: 1208,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "Sushila Institute of Medical Sciences, Dehradun",
    val: 1209,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "Sundaram Institute of Medical Science, Patna",
    val: 1210,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "MAHAYOGI GURU GORAKHNATH AYUSH UNIVERSITY",
    val: 1211,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "Bharati Vidyapeeth (Deemed to be University) Dental College and Hospital, Pune, Pune",
    val: 1212,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "Government Dental College, Thiruvananthapuram",
    val: 1213,
    isTop: "",
    created: "2025-10-01 16:40:56",
    cluster: "healthcare",
  },
  {
    text: "Government Medical College, Thiruvananthapuram, Thiruvananthapuram",
    val: 1214,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Kasturba Medical College, Mangalore, Mangaluru",
    val: 1215,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "KLE Vishwanath Katti Institute of Dental Sciences, Belgaum",
    val: 1216,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Medical College and Research Institute, Puducherry",
    val: 1217,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi P.G. Institute of Dental Sciences, Pondicherry",
    val: 1218,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Manipal College of Dental Sciences, Mangalore, Mangaluru",
    val: 1219,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Saveetha Institute of Medical and Technical Sciences, Chennai",
    val: 1220,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Sawai Man Singh Medical College, Jaipur",
    val: 1221,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "SRM Kattankulathur Dental College, Chennai",
    val: 1222,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Regional Medical Research Institute, Nicobars",
    val: 1223,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Kims Dental College And Hospital, East Godavari",
    val: 1224,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Anilneerukonda Institute Of Dental Sciences, Visakhapatanam",
    val: 1225,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Ddr College Of Para Medical Sceinces, Visakhapatanam",
    val: 1226,
    isTop: "",
    created: "2025-10-01 16:40:57",
    cluster: "healthcare",
  },
  {
    text: "Pratiksha Institute Of Allied Health Sciences, Kamrup",
    val: 1227,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Nitishwar Ayurved Medical College And Hospital, Muzaffarpur",
    val: 1228,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Late Shrimati Indira Gandhi Memorial Government Medical College Kanker, Kanker",
    val: 1229,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Shivrath Centre Of Excellence In Clinical Research, Ahmadabad",
    val: 1230,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Monark Ayurved Medical College And Hospital, Ahmadabad",
    val: 1231,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Kanoria Centre For Medical Education, Gandhinagar",
    val: 1232,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Dr N D Desai Faculty Of Medical Science And Research, Kheda",
    val: 1233,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Haji Rashidan Begum And Haji Sahab Jahan Educational Institute And Hospital, Kasganj",
    val: 1234,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Dhanalakshmi Srinivasan Dental College, Perambalur",
    val: 1235,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Sheikh Bhikhari Medical College & Hospital, Hazaribagh",
    val: 1236,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Medini Rai Medical College And Hospital, Palamu",
    val: 1237,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Laxmi Chandravansi Medical College And Hospital, Palamu",
    val: 1238,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Dr Ravi Patil Institute Of Allied Health Sciences, Belagavi",
    val: 1239,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Shri Guru Institute Of Allied Health Science Belagavi, Belagavi",
    val: 1240,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Aster Cmi Hospital, Bengaluru Urban",
    val: 1241,
    isTop: "",
    created: "2025-10-01 16:40:58",
    cluster: "healthcare",
  },
  {
    text: "Icbio Clinical Research Pvt Ltd, Bengaluru Urban",
    val: 1242,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Chhattisgarh Ayurved Medical College, Rajnandgaon",
    val: 1243,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Shantha College Of Allied Health Sciences, Chikkaballapura",
    val: 1244,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Vidyarthi College Of Allied Health Sciences, Chikkamagaluru",
    val: 1245,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Basaveshwara College Of Allied Health Sciences, Chitradurga",
    val: 1246,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Ratnadeep College Of Allied Health Sciences Hubballi, Dharwad",
    val: 1247,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Nisarga Institute Of Allied Health Sciences, Hassan",
    val: 1248,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Al-Badar Rural Dental College & Hospital, Kalaburagi",
    val: 1249,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Santana College Of Allied Health Sciences, Kalaburagi",
    val: 1250,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Sambhram Institute Of Medical Sciences And Research, Kolar",
    val: 1251,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Sri Channegowda Allied Health Sciences, Kolar",
    val: 1252,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Charkos Institute Of Allied Health Sciences, Mysuru",
    val: 1253,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Venkateshwara Institute Of Medical Sciences, Amroha",
    val: 1254,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Heritage City Institute Of Allied Health Sciences, Mysuru",
    val: 1255,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Kvc Allied Health Sciences, Mysuru",
    val: 1256,
    isTop: "",
    created: "2025-10-01 16:40:59",
    cluster: "healthcare",
  },
  {
    text: "Sigma College Of Allied Health Sciences, Mysuru",
    val: 1257,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Suyog Institute Of Allied Health Sciences, Mysuru",
    val: 1258,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Autonomous State Medical College, Firozabad",
    val: 1259,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Bapuji College Of Allied Health Sciences, Shivamogga",
    val: 1260,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Aruna College Of Allied Health Sciences Tumkur, Tumakuru",
    val: 1261,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Lombard Academy Of Allied Health Sciences, Udupi",
    val: 1262,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Vidyarathna Para Medical College, Udupi",
    val: 1263,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Al-Ameen Medical College, Vijayapura",
    val: 1264,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Shri Laxmi Thimmappa College Of Allied Health Sciences, Yadgir",
    val: 1265,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Amrita Centre For Nanomedical Sciences, Ernakulam",
    val: 1266,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Santhi Institute Of Allied Health Sciences, Kozhikode",
    val: 1267,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Iqraa International Hospital And Research Centre, Kozhikode",
    val: 1268,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Government Ayurved College And Hospital, Jalgaon",
    val: 1269,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "Al Salama Eye Hospital, Malappuram",
    val: 1270,
    isTop: "",
    created: "2025-10-01 16:41:00",
    cluster: "healthcare",
  },
  {
    text: "University Institute Of Para Medical Sciences, Faridkot",
    val: 1271,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Muthoot College Of Allied Health Sciences, Pathanamthitta",
    val: 1272,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Ktct College Of Allied Health Sciences, Thiruvananthapuram",
    val: 1273,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Sut Academy Of Medical Sciences, Thiruvananthapuram",
    val: 1274,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Autonomous State Medical College, Shahjahanpur",
    val: 1275,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Ayushi Institute Of Media & Science Bhind, Bhind",
    val: 1276,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Chirayu Institute Of Medical Science Main Road Bichhua Chhindwara, Chhindwara",
    val: 1277,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Sudha Rustagi College Of Dental Sc. & Res. Kheri More, Faridabad",
    val: 1278,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "College Of Dental Sciences & Hospital, Indore",
    val: 1279,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Mgm School Of Biomedical Sciences, Raigad",
    val: 1280,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Bhandari Group Of Hospitals And Institutions, Indore",
    val: 1281,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Ajax Medical Training, Jabalpur",
    val: 1282,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Kmct Institute Of Allied Health Sciences, Kozhikode",
    val: 1283,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Chaurashiya Pairamedical Institut Rewa, Rewa",
    val: 1284,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Institute Of Medical Science And Research, Baleshwar",
    val: 1285,
    isTop: "",
    created: "2025-10-01 16:41:01",
    cluster: "healthcare",
  },
  {
    text: "Gurukrupa College Of Medical Science, Nabarangpur",
    val: 1286,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Ssg Medical Insitution Ujjain, Ujjain",
    val: 1287,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Dr. Chavan Hospital And Research Centre, Ahmednagar",
    val: 1288,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Sivagiri Sree Narayana Medical Mission Malayalam, Thiruvananthapuram",
    val: 1289,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Shri Ram Institute Of Medical Sciences, Siwan",
    val: 1290,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Jiius Indian Institute Of Medical Science And Research, Jalna",
    val: 1291,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Patki Hospital And Research Foundation, Kolhapur",
    val: 1292,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "D C Narake Institute Of Hotel And Hospitality Kuditre Koparde Tal Karveer Dist Kolhapur, Kolhapur",
    val: 1293,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Dhanwantari Ayurved Medical College & Hospital, Latur",
    val: 1294,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "The Foundation For Medical Research, Mumbai",
    val: 1295,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Late Parshuram Patil Jadhav College Of Hospitality Studies And Administrative Services, Nanded",
    val: 1296,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Ramparva Hospitality And Tourism College, Nanded",
    val: 1297,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Lifeline Hospital And Medical Research Centre I Pvt. Ltd., Nashik",
    val: 1298,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Gouri Devi Institute Of Medical Sciences And Hospital, Paschim Bardhaman",
    val: 1299,
    isTop: "",
    created: "2025-10-01 16:41:02",
    cluster: "healthcare",
  },
  {
    text: "Sri Eshwarammaji Para Medical College, Kolar",
    val: 1300,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Saraswati Dhanwantari Dental College & Hospital, Parbhani",
    val: 1301,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Grant Medical Foundation, Pune",
    val: 1302,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "K.E.M.Hospital And Research Institute, Pune",
    val: 1303,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Rajiv Inst. Of Medical Sciences, Prakasam",
    val: 1304,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Dr. Rp Medical College, Kangra",
    val: 1305,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Yogita Dental College & Hospital, Ratnagiri",
    val: 1306,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Walavalkar Hospital And Dignostic Centre, Ratnagiri",
    val: 1307,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Prakash Institute Of Medical Sciences And Research, Sangli",
    val: 1308,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Vasantdada Patil Dental College, Sangli",
    val: 1309,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Mmppcts Ashwini Rural Medical College, Solapur",
    val: 1310,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Sai Ayurved College Hospital Research Center Vairag, Solapur",
    val: 1311,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Maharshi Vasishtha Autonomous State Medical College Basti, Basti",
    val: 1312,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Odisha Institute Of Medical Science, Baleshwar",
    val: 1313,
    isTop: "",
    created: "2025-10-01 16:41:03",
    cluster: "healthcare",
  },
  {
    text: "Vidya College Of Medical And Hospital Training, Jajapur",
    val: 1314,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Sriram Institute Of Medical Science And Research, Kendrapara",
    val: 1315,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Surya Institute Of Medical Science And Research Centre, Kendujhar",
    val: 1316,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Affinity Institute Of Medical Science, Khordha",
    val: 1317,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Franklin Institute Of Medical Science, Khordha",
    val: 1318,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Saheed Laxman Nayak Medical College And Hospital, Koraput",
    val: 1319,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Cryogenex Institute Of Medical Science And Research, Malkangiri",
    val: 1320,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Gnext Allied Medical Institute, Mayurbhanj",
    val: 1321,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Umasankar Academy Of Medical Science, Nabarangpur",
    val: 1322,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Vinayak Institute Of Medical Science, Nabarangpur",
    val: 1323,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Rajiv Inst. Of Medical Sciences, Srikakulam",
    val: 1324,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Badriprasad Institute Of Medical Science, Sambalpur",
    val: 1325,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Jaiprakash Hospital And Research Centre Pvt Ltd, Sundargarh",
    val: 1326,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "Mahe Institute Of Dental Sciences & Hospital, Mahe",
    val: 1327,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "University College Of Medical Education, Ernakulam",
    val: 1328,
    isTop: "",
    created: "2025-10-01 16:41:04",
    cluster: "healthcare",
  },
  {
    text: "College Of Hospital Administration, Thiruvananthapuram",
    val: 1329,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Pt. Shiv Shaktilal Sharma Ayurved Medical College, Ratlam",
    val: 1330,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Autonomous State Medical College Jaunpur, Jaunpur",
    val: 1331,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Shri Mangilal Nirvan Homeopathic Medical College And Research Centre, Bikaner",
    val: 1332,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Bethlahem Institute Of Medical Sciences, Kanniyakumari",
    val: 1333,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Sri Siddeshwara Para Medical College, Davangere",
    val: 1334,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "St James Institute Of Allied Health Sciences, Thrissur",
    val: 1335,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Chaudhary Charan Singh Medical Institute, Baghpat",
    val: 1336,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Bhagwant Institute Of Medical Sciences, Muzaffarnagar",
    val: 1337,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Annapurana Medical Training Instituteitute, Sikar",
    val: 1338,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Gurukripa Institute Of Medical Education, Sikar",
    val: 1339,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "School Of Allied Health Sciences, Chengalpattu",
    val: 1340,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Dr.Kamakshi Memorial Hospital Pvt. Ltd., Chennai",
    val: 1341,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Kauvery Hospital, Chennai",
    val: 1342,
    isTop: "",
    created: "2025-10-01 16:41:05",
    cluster: "healthcare",
  },
  {
    text: "Ganga Medical Centre And Hospital Pvt. Ltd., Coimbatore",
    val: 1343,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "V.G Hospital Indian Institute Of Laporoscopic Surgery Research Training Centre, Coimbatore",
    val: 1344,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Women'S Center & Hospitals Ltd, Coimbatore",
    val: 1345,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Christian Fellowship Hospital, Dindigul",
    val: 1346,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Sri Lakshmi Institute Of Para Medical Science, Chitradurga",
    val: 1347,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Dhavantri Institute Of Medical Education And Research, Erode",
    val: 1348,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Nandha Academy Of Allied Health Sciences, Erode",
    val: 1349,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Psp Medical College Hospital And Research Institute, Kanchipuram",
    val: 1350,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Global Institute Of Allied Medical Science, Puri",
    val: 1351,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Tagore Dental College & Hospital, Kanchipuram",
    val: 1352,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Government Kanyakumari Medical College, Kanniyakumari",
    val: 1353,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Siva Hospital, Kanniyakumari",
    val: 1354,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Arthur Asirvatham Hospital, Madurai",
    val: 1355,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Sri Gokulam Hospital, Salem",
    val: 1356,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Sivagangai Government Medical College, Sivaganga",
    val: 1357,
    isTop: "",
    created: "2025-10-01 16:41:06",
    cluster: "healthcare",
  },
  {
    text: "Thiravium Para Medical College, Theni",
    val: 1358,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Panimalar Medical College Hospital And Research Institute, Thiruvallur",
    val: 1359,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Kavery Medical Centre And Hospital, Tiruchirappalli",
    val: 1360,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Rajas Dental College And Hospital, Tirunelveli",
    val: 1361,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Rajas Institute Of Allied Health Sciences, Tirunelveli",
    val: 1362,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Prana Institute Of Allied Medical Sciences, Vellore",
    val: 1363,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Scudder Institute Of Allied Health Sciences, Vellore",
    val: 1364,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Sri Sakthi Amma Institute Of Allied Health Sciences, Vellore",
    val: 1365,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Duragabai Deshmukh Hospital & Research Centre, Hyderabad",
    val: 1366,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Svs Institute Of Dental Sciences, Mahbubnagar",
    val: 1367,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Mnr Dental College And Hospital, Medak",
    val: 1368,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Mallareddy Institute Of Medical Sciences, MEDCHAL MALKAJGIRI",
    val: 1369,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Mamata Academy Of Medical Sciences, MEDCHAL MALKAJGIRI",
    val: 1370,
    isTop: "",
    created: "2025-10-01 16:41:07",
    cluster: "healthcare",
  },
  {
    text: "Tirumala Institute Of Dental Sciences And Research Centre, Nizamabad",
    val: 1371,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Ayaan Institute Of Medical Sciences, Rangareddi",
    val: 1372,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Dr Patnam Mahender Reddy Institute Of Medical Sciences, Rangareddi",
    val: 1373,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Mediciti Inst. Of Medical Sciences, Rangareddi",
    val: 1374,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Shri Vinoba Bhave Institute Of Medical Science And Research, Dadra and Nagar Haveli",
    val: 1375,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Vaidik Dental College And Research Centre, Daman",
    val: 1376,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Holy Family Hospital South Delhi, South",
    val: 1377,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Krishna Murari Institute Of Medical And Health Science, Bokaro",
    val: 1378,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Sri Manjunatha Institute Of Para Medical Sciences, Chitradurga",
    val: 1379,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Sri Ram Institute Of Medical Sciencesferupur Katarpur Road, Haridwar",
    val: 1380,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Krishna Hospital And Institute Of Para Medical Science, Jaipur",
    val: 1381,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Shri Shamlaji Homoepethic Medical College, Panch Mahals",
    val: 1382,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Divine Institute Of Medical Science And Research, Mayurbhanj",
    val: 1383,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Malla Reddy Institute Of Dental Sciences, MEDCHAL MALKAJGIRI",
    val: 1384,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Lps Group Of Institute And Medical Science Aonla Bareilly, Bareilly",
    val: 1385,
    isTop: "",
    created: "2025-10-01 16:41:08",
    cluster: "healthcare",
  },
  {
    text: "Jeevak Ayurved Medical College And Hospital Research Center Kamlapur Akauni Chandauli, Chandauli",
    val: 1386,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Command Hospital, Kolkata",
    val: 1387,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Sri Maithri Institute Of Para Medical Sciences Hubli, Dharwad",
    val: 1388,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Chaitanya Institute Of Para Medical Sciences Kalaburgi, Kalaburagi",
    val: 1389,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Sri Rajamatangee Institute Of Para Medical Sciences, Vijayanagar",
    val: 1390,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Amar Shaheed Jodha Singh Ataiya Thakur Dariao Singh Medical College, Fatehpur",
    val: 1391,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "F H Medical College, Firozabad",
    val: 1392,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Ishan Ayurved Medical College And Research Centre, Gautam Buddha Nagar",
    val: 1393,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Dr. Moopen'S Medical College, Wayanad",
    val: 1394,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Noida International Institute Of Medical Sciences, Gautam Buddha Nagar",
    val: 1395,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Its Centre For Dental Studies And Research Delhi, Ghaziabad",
    val: 1396,
    isTop: "",
    created: "2025-10-01 16:41:09",
    cluster: "healthcare",
  },
  {
    text: "Shri Bakabihari Dental College & Research Centre, Ghaziabad",
    val: 1397,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Hanuman Shikshan Prasrak Mandals Ayur. Medical College, Kolhapur",
    val: 1398,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Guru Gorakshnath Institute Of Medical Sciences, Gorakhpur",
    val: 1399,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Sri Lakshmi Medical Centre And Hospital, Coimbatore",
    val: 1400,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Sri Balaji Dental College, Rangareddi",
    val: 1401,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Sri Mohan Para Medical College, Hathras",
    val: 1402,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Kannada Balaga Societys Rural Para Medical College, Belagavi",
    val: 1403,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Shri Manikprabhu Para Medical College, Bidar",
    val: 1404,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Om Para Medical College, Haveri",
    val: 1405,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Swami Vivekananda Para Medical College Lingasugur Raichur, Raichur",
    val: 1406,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Sri Manjunatha Institute Of Para Medical Sciences, Shivamogga",
    val: 1407,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Pushpagiri College Of Allied Health Sciences, Pathanamthitta",
    val: 1408,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "Mahatma Gandhi Memorial Hospital Mumbai, Mumbai",
    val: 1409,
    isTop: "",
    created: "2025-10-01 16:41:10",
    cluster: "healthcare",
  },
  {
    text: "National Institute Of Medical Science, Mayurbhanj",
    val: 1410,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Belarani Institute Of Medical Science, Bankura",
    val: 1411,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Rajeev College Of Allied Health Sciences, Hassan",
    val: 1412,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Government General Hospital, Guntur",
    val: 1413,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Indira Gadhi Institute Of Para Medical Science, Chitradurga",
    val: 1414,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Anugraha Institute Of Para Medical Sciences, Vijayapura",
    val: 1415,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Narayan Memorial Institute Of Medical Science Nmims, Kendrapara",
    val: 1416,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Acme Institute Of Medical Sciences, Bareilly",
    val: 1417,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Charnock Hospital, Kolkata",
    val: 1418,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Shree Manubhai Patel Dental College And Hospital, Vadodara",
    val: 1419,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Burdwan Rural Medical Training And Treatment Center, Purba Bardhaman",
    val: 1420,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Arogyavaram Medical Centre Arogyavaram, Chittoor",
    val: 1421,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "Dr N Y Tasgaonkar Institute Of Medical Science, Raigad",
    val: 1422,
    isTop: "",
    created: "2025-10-01 16:41:11",
    cluster: "healthcare",
  },
  {
    text: "School Of Allied Health Sciences, Karaikal",
    val: 1423,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Gifford Memorial Hospital Of 7Th Day Adventists Krishna, Krishna",
    val: 1424,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Govt General Hospital, Krishna",
    val: 1425,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Harsha Institute Of Para Medical Sciences, Prakasam",
    val: 1426,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "St Mariam College Of Allied Health Science, Tirunelveli",
    val: 1427,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Mother Vannini Hospital West Godawari, West Godavari",
    val: 1428,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Narsapur Christian Hospital, West Godavari",
    val: 1429,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Kinggate Institute Of Allied Health Science, Goalpara",
    val: 1430,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "St Luke'S Hospital Tinsukia, Tinsukia",
    val: 1431,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Medical Training Sansthan Jaso Road Buxar, Buxar",
    val: 1432,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Anm Training School Sub Divisional Hospital Janjarpur Madhubani, Madhubani",
    val: 1433,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Sher Sah Medical Research And Training Anm School, Rohtas",
    val: 1434,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Anm Training School Sub Divisional Hospital Dalsinghsarai Samastipur, Samastipur",
    val: 1435,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "The Evangelical Mission Hospital Raipur, Raipur",
    val: 1436,
    isTop: "",
    created: "2025-10-01 16:41:12",
    cluster: "healthcare",
  },
  {
    text: "Sir Ganga Ram Hospital New Delhi, Central",
    val: 1437,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Tirath Ram Shah Hospital New Delhi, North",
    val: 1438,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "E S I S General Hospital Ahmedabad, Ahmadabad",
    val: 1439,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Cambay General Hospital Nsg. School, Anand",
    val: 1440,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Civil Surgeon Hospital Junagadh, Junagadh",
    val: 1441,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Maa Kaamal Medical Center, Surat",
    val: 1442,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Aayush Medical Institute, Valsad",
    val: 1443,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Philadelphia Hospital Ambala, Ambala",
    val: 1444,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Bala Ji Institute Of Health And Medical Education, Bhiwani",
    val: 1445,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "The Lalit Suri Hospitality School, Faridabad",
    val: 1446,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Sai Sanjeevini Institute Of Medical Sciences Solan, Solan",
    val: 1447,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Royal Institute Of Para Medical Sciences, Ganderbal",
    val: 1448,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Govt Mphw M Training School General Hospital Sonipat, Sonipat",
    val: 1449,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "Sai Stiti Institute Of Medical Science, Khordha",
    val: 1450,
    isTop: "",
    created: "2025-10-01 16:41:13",
    cluster: "healthcare",
  },
  {
    text: "District Hospital Mandi, Mandi",
    val: 1451,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Sri Sai Charitable Hospital & Instt Of Medical Sciences Mandi, Mandi",
    val: 1452,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Nanda Hospital Una, Una",
    val: 1453,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Florence Para Medical Institute Anantnag, Anantnag",
    val: 1454,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Shri Nanak Medical Institute Of Health Sciences, Jammu",
    val: 1455,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Ks Institute Of Medical Sciences, Basti",
    val: 1456,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Al Noor Para Medical Institute, Srinagar",
    val: 1457,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Birsa Reseasrch Institute For Medical And Biomedical Studies, Bokaro",
    val: 1458,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Istitute Of Medical And Technological Science, Dumka",
    val: 1459,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Arogyam Hospital And Research Private Limited, Garhwa",
    val: 1460,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Ghanshyam Mehta College Of Medical And Science, Hazaribagh",
    val: 1461,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Seventh Day Adventist Hospital Ranchi, Ranchi",
    val: 1462,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Tupudana Institute Of Medical Sciences, Ranchi",
    val: 1463,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "District Hospital Bagalkote, Bagalkote",
    val: 1464,
    isTop: "",
    created: "2025-10-01 16:41:14",
    cluster: "healthcare",
  },
  {
    text: "Jeevan Arogya Para Medical College Jamkhandi, Bagalkote",
    val: 1465,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Lakshmi Narayana Para Medical Institute Badami Bagalkot, Bagalkote",
    val: 1466,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Shri Sadguru Rayalingeshwar Para Medical College Mudhol Bagalkot, Bagalkote",
    val: 1467,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Sri Banashankari Para Medical Institute Badami Bagalkot, Bagalkote",
    val: 1468,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Shashank Para Medical College, Ballari",
    val: 1469,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Arogya Para Medical College Mudalgi, Belagavi",
    val: 1470,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "C N Mugalkhod Institute Of Para Medical Sciences, Belagavi",
    val: 1471,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "J R D Bate Para Medical Institute Chikodi Belagum, Belagavi",
    val: 1472,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Mahalaxmi Para Medical Institute, Belagavi",
    val: 1473,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Samruddi Para Medical College, Belagavi",
    val: 1474,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Sri Siddi Vinayaka Institute Of Para Medical Science Raibagh Belagavi, Belagavi",
    val: 1475,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Suraksha Para Medical Institute Mudalagi, Belagavi",
    val: 1476,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Bowring And Lady Curzon Hospital, Bengaluru Urban",
    val: 1477,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Jayanagar General Hospital, Bengaluru Urban",
    val: 1478,
    isTop: "",
    created: "2025-10-01 16:41:15",
    cluster: "healthcare",
  },
  {
    text: "Padmabhushan Dr M C Modi Charitable Eye Hospital, Bengaluru Urban",
    val: 1479,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Sri S Nijalingappa Medical Educational Center, Bengaluru Urban",
    val: 1480,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Gnyanodaya Collage Of Para Medical Sciences, Bidar",
    val: 1481,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Halmadgi Para Medical College Basavakalayana, Bidar",
    val: 1482,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Hkdet Para Medical Institute Bidar, Bidar",
    val: 1483,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Jasmine Para Medical College Bidar, Bidar",
    val: 1484,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Kumar Swamiji Para Medical College Bhalki, Bidar",
    val: 1485,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Svets Shakuntala Patil Para Medical College Humnabad Bidar, Bidar",
    val: 1486,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "District Hospital Chikkaballapura, Chikkaballapura",
    val: 1487,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Shantha College Of Para Medical Sciences, Chikkaballapura",
    val: 1488,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Sharath Eye Hospital, Chikkamagaluru",
    val: 1489,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Sri Ranganatha College Of Para Medical Sceinces, Chikkamagaluru",
    val: 1490,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Vidyarthi Para Medical College, Chikkamagaluru",
    val: 1491,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "District Hospital Chitradurga, Chitradurga",
    val: 1492,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "H V Para Medical Institute Chitradurga, Chitradurga",
    val: 1493,
    isTop: "",
    created: "2025-10-01 16:41:16",
    cluster: "healthcare",
  },
  {
    text: "Kanaka Institute Of Para Medical Science Hosadurga, Chitradurga",
    val: 1494,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Meghana Para Medical Institute Chitradurga, Chitradurga",
    val: 1495,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Nutan Para Medical Institute Chitradurga, Chitradurga",
    val: 1496,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Ranganatha Institute Of Para Medical Science Holalkere, Chitradurga",
    val: 1497,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Sree Mathrushree Institute Of Para Medical Sciences Chitradurga, Chitradurga",
    val: 1498,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Sree Varu Para Medical College Chitradurga, Chitradurga",
    val: 1499,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Vasavi Institue Of Para Medical Sciences Chitradurga, Chitradurga",
    val: 1500,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Vishnu Para Medical Institute Chitradurga, Chitradurga",
    val: 1501,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Chigateri District Hospital Davangere, Davangere",
    val: 1502,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Diksuchi College Of Para Medical Science Davangere, Davangere",
    val: 1503,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Ganga Institute Of Para Medical Sciences Channagiri, Davangere",
    val: 1504,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Kanaka Para Medical College, Davangere",
    val: 1505,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Mahatama Gandhi Institute Of Para Medical Science, Davangere",
    val: 1506,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Pruthvi Para Medical College, Davangere",
    val: 1507,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Shree Ganga Para Medical College Channagiri, Davangere",
    val: 1508,
    isTop: "",
    created: "2025-10-01 16:41:17",
    cluster: "healthcare",
  },
  {
    text: "Sri Mruthyunjaya Institute Of Para Medical Sciences Davangere, Davangere",
    val: 1509,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Sri Vimaleshwara Para Medical College Davangere, Davangere",
    val: 1510,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Sushrutha Para Medical College Davangere, Davangere",
    val: 1511,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Vijaya Para Medical College, Davangere",
    val: 1512,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Anjuman Para Medical Institute Hubli Dharwad, Dharwad",
    val: 1513,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "District Hospital Para Medical Sciences Dharwad, Dharwad",
    val: 1514,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Madeena Institute Of Para Medical Sciences Dharwad, Dharwad",
    val: 1515,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Sana Institute Of Para Medical Sciences Dharwad, Dharwad",
    val: 1516,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Sana Institute Of Para Medical Sciences Hubli, Dharwad",
    val: 1517,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Sushruta Institute Of Para Medical Science, Dharwad",
    val: 1518,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Gandhiji Para Medical College Gadag, Gadag",
    val: 1519,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Shree Basaveshwar Para Medical College Gadag, Gadag",
    val: 1520,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Shri Sushruta Para Medical College Gajendragad, Gadag",
    val: 1521,
    isTop: "",
    created: "2025-10-01 16:41:18",
    cluster: "healthcare",
  },
  {
    text: "Spoorthi Para Medical College, Gadag",
    val: 1522,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "C S I Red Fern Memorial Hospital Hassan, Hassan",
    val: 1523,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "District Hospital Haveri, Haveri",
    val: 1524,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Shree Durga Para Medical College Hirekerur Haveri, Haveri",
    val: 1525,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Annapurna Para Medical Institute, Kalaburagi",
    val: 1526,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Jagajyothi Basaweshwara Para Medical College Kalaburgi, Kalaburagi",
    val: 1527,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Noble College Of Para Medical Sciences, Kalaburagi",
    val: 1528,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Vidyarthi Para Medical College Kushalanagar, Kodagu",
    val: 1529,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Bethany Para Medical College, Kolar",
    val: 1530,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Ellen Thoburn Cowen Memorial Hospital Of Kolar, Kolar",
    val: 1531,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Ramanujacharya Para Medical College, Kolar",
    val: 1532,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Snr District Hospital, Kolar",
    val: 1533,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "District Hospital Koppala, Koppal",
    val: 1534,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Shree Jagadguru Gavisiddheshwara Para Medical College, Koppal",
    val: 1535,
    isTop: "",
    created: "2025-10-01 16:41:19",
    cluster: "healthcare",
  },
  {
    text: "Madegowda Para Medical College, Mandya",
    val: 1536,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Vajrakaya Para Medical College, Mandya",
    val: 1537,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Manonidhi Institute Of Para Medical Sciences Mysuru, Mysuru",
    val: 1538,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Labubai Banitabai Bhandari Para Medical College Raichur, Raichur",
    val: 1539,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Nivedita Para Medical Institute Amadihal, Raichur",
    val: 1540,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Samarth Para Medical College Raichur, Raichur",
    val: 1541,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Sarvodya Par Medical College Manvi, Raichur",
    val: 1542,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Sunrise Para Medical College Sindhanur, Raichur",
    val: 1543,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Abhay Para Medical College, Ramanagara",
    val: 1544,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Kpsm Para Medical College, Ramanagara",
    val: 1545,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Arogyadhama Institute Of Para Medical Sciences, Shivamogga",
    val: 1546,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Gangotri Para Medical College, Shivamogga",
    val: 1547,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Jnana Gangotri Institute Of Para Medical Sciences Shivamogga, Shivamogga",
    val: 1548,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Nanjappa Institute Of Para Medical Science, Shivamogga",
    val: 1549,
    isTop: "",
    created: "2025-10-01 16:41:20",
    cluster: "healthcare",
  },
  {
    text: "Sri Shivayogeeshwara Para Medical College, Tumakuru",
    val: 1550,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Taluk Hospital Sira, Tumakuru",
    val: 1551,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Csi Lombard Memorial Hospital Udupi, Udupi",
    val: 1552,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Prashanth Institute Of Para Medical Sciences Kaup, Udupi",
    val: 1553,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Abhyudaya Para Medical College Muddebhihal Vijayapura, Vijayapura",
    val: 1554,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Adarsh Para Medical Institute Tikota, Vijayapura",
    val: 1555,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Al-Ameen Medical College And Hospital, Vijayapura",
    val: 1556,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "District Hospital Vijayapura, Vijayapura",
    val: 1557,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Fahad Institute Of Para Medical Collge Vijayapur, Vijayapura",
    val: 1558,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Ideal Para Medical Institute Kalakeri, Vijayapura",
    val: 1559,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Radha Krishna Para Medical Institute Vijayapura, Vijayapura",
    val: 1560,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Shree Durga Para Medical College Hirekerur Haveri, Vijayapura",
    val: 1561,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Siddaganga Para Medical College Muddebihal, Vijayapura",
    val: 1562,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Sirasagi Para Medical College Of Science Almel, Vijayapura",
    val: 1563,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Sirasagi Para Medical College Of Sciences Almel Sindagi Bijapur, Vijayapura",
    val: 1564,
    isTop: "",
    created: "2025-10-01 16:41:21",
    cluster: "healthcare",
  },
  {
    text: "Sri Shanteshwar Para Medical College Indi Vijayapur, Vijayapura",
    val: 1565,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Vidyanikethana Education Institute Of Para Medical Sciences, Vijayapura",
    val: 1566,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Vision Para Medical College Sindagi, Vijayapura",
    val: 1567,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Aim Para Medical College Surapur Kembhavi Yadgir, Yadgir",
    val: 1568,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Dr Surgimath Para Medical College Shahapura Yadgiri, Yadgir",
    val: 1569,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Dr Surgimath Para Medical College Shorapura Yadgir, Yadgir",
    val: 1570,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Hkgn Para Medical College Shahapur Dist Yadgir, Yadgir",
    val: 1571,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Hari Para Medical College Yadgiri, Yadgir",
    val: 1572,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Jawahar Para Medical Institute Yadgir, Yadgir",
    val: 1573,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Sri Maruti Para Medical College Yadgiri, Yadgir",
    val: 1574,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Surpur Para Medical Institute, Yadgir",
    val: 1575,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Vaishnavi Para Medical College Kodekal, Yadgir",
    val: 1576,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "K Velayudhan Memorial Hospital Alappuzha, Alappuzha",
    val: 1577,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "Shree Narayana Medical Mission General Alappuzha, Alappuzha",
    val: 1578,
    isTop: "",
    created: "2025-10-01 16:41:22",
    cluster: "healthcare",
  },
  {
    text: "St Thomas Mission Hospital Alappuzha, Alappuzha",
    val: 1579,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Deva Matha Hospital Ernakulam, Ernakulam",
    val: 1580,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Lisie Hospital Ernakulam, Ernakulam",
    val: 1581,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Lourdes Hospital Ernakulam, Ernakulam",
    val: 1582,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Mar Augustine Jubilee Mission Hospital Ernakulam, Ernakulam",
    val: 1583,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Mar Baselious Medical Mission Hospital Ernakulam, Ernakulam",
    val: 1584,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "San Joe Hospital Ernakulam, Ernakulam",
    val: 1585,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Bishop Vayalil Medical Centre Idukki, Idukki",
    val: 1586,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Koyili Hospital Kannur, Kannur",
    val: 1587,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "St Martin De-Porres Hospital Kannur, Kannur",
    val: 1588,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Malik Deenar Charitable Hospital Kasargod, Kasaragod",
    val: 1589,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Manzoor Hospital Kasargod, Kasaragod",
    val: 1590,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Dr. Nairs Hospital Kollam, Kollam",
    val: 1591,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Mar Theodosius Memorial Medical Mission Kollam, Kollam",
    val: 1592,
    isTop: "",
    created: "2025-10-01 16:41:23",
    cluster: "healthcare",
  },
  {
    text: "Parabrahma Speciality Hospital & Research Centre Kollam, Kollam",
    val: 1593,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Sabarigiri Institute Of Allied Medical Sciences, Kollam",
    val: 1594,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Travancore School Of Allied Health Sciences, Kollam",
    val: 1595,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Assissi Hospital Kottayam, Kottayam",
    val: 1596,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Holy Ghost Mission Hospital Kottayam, Kottayam",
    val: 1597,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "I H M Hospital Kottayam, Kottayam",
    val: 1598,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Mary Queen'S Hospital Kottayam, Kottayam",
    val: 1599,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Kmct National Hospital Institute Of Health Sciences, Kozhikode",
    val: 1600,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Nirmala Hospital Kozhikode, Kozhikode",
    val: 1601,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "E M S Memorial Cooperative Hospital Malappuram, Malappuram",
    val: 1602,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Assumption Hospital Palakkad, Palakkad",
    val: 1603,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Chaithanya Eye Hospital And Research Institute, Thiruvananthapuram",
    val: 1604,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Govt General Hospital Thiruvananthapuram, Thiruvananthapuram",
    val: 1605,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "State Public Health And Clinical Laboratory Thiruvananthapuram, Thiruvananthapuram",
    val: 1606,
    isTop: "",
    created: "2025-10-01 16:41:24",
    cluster: "healthcare",
  },
  {
    text: "Amala Cancer Hospital And Research Centre Thrissur, Thrissur",
    val: 1607,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Jubilee Mission Hospital Thrissur, Thrissur",
    val: 1608,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Lal Memorial Hospital Thrissur, Thrissur",
    val: 1609,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Maria Theresa Hospital Trichur, Thrissur",
    val: 1610,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Modern Hospital Kodungallur Ltd Thrissur, Thrissur",
    val: 1611,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "San Jos Parish Hospital Thrissur, Thrissur",
    val: 1612,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "St James Hospital Thrissur, Thrissur",
    val: 1613,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Fatima Mata Mission Hospital Wayanad, Wayanad",
    val: 1614,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Hamidia Hospital Bhopal, Bhopal",
    val: 1615,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Vikramaditya Institute Of Medical Sciences, Bhopal",
    val: 1616,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Akash Institute Of Para Medical Sciences Garnai Udhampur, Udhampur",
    val: 1617,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Maa Para Medical Institute, Khunti",
    val: 1618,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Sangamner Medical Foundation & Research Institutes, Ahmednagar",
    val: 1619,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Sangamner Medical Foundation & Research Institute, Ahmednagar",
    val: 1620,
    isTop: "",
    created: "2025-10-01 16:41:25",
    cluster: "healthcare",
  },
  {
    text: "Evangeline Booth Hospital Ahmednagar, Ahmednagar",
    val: 1621,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "F.J.F.M Hospital And Community Health Unit, Ahmednagar",
    val: 1622,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "General Hospital Ahmednagar, Ahmednagar",
    val: 1623,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Medical Mission Secular Institute, Ahmednagar",
    val: 1624,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "St Luke'S Hospital Ahmednagar, Ahmednagar",
    val: 1625,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Dhanwantri Medical Education And Res Centres, Beed",
    val: 1626,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Vithai Hospital And Research Centre, Beed",
    val: 1627,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Chatarpati Pramile Raje General Hospital Kolhapur, Kolhapur",
    val: 1628,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Gokuldas Tejpal Hospital Mumbai, Mumbai",
    val: 1629,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Lokmanya Tilak Municipal General Hospital Mumbai, Mumbai",
    val: 1630,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Shri Harilal Bhagwati Municipal Gen Hospital Mumbai, Mumbai",
    val: 1631,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Daga Memorial Govt. Hospital Nagpur, Nagpur",
    val: 1632,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Shree Satya College Of Medical Sciences, Moradabad",
    val: 1633,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "Rb Institute Of Medical Sciences, Sultanpur",
    val: 1634,
    isTop: "",
    created: "2025-10-01 16:41:26",
    cluster: "healthcare",
  },
  {
    text: "General Hospital Nandurbar, Nandurbar",
    val: 1635,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "General Hospital Nasik, Nashik",
    val: 1636,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "N M Wadia Hospital Pune, Pune",
    val: 1637,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "Sant Dnyaneshwar Medical Education Research Center Pune, Pune",
    val: 1638,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "General Hospital, Raigad",
    val: 1639,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "General Hospital Sangli, Sangli",
    val: 1640,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "General Hospital Satara, Satara",
    val: 1641,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "Krishna Hosp. & Medical Research Centre Satara, Satara",
    val: 1642,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "Al-Ameen Dental College, Vijayapura",
    val: 1643,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "Vasantdada Kale Medical Foudation Bhandishegaon, Solapur",
    val: 1644,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "Travancore College Of Allied Health Sciences, Kollam",
    val: 1645,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "Techno Allied Health Institute, Churachandpur",
    val: 1646,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "Dr. Norman Tunnel Hospital, West Jaintia Hills",
    val: 1647,
    isTop: "",
    created: "2025-10-01 16:41:27",
    cluster: "healthcare",
  },
  {
    text: "Dr. Balasaheb Vikhe Patil Rural Medical College, Ahmednagar",
    val: 1648,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Naga Hospital Kohima, Kohima",
    val: 1649,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Para Medical Training Institute, Kohima",
    val: 1650,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Surendra Hospital Dmlt And Dmrt Training School, Anugul",
    val: 1651,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Swarnalata Institute Of Allied Medical Science, Anugul",
    val: 1652,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Aaditri Institute Of Medical Science, Balangir",
    val: 1653,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Bolangir College Of Medical Science, Balangir",
    val: 1654,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Sushree Medical Science And Research Institute Balangir, Balangir",
    val: 1655,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Titilagarh College Of Medical Science, Balangir",
    val: 1656,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Balasore Institute Of Medical Science, Baleshwar",
    val: 1657,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Digambaridevi Institute Of Medical Science, Baleshwar",
    val: 1658,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Puri Saraswati Institute Of Medical Science, Baleshwar",
    val: 1659,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "Mahavir School Of Medical Science, Bargarh",
    val: 1660,
    isTop: "",
    created: "2025-10-01 16:41:28",
    cluster: "healthcare",
  },
  {
    text: "School Of Dental Sciences Karad, Satara",
    val: 1661,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Gopabandhu Institute Of Medical Science And Research, Cuttack",
    val: 1662,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Laxmipriya Institute Of Medical Science, Cuttack",
    val: 1663,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Sarada Devi Institute Of Medical Sciences, Cuttack",
    val: 1664,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Vision Institute Of Medical Science And Research, Cuttack",
    val: 1665,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Bapuji Academy Of Medical Science, Ganjam",
    val: 1666,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Kalam Institute Of Allied Medical Science, Ganjam",
    val: 1667,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Lingaraja Institute Of Medical Science, Ganjam",
    val: 1668,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Utkal K O N Institute Of Medical Science, Ganjam",
    val: 1669,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Mahima Institute Of Medical Science, Jagatsinghapur",
    val: 1670,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Fledge Institute Of Medical Science, Jajapur",
    val: 1671,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Aryabhatt Institute Of Medical Science, Jharsuguda",
    val: 1672,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Bhubaneswar Institute Of Medical Science Dharmagarh, Kalahandi",
    val: 1673,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Maheswari Institute Of Medical Science Bhawanipatn, Kalahandi",
    val: 1674,
    isTop: "",
    created: "2025-10-01 16:41:29",
    cluster: "healthcare",
  },
  {
    text: "Maheswari Institute Of Medical Science Junagarh, Kalahandi",
    val: 1675,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Alex Institute Of Medical Science, Kandhamal",
    val: 1676,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Bhubaneswar Institute Of Medical Science Kendrapara, Kendrapara",
    val: 1677,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Bhubaneswar Institute Of Medical Science, Kendujhar",
    val: 1678,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Cryogenex Institute Of Medical Science And Research, Kendujhar",
    val: 1679,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Keonjhar Institute Of Medical Science And Research Keonjhar, Kendujhar",
    val: 1680,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Npm Institute Of Medical Science And Research Keonjhar Near Lord Jagannath Plus Two Science Residential College College Road Baniapat Keonjhar, Kendujhar",
    val: 1681,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "School Of Dmlt Npm Institute Of Medical Science And Research, Kendujhar",
    val: 1682,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Bhava Institute Of Medical Science & Research Khordha, Khordha",
    val: 1683,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Cryogenex Institute Of Medical Science And Research, Khordha",
    val: 1684,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Divya Institute Of Medical Science, Khordha",
    val: 1685,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Eastern Institute Of Medical Science, Khordha",
    val: 1686,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Koustuv Research Institute Of Medical Science, Khordha",
    val: 1687,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Ramadevi Institute Of Medical Science And Research, Khordha",
    val: 1688,
    isTop: "",
    created: "2025-10-01 16:41:30",
    cluster: "healthcare",
  },
  {
    text: "Sarada Devi Institute Of Medical Science, Khordha",
    val: 1689,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Sarada Devi Institute Of Medical Sciences, Khordha",
    val: 1690,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Sree Vidya Niketan College Of Medical Science And Research, Khordha",
    val: 1691,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Rasik Giri Memorial Institute For Medical And Laboratory Technician, Mayurbhanj",
    val: 1692,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Sahay Medical Academy, Mayurbhanj",
    val: 1693,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Mahamaya Institute Of Medical & Tech. Science Nuapada, Nuapada",
    val: 1694,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Franklin Institute Of Medical Science, Puri",
    val: 1695,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Catholic Mission Hospital Sundergarh, Sundargarh",
    val: 1696,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Krushna Bharati Institute Of Medical Science, Sundargarh",
    val: 1697,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Gnm Training School Civil Hospital Bathinda, Bathinda",
    val: 1698,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Frances Newton Hospital Ferozepur, Firozepur",
    val: 1699,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Batala Institute Of Medical Science Gurdaspur, Gurdaspur",
    val: 1700,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Krishna Mohan Medical College And Hospital, Mathura",
    val: 1701,
    isTop: "",
    created: "2025-10-01 16:41:31",
    cluster: "healthcare",
  },
  {
    text: "Mphw Female Training School Civil Hospital Moga, Moga",
    val: 1702,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Rehbar Institute Of Medical Sciences Bhawanigarh, Sangrur",
    val: 1703,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Dev Institute Of Medical Sciences Samain Rohtak, Rohtak",
    val: 1704,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Dr Rajinder Prasad Medical College Hospital Kangra, Kangra",
    val: 1705,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Ruhi Choudhary Para Medical Institute Sadulpur, Churu",
    val: 1706,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Ayushmaan College Of Special Education, Dausa",
    val: 1707,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Prakhar Institute Of Para Medical Sciences, Dausa",
    val: 1708,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Sree Sevalal Institute Of Para Medical Science, Davangere",
    val: 1709,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Sri Maruti Para Medical College, Yadgir",
    val: 1710,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Rajat Institute Of Medical Sciences, Jaipur",
    val: 1711,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Suparshva Para Medical Institute, Jaipur",
    val: 1712,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Saraswati Para Medical College, Jodhpur",
    val: 1713,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Bharat Vikas Parishad Hospital And Research Center, Kota",
    val: 1714,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Dayanand Chaudhary College Of Medical Science, Basti",
    val: 1715,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Dr Vk Verma Institute Of Medical Science, Basti",
    val: 1716,
    isTop: "",
    created: "2025-10-01 16:41:32",
    cluster: "healthcare",
  },
  {
    text: "Maitri Institute Of Medical Sciences, Kota",
    val: 1717,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Get Well Hospital And Research Center, Sikar",
    val: 1718,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Gurukripa Institute For Medical Education, Sikar",
    val: 1719,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Kalyani Institute Of Medical Sciences, Purba Bardhaman",
    val: 1720,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Anbarasu Inst Of Medical And Research, Kanchipuram",
    val: 1721,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Andavar Para Medical Institution, Nagapattinam",
    val: 1722,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Csi Mission General Hospital, Tiruchirappalli",
    val: 1723,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Thirumalai Srinivasa Para Medical Institute, Tiruchirappalli",
    val: 1724,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Singareni Collories Company Ltd Hospital Khammam, Khammam",
    val: 1725,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "School Of Allied Health Sciences, Salem",
    val: 1726,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Shri Ayush Hospital And Research Institute, Dehradun",
    val: 1727,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Anant Medical College And Hospital Gordhanpur Khanpur Haridwar, Haridwar",
    val: 1728,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Maharishi Dayanand Medical Science And Research Institute, Haridwar",
    val: 1729,
    isTop: "",
    created: "2025-10-01 16:41:33",
    cluster: "healthcare",
  },
  {
    text: "Sanjeevani Hospital And Medical Research Institute, Haridwar",
    val: 1730,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Shanti Mangalick Hospital Agra, Agra",
    val: 1731,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Christian Hospital Azamgarh, Azamgarh",
    val: 1732,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Ch Kehar Singh Institute Of Para Medical Scineces & Hosp Baghpat, Baghpat",
    val: 1733,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Government General Hospital, East Godavari",
    val: 1734,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Columbus Institute Of Medical Science, Ballia",
    val: 1735,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Government General Hospital Kurnool, Kurnool",
    val: 1736,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Chandralok Institute Of Medical Sciences, Bareilly",
    val: 1737,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Prem Kumari College Of Medical Sciences, Basti",
    val: 1738,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Priyanka College Of Medical Science And Research Center, Bijnor",
    val: 1739,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Maxwell Institute Of Medical Sciences Chandauli, Chandauli",
    val: 1740,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Shri Malikhan Singh Mahavidhyalaya And Hospital Rudrapur Etah, Etah",
    val: 1741,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Asian Institute Of Allied Health Sciences Dhanbad, Dhanbad",
    val: 1742,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Indu Institute Of Medical Scinece, Firozabad",
    val: 1743,
    isTop: "",
    created: "2025-10-01 16:41:34",
    cluster: "healthcare",
  },
  {
    text: "Santosh Hospitals Ghaziabad, Ghaziabad",
    val: 1744,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Avadh Hospital Group Of Institution, Gonda",
    val: 1745,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Sri Satish Chandra Pandey Memorial Hospital, Gonda",
    val: 1746,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Fatima Institute Of Medical Sciences Gorakhpur, Gorakhpur",
    val: 1747,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Dhanwantari Institute Of Medical Sciences, Hardoi",
    val: 1748,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "St Jude'S Hospital Jhansi, Jhansi",
    val: 1749,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Ramakrishna Para Medical Science, Tumakuru",
    val: 1750,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Secab Institute Of Para Medical Sciences, Vijayapura",
    val: 1751,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "St Joseph Hospital, Ernakulam",
    val: 1752,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "One Beat College Of Medical Sciences, Kheri",
    val: 1753,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Baby Memorial Hospital Kozhikode, Kozhikode",
    val: 1754,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Sacred Heart Hospital Thrissur, Thrissur",
    val: 1755,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "St Joseph'S Hospital Thrissur, Thrissur",
    val: 1756,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Fatima Hospital Mau, Mau",
    val: 1757,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Rudra Institute Of Medical Science, Meerut",
    val: 1758,
    isTop: "",
    created: "2025-10-01 16:41:35",
    cluster: "healthcare",
  },
  {
    text: "Vivekanand Hospital And Research Centre, Moradabad",
    val: 1759,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "St George Hospital Mumbai, Mumbai",
    val: 1760,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Prema Devi Institute Of Para Medical Science Devli Sahabganj Pratapgarj Up, Pratapgarh",
    val: 1761,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Ruma Institute Of Medical Sciences, Pratapgarh",
    val: 1762,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Dwivedi Institute Of Medical Sciences, Prayagraj",
    val: 1763,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Swami Vivekanand Medical Mission, Nagpur",
    val: 1764,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Jeevan Jyoti Institute Of Medical Sciences, Prayagraj",
    val: 1765,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Tamanna Institute Of Allied Health Sciences Allahabad, Prayagraj",
    val: 1766,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Mahrshi Charak Para Medical College, Saharanpur",
    val: 1767,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Prabha Institute Of Medical Sciences Bidhiyani Khalilabad, Sant Kabeer Nagar",
    val: 1768,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Rml Institute Of Medical Sciences, Shahjahanpur",
    val: 1769,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Christian Hospital Ganjam, Ganjam",
    val: 1770,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Sacred Heart Hospital Jalandhar, Jalandhar",
    val: 1771,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Muktadhara Institute Of Medical Science, Bankura",
    val: 1772,
    isTop: "",
    created: "2025-10-01 16:41:36",
    cluster: "healthcare",
  },
  {
    text: "Santiniketan Institute Of Allied Health Science, Birbhum",
    val: 1773,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "School For Skills In Allied Health Sciences, Birbhum",
    val: 1774,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Suri Sadar Hospital Birbhum, Birbhum",
    val: 1775,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Sadar Hospital Darjeeling, Darjeeling",
    val: 1776,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Sub-Divisional Hospital Darjeeling, Darjeeling",
    val: 1777,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Anandaloke Medical Center Pvt Ltd Siliguri, Jalpaiguri",
    val: 1778,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Amri Hospitals Limited Mukundapur Kolkata, Kolkata",
    val: 1779,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Islamia Hospital, Kolkata",
    val: 1780,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Ruby General Hospital Ltd Kolkatta, Kolkata",
    val: 1781,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Sambhunath Pandit Hospital Kolkatta, Kolkata",
    val: 1782,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Vishwanath Ayurved Mahavidyalaya And Hospital, Kolkata",
    val: 1783,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Gnm Training School Ghatal S D Hospital, Medinipur West",
    val: 1784,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Anm R Training School Domkal Subdivisional And Superspeciality Hospital Murshidabad, Murshidabad",
    val: 1785,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Saktinagar Distrct Hospital, Nadia",
    val: 1786,
    isTop: "",
    created: "2025-10-01 16:41:37",
    cluster: "healthcare",
  },
  {
    text: "Indian Institute Of Medical Sciences Rauzagaon Faizabad, Ayodhya",
    val: 1787,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Christian Hospital Etah -, Kasganj",
    val: 1788,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Central Hospital, Kolkata",
    val: 1789,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Uttaran Institute Of Medical Sciences, Purba Bardhaman",
    val: 1790,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Daund Medical Foundation, Pune",
    val: 1791,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Jawaharlal Nehru Medical College, AMU, Aligarh",
    val: 1792,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Dr. Ziauddin Ahmad Dental College, AMU, Aligarh",
    val: 1793,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Faculty of Dental Sciences, BHU, Varanasi",
    val: 1794,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Dr. Harvansh Singh Judge Institute of Dental Sciences, Panjab University, Chandigarh",
    val: 1795,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "School of Sciences and Allied Health Science, Jeppiaar University, Chennai",
    val: 1796,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Davao Medical School Foundation, Davao",
    val: 1797,
    isTop: "",
    created: "2025-10-01 16:41:38",
    cluster: "healthcare",
  },
  {
    text: "Madhya Pradesh Medical Science University, Jabalpur",
    val: 1798,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "healthcare",
  },
  {
    text: "Pandit Bhagwat Dayal Sharma Post Graduate Institute of Medical Sciences, Rohtak",
    val: 1799,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "healthcare",
  },
  {
    text: "State Medical Faculty of West Bengal, West Bengal",
    val: 1800,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "healthcare",
  },
  {
    text: "Sri Balaji Vidyapeeth Mahatma Gandhi Medical College, Puducherry",
    val: 1801,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "healthcare",
  },
  {
    text: "Acharya BM Reddy College of Pharmacy, Bangalore",
    val: 1802,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Acharya Narendra Deo College of Pharmacy, Gonda",
    val: 1803,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Adarsh Shikshan Sansthas Institute of Pharmacy College, Beed",
    val: 1804,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Adesh College of Pharmacy, Muktsar",
    val: 1805,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Adhiparasakthi College of Pharmacy, Changalpattu",
    val: 1806,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Adichunchanagiri College of Pharmacy, Nagamangala",
    val: 1807,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Aditya College of Pharmacy and Science, Delhi",
    val: 1808,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Agnihotri College of Pharmacy, Wardha",
    val: 1809,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "AISSMS College of Pharmacy, Pune",
    val: 1810,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "AJ College of Pharmacy, Chennai",
    val: 1811,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Akal College of Pharmacy & Technical Education, Sangrur",
    val: 1812,
    isTop: "",
    created: "2025-10-01 16:41:39",
    cluster: "pharma",
  },
  {
    text: "Akrg College of Pharmacy, Nallagerla",
    val: 1813,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Al-Ameen College of Pharmacy, Bangalore",
    val: 1814,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Al-Falah College of Pharmacy, Hubli",
    val: 1815,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Allana College of Pharmacy, Pune",
    val: 1816,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Alshifa College of Pharmacy, Perinthalmanna",
    val: 1817,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "AMEs Vutkoor Laxmaiah College of Pharmacy, Raichur",
    val: 1818,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Amrutvahini College of Pharmacy, Sangamner",
    val: 1819,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Anand College of Pharmacy, Anand",
    val: 1820,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Andhra Yuvathi Mandali School of Pharmacy for Women, Hyderabad",
    val: 1821,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Annai Valankanni College of Pharmacy, Chennai",
    val: 1822,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Anuradha College of Pharmacy, Chikali",
    val: 1823,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Anurag Pharmacy College, Ranga Reddy",
    val: 1824,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Anwarul-Uloom College of Pharmacy, Hyderabad",
    val: 1825,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "Appasaheb Birnale College of Pharmacy, Sangli",
    val: 1826,
    isTop: "",
    created: "2025-10-01 16:41:40",
    cluster: "pharma",
  },
  {
    text: "AR College and GH Patel Institute of Pharmacy, Vallabh Vidyanagar",
    val: 1827,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Aravinda College of Pharmacy, Hyderabad",
    val: 1828,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Arulmigu Kalasalingam College of Pharmacy, Krishnakoil",
    val: 1829,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Arulmigu Kalasalingam College of Pharmacy, Srivilliputhur",
    val: 1830,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Avanthi Institute of Pharmaceutical Sciences, Ranga Reddy",
    val: 1831,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Azad College of Pharmacy, Ranga Reddy",
    val: 1832,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "B R Nahata College of Pharmacy, Mandsaur",
    val: 1833,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Baba Ishar Singh Pharmacy College, Ferozepur",
    val: 1834,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Baba Isher Singh Pharmacy College , Moga",
    val: 1835,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Baba Mungipa College of Pharmacy, Pilani",
    val: 1836,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Bajiraoji Karanjekar College of Pharmacy, Bhandara",
    val: 1837,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Bapatla College of Pharmacy, Bapatla",
    val: 1838,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Bapuji Pharmacy College, Davanagere",
    val: 1839,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Basaveshwara College of Pharmacy, Bagalkot",
    val: 1840,
    isTop: "",
    created: "2025-10-01 16:41:41",
    cluster: "pharma",
  },
  {
    text: "Bhagwan Pharmacy College, Aurangabad",
    val: 1841,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bhagwan Shikshan Prasarak Mandals Shri Bhagwan Pharmacy College, Aurangabad",
    val: 1842,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bharati College of Pharmacy, Mandya",
    val: 1843,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bharati Vidyapeeth College of Pharmacy, Mumbai",
    val: 1844,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bharati Vidyapeeths College of Pharmacy, Kolhapur",
    val: 1845,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bharati Vidyapeeths College of Pharmacy, Navi Mumbai",
    val: 1846,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bharati Vidyapeeths Poona College of Pharmacy, Pune",
    val: 1847,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bharati Vidyapeeths R and D Centre In Applied Chemistry, Pune",
    val: 1848,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bharti Vidyapeeth College of Pharmacy, Kolhapur",
    val: 1849,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bhaskar Pharmacy College, Ranga Reddy",
    val: 1850,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bhupal Nobels College of Pharmacy, Udaipur",
    val: 1851,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bhuvaneswari College of Pharmacy, Hangal",
    val: 1852,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bihar College of Pharmacy, Patna",
    val: 1853,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "BLDEA Associations College of Pharmacy, Bijapur",
    val: 1854,
    isTop: "",
    created: "2025-10-01 16:41:42",
    cluster: "pharma",
  },
  {
    text: "Bojjam Narasimhulu Pharmacy College for Women, Ranga Reddy",
    val: 1855,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Bombay College of Pharmacy, Mumbai",
    val: 1856,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "BVV Sanghas Hangal Shri Kumareshwar College of Pharmacy, Bagalkot",
    val: 1857,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "C N Krishnareddy College of Pharmacy, Bangalore",
    val: 1858,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "C U Shah College of Pharmacy for Women, Mumbai",
    val: 1859,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "C U Shah College of Pharmacy, Mumbai",
    val: 1860,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Central Drug Institute for Research, Lucknow",
    val: 1861,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Central Drug Reseach Institute (CDRI), Jaipur",
    val: 1862,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Centre for Cellular & Molecular Biology, Hyderabad",
    val: 1863,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Chaitanya College of Pharmacy, Hyderabad",
    val: 1864,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Chandigarh College of Pharmacy, Mohali",
    val: 1865,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Channabasweshwar Pharmacy College, Latur",
    val: 1866,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Cherraans College of Pharmacy, Coimbatore",
    val: 1867,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Chilkur Balaji College of Pharmacy, Warangal",
    val: 1868,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Chitkara Collge of Pharmacy, Rajpura",
    val: 1869,
    isTop: "",
    created: "2025-10-01 16:41:43",
    cluster: "pharma",
  },
  {
    text: "Chordia Institute of Pharmacy, Indore",
    val: 1870,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "CL Baid Mehta College of Pharmacy, Chennai",
    val: 1871,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "CM College of Pharmacy, Hyderabad",
    val: 1872,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "CMR College of Pharmacy, Hyderabad",
    val: 1873,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Life Science, Gwalior",
    val: 1874,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmaceutical Sciences, Berhampur",
    val: 1875,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmaceutical Sciences, Ganjam",
    val: 1876,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmaceutical Sciences, Khurda",
    val: 1877,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmaceutical Sciences, Manipal",
    val: 1878,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmaceutical Sciences, Puri",
    val: 1879,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmaceutical Sciences, Udupi",
    val: 1880,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Ahmednagar",
    val: 1881,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Bangalore",
    val: 1882,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Belgaum",
    val: 1883,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Bidar",
    val: 1884,
    isTop: "",
    created: "2025-10-01 16:41:44",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Chopda",
    val: 1885,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Coimbatore",
    val: 1886,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Delhi",
    val: 1887,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Dhule",
    val: 1888,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Faizpur",
    val: 1889,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Gulbarga",
    val: 1890,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Hubli",
    val: 1891,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Indore",
    val: 1892,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Jalgaon",
    val: 1893,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Mehsana",
    val: 1894,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Mumbai",
    val: 1895,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Nashik",
    val: 1896,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Patna",
    val: 1897,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Pipaliya",
    val: 1898,
    isTop: "",
    created: "2025-10-01 16:41:45",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Shahada",
    val: 1899,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Solapur",
    val: 1900,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy, Varanasi",
    val: 1901,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "CT Institute of Pharmaceutical Sciences , Jalandhar",
    val: 1902,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "CVM Pharmacy College, Ranga Reddy",
    val: 1903,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "D Y Patil College of Pharmacy, Pune",
    val: 1904,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Dadasaheb Balpande College of Pharmacy, Nagpur",
    val: 1905,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Dayananda Sagar College of Pharmacy, Bangalore",
    val: 1906,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "DCSs ARA College of Pharmacy, Dhule",
    val: 1907,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Deccan School of Pharmacy, Khammam",
    val: 1908,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Deevana College of Pharmacy, Hyderabad",
    val: 1909,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Dehat Vikas Pharmacy College, Faridabad",
    val: 1910,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Delhi Institute of Pharmaceutical Science & Research, Delhi",
    val: 1911,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Department of Chemistry University of Pune, Pune",
    val: 1912,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Dev Bhoomi Institute of Pharmacy and Research, Dehradun",
    val: 1913,
    isTop: "",
    created: "2025-10-01 16:41:46",
    cluster: "pharma",
  },
  {
    text: "Dev College of Pharmacy, Agra",
    val: 1914,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Devi Ahilya College of Pharmacy, Indore",
    val: 1915,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dhanvanthari Institute of Pharmaceutical Sciences, Nalgonda",
    val: 1916,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dhanvanthri College of Pharmaceutical Sciences, Khammam",
    val: 1917,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Doaba College of Pharmacy, Ropar",
    val: 1918,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Doon Valley Institute of Pharmacy and Medicine, Karnal",
    val: 1919,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dr Bhanuben Nanavati College of Pharmacy, Mumbai",
    val: 1920,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dr BR Ambedkar Institute of Pharmaceutical Science, Patna",
    val: 1921,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dr Dayaram Patel Pharmacy College, Bardoli",
    val: 1922,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dr DY Patil Pratishthans Womens College of Pharmacy, Pune",
    val: 1923,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dr H L Thimme Gowda College of Pharmacy, Bangalore",
    val: 1924,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dr HL Thimme Gowda College of Pharmacy, Kengal",
    val: 1925,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "Dr KN Modi Institute of Pharmaceutical Education and Research, Modinagar",
    val: 1926,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "DSTS Mandals College of Pharmacy, Solapur",
    val: 1927,
    isTop: "",
    created: "2025-10-01 16:41:47",
    cluster: "pharma",
  },
  {
    text: "East Point College of Pharmacy, Bangalore",
    val: 1928,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Erode College of Pharmacy, Erode",
    val: 1929,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Faculty of Pharmacy, Delhi",
    val: 1930,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Farooqia College of Pharmacy, Mysore",
    val: 1931,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Fathima College of Pharmacy, Kadayanallur",
    val: 1932,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Fatima College of Pharmacy, Vellai Kattabomman",
    val: 1933,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "G Pulla Reddy College of Pharmacy, Hyderabad",
    val: 1934,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "G Pulla Reddy Government Institute of Pharmacy, Kurnool",
    val: 1935,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Ganga Pharmacy College, Nalgonda",
    val: 1936,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Garden City College of Pharmacy, Bangalore",
    val: 1937,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Gayatri College of Pharmacy, Sambalpur",
    val: 1938,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Gayatri Institute of Pharmaceutical Sciences & Research Centre, Mahaboobnagar",
    val: 1939,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Geetadevi Khandelwal Institute of Pharmacy, Akola",
    val: 1940,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Geethanjali College of Pharmacy Keesara, Hyderabad",
    val: 1941,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "Geethanjali College of Pharmacy, Hyderabad",
    val: 1942,
    isTop: "",
    created: "2025-10-01 16:41:48",
    cluster: "pharma",
  },
  {
    text: "GHG Khalsa College of Pharmacy, Ludhiana",
    val: 1943,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "GKM College of Pharmacy, Bangalore",
    val: 1944,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Global College of Pharmacy, Hyderabad",
    val: 1945,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Goa College of Pharmacy, Panaji",
    val: 1946,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Goa College of Pharmacy, Panji",
    val: 1947,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Gouri Shankar Education Societys College of Pharmacy, Satara",
    val: 1948,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Goutham College of Pharmacy, Bangalore",
    val: 1949,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Government College of Pharmacy, Amravati",
    val: 1950,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Government College of Pharmacy, Aurangabad",
    val: 1951,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Government College of Pharmacy, Karad",
    val: 1952,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Government College of Pharmacy, Satara",
    val: 1953,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Greater Hyderabad Institute of Pharmacy, Secunderabad",
    val: 1954,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Gurram Balanarasiah Institute of Pharmacy, Hyderabad",
    val: 1955,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Guru Nanak Institute of Pharmacy, Hoshiarpur",
    val: 1956,
    isTop: "",
    created: "2025-10-01 16:41:49",
    cluster: "pharma",
  },
  {
    text: "Gurunanak College of Pharmacy, Nagpur",
    val: 1957,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Gurunanak Institute of Pharmacy, Hyderabad",
    val: 1958,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Gyana Jyothi College of Pharmacy, Ranga Reddy",
    val: 1959,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Hindu College of Pharmacy, Sonipat",
    val: 1960,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Horizon College of Pharmacy, Ranga Reddy",
    val: 1961,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Hygia Institute of Pharmaceutical Education and Research",
    val: 1962,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Indian Institute of Pharmacy, Jamshedpur",
    val: 1963,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Indira Gandhi Institute of Pharmacy Sciences, Bhuvaneshwar",
    val: 1964,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Indo-Soviet Friendship College of Pharmacy, Faridkot",
    val: 1965,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Institute of Diploma In Pharmacy, Wanadongri",
    val: 1966,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Institute of Diploma In Pharmacy, Wardha",
    val: 1967,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Institute of Life Science & Computer Application, Gwalior",
    val: 1968,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmaceutical Education & Research, Wardha",
    val: 1969,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmaceutical Education and Research, Surat",
    val: 1970,
    isTop: "",
    created: "2025-10-01 16:41:50",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmaceutical Science, Bilaspur",
    val: 1971,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmacy, Gwalior",
    val: 1972,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmacy, Jalpaiguri",
    val: 1973,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmacy, Jhansi",
    val: 1974,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmacy, Nadia",
    val: 1975,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmacy, Pusad",
    val: 1976,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmacy, Wardha",
    val: 1977,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "ISF Pharmacy College, Moga",
    val: 1978,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Islamiya Education Mohamadi Pharmacy College, Gulbarga",
    val: 1979,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "J S S College of Pharmacy, Ooty",
    val: 1980,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "J.J. College of Pharmacy, Ranga Reddy",
    val: 1981,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Janta College of Pharmacy, Sonipat",
    val: 1982,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Jay J College of Pharmacy, Chennai",
    val: 1983,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Jayadev College of Pharmacy, Bhuvaneshwar",
    val: 1984,
    isTop: "",
    created: "2025-10-01 16:41:51",
    cluster: "pharma",
  },
  {
    text: "Jayamukhi Institute of Pharmaceutical Sciences, Ranga Reddy",
    val: 1985,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "Jaydev College of Pharmaceutical Sciences, Naharakanta",
    val: 1986,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "JC Bose Institute of Life Sciences, Jhansi",
    val: 1987,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "JKK Natarajah College of Pharmacy, Salem",
    val: 1988,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "JL Chaturvedi College of Pharmacy, Nagpur",
    val: 1989,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "Joginapally B.R Pharmacy College",
    val: 1990,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "Joginpally B.R. Pharmacy College, Ranga Reddy",
    val: 1991,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "JSPM Mandals Sudhakarrao Naik College of Pharmacy, Yavatmal",
    val: 1992,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "JSS Pharmacy College, Mysore",
    val: 1993,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "Jyothishmathi College of Pharmacy, Ranga Reddy",
    val: 1994,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "K L E College of Pharmacy, Belgaum",
    val: 1995,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "K L E Societys College of Pharmacy, Bangalore",
    val: 1996,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "K Venkata Patheppa College of Pharmacy, Kolar",
    val: 1997,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "K K College of Pharmacy, Chennai",
    val: 1998,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "Kamalakshi Pandurangan College of Pharmacy, Tiruvannamalai",
    val: 1999,
    isTop: "",
    created: "2025-10-01 16:41:52",
    cluster: "pharma",
  },
  {
    text: "Kamla Nehru College of Pharmacy, Aurangabad",
    val: 2000,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "Kanak Manjari Institute of Pharmaceutical Sciences, Rourkela",
    val: 2001,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "Karnatak College of Pharmacy, Bidar",
    val: 2002,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "KB Institute of Pharmaceutical Education and Research, Gandhinagar",
    val: 2003,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "Khairthal Pharmacy College, Alwar",
    val: 2004,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "Kishanganj Pharmacy College, Kishanganj",
    val: 2005,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "KM College of Pharmacy, Madurai",
    val: 2006,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "KM Kundanani College of Pharmacy, Thane",
    val: 2007,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "KM Kundnani College of Pharmacy, Mumbai",
    val: 2008,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "KMCH College of Pharmacy, Coimbatore",
    val: 2009,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "Kottam Institute of Pharmacy, Mahaboobnagar",
    val: 2010,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "KRES Societys Pharmacy College, Bidar",
    val: 2011,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "Krupanidhi College of Pharmacy, Bangalore",
    val: 2012,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "KT Patil College of Pharmacy, Osmanabad",
    val: 2013,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "KVK College of Pharmacy, Nizamabad",
    val: 2014,
    isTop: "",
    created: "2025-10-01 16:41:53",
    cluster: "pharma",
  },
  {
    text: "Lakshmi Narain College of Pharmacy, Bhopal",
    val: 2015,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Lala Lajpat Rai College of Pharmacy, Moga",
    val: 2016,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Lallubhai Motilal College of Pharmacy, Ahmedabad",
    val: 2017,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Learners Land College of Pharmacy, Khammam",
    val: 2018,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "LM College of Pharmacy, Ahmedabad",
    val: 2019,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Lokmanya Tilak Jankalyan Shikshan Sansthas Institute of Pharmacy, Nagpur",
    val: 2020,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Lord Shiva College of Pharmacy, Sirsa",
    val: 2021,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "LS Institute of Pharmaceutical Sciences, Warangal",
    val: 2022,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Luqman College of Pharmacy, Gulbarga",
    val: 2023,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "M S Ramaiah College of Pharmacy, Bangalore",
    val: 2024,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "M.R.M. College of Pharmacy, Ranga Reddy",
    val: 2025,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Maharaja Surajmal College of Pharmacy, Bharatpur",
    val: 2026,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Maharaji College of Pharmacy, Chennai",
    val: 2027,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Maharashtra College of Pharmacy, Nilanga",
    val: 2028,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Maharashtra Institute of Pharmacy, Pune",
    val: 2029,
    isTop: "",
    created: "2025-10-01 16:41:54",
    cluster: "pharma",
  },
  {
    text: "Maharashtra Shiksha Samitis Maharashtra College of Pharmacy, Nilanga",
    val: 2030,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Maharishi Arvind College of Pharmacy, Jaipur",
    val: 2031,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Maheswara College of Pharmacy, Nalgonda",
    val: 2032,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Maheswara Institute of Pharmacy, Medak",
    val: 2033,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Malla Reddy Institute of Pharmaceutical Sciences, Hyderabad",
    val: 2034,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Manipal College of Pharmaceutical Sciences (MCOPS), Manipal",
    val: 2035,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Manipal Life Sciences Centre (MLSC), Manipal",
    val: 2036,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Manoharbhai Patel Institute of Pharmacy, Gondia",
    val: 2037,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Maratha Mandals College of Pharmacy, Belgaum",
    val: 2038,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Mesco College of Pharmacy, Hyderabad",
    val: 2039,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "MET Institute of Pharmacy, Mumbai",
    val: 2040,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "MGV Mandals College of Pharmacy, Nashik",
    val: 2041,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Milind Institute of Pharmacy, Bangalore",
    val: 2042,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "Millenium College of Pharmacy, Bhopal",
    val: 2043,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "MLR Institute of Pharmacy, Nalgonda",
    val: 2044,
    isTop: "",
    created: "2025-10-01 16:41:55",
    cluster: "pharma",
  },
  {
    text: "MMU College of Pharmacy, Bangalore",
    val: 2045,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "MN College of Pharmacy, Khambhat",
    val: 2046,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Mohammadi College of Pharmacy, Gulbarga",
    val: 2047,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Moonray Institute of Pharmaceutical Sciences, Nalgonda",
    val: 2048,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Mother Teresa Pharmacy College, Khammam",
    val: 2049,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "MRR College of B.Pharmacy, Ranga Reddy",
    val: 2050,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Mumbai College of Pharmacy, Mumbai",
    val: 2051,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "MVP Samajs College of Pharmacy, Nashik",
    val: 2052,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Nagpur College of Pharmacy, Nagpur",
    val: 2053,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Nagpur University Department of Pharmaceutical Sciences, Nagpur",
    val: 2054,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Nagrik Shikshan Sansthas College of Pharmacy, Mumbai",
    val: 2055,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Nalanda College of Pharmacy, Nalgonda",
    val: 2056,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Nanda College of Pharmacy, Erode",
    val: 2057,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "Nanded Pharmacy College, Nanded",
    val: 2058,
    isTop: "",
    created: "2025-10-01 16:41:56",
    cluster: "pharma",
  },
  {
    text: "National College of Pharmacy, Shimoga",
    val: 2059,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "National Institute of Pharmaceutical Education and Research, Hajipur",
    val: 2060,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "National Institute of Pharmaceutical Education and Research, Mohali",
    val: 2061,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Nehru Memorial College of Pharmacy, Hanumangarh",
    val: 2062,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Netaji Institute of Pharmaceutical Science, Nalgonda",
    val: 2063,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "NIPER National Institute of Pharmaceutical Education and Research, Kaul",
    val: 2064,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Nitte Gulabi Shetty Memorial Institute of Pharmaceutical Sciences, Mangalore",
    val: 2065,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Nitti Gulabi Shetty Memorial Institute of Pharmaceutical Sciences, Derlakatt",
    val: 2066,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Nizam Institute of Pharmacy, Nalgonda",
    val: 2067,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Noorie College of Pharmacy, Kolar",
    val: 2068,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Nova College of Pharmaceutical Education & Research, Ranga Reddy",
    val: 2069,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "P E S College of Pharmacy, Bangalore",
    val: 2070,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "P E Society's Modern College of Pharmacy, Pune",
    val: 2071,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "P Wadhwani College of Pharmacy, Yavatmal",
    val: 2072,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Padamshree Dr Vithalrao Patil Foundations College of Pharmacy, Ahmednagar",
    val: 2073,
    isTop: "",
    created: "2025-10-01 16:41:57",
    cluster: "pharma",
  },
  {
    text: "Padmavathi College of Pharmacy, Dharmapuri",
    val: 2074,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Paliava College of Pharmacy, Chengalpattu",
    val: 2075,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Pataldhamal Wadhwani College of Pharmacy Girijanagar, Yavatmal",
    val: 2076,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Patidar Jin Science and Dr Dayaram K Patel College of Pharmacy, Bardoli",
    val: 2077,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Patliputra College of Pharmacy, Patna",
    val: 2078,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Patlolla Ramakrishna Reddy College of Pharmacy, Warangal",
    val: 2079,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "PCTE Institute of Pharmacy, Ludhiana",
    val: 2080,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "PDEA Seth G R Sable College of Pharmacy, Pune",
    val: 2081,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Periyar College of Pharmaceutical Sciences for Girls, Tiruchirapalli",
    val: 2082,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Pharmacy College, Azamgarh",
    val: 2083,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Pharmacy Department, Bhopal",
    val: 2084,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Poona College of Pharmacy, Pune",
    val: 2085,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Pragathi Pharmacy College, Ranga Reddy",
    val: 2086,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Prasad Institute of Pharmaceutical Sciences, Warangal",
    val: 2087,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Pratap Narender Reddy College of Pharmacy, Warangal",
    val: 2088,
    isTop: "",
    created: "2025-10-01 16:41:58",
    cluster: "pharma",
  },
  {
    text: "Pratishtha Institute of Pharmaceutical Sciences, Ranga Reddy",
    val: 2089,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Pravara Rural Education Societys College of Pharmacy, Ahmednagar",
    val: 2090,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Princeton College of Pharmacy, Ranga Reddy",
    val: 2091,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Principal K M Kundnani College of Pharmacy, Mumbai",
    val: 2092,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Principle College of Pharmacy, Mumbai",
    val: 2093,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Procadence Institute of Pharmaceutical Sciences, Hyderabad",
    val: 2094,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "PRRM College of Pharmacy, Ranga Reddy",
    val: 2095,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "PSGVP Mandals College of Pharmacy, Nandurbar",
    val: 2096,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Pune Jilha Shikshan Mandals Sheth GR Sabale College of Pharmacy, Saswad",
    val: 2097,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "R C Patel College of Pharmacy, Shirpur",
    val: 2098,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Rajgad Dnyanpeeth's College of Pharmacy, Bhor",
    val: 2099,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Rajgad Dnyanpeeths College of Pharmacy, Pune",
    val: 2100,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Rajiv Gandhi Institute of Pharmacy, Jammu",
    val: 2101,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Rajiv Memorial Academy for Pharmacy, Mathura",
    val: 2102,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Ranchi College of Pharmacy, Ranchi",
    val: 2103,
    isTop: "",
    created: "2025-10-01 16:41:59",
    cluster: "pharma",
  },
  {
    text: "Rashtriya Rachanathmak Karya Samithis College of Pharmacy, Naupada",
    val: 2104,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "Ravi Bahu Uddeshiy Shikshan Sansthas Institute of Pharmacy, Nagpur",
    val: 2105,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "Rayat and Bahra Institute of Pharmacy, Kharrar",
    val: 2106,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "Rayat College of Pharmacy, Ropar",
    val: 2107,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "RBVRR Women's College of Pharmacy, Hyderabad",
    val: 2108,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "Rofel College of Pharmacy, Vapi",
    val: 2109,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "Roland Institute of Pharmaceutical Sciences, Berhampur",
    val: 2110,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "Roorkee College of Pharmacy, Roorkee",
    val: 2111,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "Rosory College of Pharmacy, Ranga Reddy",
    val: 2112,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "RRKs Smiths Pharmacy College, Bidar",
    val: 2113,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "Rural College of Pharmacy, Bangalore",
    val: 2114,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "RVS College of Pharmaceutical Sciences, Coimbatore",
    val: 2115,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "S B College of Pharmacy, Sivakasi",
    val: 2116,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "S Chattanatha karayalar College of Pharmacy, Tenkasi",
    val: 2117,
    isTop: "",
    created: "2025-10-01 16:42:00",
    cluster: "pharma",
  },
  {
    text: "S V Bhavan's College of Pharmacy, Thane",
    val: 2118,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "S V E Society's College of Pharmacy, Humanabad",
    val: 2119,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "SA Rajas Pharmacy College, Raja Nagar",
    val: 2120,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Sachdeva College of Pharmacy, Kharrar",
    val: 2121,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Sai Pranavi College of Pharmacy, Mahaboobnagar",
    val: 2122,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Samskruti College of Pharmacy, Ranga Reddy",
    val: 2123,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Sana College of Pharmacy, Nalgonda",
    val: 2124,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Sanjivini College of Pharmaceutical Sciences, Khetri",
    val: 2125,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Sankaralingam Bhuvaneshwari College of Pharmacy, Sivakasi",
    val: 2126,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Santosh College of Pharmacy, Ghaziabad",
    val: 2127,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Sarasvati Vidya Bhawans College of Pharmacy, Mumbai",
    val: 2128,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Saraswathi College of Pharmaceutical Sciences, Khammam",
    val: 2129,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Saraswati Vidya Bhavans College of Pharmacy, Thane",
    val: 2130,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "School of Life Science, Agra",
    val: 2131,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "SD College of Pharmacy, Barnala",
    val: 2132,
    isTop: "",
    created: "2025-10-01 16:42:01",
    cluster: "pharma",
  },
  {
    text: "Seemantha Institute of Pharmaceutical Sciences, Jharapokharia",
    val: 2133,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "SES's R C Patel College of Pharmacy, Dhule",
    val: 2134,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Seth Govind Raghunath Sable College of Pharmacy, Pune",
    val: 2135,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shadan College of Pharmacy, Hyderabad",
    val: 2136,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shadan Women's College of Pharmacy, Hyderabad",
    val: 2137,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shantha Institute of Pharmaceutical Sciences, Ranga Reddy",
    val: 2138,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shantilal Shah Pharmacy College, Bhavnagar",
    val: 2139,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Sharad Pawar College of Pharmacy, Nagpur",
    val: 2140,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shikshan Prasarak Mandals Lokmanya Tilak College of Pharmacy, Vani",
    val: 2141,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shivajinagar Vidya Prasarak Mandal's College of Pharmacy, Pune",
    val: 2142,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shivalik College of Pharmacy, Nangal",
    val: 2143,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shivnagar Vidya Prasarak Mandals College of Pharmacy, Pune",
    val: 2144,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shree SK Patel College of Pharmaceutical Education and Research, Mehsana",
    val: 2145,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shri B M Shah College of Pharmacy, Madasa",
    val: 2146,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shri Baba Mast Nath Institute of Pharmaceutical Sciences and Research, Rohtak",
    val: 2147,
    isTop: "",
    created: "2025-10-01 16:42:02",
    cluster: "pharma",
  },
  {
    text: "Shri Bhagwan College of Pharmacy, Aurangabad",
    val: 2148,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri BK Modi Government Pharmacy College, Rajkot",
    val: 2149,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri BM Shah College of Pharmacy, Modasa",
    val: 2150,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri BV Patel Pharmaceutical Education & Research Department Centre, Ahmedabad",
    val: 2151,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri Gopi Chand College of Pharmacy, Bhagpat",
    val: 2152,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri Gopichand College of Pharmacy, Meerut",
    val: 2153,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri GSSs Institute of Pharmacy, Akola",
    val: 2154,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri Sarvajanic College of Pharmacy, Mehsana",
    val: 2155,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri Sharda Bhavan Education Societys B Pharmacy college, Nanded",
    val: 2156,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri SK Patel College of Pharmaceutical Education and Research, Kherva",
    val: 2157,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Shri SS Pharmacy College, Bhavnagar",
    val: 2158,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Siddeshwar College of Pharmaceutical Science, Balasore",
    val: 2159,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "SIM College of Pharmacy, Chitradurga",
    val: 2160,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "SIMS College of Pharmacy, Guntur",
    val: 2161,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Sinhgad College of Pharmacy, Pune",
    val: 2162,
    isTop: "",
    created: "2025-10-01 16:42:03",
    cluster: "pharma",
  },
  {
    text: "Sir Vishnu College of Pharmacy, Bhimavaram",
    val: 2163,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Sitha Institute of Pharmaceutical Science, Karimnagar",
    val: 2164,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "SJM College of Pharmacy, Chitradurga",
    val: 2165,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "SLC's College of Pharmacy, Hyderabad",
    val: 2166,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Smiriti College of Pharmaceutical Education, Indore",
    val: 2167,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Smt K B College of Pharmacy, Nagpur",
    val: 2168,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Smt Kishoritai Bhoyar College of Pharmacy, Nagpur",
    val: 2169,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Smt RD Dardi Government Pharmacy College, Lakhtar",
    val: 2170,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Smt SS Patil College of Pharmacy, Jalgaon",
    val: 2171,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "SND College of Pharmacy, Yeola",
    val: 2172,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Sonekar College of Pharmacy, Nagpur",
    val: 2173,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Sree Chaitanya Institute of Pharmaceutical Sciences, Karimnagar",
    val: 2174,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Sree Datha Institute of Pharmacy, Karimnagar",
    val: 2175,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Sree Nagarjuna College of Pharmacy, Ranga Reddy",
    val: 2176,
    isTop: "",
    created: "2025-10-01 16:42:04",
    cluster: "pharma",
  },
  {
    text: "Sree Siddaganga College of Pharmacy, Tumkur",
    val: 2177,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Adichunchanagiri College of Pharmacy, Mandya",
    val: 2178,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Guru Gobind College of Pharmacy, Chandigarh",
    val: 2179,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Indu Institute of Pharmacy, Ranga Reddy",
    val: 2180,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Jaydev College of Pharmaceutical Sciences, Khurda",
    val: 2181,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri KV College of Pharmacy, Chikkaballapur",
    val: 2182,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "SRI PADMAVATHI SCHOOL OF PHARMACY, Tirupati",
    val: 2183,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Ramachandra College of Pharmacy, Chennai",
    val: 2184,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Sai College of Pharmacy, Pathankot",
    val: 2185,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Sarada College of Pharmacy, Mahaboobnagar",
    val: 2186,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Venkateswara College of Pharmacy, Hyderabad",
    val: 2187,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Sri Venkateswara College of Pharmacy, Etcherla",
    val: 2188,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Srinivasa Institute of Pharmaceutical Sciences, Ranga Reddy",
    val: 2189,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "Srinivasa Pharmaceutical Institute and Centre for Research, Ranga Reddy",
    val: 2190,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "SRM College of Pharmacy, Kattankolathur",
    val: 2191,
    isTop: "",
    created: "2025-10-01 16:42:05",
    cluster: "pharma",
  },
  {
    text: "SSJ College of Pharmacy, Khammam",
    val: 2192,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "St John's College of Pharmacy, Bangalore",
    val: 2193,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "St Peters Institute of Pharmaceutical Sciences, Hanamkonda",
    val: 2194,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "St. Mary's Pharmacy College, Hyderabad",
    val: 2195,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "St.Marys College of Pharmacy, Nalgonda",
    val: 2196,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "St.Peter's Institute of Pharmaceutical Education & Research, Ranga Reddy",
    val: 2197,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "St.Peters College of Pharmacy, Ranga Reddy",
    val: 2198,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "Sudhakarrao Naik Institute of Pharmacy, Yeotmal",
    val: 2199,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "Sultan Ul Uloom College of Pharmacy, Warangal",
    val: 2200,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "Sultan-ul-Uloom College of Pharmacy, Hyderabad",
    val: 2201,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "Sushrut Institute of Pharmacy, Warangal",
    val: 2202,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "SVB Pharmacy College, Mumbai",
    val: 2203,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "Swami Ramananda Tirtha Institute of Pharmaceutical Sciences, Ranga Reddy",
    val: 2204,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "Swamy Vivekananda College of Pharmacy, Namakkal",
    val: 2205,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "T S College of Pharmacy, Mumbai",
    val: 2206,
    isTop: "",
    created: "2025-10-01 16:42:06",
    cluster: "pharma",
  },
  {
    text: "Tapi Valley Education Societys College of Pharmacy, Jalgaon",
    val: 2207,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "Teegala Krishna Reddy College of Pharmacy, Ranga Reddy",
    val: 2208,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "Teja College of Pharmacy, Hyderabad",
    val: 2209,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "Thanthai Roever Institute of Pharmaceutical Sciences, Perambalur",
    val: 2210,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "The Kalapur Co-operative Bank Pharmacy College, Gandhinagar",
    val: 2211,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "The Oxford College of Pharmacy, Bangalore",
    val: 2212,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "The Pharmaceutical College, Bargarh",
    val: 2213,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "Tipu Sultan College of Pharmacy, Gulbarga",
    val: 2214,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "Tirumala College of Pharmacy, Ranga Reddy",
    val: 2215,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "TMAE Societys SES Pharmacy College, Harpanahalli",
    val: 2216,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "TMAEs SCS College of Pharmacy, Bellary",
    val: 2217,
    isTop: "",
    created: "2025-10-01 16:42:07",
    cluster: "pharma",
  },
  {
    text: "Togari Veeramallappa Memorial College of Pharmacy, Bellary",
    val: 2218,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Trichy College of Pharmacy, Tiruchirapalli",
    val: 2219,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "TRR College of Pharmacy, Medak",
    val: 2220,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "TVM College of Pharmacy, Bellary",
    val: 2221,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Ultra College of Pharmacy, Madurai",
    val: 2222,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "University College of Pharmaceutical Sciences, Warangal",
    val: 2223,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vaagdevi College of Pharmacy, Vaagdevi",
    val: 2224,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vaagdevi Pharmacy College, Warangal",
    val: 2225,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vagdevi College of Pharmacy, Hanamkonda",
    val: 2226,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vageswari Institute of Pharmaceutical Sciences, Karimnagar",
    val: 2227,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vasavi Pharmacy College, Bellary",
    val: 2228,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vathsalya College of Pharmacy, Hyderabad",
    val: 2229,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Venkateshwara Institute of Pharmaceutical Sciences, Ranga Reddy",
    val: 2230,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vidya Bharati College of Pharmacy, Amravati",
    val: 2231,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vignan Institute of Pharmaceutical Sciences, Nalgonda",
    val: 2232,
    isTop: "",
    created: "2025-10-01 16:42:08",
    cluster: "pharma",
  },
  {
    text: "Vijaya College of Pharmacy, Nizamabad",
    val: 2233,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Vikas Institute of Pharmaceutical Sciences, Rajahmundry",
    val: 2234,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Vinayaka Mission's College of Pharmacy",
    val: 2235,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Vinayaka Missions College of Pharmacy, Salem",
    val: 2236,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Vishnu Institute of Pharmaceutical Education and Research, Hyderabad",
    val: 2237,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Vision College of Pharmaceutical Sciences & Research, Hyderabad",
    val: 2238,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Visveswarapura Institute of Pharmaceutical Sciences, Bangalore",
    val: 2239,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Vivekananda College of Pharmacy, Bangalore",
    val: 2240,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "VMHP Shah College of Pharmacy, Thane",
    val: 2241,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "VMS College of PharmacyAmritsar Road, Batala",
    val: 2242,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "VNS Institute of Pharmacy, Bhopal",
    val: 2243,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "VV Sanghas TV Memorial College of Pharmacy, Bellary",
    val: 2244,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "YB Chavan College of Pharmacy, Aurangabad",
    val: 2245,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Biopharma Institute",
    val: 2246,
    isTop: "",
    created: "2025-10-01 16:42:09",
    cluster: "pharma",
  },
  {
    text: "Ashokrao Mane Institute Of Pharmacy, AMBAP",
    val: 2247,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Acropolis Institute of Pharmaceutical Education and Research (AIPER), Indore",
    val: 2248,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Government College of Pharmacy, Bangalore",
    val: 2249,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Pulla Reddy Institute of Pharmacy, Hyderabad",
    val: 2250,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Teegala Ram Reddy College of Pharmacy, Ranga Reddy",
    val: 2251,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Seven Hills College of Pharmacy, Tirupati",
    val: 2252,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Tirumala College of Pharmacy, Nizamabad",
    val: 2253,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Parul Institute of Pharmacy & Research, Vadodara",
    val: 2254,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "PPG College Of Pharmacy, Coimbatore",
    val: 2255,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Chalapathi Institute of Pharmaceutical Sciences (CLPT), Guntur",
    val: 2256,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Dayanand Dinanath College (DDC), Institute of Pharmacy, Kanpur",
    val: 2257,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "KGRL College of Pharmacy, Bhimavaram",
    val: 2258,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "SSM College of Pharmacy, Erode",
    val: 2259,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Vignan Pharmacy College (VPC), Guntur",
    val: 2260,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Amrita Center for Nanosciences and Molecular Medicine (ASNSMM), Kochi",
    val: 2261,
    isTop: "",
    created: "2025-10-01 16:42:10",
    cluster: "pharma",
  },
  {
    text: "Laddhad College of Pharmacy, Buldana",
    val: 2262,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Aadhi Bhagawan College of Pharmacy, Tiruvannamalai",
    val: 2263,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "ACME Institute of Pharmacy, Bareilly",
    val: 2264,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Adina Institute of Pharmaceutical Science (AIPS), Sagar",
    val: 2265,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Aditya Bengaluru Institute of Pharmacy Education and Research, Bengaluru",
    val: 2266,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Aditya Diploma Institute of Pharmacy, Beed",
    val: 2267,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Advanced Institute of Pharmacy (AIP), Palwal",
    val: 2268,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Ahinsa Institute of Pharmacy, Dhule",
    val: 2269,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Ali Allana College of Pharmacy, Akkalkuwa",
    val: 2270,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Anand Charitable Sanstha's College of Pharmaceutical Science and Research, Ashti",
    val: 2271,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "AM Reddy Memorial College of Pharmacy, Guntur",
    val: 2272,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Aman Pharmacy College Dholakhera, Udaipurwati",
    val: 2273,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Ambekeshwar Institute of Pharmaceutical Sciences, Lucknow",
    val: 2274,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Ankerite College of Pharmacy, Lucknow",
    val: 2275,
    isTop: "",
    created: "2025-10-01 16:42:11",
    cluster: "pharma",
  },
  {
    text: "Amrita School of Pharmacy, Kochi",
    val: 2276,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Annasaheb Dange College of B Pharmacy (ADCBP), Sangli",
    val: 2277,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Anurag College of Pharmacy, Bhandara",
    val: 2278,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Apollo College of Pharmacy, Durg",
    val: 2279,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Aryakul College of Pharmacy And Research, Raebareli",
    val: 2280,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Aryakul College of Pharmacy and Research, Sitapur",
    val: 2281,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Aryans College of Pharmacy, Patiala",
    val: 2282,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Ashokrao Mane College of Pharmacy, Kolhapur",
    val: 2283,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "B K Patil Institute of Pharmacy, Mumbai",
    val: 2284,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "B V Patel Pharmaceutical Education and Research Development (PERD) Centre, Ahmedabad",
    val: 2285,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Baba Farid College of Pharmacy, Ludhiana",
    val: 2286,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Baba Loknath Indian Institute of Pharmacy Science and Research Centre, Sagar",
    val: 2287,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Bengal Institute of Pharmaceutical Sciences, Nadia",
    val: 2288,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Bhabha Pharmacy Research Institute (BPRI), Bhopal",
    val: 2289,
    isTop: "",
    created: "2025-10-01 16:42:12",
    cluster: "pharma",
  },
  {
    text: "Bhagwan Aadinath College of Pharmacy, Lalitpur",
    val: 2290,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Bengal College of Pharmaceutical Science and Research (BCPSR), Durgapur",
    val: 2291,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Bhagwant Institute of Pharmacy (BIP), Muzaffarnagar",
    val: 2292,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Bhaskara Institute of Pharmacy, Vizianagaram",
    val: 2293,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Bhupal Nobles Institute of Pharmaceutical Sciences, Udaipur",
    val: 2294,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Bharti Institute of Pharmaceutical Science, Sriganganagar",
    val: 2295,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Bharti Institute of Pharmacy, Durg",
    val: 2296,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Bombay Institute of Pharmacy, Hanumangarh",
    val: 2297,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Bomma Institute of Pharmacy, Khammam",
    val: 2298,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "BPS Educational Institution of Pharmacy, Etah",
    val: 2299,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Buddha Institute of Pharmacy, Gorakhpur",
    val: 2300,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Ch Sughar Singh Pharmacy College, Etawah",
    val: 2301,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Chebrolu Hanumaiah Institute of Pharmaceutical Sciences, Guntur",
    val: 2302,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Chemists College of Pharmaceutical Sciences and Research, Ernakulam",
    val: 2303,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "Chandra Shekhar Singh College of Pharmacy, Kaushambi",
    val: 2304,
    isTop: "",
    created: "2025-10-01 16:42:13",
    cluster: "pharma",
  },
  {
    text: "CLG Pharmacy College, Pali",
    val: 2305,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Daksh Institute of Pharmaceutical Science, Chhatarpur",
    val: 2306,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "DBM College of Pharmacy, Korba",
    val: 2307,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Dev Kumari Raja Ram Pharmacy Shikshan Sansthan (DKRRPSS), Sitapur",
    val: 2308,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Devaki Amma Memorial College of Pharmacy, Malappuram",
    val: 2309,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Delonix Society's Baramati College of Pharmacy, Pune",
    val: 2310,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "DJPS College of Pharmacy, Jintur",
    val: 2311,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Dr Ambedkar Institute of Pharmaceutical Science, Sundargarh",
    val: 2312,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Distinctive Education Society's Dnyanvilas College of Pharmacy, Pune",
    val: 2313,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Dr Naikwadi College of D Pharmacy, Nashik",
    val: 2314,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Dr Gurachar Nargund College of Pharmacy, Koppal",
    val: 2315,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Dr NB Institute of Pharmacy Education and Research, Chitradurga",
    val: 2316,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Dr Om Prakash School of Pharmacy, Farrukhabad",
    val: 2317,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Dr Pushpendra Singh College of Pharmacy, Farrukhabad",
    val: 2318,
    isTop: "",
    created: "2025-10-01 16:42:14",
    cluster: "pharma",
  },
  {
    text: "Dr Radhakrishnan Pharmacy College, Nagaur",
    val: 2319,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "Dr Joseph Mar Thoma Institute of Pharmaceutical Sciences and Research, Alleppey",
    val: 2320,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "DR Karigowda College of Pharmacy, Hassan",
    val: 2321,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "Dr Rajendra Gode College of Pharmacy, Malkapur",
    val: 2322,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "Dr Mahendra Kumar Chhotelal Bind College of Pharmacy, Prayagraj",
    val: 2323,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "Dr RG Bhoyar Institute of Pharmaceutical Education and Research, Wardha",
    val: 2324,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "Dr Samuel George Institute of Pharmaceutical Sciences, Markapur",
    val: 2325,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "Dr Shivajirao Kadam College of Pharmacy, Sangli",
    val: 2326,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "DSR Ullah Institute of Pharmaceutical Sciences, Kalburagi",
    val: 2327,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "Dr Vedprakash Patil Pharmacy College, Aurangabad",
    val: 2328,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "ELIMS College of Pharmacy, Thrissur",
    val: 2329,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "ERK College of Pharmacy, Dharmapuri",
    val: 2330,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "FI Pharmacy College, Lucknow",
    val: 2331,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "Ezhuthachan College of Pharmaceutical Sciences, Marayamuttom",
    val: 2332,
    isTop: "",
    created: "2025-10-01 16:42:15",
    cluster: "pharma",
  },
  {
    text: "GD Memorial College of Pharmacy,Jodhpur",
    val: 2333,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Geeta Institute of Pharmacy, Panipat",
    val: 2334,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Geeta Pharmacy College, Lucknow",
    val: 2335,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Gauri Shankar Institute of Pharmaceutical Education and Research, Satara",
    val: 2336,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Gautam Buddha College of Pharmacy, Lucknow",
    val: 2337,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Gautam Institute of Pharmacy, Nalanda",
    val: 2338,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Giet School of Pharmacy, Rajahmundry",
    val: 2339,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Girijananda Chowdhury Institute of Pharmaceutical Science (GIPS), Guwahati",
    val: 2340,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Girijananda Chowdhury institute of Pharmaceutical Science (GIPS), Tezpur",
    val: 2341,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Gland Institute of Pharmaceutical Sciences, Medak",
    val: 2342,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "Godavari Institute of Pharmacy, Latur",
    val: 2343,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "GM Institute of Pharmaceutical Sciences and Research, Davangere",
    val: 2344,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "GMS College of Pharmacy, Amroha",
    val: 2345,
    isTop: "",
    created: "2025-10-01 16:42:16",
    cluster: "pharma",
  },
  {
    text: "GNIT College of Pharmacy, Noida",
    val: 2346,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Government Pharmacy Institute (GPI), Ranchi",
    val: 2347,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Government Pharmacy Institute, Patna",
    val: 2348,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Govindrao Nikam College of Pharmacy, Sawarde",
    val: 2349,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "GSRM Memorial College of Pharmacy, Lucknow",
    val: 2350,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Guru Binda College of Pharmaceutical Sciences, Nawada",
    val: 2351,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Green City College of Pharmacy, Bengaluru",
    val: 2352,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "GRY Institute of Pharmacy, Khargone",
    val: 2353,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Gurugram Global College of Pharmacy (GGCP), Gurugram",
    val: 2354,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Gurukrupa Institute of Pharmacy, Beed",
    val: 2355,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Hakikullah Chaudhary College of Pharmacy, Gonda",
    val: 2356,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Haldia Institute of Pharmacy, Medinipur",
    val: 2357,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Hill Grove Institute of Pharmacy, Pali",
    val: 2358,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Harsha College of Pharmacy, Bengaluru",
    val: 2359,
    isTop: "",
    created: "2025-10-01 16:42:17",
    cluster: "pharma",
  },
  {
    text: "Himachal Institute of Pharmaceutical, Hamirpur",
    val: 2360,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Himachal Institutes of Life Sciences, Paonta Sahib",
    val: 2361,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Himachal Institutes of Pharmacy, Paonta Sahib",
    val: 2362,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Himachal Pharmacy College (HPC), Solan",
    val: 2363,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Himalayan Institute of Pharmacy and Research, Dehradun",
    val: 2364,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Himalayan Institute of Pharmacy, Sirmour",
    val: 2365,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Himalayan Pharmacy Institute, Rangpo",
    val: 2366,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Hightech College of Pharmacy, Chandrapur",
    val: 2367,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "IBNE Seena Pharmacy College, Hardoi",
    val: 2368,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Ideal Institute of Pharmacy, Palghar",
    val: 2369,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "HSNCB's Dr L H Hiranandani College of Pharmacy, Thane",
    val: 2370,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Indira Institute of Pharmacy, Ratnagiri",
    val: 2371,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "IMT Pharmacy College, Puri",
    val: 2372,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Indu Prakash Pharmacy College, Mau",
    val: 2373,
    isTop: "",
    created: "2025-10-01 16:42:18",
    cluster: "pharma",
  },
  {
    text: "Ishwar Deshmukh Institute of Pharmacy, Yavatmal",
    val: 2374,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmaceutical Science and Research For Girls, Pune",
    val: 2375,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "Jagmeet Memorial College of Pharmacy, Bijnor",
    val: 2376,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "Jamia Salaffiyya College of Pharmacy, Malappuram",
    val: 2377,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "Jan Nayak Choudhary Devi Lal College of Pharmacy, Sirsa",
    val: 2378,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "JDSR Institute of Pharmacy, Shahjahanpur",
    val: 2379,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "JMB Institute of Life Sciences and Higher Education, Pilibhit",
    val: 2380,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "KB Raval College of Pharmacy, Gandhinagar",
    val: 2381,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "KDC College of Pharmacy, Mathura",
    val: 2382,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "Kerala Academy of Pharmacy, Thiruvananthapuram",
    val: 2383,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "Kinetic Institute Department of Pharmacy, Shahjahanpur",
    val: 2384,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "KITS College of Pharmacy for Women, East Godavari",
    val: 2385,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "KMCT College of Pharmacy, Malappuram",
    val: 2386,
    isTop: "",
    created: "2025-10-01 16:42:19",
    cluster: "pharma",
  },
  {
    text: "Kota College of Pharmacy, Kota",
    val: 2387,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Kunwar Hari Bansh Singh College of Pharmacy, Jaunpur",
    val: 2388,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Kunwar Haribansh Singh College of Pharmacy, Jaunpur",
    val: 2389,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Kurma Sanskriti Institute of Pharmaceutical Science, Jehanabad",
    val: 2390,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Krishna College of Pharmacy, Tiruchirappalli",
    val: 2391,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "KYDSCT College of Pharmacy, Jalgaon",
    val: 2392,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Krishnarpit Institute of Pharmacy, Prayagraj",
    val: 2393,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "KRS College of Pharmacy, Gonda",
    val: 2394,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Laureate Institute of Pharmacy, Kangra",
    val: 2395,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Laxman Seth Pharmacy College, Shivpuri",
    val: 2396,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Laxmi College of Pharmacy, Jaipur",
    val: 2397,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Laxminarayan Dev College of Pharmacy, Bharuch",
    val: 2398,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "LCIT School of Pharmacy, Bilaspur",
    val: 2399,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Late Bhagirathi Yashwantrao Pathrikar College of Pharmacy, Pune",
    val: 2400,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Late KL Pandey School of Pharmacy, Barwani",
    val: 2401,
    isTop: "",
    created: "2025-10-01 16:42:20",
    cluster: "pharma",
  },
  {
    text: "Late Narayandas Bhavandas Chabada Institute of Pharmacy, Satara",
    val: 2402,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Lisie College of Pharmacy, Ernakulam",
    val: 2403,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Lucknow Institute of Pharmacy, Lucknow",
    val: 2404,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Lucknow Model College of Pharmacy, Lucknow",
    val: 2405,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Loknete Shri Dadapatil Pharate College of Pharmacy, Pune",
    val: 2406,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Maa Shanta Devi College of Pharmacy, Betul",
    val: 2407,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Mahadeva Lal Schroff College of Pharmacy, Aurangabad",
    val: 2408,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Maharaja Agrasen College of Pharmacy, Bharatpur",
    val: 2409,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Mahati College of Pharmacy, Chittoor",
    val: 2410,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Mahatma Gandhi College of Pharmaceutical Sciences, Jaipur",
    val: 2411,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Mahatma Gandhi Institute of Pharmacy, Lucknow",
    val: 2412,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Maharshi Arvind International Institute of Pharmacy, Kota",
    val: 2413,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Mahatma Gandhi Vidyamandir's Samajshree Prashant Hiray College of Pharmacy, Malegaon",
    val: 2414,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Maliba Pharmacy College, Surat",
    val: 2415,
    isTop: "",
    created: "2025-10-01 16:42:21",
    cluster: "pharma",
  },
  {
    text: "Mahender Singh College of Pharmacy, Palwal",
    val: 2416,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Mandesh Institute of Pharmaceutical Science and Research Center, Satara",
    val: 2417,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Maya Institute of Pharmacy, Hathras",
    val: 2418,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Mathuradevi Institute of Pharmacy, Indore",
    val: 2419,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "MDA School of Pharmacy, Latur",
    val: 2420,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Medarametla Anjamma Mastan Rao College of Pharmacy, Guntur",
    val: 2421,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Maulana Azad Institute of Pharmacy, Jodhpur",
    val: 2422,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Max Institute of Pharmaceutical Sciences, Khammam",
    val: 2423,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "MESCO Institute of Pharmacy (MIP), Amroha",
    val: 2424,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Mitransh College of Pharmacy, Nagaur",
    val: 2425,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Mittal Institute of Pharmacy, Bhopal",
    val: 2426,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "MET's Institute of Pharmacy, Nashik",
    val: 2427,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Mohammadiya Institute of Pharmacy, Khammam",
    val: 2428,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Moulana Abul Kalam Azad College of Pharmacy, Raipur",
    val: 2429,
    isTop: "",
    created: "2025-10-01 16:42:22",
    cluster: "pharma",
  },
  {
    text: "Mookambika College of Pharmaceutical Sciences and Research, Ernakulam",
    val: 2430,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Mother Theresa Institute of Pharmaceutical Education and Research, Kurnool",
    val: 2431,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Nagaji Institute of Pharmaceutical Science, Thakur Baba Campus, Jhansi",
    val: 2432,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Narasaraopet Institute of Pharmaceutical Sciences, Narasaraopet",
    val: 2433,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Narayana Pharmacy College, Nellore",
    val: 2434,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Nalanda Institute of Pharmaceutical Sciences, Guntur",
    val: 2435,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Nand Kishore College of Pharmacy, Prayagraj",
    val: 2436,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "NEF College of Pharmacy, Guwahati",
    val: 2437,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Nehru College of Pharmacy, Thrissur",
    val: 2438,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Nibha Institute of Pharmaceutical Sciences, Nalanda",
    val: 2439,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Nova College of Pharmacy, Lucknow",
    val: 2440,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Nirmala College of Pharmacy, Muvattupuzha",
    val: 2441,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Novel Institute of Pharmacy, Bhopal",
    val: 2442,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "NR Vekaria Institute of Pharmacy, Junagadh",
    val: 2443,
    isTop: "",
    created: "2025-10-01 16:42:23",
    cluster: "pharma",
  },
  {
    text: "Nityananda College of Pharmacy, Baleshwar",
    val: 2444,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "OJAS College of Pharmacy, Jalna",
    val: 2445,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Nootan Pharmacy College, Visnagar",
    val: 2446,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Oriental Institute of Pharmacy, Balaghat",
    val: 2447,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Orlean College of Pharmacy, Noida",
    val: 2448,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Pallavan Pharmacy College, Kanchipuram",
    val: 2449,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Oxford College of Pharmacy, Hapur",
    val: 2450,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Oyster Institute of Pharmacy, Aurangabad",
    val: 2451,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "PA College of Pharmacy, Mangaluru",
    val: 2452,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Poddar International College of Pharmacy, Jaipur",
    val: 2453,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Pratibhatai Pawar College of Pharmacy, Ahmednagar",
    val: 2454,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Prabhat Institute of Pharmacy, Kurnool",
    val: 2455,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Prabhath Institute of Pharmacy, Kurnool",
    val: 2456,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Puran Murti College of Pharmacy, Sonipat",
    val: 2457,
    isTop: "",
    created: "2025-10-01 16:42:24",
    cluster: "pharma",
  },
  {
    text: "Raigad College of Pharmacy, Mohopre",
    val: 2458,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Raipur Institute of Pharmaceutical Education and Research, Raipur",
    val: 2459,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Radha Govind Institute of Pharmacy, Chandausi",
    val: 2460,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Rajarshi Rananjay Sinh College of Pharmacy, Amethi",
    val: 2461,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Radiant Institute of Pharmaceutical Sciences, Kishanganj",
    val: 2462,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Raghavendra Institute of Pharmaceutical Education and Research, Anantapur",
    val: 2463,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Rahman Institute of Pharmaceutical Sciences and Research, Kamrup",
    val: 2464,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Rajesh Bhaiyya Tope College of B Pharmacy, Pune",
    val: 2465,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Rajiv Gandhi Institute of Pharmaceutical Sciences and Research (RIPSAR), Kasargode",
    val: 2466,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "RDS College of Pharmacy, Jaunpur",
    val: 2467,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Rao's College of Pharmacy, Nellore",
    val: 2468,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Raosaheb Patil Danve College of Pharmacy, Badnapur",
    val: 2469,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Rashtriya Shikshan Mandal NN Sattha College of Pharmacy, Ahmednagar",
    val: 2470,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Ratnam Institute of Pharmacy, Nellore",
    val: 2471,
    isTop: "",
    created: "2025-10-01 16:42:25",
    cluster: "pharma",
  },
  {
    text: "Royal College of Pharmacy and Health Sciences, Berhampur",
    val: 2472,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Rungta Institute of Pharmaceutical Sciences and Research, Bhilai",
    val: 2473,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "RK Institute of Pharmacy, Bareilly",
    val: 2474,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Saastra College of Pharmaceutical Educational and Research, Guduru",
    val: 2475,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Saikrupa Institute of Pharmacy, Ahmednagar",
    val: 2476,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Sanjivani Institute of Pharmacy II, Jarhabhata",
    val: 2477,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Sanjo College of Pharmaceutical Studies, Palakkad",
    val: 2478,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Saraswati College of Pharmacy, Mohali",
    val: 2479,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Saraswati Institute of Pharmacy, Nanded",
    val: 2480,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Sardar Patel College of Pharmacy, Gorakhpur",
    val: 2481,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Sarojini Naidu Vanita Pharmacy Maha Vidyalaya, Hyderabad",
    val: 2482,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Scient Institute of Pharmacy, Hyderabad",
    val: 2483,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Shambhunath Institute of Pharmacy, Prayagraj",
    val: 2484,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Shankar Reddy Institute of Pharmaceutical Sciences, Bestawaripeta",
    val: 2485,
    isTop: "",
    created: "2025-10-01 16:42:26",
    cluster: "pharma",
  },
  {
    text: "Shanti Niketan College of Pharmacy, Mandi",
    val: 2486,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shantiniketan College of Pharmacy, Ahmednagar",
    val: 2487,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shardabai Pawar Institute of Pharmaceutical Sciences and Research, Pune",
    val: 2488,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shekhawati College of Pharmacy, Jhunjhunu",
    val: 2489,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shree Dhanvantary Pharmacy College, Olpad",
    val: 2490,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shree Goraksha College of Pharmacy and Research Centre, Khamgaon",
    val: 2491,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shivajirao Pawar College of Pharmacy, Ahmednagar",
    val: 2492,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shivam Pharmaceutical Studies and Research Centre, Anand",
    val: 2493,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shree Naranjibhai Lalbhai Patel College of Pharmacy, Surat",
    val: 2494,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shri Amolak Jain Vidya Prasarak Mandal's College of Pharmaceutical Science and Research Centre, Beed",
    val: 2495,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shri Balaji College of Pharmacy, Alwar",
    val: 2496,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shree Saraswati Institute of Pharmacy, Malwan",
    val: 2497,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shri Chhatrapati Sambhaji Shikshan Sanstha's Sitabai Thite College of Pharmacy, Pune",
    val: 2498,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shreeyash Institute of Pharmaceutical Education and Research, Aurangabad",
    val: 2499,
    isTop: "",
    created: "2025-10-01 16:42:27",
    cluster: "pharma",
  },
  {
    text: "Shri Gulabrao Deokar College of Pharmacy, Jalgaon",
    val: 2500,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Shri Laxmanrao Mankar Institute of Pharmacy, Amgaon",
    val: 2501,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Shri Rawatpura Sarkar Institute of Pharmacy, Jabalpur",
    val: 2502,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Shri Sai Institute of Pharmacy and Research, Aurangabad",
    val: 2503,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Shri Sai Janvikas Pratishthan's Shri Sai College of Pharmacy, Vaijapur",
    val: 2504,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Shri Vishwanath College of Pharmacy, Sultanpur",
    val: 2505,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Shri Swamiji Maharaj College of Pharmacy, Datia",
    val: 2506,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Shrinathji Institute of Pharmacy, Rajsamand",
    val: 2507,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Siddhi's Institute of Pharmacy, Nandgaon",
    val: 2508,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Sir Madanlal Institute of Pharmacy (SMIP), Etawah",
    val: 2509,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Sinhgad Institute of Pharmaceutical Science, Lonavala",
    val: 2510,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "SLBS Pharmacy College, Jodhpur",
    val: 2511,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Smt Fulehra Smarak College of Pharmacy, Ballia",
    val: 2512,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "Sorabh College of Pharmacy, Karauli",
    val: 2513,
    isTop: "",
    created: "2025-10-01 16:42:28",
    cluster: "pharma",
  },
  {
    text: "South Point College of Pharmacy, Sonipat",
    val: 2514,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Sreekrishna College of Pharmacy and Research Centre, Thiruvananthapuram",
    val: 2515,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Sri Krupa Institute of Pharmaceutical Sciences, Medak",
    val: 2516,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Sri Lakshmi Narasimha College of Pharmacy, Chittoor",
    val: 2517,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Sri Lakshminarayan College of Pharmacy, Dharmapuri",
    val: 2518,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Sri Raghavendra College of Pharmacy, Chitradurga",
    val: 2519,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Sri Shanmugha College of Pharmacy, Salem",
    val: 2520,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Srinivasa Rao College of Pharmacy, Visakhapatnam",
    val: 2521,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Srinivasan College of Pharmaceutical Sciences, Tiruchirappalli",
    val: 2522,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Sri Vijay Vidyalaya College of Pharmacy, Dharmapuri",
    val: 2523,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "SS Institute of Pharmacy, Salem",
    val: 2524,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "Srinivas College of Pharmacy, Mangaluru",
    val: 2525,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "St George Institute of Pharmacy, Bhopal",
    val: 2526,
    isTop: "",
    created: "2025-10-01 16:42:29",
    cluster: "pharma",
  },
  {
    text: "St James College of pharmaceutical Sciences, Thrissur",
    val: 2527,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "St Johns College of Pharmaceutical Sciences and Research (SJCPSR), Idukki",
    val: 2528,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "St Mary's College of BPharmacy, Peddapuram",
    val: 2529,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "StJohn Institute of Pharmacy and Research, Palghar",
    val: 2530,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "St Wilfred's Institute of Pharmacy, Panvel",
    val: 2531,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Sun Institute of Pharmaceutical Education and Research, Lahar",
    val: 2532,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Sun Institute of Pharmaceutical Education and Research, Nellore",
    val: 2533,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Suyash Institute of Pharmacy, Gorakhpur",
    val: 2534,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Surabhi Dayakar Rao College of Pharmacy, Medak",
    val: 2535,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Surendera Pharmacy College, Sriganganagar",
    val: 2536,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Swami Devi Dayal Institute of Pharmacy, Barwala",
    val: 2537,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Surya School of Pharmacy, Viluppuram",
    val: 2538,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Swami Keshvanand Institute of Pharmacy, Bikaner",
    val: 2539,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Swift School of Pharmacy, Patiala",
    val: 2540,
    isTop: "",
    created: "2025-10-01 16:42:30",
    cluster: "pharma",
  },
  {
    text: "Talla Padmavathi College of Pharmacy, Warangal",
    val: 2541,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Tagore College of Pharmacy, Jaipur",
    val: 2542,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Tagore College of Pharmacy, Kanchipuram",
    val: 2543,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Tagore Institute of Pharmacy and Research, Bilaspur",
    val: 2544,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Tatyasaheb Kore College of Pharmacy, Kolhapur",
    val: 2545,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Thakur Shivkumarsingh Memorial Pharmacy College, Burhanpur",
    val: 2546,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Thyugraj Singh Pharmacy College, Fatehpur",
    val: 2547,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "TMAE Society MMJG College of Pharmacy, Haveri",
    val: 2548,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Tolani Institute of Pharmacy, Gandhidham",
    val: 2549,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "United Institute of Pharmacy, Prayagraj",
    val: 2550,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Triveni Institute of Pharmacy, Thrissur",
    val: 2551,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Unity College of Pharmacy, Bhongir",
    val: 2552,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Ujjain Institute of Pharmaceutical Sciences, Ujjain",
    val: 2553,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "University Institute of Pharmaceutical Sciences and Research, Faridkot",
    val: 2554,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Unnati Pharmacy College, Mathura",
    val: 2555,
    isTop: "",
    created: "2025-10-01 16:42:31",
    cluster: "pharma",
  },
  {
    text: "Vallabhaneni Venkatadri Institute of Pharmaceutical Sciences, Gudlavalleru",
    val: 2556,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "V P College of Pharmacy, Sindhudurg",
    val: 2557,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vaish Institute of Pharmaceutical Education and Research, Rohtak",
    val: 2558,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vaishnavi Institute of Pharmacy, Raisen",
    val: 2559,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vedica College of BPharmacy, New Delhi",
    val: 2560,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Veerayatan Institute of Pharmacy, Jakhania",
    val: 2561,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vidya Niketan Institute of Pharmacy and Research Centre, Ahmednagar",
    val: 2562,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vishal Institute of Pharmaceutical Education and Research, Junnar",
    val: 2563,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vikas College of Pharmaceutical Sciences, Nalgonda",
    val: 2564,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vishwanath Institute of Pharmacy, Ghazipur",
    val: 2565,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vindhya Gurukul College of Pharmacy, Mirzapur",
    val: 2566,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "VJ's College of Pharmacy, East Godavari",
    val: 2567,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Vydehi Institute of Pharmacy, Bengaluru",
    val: 2568,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Yalamarty Pharmacy College, Visakhapatnam",
    val: 2569,
    isTop: "",
    created: "2025-10-01 16:42:32",
    cluster: "pharma",
  },
  {
    text: "Westfort College of Pharmacy (WCP), Thrissur",
    val: 2570,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "Yash Institute of Pharmacy,Aurangabad",
    val: 2571,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "Yashodeep Institute of Pharmacy, Pune",
    val: 2572,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "Yashraj Institute of Pharmacy, Lucknow",
    val: 2573,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "Yashwantrao Bhonsale College of Pharmacy, Sawantwadi",
    val: 2574,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "Yenepoya Pharmacy College and Research Centre, Dakshina Kannada",
    val: 2575,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "Yeshwant Redekar College of Pharmacy, Kolhapur",
    val: 2576,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "Yuva Institute of Pharmacy, Guna",
    val: 2577,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "ZEE College of Pharmacy, Unnao",
    val: 2578,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "Jagan's Institute of Pharmaceutical Sciences, Nellore",
    val: 2579,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "JKKMMRF's Annai JKK Sampoorani Ammal College of Pharmacy, Namakkal",
    val: 2580,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "National Institute of Pharmaceutical Education and Research (NIPER), Ahmedabad",
    val: 2581,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "National Institute of Pharmaceutical Education and Research (NIPER), Guwahati",
    val: 2582,
    isTop: "",
    created: "2025-10-01 16:42:33",
    cluster: "pharma",
  },
  {
    text: "National Institute of Pharmaceutical Education and Research (NIPER), Hyderabad",
    val: 2583,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "National Institute of Pharmaceutical Education and Research (NIPER), Kolkata",
    val: 2584,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "National Institute of Pharmaceutical Education and Research (NIPER), Raebareli",
    val: 2585,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "A M Reddy Memorial College of Pharmacy, Narasaraopet",
    val: 2586,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Aditya Pharmacy College, Beed",
    val: 2587,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Aditya Pharmacy College, East Godavari",
    val: 2588,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Academy of Pharmaceutical Sciences, Kannur",
    val: 2589,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "All India Shri Shivaji Memorial Society's College of Pharmacy, Pune",
    val: 2590,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Ahalia School of Pharmacy, Palakkad",
    val: 2591,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Amar Shaheed Baba Ajit Singh Jujhar Singh Memorial College of Pharmacy, Rupnagar",
    val: 2592,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Akhil Bharti College of Pharmacy, Bhopal",
    val: 2593,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Amrapali Institute of Pharmacy and Sciences, Nainital",
    val: 2594,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "APMC College of Pharmaceutical Education and Research, Himatnagar",
    val: 2595,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Anjali College of Pharmacy and Science, Agra",
    val: 2596,
    isTop: "",
    created: "2025-10-01 16:42:34",
    cluster: "pharma",
  },
  {
    text: "Annai JKK Sampoorani Ammal College of Pharmacy, Namakkal",
    val: 2597,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Annai Veilankanni S Pharmacy College, Chennai",
    val: 2598,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Avadh College of Pharmacy Nindura, Fatehpur",
    val: 2599,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Aryakul College of Pharmacy and Research, Lucknow",
    val: 2600,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Ashokrao Mane Institute of Pharmaceutical Sciences and Research, Kolhapur",
    val: 2601,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Azad Institute of Pharmacy and Research, Lucknow",
    val: 2602,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "B N College of Pharmacy, Lucknow",
    val: 2603,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Bansal College of Pharmacy, Bhopal",
    val: 2604,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Babu Sunder Singh College of Pharmacy, Lucknow",
    val: 2605,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Bbdit College of Pharmacy, Ghaziabad",
    val: 2606,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "BBS Institute of Pharmacutical and Allied Science, Greater Noida",
    val: 2607,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Balaji College of Pharmacy, Anantapur",
    val: 2608,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Balaji Institute of Pharmaceutical Sciences, Warangal",
    val: 2609,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Bhartiya Vidya Mandiar College of Pharmacy, Gwalior",
    val: 2610,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Bhagwati College of Pharmacy, Baghpat",
    val: 2611,
    isTop: "",
    created: "2025-10-01 16:42:35",
    cluster: "pharma",
  },
  {
    text: "Bharat Institute of Pharmacy Degree Course, Kurukshetra",
    val: 2612,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Birbhum Pharmacy School, Birbhum",
    val: 2613,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Bharti College of Pharmacy, Sikar",
    val: 2614,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Bharti Pharmacy College, Sikar",
    val: 2615,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Biyani Institute of Pharmaceutical Sciences, Jaipur",
    val: 2616,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "C U Shah College of Pharmacy and Research, Surendranagar",
    val: 2617,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "BS Anangpuria Institute of Pharmacy, Faridabad",
    val: 2618,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Chaitanya Institute of Pharmaceutical Sciences, Dharmasagar",
    val: 2619,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Chameli Devi Institute of Pharmacy, Indore",
    val: 2620,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "CK Pithawala Institute of Pharmaceutical Science Research, Surat",
    val: 2621,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "CK Pithawalla Institute of Pharmaceutical Science and Research, Surat",
    val: 2622,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Chhatrapati Shivaji College of Pharmacy Bpharm, Bhandara",
    val: 2623,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Chhatrapati Shivaji Institute of Pharmacy, Durg",
    val: 2624,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "College of Pharmacy Jss Academy of Technical Education, Gautam Buddha Nagar",
    val: 2625,
    isTop: "",
    created: "2025-10-01 16:42:36",
    cluster: "pharma",
  },
  {
    text: "Columbia Institute of Pharmacy, Raipur",
    val: 2626,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Corporate Institute of Pharmacy, Bhopal",
    val: 2627,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Creative Educational Society's College of Pharmacy, Kurnool",
    val: 2628,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "DBM College of Pharmacy, Janjgir - Champa",
    val: 2629,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "D K Pharma College, Rewari",
    val: 2630,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Deen Dayal Rustagi College of Pharmacy, Gurugram",
    val: 2631,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Dattakala College of Pharmacy, Daund",
    val: 2632,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Devsthali Vidhyapeeth College of Pharmacy, Udham Singh Nagar",
    val: 2633,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "DM WIMS College of Pharmacy, Wayanad",
    val: 2634,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Dnyanvilas College of Pharmacy, Pune",
    val: 2635,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Dr Radhakrishanan Pharmacy College, Nagaur",
    val: 2636,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Dr Rajendra Gode Institute of Pharmacy, Amravati",
    val: 2637,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Dr Satyendra Kumar Memorial College of Pharmacy, Bhopal",
    val: 2638,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Dr CSN Institute of Pharmacy, Bhimavaram",
    val: 2639,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Dr J J Magdum Turst Dr J J Magdum Pharmacy College, Kolhapur",
    val: 2640,
    isTop: "",
    created: "2025-10-01 16:42:37",
    cluster: "pharma",
  },
  {
    text: "Dr K V Subba Reddy Institute of Pharmacy, Kurnool",
    val: 2641,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Dr M C Saxena College of Pharmacy, Lucknow",
    val: 2642,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Dreamz College of Pharmacy, Mandi",
    val: 2643,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Edayathangudy GSPillay College of Pharmacy, Nagapattinam",
    val: 2644,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Future Institute of Pharmacy, Bareilly",
    val: 2645,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Gajanan Maharaj College of Pharmacy, Pune",
    val: 2646,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Excel College of Pharmacy, Namakkal",
    val: 2647,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Gajanan Maharaj Shikshan Prasarak Mandals Sharadchandra Pawar College of Pharmacy, Pune",
    val: 2648,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Ganpati Institute of Pharmacy, Bilaspur",
    val: 2649,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Global Institute of Pharmaceutical Education and Research, Udham Singh Nagar",
    val: 2650,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Global Pharmacy College, Nagaur",
    val: 2651,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Global Research Institute of Pharmacy, Yamunanagar",
    val: 2652,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Goel Institute of Pharmacy and Sciences, Lucknow",
    val: 2653,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Gokula Krishna College of Pharmacy, Sullurpeta",
    val: 2654,
    isTop: "",
    created: "2025-10-01 16:42:38",
    cluster: "pharma",
  },
  {
    text: "Gondia College of Pharmacy Chulod Gondia, Gondiya",
    val: 2655,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "Guru Gobind Singh College of Pharmacy, Yamunanagar",
    val: 2656,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "GP Pharmacy college, Vellore",
    val: 2657,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "Grace College of Pharmacy, Palakkad",
    val: 2658,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "Gurukul Institute of Pharmaceutical Science and Research, Gwalior",
    val: 2659,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "Gurukul Pharmacy College, Kota",
    val: 2660,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "GRT Institute of Pharmaceutical Education and Research, Thiruvallur",
    val: 2661,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "HIMT College of Pharmacy, Noida",
    val: 2662,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "Hari College of Pharmacy, Saharanpur",
    val: 2663,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "Hindustan College of Pharmacy, Kottayam",
    val: 2664,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "Hi-Tech College of Pharmacy (HCP), Bhubaneswar",
    val: 2665,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "Holy Grace Academy of Pharmacy, Thrissur",
    val: 2666,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "HR Institute of Pharmacy, Ghaziabad",
    val: 2667,
    isTop: "",
    created: "2025-10-01 16:42:39",
    cluster: "pharma",
  },
  {
    text: "IIMT College of Pharmacy, Greater Noida",
    val: 2668,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Indrayani Vidya Mandir's Indrayani Institute of Pharmaceutical Education and Research, Pune",
    val: 2669,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Innovative College of Pharmacy, Noida",
    val: 2670,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "ITS College of Pharmacy, Muradnagar",
    val: 2671,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "J K Institute of Pharmacy, Bilaspur",
    val: 2672,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Jai Institute of Pharmaceutical Sciences and Research, Gwalior",
    val: 2673,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Jayawant Shikshan Prasark Mandals Jaywantrao Sawant College of Pharmacy and Research, Pune",
    val: 2674,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "JDT Islam College of Pharmacy, Kozhikode",
    val: 2675,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Jeypore College of Pharmacy (JCP), Koraput",
    val: 2676,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "K T N College of Pharmacy, Palakkad",
    val: 2677,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "K V Virani Institute of Pharmacy and Research Centre, Amreli",
    val: 2678,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Kailash Narayan Patel College of Pharmacy, Bhopal",
    val: 2679,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Kalol Institute of Pharmacy, Kalol",
    val: 2680,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Karuna College of Pharmacy, Palakkad",
    val: 2681,
    isTop: "",
    created: "2025-10-01 16:42:40",
    cluster: "pharma",
  },
  {
    text: "Kashi Institute of Pharmacy, Varanasi",
    val: 2682,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "KC Reddy College of Pharmacy, Medikonduru",
    val: 2683,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Khajuraho Institute of Pharmaceutical Sciences, Chhatarpur",
    val: 2684,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "KMCT College of Pharmaceutical Sciences, Kozhikode",
    val: 2685,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Konkan Gyanpeeths Rahul Dharkar College of Pharmacy and Research Institute Vengaon, Raigad",
    val: 2686,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Kvm College of Pharmacy, Alleppey",
    val: 2687,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Krishna Devi Maheswari Pharmacy College, Jhunjhunun",
    val: 2688,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Krishna Institute of Pharmacy and Sciences, Kanpur Nagar",
    val: 2689,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "L B Rao Institute of Pharmaceutical Education and Research, Khambhat",
    val: 2690,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Krishna Teja Pharmacy College, Tirupati",
    val: 2691,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Lal Bahadur Shashtri College of Pharmacy, Jaipur",
    val: 2692,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Lala Birkha Ram College of Pharmacy, Panchkula",
    val: 2693,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Kuchaman Pharmacy College, Nagaur",
    val: 2694,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "LJ Institute of Pharmacy, Sanand",
    val: 2695,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "Maeers Maharashtra Institute of Pharmacy ,Pune",
    val: 2696,
    isTop: "",
    created: "2025-10-01 16:42:41",
    cluster: "pharma",
  },
  {
    text: "LR Institutes of Pharmacy, Solan",
    val: 2697,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Luckky College of Pharmaceutical Sciences, Khordha",
    val: 2698,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "M G M Silver Jubilee College of Pharmacy, Thiruvananthapuram",
    val: 2699,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "M R College of Pharmaceutical Sciences and Research, 24 Paraganas North",
    val: 2700,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Maa Sharda Pharmacy College, Machilipatnam",
    val: 2701,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Maharana Pratap College of Pharmacy, Kanpur",
    val: 2702,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Malik Deenar College of Pharmacy, Bela",
    val: 2703,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Mahatama Gandhi Vidyamandirs College of Pharmacy, Agra",
    val: 2704,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Manav Institute of Pharmacy Vill Javra Bahbalpur, Hisar",
    val: 2705,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Mahatma Gandhi College of Pharmacy, Sikar",
    val: 2706,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "MAK College of Pharmacy, Rangareddy",
    val: 2707,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Mar Dioscorus College of Pharmacy, Thiruvananthapuram",
    val: 2708,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Marathwada Mitra Mandal's College of Pharmacy, Pune",
    val: 2709,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "Marudhar College of Pharmacy, Nagaur",
    val: 2710,
    isTop: "",
    created: "2025-10-01 16:42:42",
    cluster: "pharma",
  },
  {
    text: "MGM College of Pharmacy, Kannur",
    val: 2711,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Maya College of Pharmacy, Dehradun",
    val: 2712,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Millennium College of Pharmacy and Science, Bhopal",
    val: 2713,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Minerva College of Pharmacy, Kangra",
    val: 2714,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "MIT College of Pharmacy, Moradabad",
    val: 2715,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Modern College of Pharmacy, Jhansi",
    val: 2716,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Moulana College of Pharmacy, Malappuram",
    val: 2717,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Mount Zion College of Pharmaceutical Sciences and Research, Adoor",
    val: 2718,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Nandha College of Pharmacy, Erode",
    val: 2719,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "National Centre For Rural Developments Sterling Institute of Pharmacy, Navi Mumbai",
    val: 2720,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "NGI College of Pharmacy, Meerut",
    val: 2721,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "NKBR College of Pharmacy and Research Centre, Meerut",
    val: 2722,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Om Sadashiva College of Pharmacy, Deoghar",
    val: 2723,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Omega College of Pharmacy, Rangareddy",
    val: 2724,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Northern Institute of Pharmacy and Research, Alwar",
    val: 2725,
    isTop: "",
    created: "2025-10-01 16:42:43",
    cluster: "pharma",
  },
  {
    text: "Nova College of Pharmaceutical Education and Research, Krishna",
    val: 2726,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "P A College of Pharmacy, Dakshina Kannada",
    val: 2727,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "NRK and KSR Gupta College of Pharmacy, Tenali",
    val: 2728,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "P Rami Reddy Memorial (PRRM) College of Pharmacy, Kadapa",
    val: 2729,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "Pathfinder Institute of Pharmacy Education and Research (PIPER), Warangal",
    val: 2730,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "PDM School of Pharmacy, Jind",
    val: 2731,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "Parmarth College of Pharmacy, Hapur",
    val: 2732,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "PE Societys Modern College of Pharmacy For Women, Pune",
    val: 2733,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "PGP College of Pharmaceutical Science and Research Institute, Namakkal",
    val: 2734,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "Priyadarshini JL College of Pharmacy, Hingna",
    val: 2735,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "Priyadarsini Institute of Pharmaceutical Science, Guntur",
    val: 2736,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "Pt L R College of Pharmacy, Faridabad",
    val: 2737,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "Pt Rajendra Prasad Smarak College of Pharmacy, Pilibhit",
    val: 2738,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "Prime College of Pharmacy, Palakkad",
    val: 2739,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "Pushpagiri College of Pharmacy, Thiruvalla",
    val: 2740,
    isTop: "",
    created: "2025-10-01 16:42:44",
    cluster: "pharma",
  },
  {
    text: "QIS College of Pharmacy, Ongole",
    val: 2741,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "R J College of Pharmacy, Aligarh",
    val: 2742,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Rajarshi Shahu College of Pharmacy, Buldana",
    val: 2743,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Rajasthan Pharmacy College, Jaipur",
    val: 2744,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Radha Krishna College of Pharmacy Meharban, Kanpur",
    val: 2745,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Radha Krishna Pharmacy College, Satna",
    val: 2746,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Rajeev Academy For Pharmacy, Mathura",
    val: 2747,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Rajmata Jijau Shikshan Prasarak Mandals College of Pharmacy, Pune",
    val: 2748,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Rakshpal Bahadur College of Pharmacy, Bareilly",
    val: 2749,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Ram Gopal College of Pharmacy, Sultanpur",
    val: 2750,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Ranibai Agnihotri College of Pharmacy, Wardha",
    val: 2751,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Rashbehari Pharmaceutical Institute, Medinipur",
    val: 2752,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Ravi Shankar College of Pharmacy, Bhopal",
    val: 2753,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Ramkumari College of Pharmacy, Jhunjhunun",
    val: 2754,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Regional College of Pharmacy, Jaipur",
    val: 2755,
    isTop: "",
    created: "2025-10-01 16:42:45",
    cluster: "pharma",
  },
  {
    text: "Royal College of Pharmacy, Raipur",
    val: 2756,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "RPS College of Pharmacy, Bara Banki",
    val: 2757,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Rungta College of Pharmaceutical Sciences and Research, Durg",
    val: 2758,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Rungta College of Pharmaceutical Sciences and Research, Raipur",
    val: 2759,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Sakshi College of Pharmacy, Kanpur Nagar",
    val: 2760,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "SAL Institute of Pharmacy (SALIP), Ahmedabad",
    val: 2761,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Sagar Institute of Pharmaceutical Sciences, Sagar",
    val: 2762,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Sahasra Institute of Pharmaceutical Sciences, Warangal",
    val: 2763,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Saraswati Institute of Pharmaceutical Sciences, Ahmedabad",
    val: 2764,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Sanjay College of Pharmacy, Mathura",
    val: 2765,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Sanjivan College of Pharmacy, Dausa",
    val: 2766,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Sanskar City College of Pharmacy, Rajnandgaon",
    val: 2767,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Sarojini College of Pharmacy, Kolhapur",
    val: 2768,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "Satyadeo College of Pharmacy, Ghazipur",
    val: 2769,
    isTop: "",
    created: "2025-10-01 16:42:46",
    cluster: "pharma",
  },
  {
    text: "School of Pharmacy, Rajkot",
    val: 2770,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "SD College of Pharmacy and Vocational Studies, Muzaffarnagar",
    val: 2771,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shakti College of Pharmacy, Balrampur",
    val: 2772,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Seemanta Institute of Pharmaceutical Sciences (SIPS), Jharpokharia",
    val: 2773,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Seiko College of Pharmacy, Lucknow",
    val: 2774,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Senghundhar College of Pharmacy, Namakkal",
    val: 2775,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shankarrao Ursal College of Pharmaceutical Sciences and Research Center, Pune",
    val: 2776,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shankarsinh Vaghela Bapu Institute of Pharmacy, Gandhinagar",
    val: 2777,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Seshachala College of Pharmacy, Puttur",
    val: 2778,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shankersinh Vaghela Bapu Institute of Pharmacy, Gandhinagar",
    val: 2779,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shardabai Pawar Institute of Pharmaceutical Sciences Research, Pune",
    val: 2780,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shekhawati Institute of Pharmacy, Sikar",
    val: 2781,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shree HN Shukla Institute of Pharmaceutical Education and Research, Rajkot",
    val: 2782,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shree Krishna College of Pharmacy, Sitapur",
    val: 2783,
    isTop: "",
    created: "2025-10-01 16:42:47",
    cluster: "pharma",
  },
  {
    text: "Shiva Institute of B Pharmacy, Bilaspur",
    val: 2784,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shivajirao S Jondhle College of Pharmacy, Thane",
    val: 2785,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shivlingeshwar College of Pharmacy, Ausa",
    val: 2786,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shri Amolakjain Vidya Prasarak Mandals College of Pharmaceutical Science and Research Center, Beed",
    val: 2787,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shramjivi College of Pharmacy, Osmanabad",
    val: 2788,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shri Bajrang College of Pharmacy, Bharatpur",
    val: 2789,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shri Balaji College of Pharmacy, Jaipur",
    val: 2790,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shri Krishna College of Pharmacy, Chomu",
    val: 2791,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shri Bherulal Pharmacy Institute, Indore",
    val: 2792,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shri Gurudatta Shikshan Sanstha Sanchalit Loknete Dr JD Pawar College of Pharmacy, Kalwan",
    val: 2793,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Shri Sant Gajanan Maharaj College of Pharmacy, Buldana",
    val: 2794,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Sigma College of Pharmacy, Ludhiana",
    val: 2795,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Signa College of Pharmacy, Kanpur Nagar",
    val: 2796,
    isTop: "",
    created: "2025-10-01 16:42:48",
    cluster: "pharma",
  },
  {
    text: "Sikar College of Pharmacy, Sikar",
    val: 2797,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Shri Swaminarayan College of Pharmacy, Kalol",
    val: 2798,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Shri Swaminarayan Sanskar Pharmacy College, Ahmedabad",
    val: 2799,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Shri Vile Parle Kelavani Mandals Institute of Pharmacy, Dhule",
    val: 2800,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Sir Dr MS Gosavi College of Pharmaceutical Education and Research, Nashik",
    val: 2801,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Shridevi Institute of Pharmaceutical Sciences, Mysuru",
    val: 2802,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Shrikrishna Pharmacy College, Rewa",
    val: 2803,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Sitaram Kashyap College of Pharmacy (SRKCOP), Janjgir",
    val: 2804,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "SKU College of Pharmacy, Anantapur",
    val: 2805,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Smt Sarojini Ramulamma College of Pharmacy, Mahabubnagar",
    val: 2806,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Smt Champaben Vasantbhai Gajera Pharmacy Mahila College, Amreli",
    val: 2807,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Smt Gandhimathi College of Pharmacy, Tiruvannamalai",
    val: 2808,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "Smt Vidyawati College of Pharmacy, Jhansi",
    val: 2809,
    isTop: "",
    created: "2025-10-01 16:42:49",
    cluster: "pharma",
  },
  {
    text: "SNS College of Pharmacy, Motihari",
    val: 2810,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sp College of Pharmaceutical Science and Research, Bijnor",
    val: 2811,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sri Balaji College of Pharmacy, Jaipur",
    val: 2812,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Spectrum Institute of Pharmaceutical Science and Research, Greater Noida",
    val: 2813,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sree Sastha Pharmacy College, Thiruvallur",
    val: 2814,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sri Krishna Chaitanya College of Pharmacy, Madanapalle",
    val: 2815,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sri Lakshmi Venkateswara Institute of Pharmaceutical Sciences, Proddatur",
    val: 2816,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sri Sathya Sai Institute of Pharmaceutical Sciences, Bhopal",
    val: 2817,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sri Shivani College of Pharmacy, Warangal",
    val: 2818,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sri Sukhmani Institute of Pharmacy, S.A.S. Nagar",
    val: 2819,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sri Vasavi Institute of Pharmaceutical Sciences (SVIPS), West Godavari",
    val: 2820,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "St Ann's College of Pharmacy, Chirala",
    val: 2821,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Srinath College of Pharmacy, Aurangabad",
    val: 2822,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "St Joseph's College of Pharmacy, Alleppey",
    val: 2823,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "St Pauls College of Pharmacy, Rangareddy",
    val: 2824,
    isTop: "",
    created: "2025-10-01 16:42:50",
    cluster: "pharma",
  },
  {
    text: "Sufiya College of Pharmacy, Nagaur",
    val: 2825,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "St Soldier Institute of Pharmacy, Jalandhar",
    val: 2826,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Swamy Vivekanandha College of Pharmacy, Namakkal",
    val: 2827,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Swami Vivekanand College of Pharmacy, Udgir",
    val: 2828,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Translam Institute of Pharmaceutical Education and Research, Meerut",
    val: 2829,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Trc Mahavidyalaya Department of Pharmacy, Bara Banki",
    val: 2830,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Trinity College of Pharmacy, Pune",
    val: 2831,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Vagdevi College of Pharmacy and Research Centre, Nellore",
    val: 2832,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Universal Institute of Pharmacy, S.A.S. Nagar",
    val: 2833,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Varun College of Pharmacy, Jaipur",
    val: 2834,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Vedic Institute of Pharmaceutical Education and Research, Sagar",
    val: 2835,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Vedica College of BPharmacy, Bhopal",
    val: 2836,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "US Ostwal Institute of Pharmacy, Chittaurgarh",
    val: 2837,
    isTop: "",
    created: "2025-10-01 16:42:51",
    cluster: "pharma",
  },
  {
    text: "Veerayatan Institute of Pharmacy, Kachchh",
    val: 2838,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Vidhyadeep Institute of Pharmacy, Surat",
    val: 2839,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Vinayaka College of Pharmacy, Kullu",
    val: 2840,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Vishwa Bharathi College of Pharmaceutical Sciences, Guntur",
    val: 2841,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Viit Pharmacy College, Bulandshahr",
    val: 2842,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Viswanandha Institute of Pharmaceutical Sciences, Anandapuram",
    val: 2843,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Vijaya Institute of Pharmaceutical Sciences for Women, Vijayawada",
    val: 2844,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Vivekanand College of Pharmacy, Sikar",
    val: 2845,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Yeshwant Redekar College of Pharmacy B Pharm and D Pharm, Kolhapur",
    val: 2846,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "ABESIT College of Pharmacy, Ghaziabad",
    val: 2847,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Abhilashi College of Pharmacy, Mandi",
    val: 2848,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Accurate College of Pharmacy, Gautam Buddha Nagar",
    val: 2849,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Adarsa College of Pharmacy, Gokavaram",
    val: 2850,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Aligarh College of Pharmacy, Aligarh",
    val: 2851,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Adarsh College of Pharmacy, Aurangabad",
    val: 2852,
    isTop: "",
    created: "2025-10-01 16:42:52",
    cluster: "pharma",
  },
  {
    text: "Alwar Pharmacy College, Alwar",
    val: 2853,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Anand College of Pharmacy (ACP), Agra",
    val: 2854,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Arunai College of Pharmacy, Tiruvannamalai",
    val: 2855,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Ashvin College of Pharmacy, Udupi",
    val: 2856,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Asian College of Pharmacy, Udaipur",
    val: 2857,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Aspm College of Pharmacy, Sindhudurg",
    val: 2858,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "BDM College of Pharmacy, Jhajjar",
    val: 2859,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "BA and KR College of Pharmacy, Ongole",
    val: 2860,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Browns College of Pharmacy, Khammam",
    val: 2861,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Care College of Pharmacy, Warangal",
    val: 2862,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Dadhichi College of Pharmacy (DCP), Cuttack",
    val: 2863,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Danteswari College of Pharmacy, Bastar",
    val: 2864,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "DCRM College of Pharmacy, Inkollu",
    val: 2865,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Deshraj College of Pharmacy, Rohtak",
    val: 2866,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Dolphin (PG) College of Life Sciences, Fatehgarh Sahib",
    val: 2867,
    isTop: "",
    created: "2025-10-01 16:42:53",
    cluster: "pharma",
  },
  {
    text: "Dr B R Ambedkar Pooja College of Pharmacy, Gorakhpur",
    val: 2868,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "Galgotias College of Pharmacy, Gautam Buddha Nagar",
    val: 2869,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "GCRG College of Pharmacy, Lucknow",
    val: 2870,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "Ghausia College of Pharmacy, Fatehpur",
    val: 2871,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "Goenka College of Pharmacy, Sikar",
    val: 2872,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "Gokaraju Rangaraju College of Pharmacy, Hyderabad",
    val: 2873,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "Gokul College of Pharmacy, Bobbili",
    val: 2874,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "Institute of Pharmaceutical Sciences, Jaleswar",
    val: 2875,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "Institute of Professional Studies Colleges of Pharmacy, Gwalior",
    val: 2876,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "J P College of Pharmacy, Lucknow",
    val: 2877,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "J P College of Pharmacy, Nalanda",
    val: 2878,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "Jangaon Institute of Pharmaceutical Sciences, Warangal",
    val: 2879,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "JBIT College of Pharmacy, Dehradun",
    val: 2880,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "JIET College of Pharmacy, Jodhpur",
    val: 2881,
    isTop: "",
    created: "2025-10-01 16:42:54",
    cluster: "pharma",
  },
  {
    text: "JKK Munirajah Institute of Health Sciences College of Pharmacy, Erode",
    val: 2882,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Khalsa College of Pharmacy, Amritsar",
    val: 2883,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Khammam College of Pharmacy, Khammam",
    val: 2884,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Khyati College of Pharmacy, Ahmedabad",
    val: 2885,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "KJR College of Pharmacy, East Godavari",
    val: 2886,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "KLR College of Pharmacy, Khammam",
    val: 2887,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Koringa College of Pharmacy, East Godavari",
    val: 2888,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Lydia College of Pharmacy, East Godavari",
    val: 2889,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "MNR College of Pharmacy, Medak",
    val: 2890,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "MRR College of Pharmacy, Madhira",
    val: 2891,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Nova College of Pharmacy, Jangareddigudem",
    val: 2892,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "NRI College of Pharmacy, Vijayawada",
    val: 2893,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Oriental College of Pharmacy, Bhopal",
    val: 2894,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Oriental College of Pharmacy, Jabalpur",
    val: 2895,
    isTop: "",
    created: "2025-10-01 16:42:55",
    cluster: "pharma",
  },
  {
    text: "Nethaji Institute of Pharmaceutical Sciences, Warangal",
    val: 2896,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "NIET Pharmacy Institute, Greater Noida",
    val: 2897,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Nimra College of Pharmacy, Vijayawada",
    val: 2898,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Nirmala College of Pharmacy, Mangalagiri",
    val: 2899,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Raghu College of Pharmacy, Visakhapatnam",
    val: 2900,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Raigarh College of Pharmacy, Raigarh",
    val: 2901,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Ramanbhai Patel College of Pharmacy (RPCP), Anand",
    val: 2902,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "RITEE College of Pharmacy, Raipur",
    val: 2903,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "RKSD College of Pharmacy, Kaithal",
    val: 2904,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "S N College of Pharmacy, Jaunpur",
    val: 2905,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "S N College of Pharmacy, Sriganganagar",
    val: 2906,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Sagar College of Pharmacy, Bara Banki",
    val: 2907,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Sarada College of Pharmaceutical Sciences, Guntur",
    val: 2908,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Sat Kaival College of Pharmacy, Anand",
    val: 2909,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Shaheed Bhagat Singh College of Pharmacy, Kangra",
    val: 2910,
    isTop: "",
    created: "2025-10-01 16:42:56",
    cluster: "pharma",
  },
  {
    text: "Sherwood College of Pharmacy, Bara Banki",
    val: 2911,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Shri Balaji College of Pharmaceutical Sciences, Janjgir",
    val: 2912,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Smt S M Shah Pharmacy College, Kheda",
    val: 2913,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Sri Sivani College of Pharmacy, Srikakulam",
    val: 2914,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Sri Vidyaniketan College of Pharmacy, Chittoor",
    val: 2915,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "SRR College of Pharmaceutical Sciences, Karimnagar",
    val: 2916,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Vaagdevi Institute of Pharmaceutical Sciences, Warangal",
    val: 2917,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Vivekanand College of Pharmacy, Bhopal",
    val: 2918,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Vidhyapeeth Institute of Pharmacy, Bhopal",
    val: 2919,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Acharya Nagarjuna University College of Pharmaceutical Sciences, Guntur",
    val: 2920,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "AU College of Pharmaceutical Sciences, Andhra University, Visakhapatnam",
    val: 2921,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Delhi Pharmaceutical Sciences and Research University, Delhi",
    val: 2922,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "Dr D Y Patil Institute of Pharmaceutical Sciences and Research, Pune",
    val: 2923,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "PSG College of Pharmacy, Coimbatore",
    val: 2924,
    isTop: "",
    created: "2025-10-01 16:42:57",
    cluster: "pharma",
  },
  {
    text: "R. C. Patel Institute of Pharmaceutical Education and Research, Shirpur",
    val: 2925,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Sri Venkateswara College of Pharmacy, Chittoor",
    val: 2926,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Dr Om Prakash College Of Pharmacy, Farrukhabad",
    val: 2927,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Shri Rawatpura Sarkar Institute Of Pharmacy, Satna",
    val: 2928,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Green Royal Academy Of Pharmaceutical Education & Sciences, West Godavari",
    val: 2929,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Vishnu Institute Of Pharmaceutical Education And Research, Medak",
    val: 2930,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Asian Mission Institute Of Pharmaceutical Sciences, Barpeta",
    val: 2931,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Shifa Pharmacist Institute, Cachar",
    val: 2932,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Pratiksha Institute Of Pharmaceutical Sciences, Kamrup",
    val: 2933,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Nef College Of Pharmaceutical Education And Research, Nagaon",
    val: 2934,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Zee Education Foundation Institute Of Pharmacy, Aurangabad",
    val: 2935,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Modern Institute Of Pharmacy, Banka",
    val: 2936,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "National Institute Of Pharmaceutical Education And Research, Lucknow",
    val: 2937,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "Kalyan Seva Sansthan College Of Pharmacy, Jamui",
    val: 2938,
    isTop: "",
    created: "2025-10-01 16:42:58",
    cluster: "pharma",
  },
  {
    text: "N P Institute Of Pharmacy, Nalanda",
    val: 2939,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Magadh Institute Of Pharmacy, Patna",
    val: 2940,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Swami Ramananda Thirtha Institute Of Pharmaceutical Sciences, Nalgonda",
    val: 2941,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Bodhni Devi Pharmacy Diploma College Jagdalpur Bastar, Bastar",
    val: 2942,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Gurukripa Pharmacy College Ramtal Road Sendri Bilaspur, Bilaspur",
    val: 2943,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Leela Devi College Of Pharmacy, Durg",
    val: 2944,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Apex Institute Of Pharmacy Education And Research, Raigarh",
    val: 2945,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Gracious College Of Pharmacy Belbhata Abhanpur, Raipur",
    val: 2946,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Jagrani Devi Pharmacy College Baradwar, Sakti",
    val: 2947,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Smt Nilaben Manubhai Padalia Pharmacy College, Ahmadabad",
    val: 2948,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Monark Goswami College Of Pharmacy, Ahmadabad",
    val: 2949,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Varsha Goswami College Of Pharmacy, Ahmadabad",
    val: 2950,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Intas Biopharmaceuticals Ltd., Ahmadabad",
    val: 2951,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "Dr H L Thimmegowda College Of Pharmacy, Ramanagara",
    val: 2952,
    isTop: "",
    created: "2025-10-01 16:42:59",
    cluster: "pharma",
  },
  {
    text: "A.R.College Of Pharmacy & G.H.P. Institute Of Pharmacy, Anand",
    val: 2953,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Shri Balaji College Of Pharmacy, Betul",
    val: 2954,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Arihant School Of Pharmacy, Gandhinagar",
    val: 2955,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Graduate School Of Pharmacy, Gandhinagar",
    val: 2956,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Moonray Institute Of Pharmaceutical Sciences, Mahbubnagar",
    val: 2957,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Akshar-Preet Institute Of Pharmacy, Jamnagar",
    val: 2958,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Radhe School Of Pharmacy, Mahesana",
    val: 2959,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Genezen Institute Of Pharmacy Delol, Panch Mahals",
    val: 2960,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Kishori College Of Pharmacy, Beed",
    val: 2961,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Shri Bapuji College Of Pharmacy, Nagaur",
    val: 2962,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Lord Shiva College Of Pharmacy, Bathinda",
    val: 2963,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Baba Kundan College Of Pharmacy, Ludhiana",
    val: 2964,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Palamau Institute Of Pharmacy, Palamu",
    val: 2965,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Tetri Chandravansi Pharmacy College, Palamu",
    val: 2966,
    isTop: "",
    created: "2025-10-01 16:43:00",
    cluster: "pharma",
  },
  {
    text: "Bldeas College Of Pharmacy Jamkhandi, Bagalkote",
    val: 2967,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Margadarshan Pharmacy College Ilkal, Bagalkote",
    val: 2968,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Nand College Of Pharmacy, Deoria",
    val: 2969,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "National College Of Pharmacy, Kozhikode",
    val: 2970,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Dhanvanthri College Of Pharmaceutical Scienes, Mahbubnagar",
    val: 2971,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "N E T Pharmacy College, Raichur",
    val: 2972,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Ikon Pharmacy College, Ramanagara",
    val: 2973,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Varadaraja Institute Of Pharmaceutical Education And Research, Tumakuru",
    val: 2974,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Bldea Shri Sanganabasava Mahaswamiji College Of Pharmacy And Research Centre, Vijayapura",
    val: 2975,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Shri Sharanabasaveshwar College Of Pharmacy Vijayapura, Vijayapura",
    val: 2976,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Crescent College Of Pharmaceutical Sciences, Kannur",
    val: 2977,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "The Dale View College Of Pharmacy And Research Centre, Thiruvananthapuram",
    val: 2978,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Holy Queen College Of Pharmaceutical Sciences And Research, Thrissur",
    val: 2979,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "School Of Pharmaceutical Science And Research, Balaghat",
    val: 2980,
    isTop: "",
    created: "2025-10-01 16:43:01",
    cluster: "pharma",
  },
  {
    text: "Truba Institute Of Pharmacy, Bhopal",
    val: 2981,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Gurukul Institute Of Pharmaceutical Sciences, Fatehgarh Sahib",
    val: 2982,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Mother Teresa Pharmacy College, Murshidabad",
    val: 2983,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Shanti Institute Of Pharmaceutical Sciences Nowgong, Chhatarpur",
    val: 2984,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Times College Of Pharmacy, Damoh",
    val: 2985,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Nimar Institute Of Pharmacy, Dhar",
    val: 2986,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Awadh Madhav College Of Pharmacy, Gwalior",
    val: 2987,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Ct College Of Pharmacy, Jalandhar",
    val: 2988,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Nirmal College Of Pharmacy, Karauli",
    val: 2989,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "J S Pharmacy College Prithvipur, Niwari",
    val: 2990,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Gulab Kali Memorial College Of Pharmacy, Rewa",
    val: 2991,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Jan Nayak Cdl College Of Pharmacy, Sirsa",
    val: 2992,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Chetana College Of Pharmacy, Sagar",
    val: 2993,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Ojaswini Pharmacy College Sagar, Sagar",
    val: 2994,
    isTop: "",
    created: "2025-10-01 16:43:02",
    cluster: "pharma",
  },
  {
    text: "Ganpati Institute Of Pharmacy, Yamunanagar",
    val: 2995,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Ample Dreams Institute Of Education Pharmacy, Sehore",
    val: 2996,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Krishna Institute Of Pharmaceutical Science And Research Badarwas Dist Shivpuri, Shivpuri",
    val: 2997,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Meera Devi Pharmacy College, Shivpuri",
    val: 2998,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Divy Jyoti Pharmacy College, Sidhi",
    val: 2999,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Jai Raadha Institute Of Pharmaceutical Sciences And Research, Dharmapuri",
    val: 3000,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Unity College Of Pharmacy, Nalgonda",
    val: 3001,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Universal Institute Of Pharmacy, Bareilly",
    val: 3002,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Tagore College Of Pharmacy Jamalpur, Gurugram",
    val: 3003,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Jagdamba Shikshan Prasark Mandal College Of B Pharmacy And Research Centre, Beed",
    val: 3004,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Institute Of Diploma Pharmacy, Kolhapur",
    val: 3005,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Shaheed Sukhdev Singh College Of Pharmacy, Sangrur",
    val: 3006,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Bharat Shikshan Sansthas Tatyaraoji More College Of Pharmacy Umerga Osmanabad, Dharashiv",
    val: 3007,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Hon Tukaramsheth S Baviskar Institute Of Pharmaceutical Education And Research, Dhule",
    val: 3008,
    isTop: "",
    created: "2025-10-01 16:43:03",
    cluster: "pharma",
  },
  {
    text: "Kvps'S Institute Of Pharmaceutical Education, Dhule",
    val: 3009,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Shree Sureshdada Jain Institute Of Pharmaceutical Education & Research, Jalgaon",
    val: 3010,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Vindhyanchal Shikshan Sansthas Vss Institute Of B Pharmacy, Jalna",
    val: 3011,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Roshanbi Shamanji Education Sports And Welfare Society Riyajbhai Shamanji College Of Pharmacy, Kolhapur",
    val: 3012,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Yashwant Redekar College Of Pharmacy B Pharm And D Pharm Nesari, Kolhapur",
    val: 3013,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Anandi B. Pharmacy College, Kolhapur",
    val: 3014,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Shree Ji College Of Pharmacy, Mandsaur",
    val: 3015,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Bhagyoday Tirth Pharmacy College, Sagar",
    val: 3016,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Allam Prabhu College Of Pharmacy, Latur",
    val: 3017,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Dayanand Education Socitys Dayanand Institute Of Pharmacy, Latur",
    val: 3018,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Jay Bharat College Of Pharmacy Dapka Tq Nilanga Dist Latur, Latur",
    val: 3019,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Adarsh Institute Of Pharmacy, Nagpur",
    val: 3020,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Mlr Institute Of Pharmacy, Rangareddi",
    val: 3021,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Shakuntala Patil Bahuuddeshiya Sansthas Shatabdi Institute Of Pharmacy, Nandurbar",
    val: 3022,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Krantiveer Vasantrao Narayanrao Naik Shikshan Prasarak Sansthas Institute Of Pharmaceutical Education And Research Nashik, Nashik",
    val: 3023,
    isTop: "",
    created: "2025-10-01 16:43:04",
    cluster: "pharma",
  },
  {
    text: "Khatun Minority Womens Social Welfare & Educational Societys Royal College Of Pharmaceutical, Nashik",
    val: 3024,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Sat Kabir College Of Pharmacy, Jhajjar",
    val: 3025,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Y N P College Of Pharmacy, Palghar",
    val: 3026,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Shriganesh Ramchandra Katruwar College Of Pharmacy Manwath, Parbhani",
    val: 3027,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Durgamata Institute Of Pharmacy, Parbhani",
    val: 3028,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Jbvp Vidya Niketan College Of Pharmacy, Pune",
    val: 3029,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Late Laxmibai Phadtare College Of Pharmacy Kalamb Walchandnagar, Pune",
    val: 3030,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "R.M.P.S.Bhalchandra College Of Pharmacy, Pune",
    val: 3031,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Shri Jain Vidya Prasarak Mandal'S Rasiklal M. Dhariwal Institute Of Pharmaceutical Education And Research, Pune",
    val: 3032,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Lokmanya Tilak Institute Of Pharmacy, Raigad",
    val: 3033,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Bharat Institute Of Pharmacy, Sonipat",
    val: 3034,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Sri Vishwaradhya Institute Of Pharmaceutical Sciences, Yadgir",
    val: 3035,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Caritas College Of Pharmacy, Kottayam",
    val: 3036,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Dr Ashok Gujar Institute Of Pharmacy Karad, Satara",
    val: 3037,
    isTop: "",
    created: "2025-10-01 16:43:05",
    cluster: "pharma",
  },
  {
    text: "Vijayrao Naik College Of Pharmacy, Sindhudurg",
    val: 3038,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Shri Damaram College Of Pharmacy, Nagaur",
    val: 3039,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Sai Seva Shikshan Prasarak Mandals Shri Pandit Baburao Chaughule College Of Pharmacy, Thane",
    val: 3040,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Vaishalitai Jondhale College Of Pharmacy B Pharm, Thane",
    val: 3041,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Deccan School Of Pharmacy, Rangareddi",
    val: 3042,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Jagadambha Institute Of Pharmacy And Research, Yavatmal",
    val: 3043,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Lotus Institute Of Pharmacy, Bareilly",
    val: 3044,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Regional Institute Of Pharmaceutical Science, Anugul",
    val: 3045,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Einstein College Of Pharmacy, Khordha",
    val: 3046,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Ashok Institute Of Pharmacy, Basti",
    val: 3047,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Shri Satya Sai Institute Of Pharmaceutical Science And Research, Jalaun",
    val: 3048,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Varun Arjun College Of Pharmacy, Shahjahanpur",
    val: 3049,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Om College Of Pharmacy, Haveri",
    val: 3050,
    isTop: "",
    created: "2025-10-01 16:43:06",
    cluster: "pharma",
  },
  {
    text: "Aditya Institute Of Pharmaceutical, Beed",
    val: 3051,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Kc College Of Pharmacy, Shahid Bhagat Singh Nagar",
    val: 3052,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Shri Adarsh Pharmacy College, Bikaner",
    val: 3053,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Vivekanand College Of Pharmacy Katar Chhoti, Churu",
    val: 3054,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Lokmanya Tilak Pharmacy College, Jaipur",
    val: 3055,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Ganpati Institute Of Pharmacy, Jhunjhunu",
    val: 3056,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Teja College Of Pharmacy, Nalgonda",
    val: 3057,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Kamakshi College Of Pharmacy Balotra, Balotra",
    val: 3058,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Lakhmi Chand Patwari College Of Pharmacy, Baghpat",
    val: 3059,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Maharana Pratap School Of Pharmacy, Lucknow",
    val: 3060,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Umalok College Of Pharmacy, Meerut",
    val: 3061,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Adarsh Tagore College Of Pharmacy Nadbai, Bharatpur",
    val: 3062,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Ghanshyam Baba College Of Pharmacy, Bharatpur",
    val: 3063,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Lrl Pharmacy College, Bharatpur",
    val: 3064,
    isTop: "",
    created: "2025-10-01 16:43:07",
    cluster: "pharma",
  },
  {
    text: "Stech Girls College Pharmacy, Bhilwara",
    val: 3065,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Murli Singh Memorial Prashikshan Sansthan Pharmacy College, Bikaner",
    val: 3066,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Gyan Jyoti College Of Pharmacy, Hazaribagh",
    val: 3067,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Om Shiv Pharmacy College Sagwadiya Nimbahera, Chittorgarh",
    val: 3068,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Om Shiv Sansthan Pharmacy College Mangalwad, Chittorgarh",
    val: 3069,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Asha Devi College Of Pharmacy, Churu",
    val: 3070,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Kkc College Of Pharmacy, Churu",
    val: 3071,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Marudhar Institute Of Pharmacy, Churu",
    val: 3072,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Shri Hari Pharmacy College Hanumangarh Road Sardarshahar, Churu",
    val: 3073,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Indian College Of Pharmacy, Dausa",
    val: 3074,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Katta College Of Pharmacy, Dausa",
    val: 3075,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Saptrishi Instiute Of Pharmacy, Dausa",
    val: 3076,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Radhe Krishan College Of Pharmacy, Deeg",
    val: 3077,
    isTop: "",
    created: "2025-10-01 16:43:08",
    cluster: "pharma",
  },
  {
    text: "Sri Ramachandra College Of Pharmacy Vedaraniam, Nagapattinam",
    val: 3078,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Sri Sai R R Institute Of Pharmacy, Aligarh",
    val: 3079,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Kunwar Ajeet College Of Pharmacy, Jaunpur",
    val: 3080,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Mahatma Buddha College Of Pharmacy, Kheri",
    val: 3081,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Excellence Centre Of Pharmacy, Lucknow",
    val: 3082,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Dr. Samuel George College Of Pharmaceutical Science, Prakasam",
    val: 3083,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Swami Shri Prannath Parnami Pharmacy College Padampur, Ganganagar",
    val: 3084,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Faculty Of Pharmacy, Mahesana",
    val: 3085,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Sanskar International Pharmacy College, Hanumangarh",
    val: 3086,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Times Pharmacy College, Hanumangarh",
    val: 3087,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Shri Ganpati Institute Of Pharmaceutical Sciences And Research Tembhurni, Solapur",
    val: 3088,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Alankar Girls Pharmacy College, Jaipur",
    val: 3089,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Deepak Pharmacy College, Jaipur",
    val: 3090,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "Shri Ratan Singh College Of Pharmacy, Shahjahanpur",
    val: 3091,
    isTop: "",
    created: "2025-10-01 16:43:09",
    cluster: "pharma",
  },
  {
    text: "United Institute Of Pharmacy, Kurukshetra",
    val: 3092,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Maha Laxmi College Of Pharmacy, Kathua",
    val: 3093,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Al Iqra College Of Pharmacy, Tumakuru",
    val: 3094,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Ckrd Memorial Pharmacy College, Jhunjhunu",
    val: 3095,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Inderpura Pharmacy College, Jhunjhunu",
    val: 3096,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "New Indian Institute Of Pharmacy, Jhunjhunu",
    val: 3097,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Skaran Institute Of Pharmacy, Jhunjhunu",
    val: 3098,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "St. Xavier Institute Of Pharmacy, Guntur",
    val: 3099,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Government Pharmacy College Surat, Surat",
    val: 3100,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Akshaya Institute Of Pharmacy, Tumakuru",
    val: 3101,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Apex Institute Of Pharmaceutical Science And Research, Kota",
    val: 3102,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Eklavya Pharmacy College, Kotputli-Behror",
    val: 3103,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "New Sainik College Of Pharmacy, Kotputli-Behror",
    val: 3104,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Dr R N Lahoti Institute Of Pharmaceutical Education And Research Center Sultanpur, Buldhana",
    val: 3105,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Geetanjali Pharmacy College Borawar, Nagaur",
    val: 3106,
    isTop: "",
    created: "2025-10-01 16:43:10",
    cluster: "pharma",
  },
  {
    text: "Tagore Pharmacy College, Nagaur",
    val: 3107,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Acharya Tulsi Pharmacy College Ranawas Pali, Pali",
    val: 3108,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Shree Ji Pharmacy Institute, Rajsamand",
    val: 3109,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Bethlahem College Of Pharmaceutical Sciences, Kanniyakumari",
    val: 3110,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Gurram Balanarasaiah Institute Of Pharmacy, MEDCHAL MALKAJGIRI",
    val: 3111,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Mata Phoola Devi College Of Pharmacy, Tonk",
    val: 3112,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Saint Soldier College Of Pharmacy Tonk, Tonk",
    val: 3113,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Kcp College Of Pharmacy, Udaipur",
    val: 3114,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Nagfani Institute Of Pharmacy, Udaipur",
    val: 3115,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Chettinad School Of Pharmaceutical Sciences, Chennai",
    val: 3116,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Mayor Radhakrishnan College Of Pharmacy, Cuddalore",
    val: 3117,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Sun College Of Pharmacy And Research Centre, Kanniyakumari",
    val: 3118,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Kasthooribha Gandhi Pharmacy College, Namakkal",
    val: 3119,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Shri Gulab Singh College Of Pharmacy, Auraiya",
    val: 3120,
    isTop: "",
    created: "2025-10-01 16:43:11",
    cluster: "pharma",
  },
  {
    text: "Dr Anita Yadav College Of Pharmacy, Farrukhabad",
    val: 3121,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Dr Avani College Of Pharmacy, Gonda",
    val: 3122,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "S.A. Raja Pharmacy College, Tirunelveli",
    val: 3123,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Ansh College Of Pharmacy Gwalior, Gwalior",
    val: 3124,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Surya Degree College Chandrugounda, Bhadradri Kothagudem",
    val: 3125,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Cvm College Of Pharmacy, Karimnagar",
    val: 3126,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Pulipati Prasad College Of Pharmaceutical Sciences, Khammam",
    val: 3127,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Dr Kalam College Of Pharmacy, Thanjavur",
    val: 3128,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "K.V.K College Of Pharmacy, Rangareddi",
    val: 3129,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Prathishtha Institute Of Pharmaceutical Sciences, Nalgonda",
    val: 3130,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Shri Rajendar Singh College Of Pharmacy, Hardoi",
    val: 3131,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Milestones Institute Of Pharmaceutical Sciences, Gomati",
    val: 3132,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Sarv Hnd College Of Pharmacy, Rewari",
    val: 3133,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Shri Basaveshwar Institute Of Pharmacy, Dharwad",
    val: 3134,
    isTop: "",
    created: "2025-10-01 16:43:12",
    cluster: "pharma",
  },
  {
    text: "Mizoram Institute Of Pharmaceutical Sciences, Aizawl",
    val: 3135,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Sfc Institute Of Pharmacy, Moga",
    val: 3136,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Shri Samanvay Institute Of Pharmacy, Botad",
    val: 3137,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Government Pharmacy College Gandhinagar, Gandhinagar",
    val: 3138,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Yogendra Nath Saxenxa College Of Pharmacy And Research Centre, Amroha",
    val: 3139,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Sant Bheekhadas Nakchhed Tiwari Pharmacy College Mohli Ayodhya, Ayodhya",
    val: 3140,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Dr. Ithape Institute Of Pharmacy, Ahmednagar",
    val: 3141,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Dr Sarvesh Kumar Shukla Institute Of Pharmacy, Bahraich",
    val: 3142,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Shree P R Memorial College Of Pharmacy, Nagaur",
    val: 3143,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Steller Institute Of Pharmacy, Bareilly",
    val: 3144,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Praduman Singh Shikshan Prashikshan Sansthan Pharmacy College, Basti",
    val: 3145,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Disha Institute Of Pharmacy, Bijnor",
    val: 3146,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Shikhar Institute Of Pharmacy, Budaun",
    val: 3147,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Government Pharmacy College Siwan, Siwan",
    val: 3148,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Vivekanand Education Societys College Of Pharmacy, Haveri",
    val: 3149,
    isTop: "",
    created: "2025-10-01 16:43:13",
    cluster: "pharma",
  },
  {
    text: "Lpm College Of Pharmacy, Deoria",
    val: 3150,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Maharaja Agrasen Institute Of Pharmacy, Sangrur",
    val: 3151,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Vidya Jyoti College Of Pharmacy, Sangrur",
    val: 3152,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Dr Tandon Pharmacy College, Agra",
    val: 3153,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Dr Lohia College Of Pharmacy, Ayodhya",
    val: 3154,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Lord Buddha College Of Pharmacy, Bahraich",
    val: 3155,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Vidyawati Devi College Of Pharmacy, Deoria",
    val: 3156,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Pt Ak Sharma College Of Pharmacy, Mathura",
    val: 3157,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Shakuntala Devi College Of Pharmacy, Farrukhabad",
    val: 3158,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Llyod Institute Of Pharmacy, Gautam Buddha Nagar",
    val: 3159,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Lutawan Institute Of Pharmacy, Ghazipur",
    val: 3160,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Sgm Institue Of Pharmacy, Ghazipur",
    val: 3161,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Dr Narayanrao Chate College Of Pharmacy, Latur",
    val: 3162,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "St Wilfreds Institute Of Pharmaceutical Science And Research Mira Road Thane, Thane",
    val: 3163,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Government Institute Of Pharmaceutical Sciences And Engg, Amritsar",
    val: 3164,
    isTop: "",
    created: "2025-10-01 16:43:14",
    cluster: "pharma",
  },
  {
    text: "Prabha Devi Memorial Pharmacy College, Jaipur",
    val: 3165,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Karpaga Vinayaga Institute For Pharmaceutical Sciences, Chengalpattu",
    val: 3166,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Sri Ram Nallamani Yadava College Of Pharmacy, Tirunelveli",
    val: 3167,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Rishi Ramnaresh College Of Pharmacy, Mau",
    val: 3168,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "City College Of Pharmacy, Haridwar",
    val: 3169,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Ms Bhartiya College Of Pharmacy, Auraiya",
    val: 3170,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Hp Institute Of Pharmacy, Budaun",
    val: 3171,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Cbs College Of Pharmacy, Firozabad",
    val: 3172,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Shri Bajrang Institute Of Pharmacy, Ghazipur",
    val: 3173,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Lucknow Public College Of Pharmacy, Hardoi",
    val: 3174,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Jakir Hossain Institute Of Pharmacy, Murshidabad",
    val: 3175,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Ns College Of Pharmacy, Purba Bardhaman",
    val: 3176,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "R A S Institute Of Pharmacy, Mau",
    val: 3177,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Krishna School Of Pharmacy & Research, Vadodara",
    val: 3178,
    isTop: "",
    created: "2025-10-01 16:43:15",
    cluster: "pharma",
  },
  {
    text: "Manipal School Of Life Sciences, Udupi",
    val: 3179,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "University College Of Pharmacy, Kottayam",
    val: 3180,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Shree Ji Institute Of Pharmaceutical Education And Research Village Bichhola Dhooki Sikarpur Sarai Road Post Seondara Tehsil Bilari District Moradabad, Moradabad",
    val: 3181,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Tit College Of Pharmacy, Bhopal",
    val: 3182,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Jyotiraditya Institute Of Pharmacy, Pratapgarh",
    val: 3183,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Pataldhamal Wadhwani B.Pharmacy College, Yavatmal",
    val: 3184,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Xavier Pharmacy College, Jajapur",
    val: 3185,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Mahala Institute Of Pharmacy, Sikar",
    val: 3186,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Apex Institute Of Pharmacy, Mirzapur",
    val: 3187,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Teerthanker Mahaveer College Of Pharmacy, Moradabad",
    val: 3188,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "J S Singh Institute Of Pharmacy Sitapur, Sitapur",
    val: 3189,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "K P Singh Memorial Institute Of Pharmacy, Sitapur",
    val: 3190,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Spectrum Hi Pharmacy College, Sultanpur",
    val: 3191,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Pharma Dept Sr Foundation Jee College Of Education And Traning, Unnao",
    val: 3192,
    isTop: "",
    created: "2025-10-01 16:43:16",
    cluster: "pharma",
  },
  {
    text: "Maa Savitri College Of Pharmacy, Ghazipur",
    val: 3193,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Shree Heeranand Pharmacy College, Hamirpur",
    val: 3194,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Maa Asha Gyandeep College Of Pharmacy, Jaunpur",
    val: 3195,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Maa Bhagwati College Of Pharmacy, Lucknow",
    val: 3196,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Global Institute Of Pharmacy, Murshidabad",
    val: 3197,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Nibedita Pharmacy College, Murshidabad",
    val: 3198,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Hindupat Institute Of Pharmacy Raghogarh, Guna",
    val: 3199,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Ambika Institute Of Pharmacy, Shivpuri",
    val: 3200,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Saraswati College Of Pharmacy Jaisinghwas, Jhunjhunu",
    val: 3201,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Mahila Pharmacy Mahavidhyalaya, Jodhpur",
    val: 3202,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "St Mariam College Of Pharmacy, Tirunelveli",
    val: 3203,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Govt Pharmacy College Banka, Banka",
    val: 3204,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Harnam Singh College Of Pharmacy Vill Kheri Batter Distt And Teh Ch Dadri, Charki Dadri",
    val: 3205,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Pavitra Institute Of Pharmacy, Gurugram",
    val: 3206,
    isTop: "",
    created: "2025-10-01 16:43:17",
    cluster: "pharma",
  },
  {
    text: "Mata Sahibkaur College Of Pharmacy, Jhajjar",
    val: 3207,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Naveen College Of Pharmacy, Mahendragarh",
    val: 3208,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Lr College Of Pharmacy Vpo Hathin Palwal, Palwal",
    val: 3209,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Sehrawat College Of Pharmacy Hathin Distt Palwal, Palwal",
    val: 3210,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Aravali College Of Pharmacy Village And Post Gokalgarh, Rewari",
    val: 3211,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Shree Balaji College Of Pharmacy, Chhindwara",
    val: 3212,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Rao Khemchand Pharmacy College, Rewari",
    val: 3213,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Dbm College Of Pharmacy Vpo Madina Gohana, Sonipat",
    val: 3214,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Malwa Institute Of Pharmacy, Barnala",
    val: 3215,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Punjab Pharmacy College, Fatehgarh Sahib",
    val: 3216,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Maa Saraswati College Of Pharmacy, Fazilka",
    val: 3217,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Smt Urmila Devi College Of D Pharmacy, Hoshiarpur",
    val: 3218,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Vinayaka Institute Of Pharmacy, Mandi",
    val: 3219,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Awasthi Vetrinary Pharmacist Training Institute, Solan",
    val: 3220,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Sri Sai Instt. Of Pharmacy Indira Nagar, Aligarh",
    val: 3221,
    isTop: "",
    created: "2025-10-01 16:43:18",
    cluster: "pharma",
  },
  {
    text: "Sushant College Of Pharmacy Kathua, Kathua",
    val: 3222,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Baba Vishwanath College Of Pharmacy, Ayodhya",
    val: 3223,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "K D S College Of Pharmacy, Bahraich",
    val: 3224,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Radha Vallabh College Of Pharmacy, Jaunpur",
    val: 3225,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Shri Manmohan Sharma Vaidji Institute Of Pharmacy, Moradabad",
    val: 3226,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Bharat Educational Institute Pharmacy, Muzaffarnagar",
    val: 3227,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Dr R M L Institute Of Pharmacy, Shahjahanpur",
    val: 3228,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Bright School Of Pharmacy, Bokaro",
    val: 3229,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Blm School Of Pharmacy, Deoghar",
    val: 3230,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Sims College Of Life Sciences, Guntur",
    val: 3231,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Shivam School Of Pharmacy, Deoghar",
    val: 3232,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Pemiya Rishikesh College Of Pharmacy, Dhanbad",
    val: 3233,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Kismat College Of Pharmacy, Garhwa",
    val: 3234,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Kismati College Of Pharmacy, Garhwa",
    val: 3235,
    isTop: "",
    created: "2025-10-01 16:43:19",
    cluster: "pharma",
  },
  {
    text: "Birsa School Of Pharmacy, Hazaribagh",
    val: 3236,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Aviram Gramin Vikash Swyam Sevi Sansthan College Of Pharmacy, Latehar",
    val: 3237,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Tila Institute Of Pharmaceutical Science, Ramgarh",
    val: 3238,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Ankur Institute Of Pharmacy, Ranchi",
    val: 3239,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Arnav Institute Of Pharmacy, Ranchi",
    val: 3240,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Bimla Harihar Institute Of Pharmacy, Ranchi",
    val: 3241,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Institute Of Pharmacy Research Centre Surajpur, Surajpur",
    val: 3242,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Vikas Institute Of Pharmacy, Ranchi",
    val: 3243,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Aadhar Institute Of Pharmacy, Belagavi",
    val: 3244,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Bamane Institute Of Pharmacy, Belagavi",
    val: 3245,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Dr B R Ambedkar Institute Of D Pharmacy Humnabad, Bidar",
    val: 3246,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Kres Karnataka School Of Pharmacy Chitguppa, Bidar",
    val: 3247,
    isTop: "",
    created: "2025-10-01 16:43:20",
    cluster: "pharma",
  },
  {
    text: "Neelganga Institute Of Pharmacy Science Yerbagh Basavkalyan, Bidar",
    val: 3248,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Niveditha College Of Pharmacy, Chikkaballapura",
    val: 3249,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Sushrutha Institute Of Pharmacy, Davangere",
    val: 3250,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Crescent College Ofpharmacy Kalaburagi, Kalaburagi",
    val: 3251,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Sct Krishnaveni Institute Of Pharmaceutical Sciences And Research, Kalaburagi",
    val: 3252,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Shri Kaniram Pharmacy College Dhorimana, Barmer",
    val: 3253,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Saint Pauls D Pharmacy College Gangavathi, Koppal",
    val: 3254,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Shri Hari Adarsh Pharmacy College, Jodhpur",
    val: 3255,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Divine Grace College Of Pharmacy Ramanagara, Ramanagara",
    val: 3256,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Universal College Pharmacy Ramanagara, Ramanagara",
    val: 3257,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Pinnacle Institute Of Pharmacy, Tumakuru",
    val: 3258,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Bangi College Of Pharmacy Vijayapur, Vijayapura",
    val: 3259,
    isTop: "",
    created: "2025-10-01 16:43:21",
    cluster: "pharma",
  },
  {
    text: "Lotus College Of Pharmacy, Vijayapura",
    val: 3260,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Sanjeevini School Of Pharmacy, Vijayapura",
    val: 3261,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Managuli Institute Of Pharmaceutical Sciences Shahapur, Yadgir",
    val: 3262,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "John Enoch College Of Pharmacy, Thiruvananthapuram",
    val: 3263,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Shree Vidyadhiraja Pharmacy College, Thiruvananthapuram",
    val: 3264,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "R.N.S. Instt. Of Pharmacy Gwalior, Gwalior",
    val: 3265,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Maa Saraswati College Of Pharmacy, Sirsa",
    val: 3266,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Dr. Kolpe Institute Of Pharmacy, Ahmednagar",
    val: 3267,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Dr Ithape Institute Of D Pharmacy, Ahmednagar",
    val: 3268,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Shri Swami Samarth Institute Of Pharmacy, Ahmednagar",
    val: 3269,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Shri Gurudatta Shikshan Prasarak Sanstha'S Late Shri Ramraoji Gawande Institute Of Pharmacy, Akola",
    val: 3270,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Raje Laxmansingh Bhosale College Of Pharmacy, Akola",
    val: 3271,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Institute Of Pharmacy And Research, Amravati",
    val: 3272,
    isTop: "",
    created: "2025-10-01 16:43:22",
    cluster: "pharma",
  },
  {
    text: "Jai Bhavani Shikshan Prasarak Mandal'S Institute Of Pharmacy, Beed",
    val: 3273,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Vasant Pharmacy College Kaij, Beed",
    val: 3274,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Vitthai D Pharmacy College Beed, Beed",
    val: 3275,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Dr.Arun Motghare Diploma In Pharmacy, Bhandara",
    val: 3276,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Swa Harshwardhan Humane College Of Pharmacy Belati Road Kondha Kosra Tah Pauni Dist Bhandara, Bhandara",
    val: 3277,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Gawande College Of Pharmacy Sakhar Kheda, Buldhana",
    val: 3278,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Satpuda Institute Of Pharmacy Shegaon Dist Buldhana, Buldhana",
    val: 3279,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Abhinav Bahuuddeshiya'S Siddhivinayak College Of Pharmacy, Chandrapur",
    val: 3280,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Ashoka Institute Of Pharmacy, Chandrapur",
    val: 3281,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Manwatkar College Of Pharmacy D Pharm At Ghodpeth Tah Bhadrawati Dist Chandrapur, Chandrapur",
    val: 3282,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Shree Bhairavnath Nisarga Mandal'S D. Pharmacy College, Dharashiv",
    val: 3283,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Bankey Bihari College Of Pharmacy, Fazilka",
    val: 3284,
    isTop: "",
    created: "2025-10-01 16:43:23",
    cluster: "pharma",
  },
  {
    text: "Samarth Institute Of Pharmacy, Dhule",
    val: 3285,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Rupesh Badhan Institute Of Pharmacy Pimpalner, Dhule",
    val: 3286,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Rayat Institute Of Diploma Pharmacy, Shahid Bhagat Singh Nagar",
    val: 3287,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Shree Bhairavnath Nisarg Mandal.'S Diploma In Pharmacy Institute, Hingoli",
    val: 3288,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Sarswati Institute Of Pharmacy, Hingoli",
    val: 3289,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Uttamrao Deshmukh Institute Of Pharmacy Balsond Tal Dist Hingoli, Hingoli",
    val: 3290,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Vss Institute Of Pharmacy, Jalna",
    val: 3291,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Jgvvsss Suyash College Of Pharmacy Warud, Jalna",
    val: 3292,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Ismail Mehta College Of Pharmacy, Jalna",
    val: 3293,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Shahu Chatrapati Shikshan Sanstha'S Rajarshi Shahu Chhatrapati Institute Of Pharmacy Kolhapur, Kolhapur",
    val: 3294,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Shri Y.S.P.Mandal'S Vasantidevi Patil Institute Of Pharmacy, Kolhapur",
    val: 3295,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Y.D. Mane Institute Of Pharmacy, Kolhapur",
    val: 3296,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Genesis Institute Of Pharmacy, Kolhapur",
    val: 3297,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Radhabai Shinde College Of Pharmacy, Kolhapur",
    val: 3298,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Mahatma Basveshwar Education Soc College Of Pharmacy Barshi Road Latur, Latur",
    val: 3299,
    isTop: "",
    created: "2025-10-01 16:43:24",
    cluster: "pharma",
  },
  {
    text: "Shri Vishweshwar Shikshan Prasarak Mandal'S Swa.Dagdojirao Deshmukh D.Pharmacy College, Latur",
    val: 3300,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Latur College Of Pharmacy D. Pharm, Latur",
    val: 3301,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Nbs Institute Of Pharmacy Ausa, Latur",
    val: 3302,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Arman Institute Of Pharmacy, Latur",
    val: 3303,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Shikshan Prasarak Mandal'S Smt. Kusumtai Wankhede Institute Of Pharmacy, Nagpur",
    val: 3304,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Backward Class Youth Relief Committee'S Institute Of D. Pharmacy, Nagpur",
    val: 3305,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Shri Baburam Pharmacy College, Firozabad",
    val: 3306,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Jp Verma College Of Pharmacy, Hardoi",
    val: 3307,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Narvadeshwar Narendra Pharmacy College, Lucknow",
    val: 3308,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "D.K. Patil Institute Of Pharmacy, Nanded",
    val: 3309,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Smt Latatai Baburao Patil Institute Of Pharmacy Khandgaon Nanded, Nanded",
    val: 3310,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "School Of Pharmacy & Research, Sitapur",
    val: 3311,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Ramesh Patil Institute Of Pharmacy, Nanded",
    val: 3312,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Shri Prabhat Pharmacy College, Sultanpur",
    val: 3313,
    isTop: "",
    created: "2025-10-01 16:43:25",
    cluster: "pharma",
  },
  {
    text: "Sane Guruji Vidya Prasarak'S Institute Of Pharmacy, Nandurbar",
    val: 3314,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Dr Bidhan Chandra Roy College Of Pharmacy, Murshidabad",
    val: 3315,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Anjuman Imdadut Tulba'S Institute Of Pharmacy, Nashik",
    val: 3316,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Shree Neminath Jain Brahmacharyashram Jain Gurukul'S Shri.Deepchand Fakirchand Lodha Pharmacy Institute, Nashik",
    val: 3317,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Godavari Shikshan Mandal'S Asian Institute Of Pharmacy, Nashik",
    val: 3318,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "R.G.Sapkal Institute Of Pharmacy, Nashik",
    val: 3319,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Swami Institute Of Pharmacy, Nashik",
    val: 3320,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "R.M.S. Institute Of Pharmacy, Nashik",
    val: 3321,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Jmct Institute Of Pharmacy, Nashik",
    val: 3322,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Late Valmikrao Savant Institute Of D Pharmacy, Nashik",
    val: 3323,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Vidya Amrut Dnyan Pratishthans Vithai Pandit Deore Institute Of Pharmacy Shirsondi Tal Malegaon Dist Nashik, Nashik",
    val: 3324,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Marathwada Shikshan Prasarak Mandal'S Shri Shivaji Institute Of Pharmacy Parbhani, Parbhani",
    val: 3325,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Vivekvardhini Sevabhavi Sanstha'S Diploma Pharmacy College, Parbhani",
    val: 3326,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Dnyansadhana Institute Of Pharmacy, Parbhani",
    val: 3327,
    isTop: "",
    created: "2025-10-01 16:43:26",
    cluster: "pharma",
  },
  {
    text: "Shri.Ramkrishna Paramhans College Of Pharmacy, Parbhani",
    val: 3328,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Dharti Janseva Pratishthans College Of Pharmacy Pathri D Pharm, Parbhani",
    val: 3329,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Ambadasrao Warpudkar Institute Of Pharmacy, Parbhani",
    val: 3330,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Beleshwar Institute Of Pharmacy Parbhani, Parbhani",
    val: 3331,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Department Of Pharmacy Pune, Pune",
    val: 3332,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Sharadchandra Pawar Institute Of Pharmacy, Pune",
    val: 3333,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Vishal Junnar Seva Mandal'S Institute Of Pharmacy, Pune",
    val: 3334,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Vishal Junner Seva Mandal'S Institute Of Pharmacy For Women, Pune",
    val: 3335,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Rajmata Jijau Shikshan Prasarak Mandal Institute Of Pharmacy, Pune",
    val: 3336,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Rameshwari Mauli Prathishtan Of Bhalchnadra Institute Of Pharmacy, Pune",
    val: 3337,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Shivnagar Vidya Prasarak Manda'Ls Institute Of Pharmacy Malegaon, Pune",
    val: 3338,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Anusaya Institute Of Pharmacy, Pune",
    val: 3339,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Elixir Institute Of Pharmacy, Pune",
    val: 3340,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Delight Institute Of Pharmacy, Pune",
    val: 3341,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Varvand Gram Shikshan Sansthas Eknath Sitaram Divekar College Of Pharmacy, Pune",
    val: 3342,
    isTop: "",
    created: "2025-10-01 16:43:27",
    cluster: "pharma",
  },
  {
    text: "Bhartiya Education Soc.'S Institute Of Pharmacy, Raigad",
    val: 3343,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "B K Patil Institute Of Pharmacy, Raigad",
    val: 3344,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Dr Bapuji Salunkhe Institute Of Pharmacy, Sangli",
    val: 3345,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Shree Ambabai Talim Sanstha'S Diploma In Pharmacy, Sangli",
    val: 3346,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Annasaheb Dange College Of D. Pharmacy, Sangli",
    val: 3347,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Padmabhushan Krantiveer Dr Nagnath Anna Nayakawadi College Of Pharmacy, Sangli",
    val: 3348,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Meruling Shikshan Sanstha'S Diploma In Pharmacy, Satara",
    val: 3349,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Mahalaxmi Institute Of Pharmacy, Satara",
    val: 3350,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Zadbuke Institute Of Pharmacy, Solapur",
    val: 3351,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Shri Ganpati Institute Of D Pharmacy Tembhurni, Solapur",
    val: 3352,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Amepurva Forums Nirant Institute Of Pharmacy, Solapur",
    val: 3353,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Siddhis Institute Of Pharmacy, Thane",
    val: 3354,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Abhinav Institute Of Pharmacy, Thane",
    val: 3355,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Dpos Nett College Of Pharmacy, Thane",
    val: 3356,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Saket Institute Of Pharmacy, Thane",
    val: 3357,
    isTop: "",
    created: "2025-10-01 16:43:28",
    cluster: "pharma",
  },
  {
    text: "Vaishalitai Jondhale College Of Pharmacy D Pharm, Thane",
    val: 3358,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Sudam Shikshan Prasarak Mandal'S Shree Babasaheb Gharfalkar College Of Pharmacy, Wardha",
    val: 3359,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Narendra Suryawanshi College Of Pharmacy, Wardha",
    val: 3360,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Yogeshwar College Of Pharmacy, Barwani",
    val: 3361,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Vidarbha Institute Of Pharmacy, Washim",
    val: 3362,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Kamalprakash Pharmacy College & Research Centre, Washim",
    val: 3363,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Shraddha Institite Of Pharmacy, Washim",
    val: 3364,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Advika College Of Pharmacy And Research Center, Washim",
    val: 3365,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Mauli Institute Of Pharmacy And Research Center Washim, Washim",
    val: 3366,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Shikshan Prsarak Mandal'S Institute Of Pharmacy, Yavatmal",
    val: 3367,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Sanjay Rathod Shikshan Sanstha'S Manohar Naik Institute Of Pharmacy Yawatmal, Yavatmal",
    val: 3368,
    isTop: "",
    created: "2025-10-01 16:43:29",
    cluster: "pharma",
  },
  {
    text: "Shri Chhatrapati Shahumaharaj Shikshan Santha'S Institute Of Pharmacy, Yavatmal",
    val: 3369,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Laithangpuii College Of Pharmacy, Aizawl",
    val: 3370,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Sankar Rukmini College Of Pharmacy, Anugul",
    val: 3371,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Sabitri Institute Of Pharmacy, Baleshwar",
    val: 3372,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Rajib Lochan Hota College Of Pharmacy, Bargarh",
    val: 3373,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Aurosri Institute Of Pharmaceutical Education And Research, Cuttack",
    val: 3374,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Herbal Cross Institute Of Pharmacy, Cuttack",
    val: 3375,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Santoshi Institute Of Pharmaceutical Education And Research, Cuttack",
    val: 3376,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Unopos School Of Pharmacy, Jagatsinghapur",
    val: 3377,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Maa Bharti Pharmacy Ccollege, Banswara",
    val: 3378,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Jajpur Pharmacy College, Jajapur",
    val: 3379,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Subash Bose College Of Pharmacy, Jajapur",
    val: 3380,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Nirmalya School Of Pharmacy, Kendujhar",
    val: 3381,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Bhagwan Mahaveer Institute Of Pharmacy, Karauli",
    val: 3382,
    isTop: "",
    created: "2025-10-01 16:43:30",
    cluster: "pharma",
  },
  {
    text: "Maa Mangala College Of Pharmaceutical Sciences, Mayurbhanj",
    val: 3383,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Maa Bhandara Gharani College Of Pharmacy, Nabarangpur",
    val: 3384,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Maa Samalai Pharmacy College, Sambalpur",
    val: 3385,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Hrudananda Dani Pharmacy College, Sundargarh",
    val: 3386,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Maheswari Pharmaceutical College Sundargarh, Sundargarh",
    val: 3387,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Sri Guru Ramdass Pharmacy College, Amritsar",
    val: 3388,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Mahant Gurbanta Dass Memorial College Of Pharmacy, Bathinda",
    val: 3389,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Jain Institute Of Pharmacy, Fazilka",
    val: 3390,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Maa Saraswati Institute Of Pharmaceutical Sciences, Fazilka",
    val: 3391,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Bhagwan Singh Institute Of Pharmacy, Jalaun",
    val: 3392,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Faculty Of Pharmacy Js University, Kheri",
    val: 3393,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Malwa College Of Pharmacy Malakpur Khiala Mansa, Mansa",
    val: 3394,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Saint Kabir Institute Of Pharmacy Moga, Moga",
    val: 3395,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Thapar College Of Pharmacy, Moga",
    val: 3396,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Aryabhatta Institute Of Pharmacy, Sangrur",
    val: 3397,
    isTop: "",
    created: "2025-10-01 16:43:31",
    cluster: "pharma",
  },
  {
    text: "Onkar Colelge Of Pharmacy, Sangrur",
    val: 3398,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Ehsan College Of Pharmacy, Bokaro",
    val: 3399,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Lala Lajpat Rai Institute Of Pharmacy, Jalandhar",
    val: 3400,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Chaudhary College Of Pharmacy, Ambedkar Nagar",
    val: 3401,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Dev Indrawati College Of Pharmacy, Ambedkar Nagar",
    val: 3402,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Venkateshwara Institute Of Pharmacy, Meerut",
    val: 3403,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Aryan Institute Of Pharmacy, Murshidabad",
    val: 3404,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Burdwan Institute Of Pharmacy, Purba Bardhaman",
    val: 3405,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Kamarajar College Of Pharmacy, Cuddalore",
    val: 3406,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Noble College Of Pharmacy, Medak",
    val: 3407,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "C S Jain College Of Pharmacy, Cuddalore",
    val: 3408,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Department Of Pharmacy, Vadodara",
    val: 3409,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "World College Of Pharmaceutical Sciences, Jhajjar",
    val: 3410,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Nazareth College Of Pharmacy, Pathanamthitta",
    val: 3411,
    isTop: "",
    created: "2025-10-01 16:43:32",
    cluster: "pharma",
  },
  {
    text: "Advance College Of Pharmacy Datia, Datia",
    val: 3412,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Navsahyadri Institute Of Pharmacy, Pune",
    val: 3413,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Bhagirathi Institute Of Pharmacy, Champawat",
    val: 3414,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Mother Teresa College Of Pharmacy, MEDCHAL MALKAJGIRI",
    val: 3415,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Lord Krishna Institute Of Pharmacy Atrauli Aligarh, Aligarh",
    val: 3416,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Prem Institute Of Pharmacy, Aligarh",
    val: 3417,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Chaudhary Charan Singh College Of Pharmacy, Gautam Buddha Nagar",
    val: 3418,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Bhagirathi Ayurved Pharmacy College Pratappur Chamurkha Katehari Ambedkarnagar, Ambedkar Nagar",
    val: 3419,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Bhagirathi Kamala Homeopathic Pharmacy College Pratappur Chamurkha Katehari Ambedkarnagar, Ambedkar Nagar",
    val: 3420,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Bhanmati Smarak College Of Pharmacy, Ambedkar Nagar",
    val: 3421,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Bm Memorial Degree College Pharmacy, Ambedkar Nagar",
    val: 3422,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Dev Indrawati College Of Pharmacy Arkhapur, Ambedkar Nagar",
    val: 3423,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Doyen Institute Of Homeopathic Pharmacy, Ambedkar Nagar",
    val: 3424,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Smt Satyawati Devi College Of Pharmacy, Ambedkar Nagar",
    val: 3425,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Shri Amar Bahadur Singh Institute Of Pharmacy, Amethi",
    val: 3426,
    isTop: "",
    created: "2025-10-01 16:43:33",
    cluster: "pharma",
  },
  {
    text: "Jai Shiv College Of Pharmacy And Research Centree, Amroha",
    val: 3427,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Choudhary Suresh Singh Pharmacy College, Auraiya",
    val: 3428,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Bhavdiya Institute Of Pharmaceutical Science & Research, Ayodhya",
    val: 3429,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Department Of Pharmacy Shri Paramhans Shikshan Prashikshan Mahavidyalaya, Ayodhya",
    val: 3430,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Cross Belly Institute Of Homeopathic Pharmacy Kukuripur Sathion Azamgarh, Azamgarh",
    val: 3431,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Shri Chandra Shekhar Pandey College Of Pharmacy, Banda",
    val: 3432,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "New Khusro Pharmacy Institute Of Sciences Bareilly, Bareilly",
    val: 3433,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Utkarsh Institute Of Pharmacy, Bareilly",
    val: 3434,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Brmhdutt Dwivedi Prabha Dwivedi Collage Of Homyopathic Pharmacy, Basti",
    val: 3435,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Ishrawati Devi Institute Of Pharmacy College, Basti",
    val: 3436,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Narpat Singh College Of Pharmacy, Basti",
    val: 3437,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Kdh College Of Pharmacy, Budaun",
    val: 3438,
    isTop: "",
    created: "2025-10-01 16:43:34",
    cluster: "pharma",
  },
  {
    text: "Universal College Of Pharmacy Udaipur Khurd Karanwas Road Anoopshahr Dist Bulandshahr, Bulandshahr",
    val: 3439,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Bahadur Yadav College Of Pharmacy Nagar Panchayat Bhatni Deoria, Deoria",
    val: 3440,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Kamla Devi Institute Of Pharmacy Tilai Belwa Deoria, Deoria",
    val: 3441,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Lalita College Of Pharmacy, Deoria",
    val: 3442,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Maa Urmila Devi College Of Pharmacy Rampur Mukund Deoria, Deoria",
    val: 3443,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Ramrekha Rai Institute Of Pharmacy, Deoria",
    val: 3444,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Shri Dinesh Chandra Geeta College Of Pharmacy Baruwadih Baikunthpur Deoria, Deoria",
    val: 3445,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Swatantrata Senani Chhangur Tripathi Institute Of Pharmacy, Deoria",
    val: 3446,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Vageshwari Shikshan Sansthan Pharmacy College Mail Deoria, Deoria",
    val: 3447,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "C S College Of Pharmacy, Etah",
    val: 3448,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Avadh Institute Of Pharmacy, Farrukhabad",
    val: 3449,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Chaudhary Pancham Singh Pharmacy College, Farrukhabad",
    val: 3450,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Dr Angna Pharmacy College, Farrukhabad",
    val: 3451,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Shakuntala Devi Pharmacy College, Farrukhabad",
    val: 3452,
    isTop: "",
    created: "2025-10-01 16:43:35",
    cluster: "pharma",
  },
  {
    text: "Shri Jay Singh Chote Sahab College Of Pharmacy, Farrukhabad",
    val: 3453,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Shri Jay Singh Pharmacy College, Farrukhabad",
    val: 3454,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Shri Virendra Singh Katiyar Institute Of Pharmacy, Farrukhabad",
    val: 3455,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Tejas Institute Of Pharmacy, Farrukhabad",
    val: 3456,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Amar Shahid Kanchan Singh Mahavidyalaya Faculty Of Pharmacy, Fatehpur",
    val: 3457,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Department Of Pharmacy Rama Shiksha Sansthan, Fatehpur",
    val: 3458,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Kiran Singh Pharmacy College, Fatehpur",
    val: 3459,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Maa Kusum College Of Pharmacy, Fatehpur",
    val: 3460,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Pandit Dev Narayan Shukla College Of Pharmacy, Fatehpur",
    val: 3461,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Pt Khere Prasad Vipin Bihari College Of Pharmacy, Fatehpur",
    val: 3462,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Tulsi Pharmacy College Mahraha Bindki Fatehpur, Fatehpur",
    val: 3463,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Uday Pharmacy College, Fatehpur",
    val: 3464,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Ujjwal Pharmacy College, Fatehpur",
    val: 3465,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Umraw Pharmacy College, Fatehpur",
    val: 3466,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Heritage Pharmacy College, Garhwa",
    val: 3467,
    isTop: "",
    created: "2025-10-01 16:43:36",
    cluster: "pharma",
  },
  {
    text: "Indian College Of Pharmacy, Palamu",
    val: 3468,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Jharkhand School Of Pharmacy, Ranchi",
    val: 3469,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Ishan Institute Of Pharmacy, Gautam Buddha Nagar",
    val: 3470,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Rakshpal Bahadur Pharmacy Institute, Gautam Buddha Nagar",
    val: 3471,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Jms Pharmacy College, Ghaziabad",
    val: 3472,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Nanotech Institute Of Pharmacy, Ghaziabad",
    val: 3473,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Hira Singh Yadav College Of Pharmacy, Ghazipur",
    val: 3474,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "I D Memorial College Of Pharmacy, Ghazipur",
    val: 3475,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Krisna Sudama College Of Pharmacy Vill Baksupur Post Hurmujpur Ghazipur, Ghazipur",
    val: 3476,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Sama Mahendra College Of Pharmacy Dhirjijote Sikhrie Jakhaniya Ghazipur, Ghazipur",
    val: 3477,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Pandit Jamuna Prasad College Of Pharmacy, Gonda",
    val: 3478,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Pt Jamuna Prasad Institute Of Pharmacy, Gonda",
    val: 3479,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Platinum Institute Of Pharmacy, Gorakhpur",
    val: 3480,
    isTop: "",
    created: "2025-10-01 16:43:37",
    cluster: "pharma",
  },
  {
    text: "Let Pooran Ramprakash Dixit College Of Pharmacy, Hamirpur",
    val: 3481,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Sw Sunder Lal Shivhare College Of Pharmacy, Hamirpur",
    val: 3482,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Elite College Of Pharmacy, Hardoi",
    val: 3483,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Jivika Institute Of Pharmacy, Hardoi",
    val: 3484,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Prem Raghu Institute Of Pharmacy, Hathras",
    val: 3485,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Ashok Singh Pharmacy College Jaunpur, Jaunpur",
    val: 3486,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Baba Vishwanath College Of Pharmacy, Jaunpur",
    val: 3487,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Harishchandra Pharmacy College Jaunpur, Jaunpur",
    val: 3488,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Maa Saraswati College Of Pharmacy, Jaunpur",
    val: 3489,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Manvendra Singh Suman Mahavidyalaya Pharmacy College Jaunpur, Jaunpur",
    val: 3490,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "M S D College Of Pharmacy Vill Post Asbaranpur Trilochan Mahadev Teh Kerakat Jaunpur, Jaunpur",
    val: 3491,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Neelkanth College Of Pharmacy Education, Jaunpur",
    val: 3492,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Nirmala Devi Pharmacy College, Jaunpur",
    val: 3493,
    isTop: "",
    created: "2025-10-01 16:43:38",
    cluster: "pharma",
  },
  {
    text: "Rammurti Institute Of Pharmacy, Jaunpur",
    val: 3494,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Chaudhary Ramveer Singh Yadav Pharmacy College Harsaina Kasganj, Kasganj",
    val: 3495,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Ch Ram Prakash Yadav College Of Pharmacy Badariya Soron, Kasganj",
    val: 3496,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Sir M U Pharmacy College, Kasganj",
    val: 3497,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Shri Raghuraj Singh Memorial College Of Pharmacy, Kaushambi",
    val: 3498,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Chaudhary Bechelal College Of Pharmacy, Kheri",
    val: 3499,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Srajan Institute Of Pharmacy, Kheri",
    val: 3500,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Study Well Institute Of Pharmacy, Kheri",
    val: 3501,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Heeralal Yadav College Of Pharmacy, Lucknow",
    val: 3502,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Karamat College Of Pharmacy, Lucknow",
    val: 3503,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Kunwars College Of Pharmacy, Lucknow",
    val: 3504,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Qadar Ahmad Khan College Of Pharmacy, Lucknow",
    val: 3505,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "St Mother Teresa College Of Pharmacy, Lucknow",
    val: 3506,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Vikat Institute Of Pharmaceutical Science, Lucknow",
    val: 3507,
    isTop: "",
    created: "2025-10-01 16:43:39",
    cluster: "pharma",
  },
  {
    text: "Vinayaka Institute Of Pharmaceutical Science, Lucknow",
    val: 3508,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Wisdom College Of Pharmacy, Lucknow",
    val: 3509,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Brijraj Smarak Pharmacy College, Maharajganj",
    val: 3510,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Parmeshwar Singh Memorial College Of Pharmacy, Maharajganj",
    val: 3511,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Yaduvansh Prasad Mishra Institute Of Pharmacy, Maharajganj",
    val: 3512,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Chandra Kamal Pharmacy Mahavidalaya, Mainpuri",
    val: 3513,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Chandra Kamal Pharmacy Mahavidyalaya, Mainpuri",
    val: 3514,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "D S Pharmacy College, Mathura",
    val: 3515,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Shree Digamber Singh Angoori Devi Institute Of Pharmacy, Mathura",
    val: 3516,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Ramashray Singh Institute Of Homeopathic Pharmacy, Mau",
    val: 3517,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Ramashray Singh Institute Of Pharmacy, Mau",
    val: 3518,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Shyampati Baliram Maurya Institute Of Pharmacy Maalav Karahan Mau, Mau",
    val: 3519,
    isTop: "",
    created: "2025-10-01 16:43:40",
    cluster: "pharma",
  },
  {
    text: "Kamakhya College Of Pharmacy, Meerut",
    val: 3520,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Svs School Of Pharmacy, Meerut",
    val: 3521,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Ambedkar Institute Of Pharmacy Mirzapur, Mirzapur",
    val: 3522,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Krishak Collage Of Pharmacy, Mirzapur",
    val: 3523,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Ordial College Of Pharmacy, Mirzapur",
    val: 3524,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Ramratti Devi College Of Pharmacy, Mirzapur",
    val: 3525,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Akhilesh Yadav Pharmacy College, Moradabad",
    val: 3526,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Rampal Singh Smarak College Of Pharmacy, Moradabad",
    val: 3527,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "M Y Institute Of Pharmacy Shivgarh Raniganj Pratapgarh, Pratapgarh",
    val: 3528,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Ruma Institute Of Pharmacy, Pratapgarh",
    val: 3529,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Surya Pal Institute Of Pharmacy, Pratapgarh",
    val: 3530,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Archana College Of Pharmacy Prayagraj, Prayagraj",
    val: 3531,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Badridhar Dwivedi College Of Pharmacy, Prayagraj",
    val: 3532,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Omkar Nath Singh College Of Pharmacy, Prayagraj",
    val: 3533,
    isTop: "",
    created: "2025-10-01 16:43:41",
    cluster: "pharma",
  },
  {
    text: "Savitri Devi College Of Pharmacy, Prayagraj",
    val: 3534,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Dixit College Of Pharmacy And Research, Rampur",
    val: 3535,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Doon Pharmacy Research Institute, Saharanpur",
    val: 3536,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Bmbl Jain College Of Pharmacy, Sambhal",
    val: 3537,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Munna Singh Pharmacy College Village Bhainsora Post Yusufpur Nagaliya Sambhal, Sambhal",
    val: 3538,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Sggs College Of Pharmacy And Research Centre, Sambhal",
    val: 3539,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Narpati Singh Mahavidyalaya Pharmacy Sant Kabir Nagar, Sant Kabeer Nagar",
    val: 3540,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Choudhary Charan Singh Pharmacy College, Shahjahanpur",
    val: 3541,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Dilip Kishore Mehrotra Institute Of Pharmacy, Sitapur",
    val: 3542,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Madan Mohan Lal Mehrotra Institute Of Pharmacy, Sitapur",
    val: 3543,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Ram Akbaal Shivrani Pharmacy College, Sitapur",
    val: 3544,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Sri Vimal Nath Pharmacy Institute, Sitapur",
    val: 3545,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Vidya Niketan Pharmacy, Sitapur",
    val: 3546,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Acharya Chankya Mahavidayalya Faculty Of Pharmacy, Sultanpur",
    val: 3547,
    isTop: "",
    created: "2025-10-01 16:43:42",
    cluster: "pharma",
  },
  {
    text: "Pt Deen Dayal Upadhyay College Of Pharmacy, Sultanpur",
    val: 3548,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Tabish Pharmacy School, Sultanpur",
    val: 3549,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Cksm College Of Pharmacy Unnao, Unnao",
    val: 3550,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Banaras Institute Of Pharmacy, Varanasi",
    val: 3551,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Sb Institute Of Pharmacy, Varanasi",
    val: 3552,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Nurul Islam College Of Pharmacy, Alipurduar",
    val: 3553,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Disha Institute Of Pharmacy, Birbhum",
    val: 3554,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Illambazar Institute Of Pharmacy, Birbhum",
    val: 3555,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Natural College Of Pharmacy, Birbhum",
    val: 3556,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Seba Institute Of Pharmacy, Birbhum",
    val: 3557,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Skm Institute Of Pharmaceutical Sciences And Research, Birbhum",
    val: 3558,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Suptendu Pharmacy Institute, Hooghly",
    val: 3559,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Bhagawan Prasad Pharmacy College, Maldah",
    val: 3560,
    isTop: "",
    created: "2025-10-01 16:43:43",
    cluster: "pharma",
  },
  {
    text: "Charaktala College Of Pharmacy, Maldah",
    val: 3561,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Credence Pharmacy College, Maldah",
    val: 3562,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Dishari Institute Of Pharmacy, Maldah",
    val: 3563,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Mango Valley Pharmacy College, Maldah",
    val: 3564,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Netaji College Of Pharmacy, Maldah",
    val: 3565,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Derozio Pharma Institute, Medinipur East",
    val: 3566,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Kazi Nazrul Islam Pharmaceutical Sciences, Medinipur West",
    val: 3567,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Kharagpur Pharmaceutical Institute, Medinipur West",
    val: 3568,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Pandit Iswar Chandra Vidyasagar College Of Pharmacy, Medinipur West",
    val: 3569,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Aastha Institute Of Pharmacy, Murshidabad",
    val: 3570,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Abl Institute Of Pharmacy, Murshidabad",
    val: 3571,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Adhayan Institute Of Pharmacy, Murshidabad",
    val: 3572,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Bengal Education Of Pharmacy, Murshidabad",
    val: 3573,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Hemchandra Memorial College Of Pharmacy, Murshidabad",
    val: 3574,
    isTop: "",
    created: "2025-10-01 16:43:44",
    cluster: "pharma",
  },
  {
    text: "Jiaganj Institute Of Pharmacy, Murshidabad",
    val: 3575,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Kader Molla College Of Pharmacy, Murshidabad",
    val: 3576,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Kaviguru College Of Pharmacy, Murshidabad",
    val: 3577,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Najimuddin Institute Of Pharmacy, Murshidabad",
    val: 3578,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Nscb Institute Of Pharmacy, Murshidabad",
    val: 3579,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Rjtja Diploma Pharmacy College, Murshidabad",
    val: 3580,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Tarifa Memorial Institute Of Pharmacy, Murshidabad",
    val: 3581,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Jeevan Jyoti Institute Of Pharmacy, Aligarh",
    val: 3582,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Vidyasagar Pharmaceutical College Of Education, Nadia",
    val: 3583,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Nsms Institute Of Pharmacy, Paschim Bardhaman",
    val: 3584,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Kalpana College Of Pharmacy, Purba Bardhaman",
    val: 3585,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Lakshmi Pharmacy Institute, Purba Bardhaman",
    val: 3586,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Upasana College Of Pharmacy, Purba Bardhaman",
    val: 3587,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Adarsh Shikshan Sansta'S Colllege Of Pharmacy Beed, Beed",
    val: 3588,
    isTop: "",
    created: "2025-10-01 16:43:45",
    cluster: "pharma",
  },
  {
    text: "Lokseva Pratisthan'S Lokseva College Of Pharmacy Phulgaon Haveli Pune, Pune",
    val: 3589,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Sahyadri Shikshan Sanstha'S College Of Pharmacy Sawarde, Ratnagiri",
    val: 3590,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Mahila Utkarsha Pratishstan'S Pharmacy College Risod Washim, Washim",
    val: 3591,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Navsanjivan Shikshan Mandal'S College Of Pharmacy Dharwa, Yavatmal",
    val: 3592,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "University Institute of Pharmaceutical Sciences, Panjab University, Chandigarh",
    val: 3593,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Department of Pharmaceutical Sciences, Dibrugarh University, Dibrugarh",
    val: 3594,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "SLT Institute of Pharmaceutical Sciences (Department of Pharmacy), GGU, Bilaspur",
    val: 3595,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Millennium College of Pharmacy, Bhopal",
    val: 3596,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "SVERIs College of Pharmacy, Pandharpur",
    val: 3597,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Department of Chemistry, Chaudhary Ranbir Singh University, Jind, Haryana",
    val: 3598,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Adesh Institute of Pharmacy & Biomedical Sciences, Bathinda",
    val: 3599,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Nava Bharat Institute of Pharmaceutical and Medical Sciences, Ranga Reddy",
    val: 3600,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Pearl Peace Medical Mission College of Pharmacy, Tirunelveli",
    val: 3601,
    isTop: "",
    created: "2025-10-01 16:43:46",
    cluster: "pharma",
  },
  {
    text: "Ayush College of Pharmacy, Bilaspur",
    val: 3602,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Jeevan Jyoti Pharmacy and Medical Science, Palwal",
    val: 3603,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Chanakya College of Pharmacy and Medical Sciences, Bhojpur",
    val: 3604,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "JKK Munirajah Medical Research Foundation Annai JKK Sampoorani Ammal College of Pharmacy, Namakkal",
    val: 3605,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Shri Indra Ganesan Institute of Medical Science College of Pharmacy, Tiruchirapalli",
    val: 3606,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Dr. B. C. Roy College of Pharmacy and Allied Health Sciences, Durgapur",
    val: 3607,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Prabha Harjilal College Of Pharmacy And Paraclinical Sciences, Jammu",
    val: 3608,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Doon Valley Institute Of Pharmacy & Medical Outside Jundla Gate, Karnal",
    val: 3609,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Starcity Medical College Of Pharmacy, Churu",
    val: 3610,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Sms Medical Department Of Pharmacy, Jaipur",
    val: 3611,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Adarsh Medical College Of Pharmacy, Churu",
    val: 3612,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Sai Hospital And Institute Of Pharmacy, Sonbhadra",
    val: 3613,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Usha College Of Pharmacy And Medical Sciences, Ambedkar Nagar",
    val: 3614,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Professor Deenanath Pandey Medical College Of Pharmacy, Banda",
    val: 3615,
    isTop: "",
    created: "2025-10-01 16:43:47",
    cluster: "pharma",
  },
  {
    text: "Pt Shravan Kumar Dwivedi Suneeta Dwivedi Medical College Of Pharmacy Jagammanpur Jalaun, Jalaun",
    val: 3616,
    isTop: "",
    created: "2025-10-01 16:43:48",
    cluster: "pharma",
  },
  {
    text: "Dolphin College Of Pharmacy And Medical Sciences, Murshidabad",
    val: 3617,
    isTop: "",
    created: "2025-10-01 16:43:48",
    cluster: "pharma",
  },
  {
    text: "Parbatipur College Of Pharmacy And Medical Science, Murshidabad",
    val: 3618,
    isTop: "",
    created: "2025-10-01 16:43:48",
    cluster: "pharma",
  },
].sort(function (a, b) {
      return a["text"].localeCompare(b.text)
  });

var instituteTagsDataHirist = [
  {
      "val": "1",
      "text": "Aalim Muhammed Salegh College of Engineering, Chennai",
  },
  {
      "val": "2",
      "text": "ABES Engineering College, Ghaziabad",

  },
  {
      "val": "3",
      "text": "ABV- Indian Institute of Information Technology and Management, Gwalior",
      "isTop": "topinst"
  },
  {
      "val": "4",
      "text": "Acharya Institute of Technology, Bangalore",
  },
  {
      "val": "5",
      "text": "AD Patel Institute of Technology, Anand",
  },
  {
      "val": "6",
      "text": "Adesh Institute of Engineering and Technology, Faridkot",
  },
  {
      "val": "7",
      "text": "Adhiparasakthi Engineering College, Kancheepuram",
  },
  {
      "val": "11",
      "text": "Aditya Engineering College, Surampalem",
  },
  {
      "val": "14",
      "text": "Aditya Institute of Technology and Management, Tekkali",
  },
  {
      "val": "15",
      "text": "Ajay Kumar Garg Engineering College, Ghaziabad",
  },
  {
      "val": "16",
      "text": "Alagappa Chettiar College of Engineering and Technology, Karaikudi",
  },
  {
      "val": "17",
      "text": "Alagappa College of Technology, Chennai",
  },
  {
      "val": "18",
      "text": "Aligarh Muslim University, Aligarh",
  },
  {
      "val": "19",
      "text": "Alliance College of Engineering and Design, Bangalore",
  },
  {
      "val": "20",
      "text": "Ambedkar Institute of Advanced Communication Technologies and Research, Delhi",
  },
  {
      "val": "21",
      "text": "Amity School of Engineering and Technology, Delhi",
  },
  {
      "val": "22",
      "text": "Amity School of Engineering and Technology, Noida",
  },
  {
      "val": "23",
      "text": "Amity University, Noida",
  },
  {
      "val": "24",
      "text": "Amrita School of Engineering, Coimbatore",
  },
  {
      "val": "25",
      "text": "Anand Institute of Higher Technology, Chennai",
  },
  {
      "val": "26",
      "text": "Anil Neerukonda Institute of Technology and Sciences, Vishakhapatnam",
  },
  {
      "val": "103",
      "text": "Anna University Chennai, CEG Campus",
  },
  {
      "val": "27",
      "text": "Anna University Tiruchirappalli, BIT Campus",
  },
  {
      "val": "28",
      "text": "Annamacharya Institute of Technology and Sciences, Rajampet",
  },
  {
      "val": "29",
      "text": "Arunai Engineering College, Tiruvannamalai",
  },
  {
      "val": "30",
      "text": "Asansol Engineering College, Asansol",
  },
  {
      "val": "31",
      "text": "Assam University, Silchar",
  },
  {
      "val": "33",
      "text": "AU College of Engineering for Women, Vishakapattnam",
  },
  {
      "val": "34",
      "text": "AU College of Engineering, Vishakhapatnam",
  },
  {
      "val": "35",
      "text": "Audisankara College of Engineering and Technology, Gudur",
  },
  {
      "val": "36",
      "text": "Aurora's Engineering College, Nalgonda",
  },
  {
      "val": "37",
      "text": "Aurora's Scientific, Technological and Research Academy, Hyderabad",

  },
  {
      "val": "38",
      "text": "Aurora's Technological and Research Institute, Hyderabad",

  },
  {
      "val": "39",
      "text": "Avanthi Institute of Engineering and Technology, Vishakhapatnam",
  },
  {
      "val": "40",
      "text": "B K Birla Institute of Engineering and Technology, Pilani",
  },
  {
      "val": "41",
      "text": "Baddi University of Emerging Sciences and Technologies, Baddi",
  },
  {
      "val": "42",
      "text": "Banasthali University, Banasthali",
  },
  {
      "val": "43",
      "text": "Bangalore Institute of Technology, Bangalore",
  },
  {
      "val": "44",
      "text": "Bankura Unnayani Institute of Engineering, Bankura",
  },
  {
      "val": "45",
      "text": "Bannari Amman Institute of Technology, Erode",
  },
  {
      "val": "46",
      "text": "Bapatala Engineering College, Bapatala",
  },
  {
      "val": "47",
      "text": "Bapuji Institute of Engineering and Technology, Davangere",
  },
  {
      "val": "49",
      "text": "Barkatullah University Institute of Technology, Barkatullah University, Bhopal",
  },
  {
      "val": "50",
      "text": "Basaveshwar Engineering College, Bagalkot",
  },
  {
      "val": "51",
      "text": "Beant College of Engineering and Technology, Gurdaspur",
  },
  {
      "val": "52",
      "text": "Bhagalpur College of Engineering, Bhagalpur",
  },
  {
      "val": "55",
      "text": "Bharath University, Chennai",
  },
  {
      "val": "56",
      "text": "Bharati Vidyapeeth Deemed University College of Engineering, Pune",
  },
  {
      "val": "57",
      "text": "Bharati Vidyapeeth",

  },
  {
      "val": "58",
      "text": "Bhartiya Vidya Bhavans, Sardar Patel College of Engineering, Mumbai",
  },
  {
      "val": "59",
      "text": "Bhilai Institute of Technology, Durg",
  },
  {
      "val": "60",
      "text": "Bhilai Institute of Technology, Raipur",
  },
  {
      "val": "62",
      "text": "Bidhan Chandra Krishi Viswa Vidyalaya, Nadia",
  },
  {
      "val": "63",
      "text": "Bipin Tripathi Kumaon Institute of Technology, Dwarahat",
  },
  {
      "val": "64",
      "text": "Birbhum Institute of Engineering Technology, Birbhum",

  },
  {
      "val": "53",
      "text": "Birla Institute of Technology and Science, Pilani",
      "isTop": "topinst"

  },
  {
      "val": "65",
      "text": "Birla Institute of Technology, Mesra",
      "isTop": "topinst"
  },
  {
      "val": "66",
      "text": "Birla Institute of Technology, Patna",
  },
  {
      "val": "67",
      "text": "BIT Sindri, Dhanbad",
  },
  {
      "val": "68",
      "text": "BITS Pilani- Hyderabad Campus, Hyderabad",
  },
  {
      "val": "69",
      "text": "BITS Pilani, Goa Campus",
  },
  {
      "val": "70",
      "text": "BMS College of Engineering, Bangalore",
  },
  {
      "val": "71",
      "text": "BMS Institute of Technology, Bangalore",
  },
  {
      "val": "72",
      "text": "BNM Institute of Technology, Bangalore",
  },
  {
      "val": "102",
      "text": "BS Abdur Rahman University, Chennai",
  },
  {
      "val": "73",
      "text": "Bundelkhand Institute of Engineering and Technology, Jhansi",
  },
  {
      "val": "74",
      "text": "BV Bhoomaraddi College of Engineering and Technology, Hubli",
  },
  {
      "val": "75",
      "text": "BVRIT Padmasri Dr BV Raju Institute of Technology, Hyderabad",
  },
  {
      "val": "76",
      "text": "CBS Group of Instiutions, Jhajjar",
  },
  {
      "val": "77",
      "text": "Central Institute of Plastic Engineering Technology, Lucknow",
  },
  {
      "val": "78",
      "text": "Central Institute of Plastics Engineering and Technology, Chennai",
  },
  {
      "val": "79",
      "text": "Centurion University, Paralakhemundi",
  },
  {
      "val": "80",
      "text": "Chaitanya Bharathi Institute of Technology, Hyderabad",
  },
  {
      "val": "81",
      "text": "Chaitanya Engineering College, Vishakhapatnam",
  },
  {
      "val": "82",
      "text": "Chandigarh College of Engineering and Technology, Chandigarh",
  },
  {
      "val": "83",
      "text": "Charotar University of Science and Technology, Petlad",
  },
  {
      "val": "84",
      "text": "Chaudhary Charan Singh Haryana Agricultural University, Hisar",
  },
  {
      "val": "85",
      "text": "Chitkara University, Patiala",
  },
  {
      "val": "86",
      "text": "Christ University, Bangalore",
  },
  {
      "val": "87",
      "text": "CMR Engineering College, Hyderabad",
  },
  {
      "val": "88",
      "text": "CMR Institute of Technology, Bangalore",
  },
  {
      "val": "90",
      "text": "CMR Institute of Technology, Hyderabad",
  },
  {
      "val": "91",
      "text": "CMR Technical Campus, Hyderabad",
  },
  {
      "val": "92",
      "text": "Coimbatore Institute of Technology, Coimbatore",
  },
  {
      "val": "93",
      "text": "College of Dairy Science and Technology, Mannuthi, Thrissur",
  },
  {
      "val": "101",
      "text": "College of Engineering Adoor",
  },
  {
      "val": "104",
      "text": "College of Engineering and Management, Kolaghat",
  },
  {
      "val": "105",
      "text": "College of Engineering and Technology ,Bhubaneswar",
  },
  {
      "val": "107",
      "text": "College of Engineering Roorkee, Roorkee",
  },
  {
      "val": "108",
      "text": "College of Engineering Studies, University of Petroleum and Energy Studies, Dehradun",
  },
  {
      "val": "109",
      "text": "College of Engineering, Chengannur",

  },
  {
      "val": "113",
      "text": "College of Engineering, Pune",
      "isTop": "topinst"
  },
  {
      "val": "119",
      "text": "College of Engineering, Trivandrum",

  },
  {
      "val": "121",
      "text": "College of Technology and Engineering, Maharana Pratap University of Agriculture and Technology, Udaipur",
      "isTop": "topinst"
  },
  {
      "val": "127",
      "text": "College of Technology, GB Pant University of Agriculture and Technology, Pantnagar",
  },
  {
      "val": "132",
      "text": "CV Raman College of Engineering, Bhubaneswar",
  },
  {
      "val": "138",
      "text": "CVR College of Engineering, Hyderabad",
  },
  {
      "val": "139",
      "text": "DAV Institute of Engineering and Technology, Jalandhar",
  },
  {
      "val": "140",
      "text": "Dayalbagh Educational Institute, Agra",
  },
  {
      "val": "141",
      "text": "Dayanand Sagar College of Engineering, Bangalore",
  },
  {
      "val": "142",
      "text": "Deenbandhu Chhotu Ram University of Science and Technology, Murthal",

  },
  {
      "val": "110",
      "text": "Delhi Technological University, Delhi",
      "isTop": "topinst"
  },
  {
      "val": "147",
      "text": "Dharmsinh Desai University, Nadiad",
  },
  {
      "val": "111",
      "text": "Dhirubhai Ambani Institute of Information and Communication Technology, Gandhinagar",
  },
  {
      "val": "149",
      "text": "DIT University, Dehradun",
  },
  {
      "val": "155",
      "text": "Don Bosco Institute of Technology, Mumbai",

  },
  {
      "val": "156",
      "text": "Dr B R Ambedkar National Institute of Technology, Jalandhar (NITJ)",
      "isTop": "topinst"
  },
  {
      "val": "157",
      "text": "Dr S and SS Ghandhy College of Engineering and Technology, Surat",
  },
  {
      "val": "158",
      "text": "Dr. Ambedkar Institute of Technology for Handicapped, Kanpur  ",
  },
  {
      "val": "159",
      "text": "Dr. Ambedkar Institute of Technology, Bangalore",
  },
  {
      "val": "160",
      "text": "Dr. Babasaheb Ambedkar Technological University, Lonere",
  },
  {
      "val": "161",
      "text": "Dr. Bhimrao Ambedkar Engineering College of Information Technology, Banda",
  },
  {
      "val": "162",
      "text": "Dr. Bhimrao Ambedkar Engineering College of Information Technology, Bijnor",
  },
  {
      "val": "163",
      "text": "Dr. Mahalingam College of Engineering and Technology, Pollachi",
  },
  {
      "val": "164",
      "text": "Dr. Sivanthi Aditanar College of Engineering, Thoothukudi",
  },
  {
      "val": "165",
      "text": "Dronacharya College of Engineering, Gurgaon",
  },
  {
      "val": "166",
      "text": "Easwari Engineering College, Chennai",
  },
  {
      "val": "167",
      "text": "Faculty of Engineering and Technology, Manav Rachna International University, Faridabad",
  },
  {
      "val": "168",
      "text": "Feroze Gandhi Institute of Engineering and Technology, Raibareli",
  },
  {
      "val": "169",
      "text": "Fr. C Rodrigues Institute of Technology, Navi Mumbai",
  },
  {
      "val": "170",
      "text": "Fr. Conceicao Rodrigues College of Engineering, Mumbai",
  },
  {
      "val": "171",
      "text": "G Narayanamma Institute of Technology and Science (For Women), Hyderabad",
  },
  {
      "val": "172",
      "text": "G Pulla Reddy Engineering College, Kurnool",
  },
  {
      "val": "173",
      "text": "Galgotias College of Engineering and Technology, Greater Noida",
  },
  {
      "val": "174",
      "text": "Galgotias University, Greater Noida",
  },
  {
      "val": "175",
      "text": "Gandhi Institute of Engineering and Technology, Gunupur",
  },
  {
      "val": "176",
      "text": "Gayatri Vidya Parishad College of Engineering, Vishakhapatnam",
  },
  {
      "val": "177",
      "text": "GH Patel College of Engineering and Technology, Anand",
  },
  {
      "val": "178",
      "text": "GH Raisoni College of Engineering, Nagpur",
  },
  {
      "val": "179",
      "text": "Giani Zail Singh Punjab Technical University Campus, Bathinda",
  },
  {
      "val": "180",
      "text": "GLA University, Mathura",
  },
  {
      "val": "181",
      "text": "GMR Institute of Technology, Rajam",
  },
  {
      "val": "182",
      "text": "Gokaraju Rangaraju Institute of Engineering and Technology, Hyderabad",
  },
  {
      "val": "183",
      "text": "Government College of Engineering and Ceramic Technology, Kolkata",
  },
  {
      "val": "184",
      "text": "Government College of Engineering and Leather Technology,Kolkata",
  },
  {
      "val": "185",
      "text": "Government College of Engineering and Technology, Bikaner",
  },
  {
      "val": "186",
      "text": "Government College of Engineering and Technology, Jammu",
  },
  {
      "val": "187",
      "text": "Government College of Engineering and Textile Technology, Berhampore",
  },
  {
      "val": "188",
      "text": "Government College of Engineering, Aurangabad",
  },
  {
      "val": "189",
      "text": "Government College of Engineering, Bargur",
  },
  {
      "val": "190",
      "text": "Government College of Engineering, Kalahandi",
  },
  {
      "val": "191",
      "text": "Government College of Engineering, Kannur",
  },
  {
      "val": "192",
      "text": "Government College of Engineering, Karad",
  },
  {
      "val": "193",
      "text": "Government College of Engineering, Salem",
  },
  {
      "val": "194",
      "text": "Government College of Engineering, Tirunelveli",
  },
  {
      "val": "195",
      "text": "Government College of Technology, Coimbatore",
  },
  {
      "val": "196",
      "text": "Government Engineering College, Ajmer",
  },
  {
      "val": "197",
      "text": "Government Engineering College, Barton Hill, Thiruvananthapuram ",
  },
  {
      "val": "198",
      "text": "Government Engineering College, Bastar",
  },
  {
      "val": "199",
      "text": "Government Engineering College, Bhavnagar",
  },
  {
      "val": "200",
      "text": "Government Engineering College, Bikaner",
  },
  {
      "val": "201",
      "text": "Government Engineering College, Bilaspur",
  },
  {
      "val": "202",
      "text": "Government Engineering College, Gandhinagar",
  },
  {
      "val": "203",
      "text": "Government Engineering College, Jhalawar",
  },
  {
      "val": "204",
      "text": "Government Engineering College, Kozhikode",
  },
  {
      "val": "205",
      "text": "Government Engineering College, Modasa",
  },
  {
      "val": "206",
      "text": "Government Engineering College, Patan",
  },
  {
      "val": "207",
      "text": "Government Engineering College, Raipur",
  },
  {
      "val": "208",
      "text": "Government Engineering College, Rajkot",
  },
  {
      "val": "209",
      "text": "Government Engineering College, Sreekrishnapuram",
  },
  {
      "val": "210",
      "text": "Government Engineering College, Surat",
  },
  {
      "val": "211",
      "text": "Government Engineering College, Thrissur",
  },
  {
      "val": "212",
      "text": "Government Engineering College, Wayanad",
  },
  {
      "val": "125",
      "text": "Government Model Engineering College, Thrikkakara",
  },
  {
      "val": "213",
      "text": "Government Sri Krishnarajendra Silver Jubilee Technological Institute, Bangalore",
  },
  {
      "val": "214",
      "text": "Government Women Engineering College, Ajmer",
  },
  {
      "val": "215",
      "text": "Govind Ballabh Pant Engineering College, Pauri-Garhwal",
  },
  {
      "val": "216",
      "text": "Gudlavalleru Engineering College, Gudlavalleru",
  },
  {
      "val": "217",
      "text": "Guru Ghasidas Vishwavidyalaya, Bilaspur",
  },
  {
      "val": "116",
      "text": "Guru Gobind Singh Indraprastha University, Delhi",
  },
  {
      "val": "218",
      "text": "Guru Jambheshwar University of Science and Technology, Hisar",
  },
  {
      "val": "219",
      "text": "Guru Nanak Dev Engineering College, Bidar",
  },
  {
      "val": "220",
      "text": "Guru Nanak Dev Engineering College, Ludhiana",
  },
  {
      "val": "221",
      "text": "Guru Nanak Dev University Regional Campus Jalandhar",
  },
  {
      "val": "222",
      "text": "Guru Nanak Dev University, Amritsar",
  },
  {
      "val": "223",
      "text": "Guru Nanak Institutions Technical Campus, Secunderabad",
  },
  {
      "val": "224",
      "text": "Gurukul Kangri Vishwavidyalaya, Haridwar",
  },
  {
      "val": "225",
      "text": "Haldia Institute of Technology, Haldia",
  },
  {
      "val": "114",
      "text": "Harcourt Butler Technological Institute, Kanpur",
  },
  {
      "val": "226",
      "text": "Heritage Institute of Technology, Kolkata",
  },
  {
      "val": "227",
      "text": "Hindu College of Engineering, Sonipat",
  },
  {
      "val": "228",
      "text": "Hindustan University, Kelambakkam",
  },
  {
      "val": "229",
      "text": "Hindusthan College of Engineering and Technology, Coimbatore",
  },
  {
      "val": "32",
      "text": "ICFAI Foundation for Higher Education, Hyderabad",
  },
  {
      "val": "230",
      "text": "Indian Institute of Carpet Technology, Bhadohi",

  },
  {
      "val": "231",
      "text": "Indian Institute of Engineering Science and Technology, Shibpur",
      "isTop": "topinst"

  },
  {
      "val": "117",
      "text": "Indian Institute of Information Technology, Allahabad",
      "isTop": "topinst"

  },
  {
      "val": "232",
      "text": "Indian Institute of Information Technology, Design and Manufacturing, Jabalpur",
      "isTop": "topinst"
  },
  {
      "val": "233",
      "text": "Indian Institute of Information Technology, Design and Manufacturing, Kancheepuram",
  },
  {
      "val": "234",
      "text": "Indian Institute of Science Education and Research, Bhopal",

  },
  {
      "val": "235",
      "text": "Indian Institute of Science Education and Research, Kolkata",
      "isTop": "topinst"

  },
  {
      "val": "236",
      "text": "Indian Institute of Science Education and Research, Mohali",
      "isTop": "topinst"
  },
  {
      "val": "237",
      "text": "Indian Institute of Science Education and Research, Pune",
  },
  {
      "val": "238",
      "text": "Indian Institute of Science Education and Research, Thiruvananthapuram",
  },
  {
      "val": "239",
      "text": "Indian Institute of Space Science and Technology, Thiruvananthapuram",

  },
  {
      "val": "89",
      "text": "Indian Institute of Technology, Banaras Hindu University, Varanasi (IITBHU)",
      "isTop": "topinst"

  },
  {
      "val": "48",
      "text": "Indian Institute of Technology, Bhubaneswar (IITBBS)",
      "isTop": "topinst"

  },
  {
      "val": "9",
      "text": "Indian Institute of Technology, Bombay (IITB)",
      "isTop": "topinst"

  },
  {
      "val": "8",
      "text": "Indian Institute of Technology, Delhi (IITD)",
      "isTop": "topinst"

  },
  {
      "val": "94",
      "text": "Indian Institute of Technology, Gandhinagar (IITGN)",
      "isTop": "topinst"

  },
  {
      "val": "54",
      "text": "Indian Institute of Technology, Guwahati (IITG)",
      "isTop": "topinst"

  },
  {
      "val": "95",
      "text": "Indian Institute of Technology, Hyderabad (IITH)",
      "isTop": "topinst"

  },
  {
      "val": "96",
      "text": "Indian Institute of Technology, Indore (IITI)",
      "isTop": "topinst"

  },
  {
      "val": "97",
      "text": "Indian Institute of Technology, Jodhpur (IITJ)",
      "isTop": "topinst"

  },
  {
      "val": "12",
      "text": "Indian Institute of Technology, Kanpur (IITK)",
      "isTop": "topinst"

  },
  {
      "val": "13",
      "text": "Indian Institute of Technology, Kharagpur (IITKGP)",
      "isTop": "topinst"

  },
  {
      "val": "10",
      "text": "Indian Institute of Technology, Madras (IITM)",
      "isTop": "topinst"

  },
  {
      "val": "98",
      "text": "Indian Institute of Technology, Mandi (IITMANDI)",
      "isTop": "topinst"

  },
  {
      "val": "99",
      "text": "Indian Institute of Technology, Patna (IITP)",
      "isTop": "topinst"

  },
  {
      "val": "61",
      "text": "Indian Institute of Technology, Roorkee (IITR)",
      "isTop": "topinst"

  },
  {
      "val": "100",
      "text": "Indian Institute of Technology, Ropar (IITRPR)",
      "isTop": "topinst"

  },
  {
      "val": "118",
      "text": "Indian School of Mines, Dhanbad",
      "isTop": "topinst"
  },
  {
      "val": "240",
      "text": "Indira Gandhi Institute of Technology, Delhi",
  },
  {
      "val": "241",
      "text": "Indira Gandhi Institute of Technology, Sarang",
  },
  {
      "val": "242",
      "text": "Indraprastha Institute of Information Technology, Delhi",
  },
  {
      "val": "243",
      "text": "Institute of Chemical Technology, Mumbai",
  },
  {
      "val": "244",
      "text": "Institute of Engineering and Management, Kolkata",
  },
  {
      "val": "245",
      "text": "Institute of Engineering and Rural Technology, Allahabad",
  },
  {
      "val": "246",
      "text": "Institute of Engineering and Science, IPS Academy, Indore",
  },
  {
      "val": "247",
      "text": "Institute of Engineering and Technology, Alwar",
  },
  {
      "val": "248",
      "text": "Institute of Engineering and Technology, Indore",
  },
  {
      "val": "249",
      "text": "Institute of Engineering and Technology, Lucknow",
  },
  {
      "val": "250",
      "text": "Institute of Information and Communication Technology, Ahmedabad",
  },
  {
      "val": "251",
      "text": "Institute of Infrastructure, Technology, Research and Management, Ahmedabad",
  },
  {
      "val": "252",
      "text": "Institute of Road and Transport Technology, Erode",
  },
  {
      "val": "253",
      "text": "Institute of Science and Technology, Jawaharlal Nehru Technological University, Hyderabad",
  },
  {
      "val": "254",
      "text": "Integral University, Lucknow",
  },
  {
      "val": "255",
      "text": "International Institute of Information Technology, Bangalore",
  },
  {
      "val": "256",
      "text": "International Institute of Information Technology, Bhubaneswar",

  },
  {
      "val": "120",
      "text": "International Institute of Information Technology, Hyderabad",
      "isTop": "topinst"
  },
  {
      "val": "257",
      "text": "International Institute of Information Technology, Pune",
  },
  {
      "val": "258",
      "text": "Islamic University of Science and Technology, Pulwama",
  },
  {
      "val": "259",
      "text": "ITM University, Gwalior",
  },
  {
      "val": "260",
      "text": "Jabalpur Engineering College, Jabalpur",

  },
  {
      "val": "261",
      "text": "Jadavpur University, Kolkata",
      "isTop": "topinst"
  },
  {
      "val": "262",
      "text": "Jaipur Engineering College and Research Centre, Jaipur",
  },
  {
      "val": "263",
      "text": "Jaipur National University, Jaipur",
  },
  {
      "val": "264",
      "text": "Jalpaiguri Government Engineering College, Jalpaiguri",
  },
  {
      "val": "265",
      "text": "Jamia Millia Islamia, New Delhi",
  },
  {
      "val": "266",
      "text": "Jawaharlal Nehru Technological University College of Engineering, Kakinada",
  },
  {
      "val": "267",
      "text": "Jawaharlal Nehru Technological University, Kakinada",
  },
  {
      "val": "268",
      "text": "Jaypee Institute of Information Technology, Noida",

  },
  {
      "val": "269",
      "text": "Jaypee University of Information Technology, Solan",
      "isTop": "topinst"

  },
  {
      "val": "270",
      "text": "Jiwaji University, Gwalior",
      "isTop": "topinst"

  },
  {
      "val": "271",
      "text": "JNTU College of Engineering, Hyderabad",
      "isTop": "topinst"
  },
  {
      "val": "272",
      "text": "JNTU, University College of Engineering, Vizianagaram ",
  },
  {
      "val": "273",
      "text": "JNTUH College of Engineering, Karimnagar",
  },
  {
      "val": "274",
      "text": "Jodhpur National University, Jodhpur",
  },
  {
      "val": "275",
      "text": "Joginpally B R Engineering College, Moinabad",
  },
  {
      "val": "276",
      "text": "JSS Academy of Technical Education, Bangalore",
  },
  {
      "val": "277",
      "text": "JSS Academy of Technical Education, Noida",
  },
  {
      "val": "278",
      "text": "Kakatiya Institute of Technology and Science, Warangal",
  },
  {
      "val": "279",
      "text": "Kalinga Institute of Industrial Technology, Bhubaneswar",
  },
  {
      "val": "280",
      "text": "Kamla Nehru Institute of Technology, Sultanpur",
  },
  {
      "val": "281",
      "text": "Karunya University, Coimbatore",
  },
  {
      "val": "282",
      "text": "Kasegaon Education Society’s Rajarambapu Institute of Technology, Sangli",
  },
  {
      "val": "283",
      "text": "KJ Somaiya College of Engineering, Mumbai",
  },
  {
      "val": "284",
      "text": "KJ Somaiya College of Engineering, Mumbai",
  },
  {
      "val": "285",
      "text": "KLS Gogte Institute of Technology, Belgaum",
  },
  {
      "val": "286",
      "text": "Kongu Engineering College, Erode",
  },
  {
      "val": "287",
      "text": "Krishna Institute of Engineering and Technology, Ghaziabad",
  },
  {
      "val": "288",
      "text": "Kumaraguru College of Technology, Coimbatore",
  },
  {
      "val": "289",
      "text": "Lakshmi Narain College of Technology, Bhopal",
  },
  {
      "val": "290",
      "text": "LBS College of Engineering, Kasargod",
  },
  {
      "val": "291",
      "text": "LBS Institute of Technology for Women, Thiruvananthapuram",
  },
  {
      "val": "292",
      "text": "LD College of Engineering, Ahmedabad",
  },
  {
      "val": "293",
      "text": "Lovely Professional University, Jalandhar",
  },
  {
      "val": "294",
      "text": "Lukhdhirji Engineering College, Morbi",
  },
  {
      "val": "295",
      "text": "M Kumarasamy College of Engineering, Karur",
  },
  {
      "val": "296",
      "text": "Madan Mohan Malaviya University of Technology. Gorakhpur",
  },
  {
      "val": "297",
      "text": "Madanpalle Institute of Technology and Science, Madanapalle",
  },
  {
      "val": "298",
      "text": "Madhav Institute of Technology and Science, Gwalior",
  },
  {
      "val": "299",
      "text": "Madras Institute of Technology, Chennai",
  },
  {
      "val": "300",
      "text": "Maharaj Vijayaram Gajapathi Raj College of Engineering, Vizianagaram",
  },
  {
      "val": "301",
      "text": "Maharaja Agrasen Institute of Technology, Delhi",
  },
  {
      "val": "302",
      "text": "Maharaja Sayajirao University of Baroda, Vadodara",
  },
  {
      "val": "303",
      "text": "Maharashtra Institute of Technology, Pune",
  },
  {
      "val": "304",
      "text": "Maharishi Markandeshwar University, Ambala ",
  },
  {
      "val": "305",
      "text": "Mahatma Gandhi Institute of Technology, Hyderabad",
  },
  {
      "val": "306",
      "text": "Mahatma Jyotiba Phule Rohilkhand University, Bareilly",

  },
  {
      "val": "112",
      "text": "Malaviya National Institute of Technology, Jaipur (MNIT)",
      "isTop": "topinst"
  },
  {
      "val": "307",
      "text": "Malla Reddy College of Engineering and Technology, Hyderabad",
  },
  {
      "val": "308",
      "text": "Malla Reddy Engineering College, Hyderabad",
  },
  {
      "val": "309",
      "text": "Malnad College of Engineering, Hassan",
  },
  {
      "val": "310",
      "text": "Manav Rachna College of Engineering, Faridabad",

  },
  {
      "val": "122",
      "text": "Manipal Institute of Technology, Manipal",
      "isTop": "topinst"
  },
  {
      "val": "311",
      "text": "Manyawar Kansi Ram Engineering College of Information Technology, Ambedkar Nagar",
  },
  {
      "val": "312",
      "text": "Manyawar Kansi Ram Engineering College of Information Technology, Azamgarh",
  },
  {
      "val": "313",
      "text": "Mar Athanasius College of Engineering, Kothamangalam",
  },
  {
      "val": "314",
      "text": "Maturi Venkata Subba Rao Engineering College, Hyderabad",

  },
  {
      "val": "315",
      "text": "Maulana Azad National Institute of Technology, Bhopal (MANIT)",
      "isTop": "topinst"
  },
  {
      "val": "316",
      "text": "MBM Engineering College, Jodhpur",
  },
  {
      "val": "317",
      "text": "MCT’s Rajiv Gandhi Institute of Technology, Mumbai",
  },
  {
      "val": "318",
      "text": "Medi-Caps Institute of Science and Technology, Indore",
  },
  {
      "val": "319",
      "text": "Medi-Caps Institute of Technology and Management, Indore",
  },
  {
      "val": "320",
      "text": "Meenakshi Sundararajan Engineering College, Chennai",
  },
  {
      "val": "124",
      "text": "Mepco Schlenk Engineering College, Sivakasi",
  },
  {
      "val": "321",
      "text": "MES College of Engineering, Malappuram",
  },
  {
      "val": "322",
      "text": "Mizoram University, Aizawl",
  },
  {
      "val": "323",
      "text": "MLV Government Textile and Engineering College, Bhilwara",
  },
  {
      "val": "324",
      "text": "Mody University of Science and Technology, Sikar",

  },
  {
      "val": "126",
      "text": "Motilal Nehru National Institute of Technology, Allahabad (MNNIT)",
      "isTop": "topinst"
  },
  {
      "val": "325",
      "text": "MS Engineering College, Bangalore",
  },
  {
      "val": "123",
      "text": "MS Ramaiah Institute of Technology, Bangalore",
  },
  {
      "val": "326",
      "text": "Mukesh Patel School of Technology Management and Engineering, Mumbai",
  },
  {
      "val": "327",
      "text": "Muzaffarpur Institute of Technology, Muzaffarpur",
  },
  {
      "val": "328",
      "text": "MVJ College of Engineering, Bangalore",
  },
  {
      "val": "329",
      "text": "Narasaraopeta Engineering College, Narasaraopet",
  },
  {
      "val": "330",
      "text": "National Dairy Research Institute, Karnal",
  },
  {
      "val": "331",
      "text": "National Institute of Foundry and Forge Technology, Ranchi",
  },
  {
      "val": "332",
      "text": "National Institute of Science Education and Research, Bhubaneswar",

  },
  {
      "val": "333",
      "text": "National Institute of Technology, Agartala (NITA)",
      "isTop": "topinst"

  },
  {
      "val": "129",
      "text": "National Institute of Technology, Calicut (NITC)",
      "isTop": "topinst"
  },
  {
      "val": "334",
      "text": "National Institute of Technology, Delhi (NITDELHI)",

  },
  {
      "val": "130",
      "text": "National Institute of Technology, Durgapur (NITDGP)",
      "isTop": "topinst"
  },
  {
      "val": "335",
      "text": "National Institute of Technology, Goa (NITGOA)",

  },
  {
      "val": "131",
      "text": "National Institute of Technology, Hamirpur (NITH)",
      "isTop": "topinst"

  },
  {
      "val": "336",
      "text": "National Institute of Technology, Jamshedpur (NITJSR)",
      "isTop": "topinst"

  },
  {
      "val": "337",
      "text": "National Institute of Technology, Kurukshetra (NITKKR)",
      "isTop": "topinst"
  },
  {
      "val": "338",
      "text": "National Institute of Technology, Mizoram (NITMZ)",
  },
  {
      "val": "339",
      "text": "National Institute of Technology, Nagaland (NITNAGALAND)",
  },
  {
      "val": "340",
      "text": "National Institute of Technology, Patna (NITP)",
  },
  {
      "val": "341",
      "text": "National Institute of Technology, Puducherry (NITPY)",

  },
  {
      "val": "342",
      "text": "National Institute of Technology, Raipur (NITRR)",
      "isTop": "topinst"

  },
  {
      "val": "133",
      "text": "National Institute of Technology, Rourkela (NITRKL)",
      "isTop": "topinst"
  },
  {
      "val": "343",
      "text": "National Institute of Technology, Sikkim (NITSIKKIM)",

  },
  {
      "val": "134",
      "text": "National Institute of Technology, Silchar (NITS)",
      "isTop": "topinst"
  },
  {
      "val": "128",
      "text": "National Institute of Technology, Srinagar (NITSRI)",

  },
  {
      "val": "344",
      "text": "National Institute of Technology, Surathkal (NITK)",
      "isTop": "topinst"

  },
  {
      "val": "135",
      "text": "National Institute of Technology, Tiruchirappalli (NITT)",
      "isTop": "topinst"
  },
  {
      "val": "345",
      "text": "National Institute of Technology, Uttarakhand (NITUK)",

  },
  {
      "val": "136",
      "text": "National Institute of Technology, Warangal (NITW)",
      "isTop": "topinst"
  },
  {
      "val": "346",
      "text": "National Power Training Institute, Durgapur",
  },
  {
      "val": "347",
      "text": "National Power Training Institute, Faridabad",
  },
  {
      "val": "348",
      "text": "NC College of Engineering, Israna",

  },
  {
      "val": "137",
      "text": "Netaji Subhas Institute of Technology, Delhi",
      "isTop": "topinst"
  },
  {
      "val": "349",
      "text": "Netaji Subhash Engineering College, Garia",
  },
  {
      "val": "350",
      "text": "New Horizon College of Engineering, Bangalore",
  },
  {
      "val": "351",
      "text": "NIIT University, Neemrana",
  },
  {
      "val": "352",
      "text": "Nirma University, Ahmedabad",
  },
  {
      "val": "353",
      "text": "Nitte Meenakshi Institute of Technology, Bangalore",
  },
  {
      "val": "354",
      "text": "Nizam Institute of Engineering and Technology, Hyderabad",
  },
  {
      "val": "355",
      "text": "NMAM Institute of Technology, Karkala Taluk",
  },
  {
      "val": "356",
      "text": "North Eastern Regional Institute of Science and Technology, Nirjuli",
  },
  {
      "val": "357",
      "text": "NSS College of Engineering, Palakkad",
  },
  {
      "val": "358",
      "text": "Orissa School of Mining Engineering, Keonjhar",
  },
  {
      "val": "359",
      "text": "PA College of Engineering, Mangalore",
  },
  {
      "val": "360",
      "text": "Pandit Deendayal Petroleum University- School of Technology, Gandhinagar",
  },
  {
      "val": "361",
      "text": "Panimalar Engineering College, Chennai",
  },
  {
      "val": "362",
      "text": "Panipat Institute of Engineering and Technology, Panipat",

  },
  {
      "val": "363",
      "text": "Panjab University, Chandigarh",
      "isTop": "topinst"
  },
  {
      "val": "364",
      "text": "Panjab University, SSG Regional Centre, Hoshiarpur",
  },
  {
      "val": "365",
      "text": "Parala Maharaja Engineering College, Berhampur",
  },
  {
      "val": "366",
      "text": "Parvatha Reddy Babul Reddy Visvodaya Institute of Technology and Science, Nellore",
  },
  {
      "val": "367",
      "text": "PES College of Engineering, Mandya",
  },
  {
      "val": "368",
      "text": "PES Institute of Technology, Bangalore South Campus, Bangalore",

  },
  {
      "val": "369",
      "text": "Pondicherry Engineering College, Puducherry",
      "isTop": "topinst"
  },
  {
      "val": "370",
      "text": "Poojya Doddappa Appa College, Gulbarga",
  },
  {
      "val": "371",
      "text": "Poornima College of Engineering, Jaipur",
  },
  {
      "val": "372",
      "text": "Pragati Engineering College, Kakinada",
  },
  {
      "val": "373",
      "text": "PSG College of Technology, Coimbatore",
  },
  {
      "val": "374",
      "text": "Punjab Agricultural University, Ludhiana",
  },
  {
      "val": "375",
      "text": "Punjab Engineering College University of Technology, Chandigarh",
  },
  {
      "val": "376",
      "text": "QIS College of Engineering and Technology, Ongole",
  },
  {
      "val": "377",
      "text": "Quantum School of Technology, Roorkee",
  },
  {
      "val": "143",
      "text": "Rajagiri School of Engineering and Technology, Ernakulam",
  },
  {
      "val": "378",
      "text": "Rajasthan Technical University, Kota",
  },
  {
      "val": "379",
      "text": "Rajeev Gandhi Memorial College of Engineering and Technology, Kurnool",
  },
  {
      "val": "380",
      "text": "Rajiv Gandhi Institute of Technology, Kottayam",
  },
  {
      "val": "381",
      "text": "Rajiv Gandhi Proudyogiki Vishwavidyalaya, Bhopal",
  },
  {
      "val": "382",
      "text": "Rayat Bahra Faculty of Engineering and Technology, Patiala Campus, Patiala",
  },
  {
      "val": "383",
      "text": "RCC Institute of Information Technology, Beliaghata",
  },
  {
      "val": "384",
      "text": "Reva Institute of Technology and Management, Bangalore",
  },
  {
      "val": "385",
      "text": "Rewa Engineering College, Rewa",
  },
  {
      "val": "386",
      "text": "RMK Engineering College, Thiruvallur",
  },
  {
      "val": "387",
      "text": "RNS Institute of Technology, Bangalore",
  },
  {
      "val": "388",
      "text": "RTE Sociey",

  },
  {
      "val": "389",
      "text": "Rungta College of Engineering and Technology, Bhilai",
  },
  {
      "val": "390",
      "text": "Rustamji Institute of Technology, Gwalior",
  },
  {
      "val": "391",
      "text": "RV College of Engineering, Bangalore",
  },
  {
      "val": "392",
      "text": "Sagi Ramakrishnam Raju Engineering College, Bhimavaram",
  },
  {
      "val": "393",
      "text": "Sam Higginbottom Institute of Agriculture, Technology and Science, Allahabad",
  },
  {
      "val": "394",
      "text": "Samrat Ashok Technological Institute, Vidisha",
  },
  {
      "val": "395",
      "text": "Sant Longowal Institute of Engineering and Technology, Longowal",

  },
  {
      "val": "144",
      "text": "Sardar Vallabhbhai National Institute of Technology, Surat (SVNIT)",
      "isTop": "topinst"

  },
  {
      "val": "396",
      "text": "SASTRA University, Thanjavur",
      "isTop": "topinst"
  },
  {
      "val": "397",
      "text": "Sathyabama University, Chennai",
  },
  {
      "val": "398",
      "text": "Satyam Institute of Engineering and Technology, Amritsar",
  },
  {
      "val": "399",
      "text": "Saveetha Engineering College, Chennai",
  },
  {
      "val": "400",
      "text": "School of Engineering and Technology, Jain University, Bangalore",
  },
  {
      "val": "401",
      "text": "School of Engineering, Cochin University of Science and Technology, Ernakulam",
  },
  {
      "val": "402",
      "text": "SCMS School of Engineering and Technology, Ernakulum",
  },
  {
      "val": "403",
      "text": "SDM College of Engineering and Technology, Dharwad",
  },
  {
      "val": "404",
      "text": "Seth Jai Parkash Mukand Lal Institute of Engineering and Technology, Yamunanagar",
  },
  {
      "val": "405",
      "text": "Shaheed Bhagat Singh State Technical Campus, Firozpur",
  },
  {
      "val": "406",
      "text": "Shantilal Shah Engineering College, Bhavnagar",
  },
  {
      "val": "407",
      "text": "Sharda University, Greater Noida",
  },
  {
      "val": "408",
      "text": "Shiv Nadar University, Dadri",
  },
  {
      "val": "409",
      "text": "Shivaji University, Kolhapur",
  },
  {
      "val": "410",
      "text": "Shobhit Institute of Engineering and  Technology, Meerut",
  },
  {
      "val": "411",
      "text": "Shri GS Institute of Technology and Science, Indore",
  },
  {
      "val": "412",
      "text": "Shri Guru Gobind Singhji Institute of Engineering and Technology, Vishnupuri",
  },
  {
      "val": "145",
      "text": "Shri Mata Vaishno Devi University, Katra",
  },
  {
      "val": "413",
      "text": "Shri Ram Murti Smarak College of Engineering and Technology, Bareilly",
  },
  {
      "val": "414",
      "text": "Shri Sant Gajanan Maharaj College of Engineering, Shegaon",
  },
  {
      "val": "415",
      "text": "Shri Shankaracharya Engineering College, Bhilai",
  },
  {
      "val": "416",
      "text": "Shri Vaishnav Institute of Technology and Science, Indore",
  },
  {
      "val": "417",
      "text": "Siddaganga Institute of Technology, Tumkur",
  },
  {
      "val": "418",
      "text": "Siksha O' Anusandhan University, Bhubaneshwar",
  },
  {
      "val": "419",
      "text": "Silicon Institute of Technology, Bhubaneswar",
  },
  {
      "val": "420",
      "text": "Sinhgad College of Engineering, Pune",
  },
  {
      "val": "146",
      "text": "Sir M Visvesvaraya Institute of Technology, Bangalore",
  },
  {
      "val": "421",
      "text": "SJB Institute of Technology, Bangalore",
  },
  {
      "val": "422",
      "text": "Sona College of Technology, Salem",
  },
  {
      "val": "423",
      "text": "Sree Chitra Thirunal College of Engineering, Thiruvananthapuram ",
  },
  {
      "val": "424",
      "text": "Sree Vidyanikethan Engineering College, Tirupati",
  },
  {
      "val": "425",
      "text": "Sreenidhi Institute of Science and Technology, Ghatkesar",
  },
  {
      "val": "426",
      "text": "Sri Aditya Engineering College, Surampalem",
  },
  {
      "val": "427",
      "text": "Sri Jayachamarajendra College of Engineering, Mysore",
  },
  {
      "val": "428",
      "text": "Sri Krishna College of Engineering and Technology, Coimbatore",
  },
  {
      "val": "429",
      "text": "Sri Manakula Vinayagar Engineering College, Puducherry",
  },
  {
      "val": "430",
      "text": "Sri Ramakrishna Engineering College, Coimbatore",
  },
  {
      "val": "431",
      "text": "Sri Sai Ram Engineering College, Chennai",
  },
  {
      "val": "432",
      "text": "Sri Siddhartha Institute of Technology, Tumkur",
  },
  {
      "val": "433",
      "text": "Sri Venkateswara College of Engineering, Sriperumbudur",
  },
  {
      "val": "434",
      "text": "Sri Venkateswara University, Tirupati",
  },
  {
      "val": "435",
      "text": "Sri Vishnu Engineering College for Women, Bhimavaram",
  },
  {
      "val": "148",
      "text": "SRM University, Chennai",
  },
  {
      "val": "436",
      "text": "St. Ann",

  },
  {
      "val": "437",
      "text": "Swami Keshvanand Institute of Technology, Management and Gramothan, Jaipur",
  },
  {
      "val": "438",
      "text": "Symbiosis International University, Pune",
  },
  {
      "val": "439",
      "text": "Techno India University, Kolkata",
  },
  {
      "val": "440",
      "text": "Tezpur University, Tezpur",

  },
  {
      "val": "150",
      "text": "Thapar University, Patiala",
      "isTop": "topinst"
  },
  {
      "val": "441",
      "text": "The LNM Institute of Information Technology, Jaipur",
  },
  {
      "val": "442",
      "text": "The National Institute of Engineering, Mysore",
  },
  {
      "val": "443",
      "text": "The Oxford College of Engineering, Bangalore",
  },
  {
      "val": "444",
      "text": "The Technological Institute of Textile and Sciences, Bhiwani",

  },
  {
      "val": "445",
      "text": "Thiagarajar College of Engineering, Madurai",
      "isTop": "topinst"
  },
  {
      "val": "446",
      "text": "TKM College of Engineering, Kollam",
  },
  {
      "val": "447",
      "text": "Tripura Institute of Technology, Agartala",
  },
  {
      "val": "448",
      "text": "Tula’s Institute, The Engineering and Management College, Dehradun",
  },
  {
      "val": "449",
      "text": "UBDT College of Engineering, Davangere",
  },
  {
      "val": "450",
      "text": "UIET, Chhatrapati Sahuji Maharaj University, Kanpur",
  },
  {
      "val": "451",
      "text": "Ujjain Engineering College, Ujjain",
  },
  {
      "val": "106",
      "text": "University College of Engineering, Osmania University, Hyderabad",
  },
  {
      "val": "452",
      "text": "University College of Engineering, Punjabi University, Patiala",
  },
  {
      "val": "453",
      "text": "University College of Technology, Osmania University, Hyderabad",
  },
  {
      "val": "454",
      "text": "University Institute of Chemical Engineering and Technology, Chandigarh",
  },
  {
      "val": "455",
      "text": "University Institute of Engineering and Technology, Chandigarh",

  },
  {
      "val": "456",
      "text": "University Institute of Engineering and Technology, Kurukshetra University, Kurukshetra",
      "isTop": "topinst"
  },
  {
      "val": "457",
      "text": "University Institute of Engineering and Technology, Maharshi Dayanand University, Rohtak",
  },
  {
      "val": "458",
      "text": "University Institute of Information Technology, Shimla",
  },
  {
      "val": "459",
      "text": "University Institute of Technology, Burdwan",
  },
  {
      "val": "460",
      "text": "University of Kalyani, Kalyani",
  },
  {
      "val": "461",
      "text": "University Visvesvaraya College of Engineering, Bangalore",
  },
  {
      "val": "462",
      "text": "UP Textile Technology Institute, Kanpur",
  },
  {
      "val": "463",
      "text": "Uttar Banga Krishi Vishwavidyalaya, Pundibari",
  },
  {
      "val": "464",
      "text": "Uttaranchal Institute of Technology, Dehradun",
  },
  {
      "val": "465",
      "text": "Vaagdevi College of Engineering, Warangal",
  },
  {
      "val": "466",
      "text": "Vaish College of Engineering, Rohtak",
  },
  {
      "val": "467",
      "text": "Vardhaman College of Engineering, Hyderabad",
  },
  {
      "val": "468",
      "text": "Vasavi College of Engineering, Hyderabad",
  },
  {
      "val": "469",
      "text": "Veer Surendra Sai University of Technology, Sambalpur",
  },
  {
      "val": "151",
      "text": "Veermata Jijabai Technological Institute, Mumbai",
  },
  {
      "val": "470",
      "text": "Vel Tech Dr Rangrajan Dr Sakunthala Technical University, Chennai",
  },
  {
      "val": "471",
      "text": "Vel Tech High Tech Dr. Rangarajan Dr. Sakunthala Engineering College, Chennai",
  },
  {
      "val": "472",
      "text": "Velagapudi Ramakrishna Siddhartha Engineering College, Vijaywada",
  },
  {
      "val": "473",
      "text": "Velammal Engineering College, Chennai",
  },
  {
      "val": "474",
      "text": "Vels University, Chennai",
  },
  {
      "val": "475",
      "text": "Vidya Jyothi Institute of Technology, Hyderabad",
  },
  {
      "val": "476",
      "text": "Vidyavardhaka College of Engineering, Mysore",
  },
  {
      "val": "477",
      "text": "Vignan University, Guntur",
  },
  {
      "val": "478",
      "text": "Vishnu Institute of Technology, Bhimavaram",
  },
  {
      "val": "479",
      "text": "Vishwakarma Government Engineering College, Ahmedabad",
  },
  {
      "val": "480",
      "text": "Vishwakarma Institute of Information Technology, Pune",
  },
  {
      "val": "481",
      "text": "Vishwakarma Institute of Technology, Pune",
  },
  {
      "val": "153",
      "text": "Visvesvaraya National Institute of Technology, Nagpur (VNIT)",

  },
  {
      "val": "152",
      "text": "VIT University, Vellore",
      "isTop": "topinst"
  },
  {
      "val": "482",
      "text": "VNR Vignana Jyothi Institute of Engineering and Technology, Hyderabad",
  },
  {
      "val": "483",
      "text": "VSB Engineering College, Karur",
  },
  {
      "val": "115",
      "text": "Walchand College of Engineering, Sangli",
  },
  {
      "val": "154",
      "text": "West Bengal University of Technology, Kolkata",
  },
  {
      "val": "484",
      "text": "Yeshwantrao Chavan College of Engineering, Nagpur",
  },
  {
      "val": "485",
      "text": "YMCA University of Science and Technology, Faridabad",
  },
  {
      "val": "487",
      "text": "National Institute of Technology, Kurukshetra (NIT KKR)",

  },
  {
      "val": "488",
      "text": "Indian Institute of Science (IISc)",
      "isTop": "topinst"

  },
  {
      "val": "489",
      "text": "IIM Sirmaur",
      "isTop": "topinst"
  },
  {
      "val": "490",
      "text": "Indraprastha Institute of Information Technology",

  },
  {
      "val": "491",
      "text": "IIM Amritsar",
      "isTop": "topinst"
  }
]

var instituteTagsDataUpdazz = [
  {
  text: "Aalim Muhammed Salegh College of Engineering, Chennai",
  val: "1"
}, {
  text: "ABES Engineering College, Ghaziabad",
  val: "2"
}, {
  text: "ABV- Indian Institute of Information Technology and Management, Gwalior",
  val: "3"
}, {
  text: "Acharya Institute of Technology, Bangalore",
  val: "4"
}, {
  text: "AD Patel Institute of Technology, Anand",
  val: "5"
}, {
  text: "Adesh Institute of Engineering and Technology, Faridkot",
  val: "6"
}, {
  text: "Adhiparasakthi Engineering College, Kancheepuram",
  val: "7"
}, {
  text: "Indian Institute of Technology, Delhi (IITD)",
  val: "8"
}, {
  text: "Indian Institute of Technology, Bombay (IITB)",
  val: "9"
}, {
  text: "Indian Institute of Technology, Madras (IITM)",
  val: "10"
}, {
  text: "Aditya Engineering College, Surampalem",
  val: "11"
}, {
  text: "Indian Institute of Technology, Kanpur (IITK)",
  val: "12"
}, {
  text: "Indian Institute of Technology, Kharagpur (IITKGP)",
  val: "13"
}, {
  text: "Aditya Institute of Technology and Management, Tekkali",
  val: "14"
}, {
  text: "Ajay Kumar Garg Engineering College, Ghaziabad",
  val: "15"
}, {
  text: "Alagappa Chettiar College of Engineering and Technology, Karaikudi",
  val: "16"
}, {
  text: "Alagappa College of Technology, Chennai",
  val: "17"
}, {
  text: "Aligarh Muslim University, Aligarh",
  val: "18"
}, {
  text: "Alliance College of Engineering and Design, Bangalore",
  val: "19"
}, {
  text: "Ambedkar Institute of Advanced Communication Technologies and Research, Delhi",
  val: "20"
}, {
  text: "Amity School of Engineering and Technology, Delhi",
  val: "21"
}, {
  text: "Amity School of Engineering and Technology, Noida",
  val: "22"
}, {
  text: "Amity University, Noida",
  val: "23"
}, {
  text: "Amrita School of Engineering, Coimbatore",
  val: "24"
}, {
  text: "Anand Institute of Higher Technology, Chennai",
  val: "25"
}, {
  text: "Anil Neerukonda Institute of Technology and Sciences, Vishakhapatnam",
  val: "26"
}, {
  text: "Anna University Tiruchirappalli, BIT Campus",
  val: "27"
}, {
  text: "Annamacharya Institute of Technology and Sciences, Rajampet",
  val: "28"
}, {
  text: "Arunai Engineering College, Tiruvannamalai",
  val: "29"
}, {
  text: "Asansol Engineering College, Asansol",
  val: "30"
}, {
  text: "Assam University, Silchar",
  val: "31"
}, {
  text: "ICFAI Foundation for Higher Education, Hyderabad",
  val: "32"
}, {
  text: "AU College of Engineering for Women, Vishakapattnam",
  val: "33"
}, {
  text: "AU College of Engineering, Vishakhapatnam",
  val: "34"
}, {
  text: "Audisankara College of Engineering and Technology, Gudur",
  val: "35"
}, {
  text: "Aurora's Engineering College, Nalgonda",
  val: "36"
}, {
  text: "Aurora's Scientific, Technological and Research Academy, Hyderabad",
  val: "37"
}, {
  text: "Aurora's Technological and Research Institute, Hyderabad",
  val: "38"
}, {
  text: "Avanthi Institute of Engineering and Technology, Vishakhapatnam",
  val: "39"
}, {
  text: "B K Birla Institute of Engineering and Technology, Pilani",
  val: "40"
}, {
  text: "Baddi University of Emerging Sciences and Technologies, Baddi",
  val: "41"
}, {
  text: "Banasthali University, Banasthali",
  val: "42"
}, {
  text: "Bangalore Institute of Technology, Bangalore",
  val: "43"
}, {
  text: "Bankura Unnayani Institute of Engineering, Bankura",
  val: "44"
}, {
  text: "Bannari Amman Institute of Technology, Erode",
  val: "45"
}, {
  text: "Bapatala Engineering College, Bapatala",
  val: "46"
}, {
  text: "Bapuji Institute of Engineering and Technology, Davangere",
  val: "47"
}, {
  text: "Indian Institute of Technology, Bhubaneswar (IITBBS)",
  val: "48"
}, {
  text: "Barkatullah University Institute of Technology, Barkatullah University, Bhopal",
  val: "49"
}, {
  text: "Basaveshwar Engineering College, Bagalkot",
  val: "50"
}, {
  text: "Beant College of Engineering and Technology, Gurdaspur",
  val: "51"
}, {
  text: "Bhagalpur College of Engineering, Bhagalpur",
  val: "52"
}, {
  text: "Birla Institute of Technology and Science, Pilani",
  val: "53"
}, {
  text: "Indian Institute of Technology, Guwahati (IITG)",
  val: "54"
}, {
  text: "Bharath University, Chennai",
  val: "55"
}, {
  text: "Bharati Vidyapeeth Deemed University College of Engineering, Pune",
  val: "56"
}, {
  text: "Bharati Vidyapeeth",
  val: "57"
}, {
  text: "Bhartiya Vidya Bhavans, Sardar Patel College of Engineering, Mumbai",
  val: "58"
}, {
  text: "Bhilai Institute of Technology, Durg",
  val: "59"
}, {
  text: "Bhilai Institute of Technology, Raipur",
  val: "60"
}, {
  text: "Indian Institute of Technology, Roorkee (IITR)",
  val: "61"
}, {
  text: "Bidhan Chandra Krishi Viswa Vidyalaya, Nadia",
  val: "62"
}, {
  text: "Bipin Tripathi Kumaon Institute of Technology, Dwarahat",
  val: "63"
}, {
  text: "Birbhum Institute of Engineering Technology, Birbhum",
  val: "64"
}, {
  text: "Birla Institute of Technology, Mesra",
  val: "65"
}, {
  text: "Birla Institute of Technology, Patna",
  val: "66"
}, {
  text: "BIT Sindri, Dhanbad",
  val: "67"
}, {
  text: "BITS Pilani- Hyderabad Campus, Hyderabad",
  val: "68"
}, {
  text: "BITS Pilani, Goa Campus",
  val: "69"
}, {
  text: "BMS College of Engineering, Bangalore",
  val: "70"
}, {
  text: "BMS Institute of Technology, Bangalore",
  val: "71"
}, {
  text: "BNM Institute of Technology, Bangalore",
  val: "72"
}, {
  text: "Bundelkhand Institute of Engineering and Technology, Jhansi",
  val: "73"
}, {
  text: "BV Bhoomaraddi College of Engineering and Technology, Hubli",
  val: "74"
}, {
  text: "BVRIT Padmasri Dr BV Raju Institute of Technology, Hyderabad",
  val: "75"
}, {
  text: "CBS Group of Instiutions, Jhajjar",
  val: "76"
}, {
  text: "Central Institute of Plastic Engineering Technology, Lucknow",
  val: "77"
}, {
  text: "Central Institute of Plastics Engineering and Technology, Chennai",
  val: "78"
}, {
  text: "Centurion University, Paralakhemundi",
  val: "79"
}, {
  text: "Chaitanya Bharathi Institute of Technology, Hyderabad",
  val: "80"
}, {
  text: "Chaitanya Engineering College, Vishakhapatnam",
  val: "81"
}, {
  text: "Chandigarh College of Engineering and Technology, Chandigarh",
  val: "82"
}, {
  text: "Charotar University of Science and Technology, Petlad",
  val: "83"
}, {
  text: "Chaudhary Charan Singh Haryana Agricultural University, Hisar",
  val: "84"
}, {
  text: "Chitkara University, Patiala",
  val: "85"
}, {
  text: "Christ University, Bangalore",
  val: "86"
}, {
  text: "CMR Engineering College, Hyderabad",
  val: "87"
}, {
  text: "CMR Institute of Technology, Bangalore",
  val: "88"
}, {
  text: "Indian Institute of Technology, Banaras Hindu University, Varanasi (IITBHU)",
  val: "89"
}, {
  text: "CMR Institute of Technology, Hyderabad",
  val: "90"
}, {
  text: "CMR Technical Campus, Hyderabad",
  val: "91"
}, {
  text: "Coimbatore Institute of Technology, Coimbatore",
  val: "92"
}, {
  text: "College of Dairy Science and Technology, Mannuthi, Thrissur",
  val: "93"
}, {
  text: "Indian Institute of Technology, Gandhinagar (IITGN)",
  val: "94"
}, {
  text: "Indian Institute of Technology, Hyderabad (IITH)",
  val: "95"
}, {
  text: "Indian Institute of Technology, Indore (IITI)",
  val: "96"
}, {
  text: "Indian Institute of Technology, Jodhpur (IITJ)",
  val: "97"
}, {
  text: "Indian Institute of Technology, Mandi (IITMANDI)",
  val: "98"
}, {
  text: "Indian Institute of Technology, Patna (IITP)",
  val: "99"
}, {
  text: "Indian Institute of Technology, Ropar (IITRPR)",
  val: "100"
}, {
  text: "College of Engineering Adoor",
  val: "101"
}, {
  text: "BS Abdur Rahman University, Chennai",
  val: "102"
}, {
  text: "Anna University Chennai, CEG Campus",
  val: "103"
}, {
  text: "College of Engineering and Management, Kolaghat",
  val: "104"
}, {
  text: "College of Engineering and Technology ,Bhubaneswar",
  val: "105"
}, {
  text: "University College of Engineering, Osmania University, Hyderabad",
  val: "106"
}, {
  text: "College of Engineering Roorkee, Roorkee",
  val: "107"
}, {
  text: "College of Engineering Studies, University of Petroleum and Energy Studies, Dehradun",
  val: "108"
}, {
  text: "College of Engineering, Chengannur",
  val: "109"
}, {
  text: "Delhi Technological University, Delhi",
  val: "110"
}, {
  text: "Dhirubhai Ambani Institute of Information and Communication Technology, Gandhinagar",
  val: "111"
}, {
  text: "Malaviya National Institute of Technology, Jaipur (MNIT)",
  val: "112"
}, {
  text: "College of Engineering, Pune",
  val: "113"
}, {
  text: "Harcourt Butler Technological Institute, Kanpur",
  val: "114"
}, {
  text: "Walchand College of Engineering, Sangli",
  val: "115"
}, {
  text: "Guru Gobind Singh Indraprastha University, Delhi",
  val: "116"
}, {
  text: "Indian Institute of Information Technology, Allahabad",
  val: "117"
}, {
  text: "Indian School of Mines, Dhanbad",
  val: "118"
}, {
  text: "College of Engineering, Trivandrum",
  val: "119"
}, {
  text: "International Institute of Information Technology, Hyderabad",
  val: "120"
}, {
  text: "College of Technology and Engineering, Maharana Pratap University of Agriculture and Technology, Udaipur",
  val: "121"
}, {
  text: "Manipal Institute of Technology, Manipal",
  val: "122"
}, {
  text: "MS Ramaiah Institute of Technology, Bangalore",
  val: "123"
}, {
  text: "Mepco Schlenk Engineering College, Sivakasi",
  val: "124"
}, {
  text: "Government Model Engineering College, Thrikkakara",
  val: "125"
}, {
  text: "Motilal Nehru National Institute of Technology, Allahabad (MNNIT)",
  val: "126"
}, {
  text: "College of Technology, GB Pant University of Agriculture and Technology, Pantnagar",
  val: "127"
}, {
  text: "National Institute of Technology, Srinagar (NITSRI)",
  val: "128"
}, {
  text: "National Institute of Technology, Calicut (NITC)",
  val: "129"
}, {
  text: "National Institute of Technology, Durgapur (NITDGP)",
  val: "130"
}, {
  text: "National Institute of Technology, Hamirpur (NITH)",
  val: "131"
}, {
  text: "CV Raman College of Engineering, Bhubaneswar",
  val: "132"
}, {
  text: "National Institute of Technology, Rourkela (NITRKL)",
  val: "133"
}, {
  text: "National Institute of Technology, Silchar (NITS)",
  val: "134"
}, {
  text: "National Institute of Technology, Tiruchirappalli (NITT)",
  val: "135"
}, {
  text: "National Institute of Technology, Warangal (NITW)",
  val: "136"
}, {
  text: "Netaji Subhas Institute of Technology, Delhi",
  val: "137"
}, {
  text: "CVR College of Engineering, Hyderabad",
  val: "138"
}, {
  text: "DAV Institute of Engineering and Technology, Jalandhar",
  val: "139"
}, {
  text: "Dayalbagh Educational Institute, Agra",
  val: "140"
}, {
  text: "Dayanand Sagar College of Engineering, Bangalore",
  val: "141"
}, {
  text: "Deenbandhu Chhotu Ram University of Science and Technology, Murthal",
  val: "142"
}, {
  text: "Rajagiri School of Engineering and Technology, Ernakulam",
  val: "143"
}, {
  text: "Sardar Vallabhbhai National Institute of Technology, Surat (SVNIT)",
  val: "144"
}, {
  text: "Shri Mata Vaishno Devi University, Katra",
  val: "145"
}, {
  text: "Sir M Visvesvaraya Institute of Technology, Bangalore",
  val: "146"
}, {
  text: "Dharmsinh Desai University, Nadiad",
  val: "147"
}, {
  text: "SRM University, Chennai",
  val: "148"
}, {
  text: "DIT University, Dehradun",
  val: "149"
}, {
  text: "Thapar University, Patiala",
  val: "150"
}, {
  text: "Veermata Jijabai Technological Institute, Mumbai",
  val: "151"
}, {
  text: "VIT University, Vellore",
  val: "152"
}, {
  text: "Visvesvaraya National Institute of Technology, Nagpur (VNIT)",
  val: "153"
}, {
  text: "West Bengal University of Technology, Kolkata",
  val: "154"
}, {
  text: "Don Bosco Institute of Technology, Mumbai",
  val: "155"
}, {
  text: "Dr B R Ambedkar National Institute of Technology, Jalandhar (NITJ)",
  val: "156"
}, {
  text: "Dr S and SS Ghandhy College of Engineering and Technology, Surat",
  val: "157"
}, {
  text: "Dr. Ambedkar Institute of Technology for Handicapped, Kanpur  ",
  val: "158"
}, {
  text: "Dr. Ambedkar Institute of Technology, Bangalore",
  val: "159"
}, {
  text: "Dr. Babasaheb Ambedkar Technological University, Lonere",
  val: "160"
}, {
  text: "Dr. Bhimrao Ambedkar Engineering College of Information Technology, Banda",
  val: "161"
}, {
  text: "Dr. Bhimrao Ambedkar Engineering College of Information Technology, Bijnor",
  val: "162"
}, {
  text: "Dr. Mahalingam College of Engineering and Technology, Pollachi",
  val: "163"
}, {
  text: "Dr. Sivanthi Aditanar College of Engineering, Thoothukudi",
  val: "164"
}, {
  text: "Dronacharya College of Engineering, Gurgaon",
  val: "165"
}, {
  text: "Easwari Engineering College, Chennai",
  val: "166"
}, {
  text: "Faculty of Engineering and Technology, Manav Rachna International University, Faridabad",
  val: "167"
}, {
  text: "Feroze Gandhi Institute of Engineering and Technology, Raibareli",
  val: "168"
}, {
  text: "Fr. C Rodrigues Institute of Technology, Navi Mumbai",
  val: "169"
}, {
  text: "Fr. Conceicao Rodrigues College of Engineering, Mumbai",
  val: "170"
}, {
  text: "G Narayanamma Institute of Technology and Science (For Women), Hyderabad",
  val: "171"
}, {
  text: "G Pulla Reddy Engineering College, Kurnool",
  val: "172"
}, {
  text: "Galgotias College of Engineering and Technology, Greater Noida",
  val: "173"
}, {
  text: "Galgotias University, Greater Noida",
  val: "174"
}, {
  text: "Gandhi Institute of Engineering and Technology, Gunupur",
  val: "175"
}, {
  text: "Gayatri Vidya Parishad College of Engineering, Vishakhapatnam",
  val: "176"
}, {
  text: "GH Patel College of Engineering and Technology, Anand",
  val: "177"
}, {
  text: "GH Raisoni College of Engineering, Nagpur",
  val: "178"
}, {
  text: "Giani Zail Singh Punjab Technical University Campus, Bathinda",
  val: "179"
}, {
  text: "GLA University, Mathura",
  val: "180"
}, {
  text: "GMR Institute of Technology, Rajam",
  val: "181"
}, {
  text: "Gokaraju Rangaraju Institute of Engineering and Technology, Hyderabad",
  val: "182"
}, {
  text: "Government College of Engineering and Ceramic Technology, Kolkata",
  val: "183"
}, {
  text: "Government College of Engineering and Leather Technology,Kolkata",
  val: "184"
}, {
  text: "Government College of Engineering and Technology, Bikaner",
  val: "185"
}, {
  text: "Government College of Engineering and Technology, Jammu",
  val: "186"
}, {
  text: "Government College of Engineering and Textile Technology, Berhampore",
  val: "187"
}, {
  text: "Government College of Engineering, Aurangabad",
  val: "188"
}, {
  text: "Government College of Engineering, Bargur",
  val: "189"
}, {
  text: "Government College of Engineering, Kalahandi",
  val: "190"
}, {
  text: "Government College of Engineering, Kannur",
  val: "191"
}, {
  text: "Government College of Engineering, Karad",
  val: "192"
}, {
  text: "Government College of Engineering, Salem",
  val: "193"
}, {
  text: "Government College of Engineering, Tirunelveli",
  val: "194"
}, {
  text: "Government College of Technology, Coimbatore",
  val: "195"
}, {
  text: "Government Engineering College, Ajmer",
  val: "196"
}, {
  text: "Government Engineering College, Barton Hill, Thiruvananthapuram ",
  val: "197"
}, {
  text: "Government Engineering College, Bastar",
  val: "198"
}, {
  text: "Government Engineering College, Bhavnagar",
  val: "199"
}, {
  text: "Government Engineering College, Bikaner",
  val: "200"
}, {
  text: "Government Engineering College, Bilaspur",
  val: "201"
}, {
  text: "Government Engineering College, Gandhinagar",
  val: "202"
}, {
  text: "Government Engineering College, Jhalawar",
  val: "203"
}, {
  text: "Government Engineering College, Kozhikode",
  val: "204"
}, {
  text: "Government Engineering College, Modasa",
  val: "205"
}, {
  text: "Government Engineering College, Patan",
  val: "206"
}, {
  text: "Government Engineering College, Raipur",
  val: "207"
}, {
  text: "Government Engineering College, Rajkot",
  val: "208"
}, {
  text: "Government Engineering College, Sreekrishnapuram",
  val: "209"
}, {
  text: "Government Engineering College, Surat",
  val: "210"
}, {
  text: "Government Engineering College, Thrissur",
  val: "211"
}, {
  text: "Government Engineering College, Wayanad",
  val: "212"
}, {
  text: "Government Sri Krishnarajendra Silver Jubilee Technological Institute, Bangalore",
  val: "213"
}, {
  text: "Government Women Engineering College, Ajmer",
  val: "214"
}, {
  text: "Govind Ballabh Pant Engineering College, Pauri-Garhwal",
  val: "215"
}, {
  text: "Gudlavalleru Engineering College, Gudlavalleru",
  val: "216"
}, {
  text: "Guru Ghasidas Vishwavidyalaya, Bilaspur",
  val: "217"
}, {
  text: "Guru Jambheshwar University of Science and Technology, Hisar",
  val: "218"
}, {
  text: "Guru Nanak Dev Engineering College, Bidar",
  val: "219"
}, {
  text: "Guru Nanak Dev Engineering College, Ludhiana",
  val: "220"
}, {
  text: "Guru Nanak Dev University Regional Campus Jalandhar",
  val: "221"
}, {
  text: "Guru Nanak Dev University, Amritsar",
  val: "222"
}, {
  text: "Guru Nanak Institutions Technical Campus, Secunderabad",
  val: "223"
}, {
  text: "Gurukul Kangri Vishwavidyalaya, Haridwar",
  val: "224"
}, {
  text: "Haldia Institute of Technology, Haldia",
  val: "225"
}, {
  text: "Heritage Institute of Technology, Kolkata",
  val: "226"
}, {
  text: "Hindu College of Engineering, Sonipat",
  val: "227"
}, {
  text: "Hindustan University, Kelambakkam",
  val: "228"
}, {
  text: "Hindusthan College of Engineering and Technology, Coimbatore",
  val: "229"
}, {
  text: "Indian Institute of Carpet Technology, Bhadohi",
  val: "230"
}, {
  text: "Indian Institute of Engineering Science and Technology, Shibpur",
  val: "231"
}, {
  text: "Indian Institute of Information Technology, Design and Manufacturing, Jabalpur",
  val: "232"
}, {
  text: "Indian Institute of Information Technology, Design and Manufacturing, Kancheepuram",
  val: "233"
}, {
  text: "Indian Institute of Science Education and Research, Bhopal",
  val: "234"
}, {
  text: "Indian Institute of Science Education and Research, Kolkata",
  val: "235"
}, {
  text: "Indian Institute of Science Education and Research, Mohali",
  val: "236"
}, {
  text: "Indian Institute of Science Education and Research, Pune",
  val: "237"
}, {
  text: "Indian Institute of Science Education and Research, Thiruvananthapuram",
  val: "238"
}, {
  text: "Indian Institute of Space Science and Technology, Thiruvananthapuram",
  val: "239"
}, {
  text: "Indira Gandhi Institute of Technology, Delhi",
  val: "240"
}, {
  text: "Indira Gandhi Institute of Technology, Sarang",
  val: "241"
}, {
  text: "Indraprastha Institute of Information Technology, Delhi",
  val: "242"
}, {
  text: "Institute of Chemical Technology, Mumbai",
  val: "243"
}, {
  text: "Institute of Engineering and Management, Kolkata",
  val: "244"
}, {
  text: "Institute of Engineering and Rural Technology, Allahabad",
  val: "245"
}, {
  text: "Institute of Engineering and Science, IPS Academy, Indore",
  val: "246"
}, {
  text: "Institute of Engineering and Technology, Alwar",
  val: "247"
}, {
  text: "Institute of Engineering and Technology, Indore",
  val: "248"
}, {
  text: "Institute of Engineering and Technology, Lucknow",
  val: "249"
}, {
  text: "Institute of Information and Communication Technology, Ahmedabad",
  val: "250"
}, {
  text: "Institute of Infrastructure, Technology, Research and Management, Ahmedabad",
  val: "251"
}, {
  text: "Institute of Road and Transport Technology, Erode",
  val: "252"
}, {
  text: "Institute of Science and Technology, Jawaharlal Nehru Technological University, Hyderabad",
  val: "253"
}, {
  text: "Integral University, Lucknow",
  val: "254"
}, {
  text: "International Institute of Information Technology, Bangalore",
  val: "255"
}, {
  text: "International Institute of Information Technology, Bhubaneswar",
  val: "256"
}, {
  text: "International Institute of Information Technology, Pune",
  val: "257"
}, {
  text: "Islamic University of Science and Technology, Pulwama",
  val: "258"
}, {
  text: "ITM University, Gwalior",
  val: "259"
}, {
  text: "Jabalpur Engineering College, Jabalpur",
  val: "260"
}, {
  text: "Jadavpur University, Kolkata",
  val: "261"
}, {
  text: "Jaipur Engineering College and Research Centre, Jaipur",
  val: "262"
}, {
  text: "Jaipur National University, Jaipur",
  val: "263"
}, {
  text: "Jalpaiguri Government Engineering College, Jalpaiguri",
  val: "264"
}, {
  text: "Jamia Millia Islamia, New Delhi",
  val: "265"
}, {
  text: "Jawaharlal Nehru Technological University College of Engineering, Kakinada",
  val: "266"
}, {
  text: "Jawaharlal Nehru Technological University, Kakinada",
  val: "267"
}, {
  text: "Jaypee Institute of Information Technology, Noida",
  val: "268"
}, {
  text: "Jaypee University of Information Technology, Solan",
  val: "269"
}, {
  text: "Jiwaji University, Gwalior",
  val: "270"
}, {
  text: "JNTU College of Engineering, Hyderabad",
  val: "271"
}, {
  text: "JNTU, University College of Engineering, Vizianagaram ",
  val: "272"
}, {
  text: "JNTUH College of Engineering, Karimnagar",
  val: "273"
}, {
  text: "Jodhpur National University, Jodhpur",
  val: "274"
}, {
  text: "Joginpally B R Engineering College, Moinabad",
  val: "275"
}, {
  text: "JSS Academy of Technical Education, Bangalore",
  val: "276"
}, {
  text: "JSS Academy of Technical Education, Noida",
  val: "277"
}, {
  text: "Kakatiya Institute of Technology and Science, Warangal",
  val: "278"
}, {
  text: "Kalinga Institute of Industrial Technology, Bhubaneswar",
  val: "279"
}, {
  text: "Kamla Nehru Institute of Technology, Sultanpur",
  val: "280"
}, {
  text: "Karunya University, Coimbatore",
  val: "281"
}, {
  text: "Kasegaon Education Society’s Rajarambapu Institute of Technology, Sangli",
  val: "282"
}, {
  text: "KJ Somaiya College of Engineering, Mumbai",
  val: "283"
}, {
  text: "KJ Somaiya College of Engineering, Mumbai",
  val: "284"
}, {
  text: "KLS Gogte Institute of Technology, Belgaum",
  val: "285"
}, {
  text: "Kongu Engineering College, Erode",
  val: "286"
}, {
  text: "Krishna Institute of Engineering and Technology, Ghaziabad",
  val: "287"
}, {
  text: "Kumaraguru College of Technology, Coimbatore",
  val: "288"
}, {
  text: "Lakshmi Narain College of Technology, Bhopal",
  val: "289"
}, {
  text: "LBS College of Engineering, Kasargod",
  val: "290"
}, {
  text: "LBS Institute of Technology for Women, Thiruvananthapuram",
  val: "291"
}, {
  text: "LD College of Engineering, Ahmedabad",
  val: "292"
}, {
  text: "Lovely Professional University, Jalandhar",
  val: "293"
}, {
  text: "Lukhdhirji Engineering College, Morbi",
  val: "294"
}, {
  text: "M Kumarasamy College of Engineering, Karur",
  val: "295"
}, {
  text: "Madan Mohan Malaviya University of Technology. Gorakhpur",
  val: "296"
}, {
  text: "Madanpalle Institute of Technology and Science, Madanapalle",
  val: "297"
}, {
  text: "Madhav Institute of Technology and Science, Gwalior",
  val: "298"
}, {
  text: "Madras Institute of Technology, Chennai",
  val: "299"
}, {
  text: "Maharaj Vijayaram Gajapathi Raj College of Engineering, Vizianagaram",
  val: "300"
}, {
  text: "Maharaja Agrasen Institute of Technology, Delhi",
  val: "301"
}, {
  text: "Maharaja Sayajirao University of Baroda, Vadodara",
  val: "302"
}, {
  text: "Maharashtra Institute of Technology, Pune",
  val: "303"
}, {
  text: "Maharishi Markandeshwar University, Ambala ",
  val: "304"
}, {
  text: "Mahatma Gandhi Institute of Technology, Hyderabad",
  val: "305"
}, {
  text: "Mahatma Jyotiba Phule Rohilkhand University, Bareilly",
  val: "306"
}, {
  text: "Malla Reddy College of Engineering and Technology, Hyderabad",
  val: "307"
}, {
  text: "Malla Reddy Engineering College, Hyderabad",
  val: "308"
}, {
  text: "Malnad College of Engineering, Hassan",
  val: "309"
}, {
  text: "Manav Rachna College of Engineering, Faridabad",
  val: "310"
}, {
  text: "Manyawar Kansi Ram Engineering College of Information Technology, Ambedkar Nagar",
  val: "311"
}, {
  text: "Manyawar Kansi Ram Engineering College of Information Technology, Azamgarh",
  val: "312"
}, {
  text: "Mar Athanasius College of Engineering, Kothamangalam",
  val: "313"
}, {
  text: "Maturi Venkata Subba Rao Engineering College, Hyderabad",
  val: "314"
}, {
  text: "Maulana Azad National Institute of Technology, Bhopal (MANIT)",
  val: "315"
}, {
  text: "MBM Engineering College, Jodhpur",
  val: "316"
}, {
  text: "MCT’s Rajiv Gandhi Institute of Technology, Mumbai",
  val: "317"
}, {
  text: "Medi-Caps Institute of Science and Technology, Indore",
  val: "318"
}, {
  text: "Medi-Caps Institute of Technology and Management, Indore",
  val: "319"
}, {
  text: "Meenakshi Sundararajan Engineering College, Chennai",
  val: "320"
}, {
  text: "MES College of Engineering, Malappuram",
  val: "321"
}, {
  text: "Mizoram University, Aizawl",
  val: "322"
}, {
  text: "MLV Government Textile and Engineering College, Bhilwara",
  val: "323"
}, {
  text: "Mody University of Science and Technology, Sikar",
  val: "324"
}, {
  text: "MS Engineering College, Bangalore",
  val: "325"
}, {
  text: "Mukesh Patel School of Technology Management and Engineering, Mumbai",
  val: "326"
}, {
  text: "Muzaffarpur Institute of Technology, Muzaffarpur",
  val: "327"
}, {
  text: "MVJ College of Engineering, Bangalore",
  val: "328"
}, {
  text: "Narasaraopeta Engineering College, Narasaraopet",
  val: "329"
}, {
  text: "National Dairy Research Institute, Karnal",
  val: "330"
}, {
  text: "National Institute of Foundry and Forge Technology, Ranchi",
  val: "331"
}, {
  text: "National Institute of Science Education and Research, Bhubaneswar",
  val: "332"
}, {
  text: "National Institute of Technology, Agartala (NITA)",
  val: "333"
}, {
  text: "National Institute of Technology, Delhi (NITDELHI)",
  val: "334"
}, {
  text: "National Institute of Technology, Goa (NITGOA)",
  val: "335"
}, {
  text: "National Institute of Technology, Jamshedpur (NITJSR)",
  val: "336"
}, {
  text: "National Institute of Technology, Kurukshetra (NITKKR)",
  val: "337"
}, {
  text: "National Institute of Technology, Mizoram (NITMZ)",
  val: "338"
}, {
  text: "National Institute of Technology, Nagaland (NITNAGALAND)",
  val: "339"
}, {
  text: "National Institute of Technology, Patna (NITP)",
  val: "340"
}, {
  text: "National Institute of Technology, Puducherry (NITPY)",
  val: "341"
}, {
  text: "National Institute of Technology, Raipur (NITRR)",
  val: "342"
}, {
  text: "National Institute of Technology, Sikkim (NITSIKKIM)",
  val: "343"
}, {
  text: "National Institute of Technology, Surathkal (NITK)",
  val: "344"
}, {
  text: "National Institute of Technology, Uttarakhand (NITUK)",
  val: "345"
}, {
  text: "National Power Training Institute, Durgapur",
  val: "346"
}, {
  text: "National Power Training Institute, Faridabad",
  val: "347"
}, {
  text: "NC College of Engineering, Israna",
  val: "348"
}, {
  text: "Netaji Subhash Engineering College, Garia",
  val: "349"
}, {
  text: "New Horizon College of Engineering, Bangalore",
  val: "350"
}, {
  text: "NIIT University, Neemrana",
  val: "351"
}, {
  text: "Nirma University, Ahmedabad",
  val: "352"
}, {
  text: "Nitte Meenakshi Institute of Technology, Bangalore",
  val: "353"
}, {
  text: "Nizam Institute of Engineering and Technology, Hyderabad",
  val: "354"
}, {
  text: "NMAM Institute of Technology, Karkala Taluk",
  val: "355"
}, {
  text: "North Eastern Regional Institute of Science and Technology, Nirjuli",
  val: "356"
}, {
  text: "NSS College of Engineering, Palakkad",
  val: "357"
}, {
  text: "Orissa School of Mining Engineering, Keonjhar",
  val: "358"
}, {
  text: "PA College of Engineering, Mangalore",
  val: "359"
}, {
  text: "Pandit Deendayal Petroleum University- School of Technology, Gandhinagar",
  val: "360"
}, {
  text: "Panimalar Engineering College, Chennai",
  val: "361"
}, {
  text: "Panipat Institute of Engineering and Technology, Panipat",
  val: "362"
}, {
  text: "Panjab University, Chandigarh",
  val: "363"
}, {
  text: "Panjab University, SSG Regional Centre, Hoshiarpur",
  val: "364"
}, {
  text: "Parala Maharaja Engineering College, Berhampur",
  val: "365"
}, {
  text: "Parvatha Reddy Babul Reddy Visvodaya Institute of Technology and Science, Nellore",
  val: "366"
}, {
  text: "PES College of Engineering, Mandya",
  val: "367"
}, {
  text: "PES Institute of Technology, Bangalore South Campus, Bangalore",
  val: "368"
}, {
  text: "Pondicherry Engineering College, Puducherry",
  val: "369"
}, {
  text: "Poojya Doddappa Appa College, Gulbarga",
  val: "370"
}, {
  text: "Poornima College of Engineering, Jaipur",
  val: "371"
}, {
  text: "Pragati Engineering College, Kakinada",
  val: "372"
}, {
  text: "PSG College of Technology, Coimbatore",
  val: "373"
}, {
  text: "Punjab Agricultural University, Ludhiana",
  val: "374"
}, {
  text: "Punjab Engineering College University of Technology, Chandigarh",
  val: "375"
}, {
  text: "QIS College of Engineering and Technology, Ongole",
  val: "376"
}, {
  text: "Quantum School of Technology, Roorkee",
  val: "377"
}, {
  text: "Rajasthan Technical University, Kota",
  val: "378"
}, {
  text: "Rajeev Gandhi Memorial College of Engineering and Technology, Kurnool",
  val: "379"
}, {
  text: "Rajiv Gandhi Institute of Technology, Kottayam",
  val: "380"
}, {
  text: "Rajiv Gandhi Proudyogiki Vishwavidyalaya, Bhopal",
  val: "381"
}, {
  text: "Rayat Bahra Faculty of Engineering and Technology, Patiala Campus, Patiala",
  val: "382"
}, {
  text: "RCC Institute of Information Technology, Beliaghata",
  val: "383"
}, {
  text: "Reva Institute of Technology and Management, Bangalore",
  val: "384"
}, {
  text: "Rewa Engineering College, Rewa",
  val: "385"
}, {
  text: "RMK Engineering College, Thiruvallur",
  val: "386"
}, {
  text: "RNS Institute of Technology, Bangalore",
  val: "387"
}, {
  text: "RTE Sociey",
  val: "388"
}, {
  text: "Rungta College of Engineering and Technology, Bhilai",
  val: "389"
}, {
  text: "Rustamji Institute of Technology, Gwalior",
  val: "390"
}, {
  text: "RV College of Engineering, Bangalore",
  val: "391"
}, {
  text: "Sagi Ramakrishnam Raju Engineering College, Bhimavaram",
  val: "392"
}, {
  text: "Sam Higginbottom Institute of Agriculture, Technology and Science, Allahabad",
  val: "393"
}, {
  text: "Samrat Ashok Technological Institute, Vidisha",
  val: "394"
}, {
  text: "Sant Longowal Institute of Engineering and Technology, Longowal",
  val: "395"
}, {
  text: "SASTRA University, Thanjavur",
  val: "396"
}, {
  text: "Sathyabama University, Chennai",
  val: "397"
}, {
  text: "Satyam Institute of Engineering and Technology, Amritsar",
  val: "398"
}, {
  text: "Saveetha Engineering College, Chennai",
  val: "399"
}, {
  text: "School of Engineering and Technology, Jain University, Bangalore",
  val: "400"
}, {
  text: "School of Engineering, Cochin University of Science and Technology, Ernakulam",
  val: "401"
}, {
  text: "SCMS School of Engineering and Technology, Ernakulum",
  val: "402"
}, {
  text: "SDM College of Engineering and Technology, Dharwad",
  val: "403"
}, {
  text: "Seth Jai Parkash Mukand Lal Institute of Engineering and Technology, Yamunanagar",
  val: "404"
}, {
  text: "Shaheed Bhagat Singh State Technical Campus, Firozpur",
  val: "405"
}, {
  text: "Shantilal Shah Engineering College, Bhavnagar",
  val: "406"
}, {
  text: "Sharda University, Greater Noida",
  val: "407"
}, {
  text: "Shiv Nadar University, Dadri",
  val: "408"
}, {
  text: "Shivaji University, Kolhapur",
  val: "409"
}, {
  text: "Shobhit Institute of Engineering and  Technology, Meerut",
  val: "410"
}, {
  text: "Shri GS Institute of Technology and Science, Indore",
  val: "411"
}, {
  text: "Shri Guru Gobind Singhji Institute of Engineering and Technology, Vishnupuri",
  val: "412"
}, {
  text: "Shri Ram Murti Smarak College of Engineering and Technology, Bareilly",
  val: "413"
}, {
  text: "Shri Sant Gajanan Maharaj College of Engineering, Shegaon",
  val: "414"
}, {
  text: "Shri Shankaracharya Engineering College, Bhilai",
  val: "415"
}, {
  text: "Shri Vaishnav Institute of Technology and Science, Indore",
  val: "416"
}, {
  text: "Siddaganga Institute of Technology, Tumkur",
  val: "417"
}, {
  text: "Siksha O' Anusandhan University, Bhubaneshwar",
  val: "418"
}, {
  text: "Silicon Institute of Technology, Bhubaneswar",
  val: "419"
}, {
  text: "Sinhgad College of Engineering, Pune",
  val: "420"
}, {
  text: "SJB Institute of Technology, Bangalore",
  val: "421"
}, {
  text: "Sona College of Technology, Salem",
  val: "422"
}, {
  text: "Sree Chitra Thirunal College of Engineering, Thiruvananthapuram ",
  val: "423"
}, {
  text: "Sree Vidyanikethan Engineering College, Tirupati",
  val: "424"
}, {
  text: "Sreenidhi Institute of Science and Technology, Ghatkesar",
  val: "425"
}, {
  text: "Sri Aditya Engineering College, Surampalem",
  val: "426"
}, {
  text: "Sri Jayachamarajendra College of Engineering, Mysore",
  val: "427"
}, {
  text: "Sri Krishna College of Engineering and Technology, Coimbatore",
  val: "428"
}, {
  text: "Sri Manakula Vinayagar Engineering College, Puducherry",
  val: "429"
}, {
  text: "Sri Ramakrishna Engineering College, Coimbatore",
  val: "430"
}, {
  text: "Sri Sai Ram Engineering College, Chennai",
  val: "431"
}, {
  text: "Sri Siddhartha Institute of Technology, Tumkur",
  val: "432"
}, {
  text: "Sri Venkateswara College of Engineering, Sriperumbudur",
  val: "433"
}, {
  text: "Sri Venkateswara University, Tirupati",
  val: "434"
}, {
  text: "Sri Vishnu Engineering College for Women, Bhimavaram",
  val: "435"
}, {
  text: "St. Ann",
  val: "436"
}, {
  text: "Swami Keshvanand Institute of Technology, Management and Gramothan, Jaipur",
  val: "437"
}, {
  text: "Symbiosis International University, Pune",
  val: "438"
}, {
  text: "Techno India University, Kolkata",
  val: "439"
}, {
  text: "Tezpur University, Tezpur",
  val: "440"
}, {
  text: "The LNM Institute of Information Technology, Jaipur",
  val: "441"
}, {
  text: "The National Institute of Engineering, Mysore",
  val: "442"
}, {
  text: "The Oxford College of Engineering, Bangalore",
  val: "443"
}, {
  text: "The Technological Institute of Textile and Sciences, Bhiwani",
  val: "444"
}, {
  text: "Thiagarajar College of Engineering, Madurai",
  val: "445"
}, {
  text: "TKM College of Engineering, Kollam",
  val: "446"
}, {
  text: "Tripura Institute of Technology, Agartala",
  val: "447"
}, {
  text: "Tula’s Institute, The Engineering and Management College, Dehradun",
  val: "448"
}, {
  text: "UBDT College of Engineering, Davangere",
  val: "449"
}, {
  text: "UIET, Chhatrapati Sahuji Maharaj University, Kanpur",
  val: "450"
}, {
  text: "Ujjain Engineering College, Ujjain",
  val: "451"
}, {
  text: "University College of Engineering, Punjabi University, Patiala",
  val: "452"
}, {
  text: "University College of Technology, Osmania University, Hyderabad",
  val: "453"
}, {
  text: "University Institute of Chemical Engineering and Technology, Chandigarh",
  val: "454"
}, {
  text: "University Institute of Engineering and Technology, Chandigarh",
  val: "455"
}, {
  text: "University Institute of Engineering and Technology, Kurukshetra University, Kurukshetra",
  val: "456"
}, {
  text: "University Institute of Engineering and Technology, Maharshi Dayanand University, Rohtak",
  val: "457"
}, {
  text: "University Institute of Information Technology, Shimla",
  val: "458"
}, {
  text: "University Institute of Technology, Burdwan",
  val: "459"
}, {
  text: "University of Kalyani, Kalyani",
  val: "460"
}, {
  text: "University Visvesvaraya College of Engineering, Bangalore",
  val: "461"
}, {
  text: "UP Textile Technology Institute, Kanpur",
  val: "462"
}, {
  text: "Uttar Banga Krishi Vishwavidyalaya, Pundibari",
  val: "463"
}, {
  text: "Uttaranchal Institute of Technology, Dehradun",
  val: "464"
}, {
  text: "Vaagdevi College of Engineering, Warangal",
  val: "465"
}, {
  text: "Vaish College of Engineering, Rohtak",
  val: "466"
}, {
  text: "Vardhaman College of Engineering, Hyderabad",
  val: "467"
}, {
  text: "Vasavi College of Engineering, Hyderabad",
  val: "468"
}, {
  text: "Veer Surendra Sai University of Technology, Sambalpur",
  val: "469"
}, {
  text: "Vel Tech Dr Rangrajan Dr Sakunthala Technical University, Chennai",
  val: "470"
}, {
  text: "Vel Tech High Tech Dr. Rangarajan Dr. Sakunthala Engineering College, Chennai",
  val: "471"
}, {
  text: "Velagapudi Ramakrishna Siddhartha Engineering College, Vijaywada",
  val: "472"
}, {
  text: "Velammal Engineering College, Chennai",
  val: "473"
}, {
  text: "Vels University, Chennai",
  val: "474"
}, {
  text: "Vidya Jyothi Institute of Technology, Hyderabad",
  val: "475"
}, {
  text: "Vidyavardhaka College of Engineering, Mysore",
  val: "476"
}, {
  text: "Vignan University, Guntur",
  val: "477"
}, {
  text: "Vishnu Institute of Technology, Bhimavaram",
  val: "478"
}, {
  text: "Vishwakarma Government Engineering College, Ahmedabad",
  val: "479"
}, {
  text: "Vishwakarma Institute of Information Technology, Pune",
  val: "480"
}, {
  text: "Vishwakarma Institute of Technology, Pune",
  val: "481"
}, {
  text: "VNR Vignana Jyothi Institute of Engineering and Technology, Hyderabad",
  val: "482"
}, {
  text: "VSB Engineering College, Karur",
  val: "483"
}, {
  text: "Yeshwantrao Chavan College of Engineering, Nagpur",
  val: "484"
}, {
  text: "YMCA University of Science and Technology, Faridabad",
  val: "485"
}, {
  text: "National Institute of Technology, Kurukshetra (NIT KKR)",
  val: "487"
}, {
  text: "Indian Institute of Science (IISc)",
  val: "488"
}, {
  text: "IIM Sirmaur",
  val: "489"
}, {
  text: "Indraprastha Institute of Information Technology",
  val: "490"
}, {
  text: "IIM Amritsar",
  val: "491"
}]


export function getInstitutesName() {
  let institutes = [];
  if (process.env.REACT_APP_PLATFORM == 'iimjobs'){
      institutes = instituteTagsDataIimjobs
  }
  else if(process.env.REACT_APP_PLATFORM == 'updazz'){
      institutes = instituteTagsDataUpdazz
  }
  else{
      institutes = instituteTagsDataHirist
  }
  return institutes.map(item => {
      return {
          label: item.text,
          value: item.text.toString(),
          key: item.text,
          isTop: item.isTop
      }
  })
}

export function getInstitutes() {
  let institutes = [];
  if (process.env.REACT_APP_PLATFORM == 'iimjobs'){
      institutes = instituteTagsDataIimjobs
  }else{
      institutes = instituteTagsDataHirist
  }
  return institutes.map(item => {
      return {
          label: item.text,
          value: item.val.toString(),
          key: item.val,
          isTop: item.isTop
      }
  })
}

export function getInstituteMap() {
    const instittutes = getInstitutes()
    return instittutes.reduce((p,c) => {
        p[c.value] = c.label;
        return p;
    }, {})
}